import {isMobile } from 'react-device-detect';

export const TOOLTIP = {
    LIKE: "Press,To like the pair.",
    DISLIKE: "Press,To dislike the pair.",
    UNDO: "Press,To see previous pair from history.",
    REDO: "Press,To see next pair from history.",
    NIGHT_MODE: "Press,To toggle dark and light view.",
    MORE_PAIRS: "Press,To see hand picked pairs.",
    RANDOMISE: "Press,To see next random good pair.",
    LOCK_UNLOCK_ICON: "Press,To lock/unlock the font.",
    SWAP_ICON:"Press,To swap heading body font.",
    FONT_SIZE_SLIDER:"Slide,To change font size.",
    GET_FONT:"Press,To explore family on Myfonts",
    SHARE_PAIR:"Press,To share the pair",
  };

const headingSmall = 'The art of Typography';
const descSmall = 'Typography is the art and technique of arranging type to make written language legible, readable, and appealing when displayed. It involves choosing typefaces, point sizes, line lengths, etc.';

export const CAMPAIGN_METADATA = "?utm_source=font_pairing_engine&utm_medium=webapp&utm_campaign=font_pairing_launch"  
let desc ;
let heading ;
if (isMobile){
    desc = descSmall;
    heading = headingSmall;
}
else{
    heading = 'The art of Typography: How to craft beautiful text';
    desc = 'Typography is the art and technique of arranging type to make written language legible, readable, and appealing when displayed. It involves choosing typefaces, point sizes, line lengths, line-spacing, and letter-spacing, and adjusting the space between pairs of letters. Typography also includes the use of color and other design elements to enhance the visual appeal of text. \n\nOne of the main goals of typography is to make text easy to read, so that people can understand the information that is being presented to them. This is especially important when it comes to things like books, websites, and other documents that are meant to be read by a lot of people.';
}
export const HEADER_INPUT = heading;
export const DESCRIPTION_INPUT = desc;

export const FONT_PAIR_HEADER = headingSmall;
export const FONT_PAIR_BODY = descSmall;

export const reDirection_url_map = new Map(
    [['Zurich', 'https://www.myfonts.com/collections/zurich-font-bitstream'],
    ['Zenon', 'https://www.myfonts.com/collections/zenon-font-cast'],
    ['Zapf Humanist 601',
     'https://www.myfonts.com/collections/zapf-humanist-601-font-bitstream'],
    ['Zapf Calligraphic 801',
     'https://www.myfonts.com/collections/zapf-calligraphic-801-font-bitstream'],
    ['Zapf Calligraphic 801',
     'https://www.myfonts.com/collections/zapf-calligr-font-tilde'],
    ['Yorkten Slab',
     'https://www.myfonts.com/collections/yorkten-slab-font-insigne'],
    ['Yorkten', 'https://www.myfonts.com/collections/yorkten-font-insigne'],
    ['FF Yoga', 'https://www.myfonts.com/collections/yoga-pro-font-fontfont'],
    ['Yassitf',
     'https://www.myfonts.com/collections/yassitf-font-ingrimayne-type'],
    ['Winterthur', false],
    ['Winden', 'https://www.myfonts.com/collections/winden-font-latinotype'],
    ['Weissenhof Grotesk',
     'https://www.myfonts.com/collections/weissenhof-grotesk-font-indian-type-foundry'],
    ['Weekly', 'https://www.myfonts.com/collections/weekly-font-los-andes'],
    ['Wayfinding Sans Pro',
     'https://www.myfonts.com/collections/wayfinding-sans-pro-font-fdi'],
    ['Walbaum',
     'https://www.myfonts.com/collections/walbaum-font-monotype-imaging'],
    ['Volte',
     'https://www.myfonts.com/collections/volte-font-indian-type-foundry'],
    ['Vigor DT', 'https://www.myfonts.com/collections/vigor-dt-font-dtp-types'],
    ['Vicky', 'https://www.myfonts.com/collections/vicky-font-letritas'],
    ['Versailles LT Com 55 Roman',
     'https://www.myfonts.com/collections/versailles-font-linotype'],
    ['MVB Verdigris Pro',
     'https://www.myfonts.com/collections/mbv-verdigris-pro-font-mvb'],
    ['Velino Text',
     'https://www.myfonts.com/collections/velino-text-font-dstype'],
    ['Valencia Serial',
     'https://www.myfonts.com/collections/valencia-serial-font-softmaker'],
    ['V&W Syntax (Adobe)',
     'https://www.myfonts.com/collections/syntax-inactive-font-urw'],
    ['Utopia', 'https://www.myfonts.com/collections/utopia-font-adobe'],
    ['URW Antiqua', 'https://www.myfonts.com/collections/antiqua-font-urw'],
    ['Urge Text',
     'https://www.myfonts.com/collections/urge-text-font-schizotype'],
    ['Univers', 'https://www.myfonts.com/collections/univers-font-linotype'],
    ['Unitext',
     'https://www.myfonts.com/collections/unitext-font-monotype-imaging'],
    ['Uniform Pro',
     'https://www.myfonts.com/collections/uniform-pro-font-miller-type'],
    ['Typold',
     'https://www.myfonts.com/collections/typold-font-the-northern-block'],
    ['TwCenMTPro-Light', false],
    ['TT Rationalist',
     'https://www.myfonts.com/collections/tt-rationalist-font-typetype'],
    ['TT Norms Pro',
     'https://www.myfonts.com/collections/tt-norms-font-typetype'],
    ['TT Livret', 'https://www.myfonts.com/collections/tt-livret-font-typetype'],
    ['TT Jenevers',
     'https://www.myfonts.com/collections/tt-jenevers-font-typetype'],
    ['TT Fors', 'https://www.myfonts.com/collections/tt-fors-font-typetype'],
    ['TT Commons __Classic',
     'https://www.myfonts.com/collections/tt-commons-classic-font-typetype'],
    ['Trola', 'https://www.myfonts.com/collections/trola-font-tipografies'],
    ['Trivia Sans', 'https://www.myfonts.com/collections/trivia-sans-font-storm'],
    ['Trenda', 'https://www.myfonts.com/collections/trenda-font-latinotype'],
    ['Trebuchet',
     'https://www.myfonts.com/collections/trebuchet-font-microsoft-corporation'],
    ['Trade Gothic',
     'https://www.myfonts.com/collections/trade-gothic-font-linotype'],
    ['Toma Sans',
     'https://www.myfonts.com/collections/toma-sans-font-jam-type-design'],
    ['FF Tisa Sans Paneuropean',
     'https://www.myfonts.com/collections/ff-tisa-sans-paneuropean-font-fontfont'],
    ['Times New Roman',
     'https://www.myfonts.com/collections/times-new-roman-font-monotype-imaging'],
    ['TheSans', 'https://www.myfonts.com/collections/thesans-font-lucasfonts'],
    ['TG Aqsa Grotesque Pro',
     'https://www.myfonts.com/collections/tg-aqsa-grotesque-pro-font-tegami-type'],
    ['Tenon', 'https://www.myfonts.com/collections/tenon-font-signal'],
    ['Tee Franklin',
     'https://www.myfonts.com/collections/tee-franklin-font-suomi'],
    ['Tazugane Gothic',
     'https://www.myfonts.com/collections/tazugane-gothic-font-monotype-imaging'],
    ['Tarsus',
     'https://www.myfonts.com/collections/tarsus-font-indian-type-foundry'],
    ['Tabac Sans',
     'https://www.myfonts.com/collections/tabac-sans-font-suitcase-type-foundry'],
    ['Tabac Slab',
     'https://www.myfonts.com/collections/tabac-slab-font-suitcase-type-foundry'],
    ['Syntax', 'https://www.myfonts.com/collections/syntax-font-linotype'],
    ['Synerga Pro',
     'https://www.myfonts.com/collections/synerga-pro-font-mint-type'],
    ['Swiss721 BT Regular',
     'https://www.myfonts.com/collections/swiss-721-rounded-font-bitstream'],
    ['Neue Swift',
     'https://www.myfonts.com/collections/neue-swift-font-linotype'],
    ['Sweet Sans Pro', 'https://www.myfonts.com/collections/sans-pro-font-sweet'],
    ['Suprema', 'https://www.myfonts.com/collections/suprema-font-artegra'],
    ['Supra Mezzo',
     'https://www.myfonts.com/collections/supra-mezzo-font-wiescher-design'],
    ['PTL Superla', 'https://www.myfonts.com/collections/superla-font-primetype'],
    ['ITC Stone Serif',
     'https://www.myfonts.com/collections/stone-serif-font-itc'],
    ['ITC Stone Sans II',
     'https://www.myfonts.com/collections/stone-sans-ii-font-itc'],
    ['Stempel Garamond LT',
     'https://www.myfonts.com/collections/stempel-garamond-font-linotype'],
    ['Stella', 'https://www.myfonts.com/collections/stella-font-feliciano'],
    ['SST', 'https://www.myfonts.com/collections/sst-font-monotype-imaging'],
    ['Specify', 'https://www.myfonts.com/collections/specify-font-mans-greback'],
    ['Sonus', 'https://www.myfonts.com/collections/sonus-font-hoftype'],
    ['Solitas Serif',
     'https://www.myfonts.com/collections/solitas-serif-font-insigne'],
    ['Sole Serif', 'https://www.myfonts.com/collections/sole-serif-font-cast'],
    ['Sole Sans', 'https://www.myfonts.com/collections/sole-sans-font-cast'],
    ['Sofia Pro',
     'https://www.myfonts.com/collections/sofia-pro-font-mostardesign'],
    ['PMN Caecilia',
     'https://www.myfonts.com/collections/pmn-caecilia-font-monotype-imaging'],
    ['Skolar Sans Latin',
     'https://www.myfonts.com/collections/skolar-sans-font-rosetta'],
    ['Skema Pro', 'https://www.myfonts.com/collections/skema-pro-font-mint-type'],
    ['Sirius', 'https://www.myfonts.com/collections/sirius-font-urw'],
    ['Sirba', 'https://www.myfonts.com/collections/sirba-font-type-together'],
    ['Shandon Slab',
     'https://www.myfonts.com/collections/shandon-slab-font-hoftype'],
    ['Serifa', 'https://www.myfonts.com/collections/serifa-font-bitstream'],
    ['Sequel Sans',
     'https://www.myfonts.com/collections/sequel-sans-font-ogj-type-design'],
    ['Sebino', 'https://www.myfonts.com/collections/sebino-font-nine-font'],
    ['Seaside', 'https://www.myfonts.com/collections/seaside-font-andrijtype'],
    ['Schulbuch Nord Offc Pro',
     'https://www.myfonts.com/collections/ff-schulbuch-font-fontfont'],
    ['Schotis Text',
     'https://www.myfonts.com/collections/schotis-text-font-juan-jose-lopez'],
    ['Schnebel Sans Pro',
     'https://www.myfonts.com/collections/kronos-sans-pro-font-urw'],
    ['Scala Pro', 'https://www.myfonts.com/collections/ff-scala-font-fontfont'],
    ['Santral', 'https://www.myfonts.com/collections/santral-font-taner-ardali'],
    ['Sanchez Slab',
     'https://www.myfonts.com/collections/sanchez-slab-font-latinotype'],
    ['S‡nchez Niu',
     'https://www.myfonts.com/collections/sanchez-niu-font-latinotype'],
    ['Salom', 'https://www.myfonts.com/collections/salom-font-schriftlabor'],
    ['Sailec', 'https://www.myfonts.com/collections/sailec-font-typedynamic'],
    ['Sabon Next',
     'https://www.myfonts.com/collections/sabon-next-font-linotype'],
    ['Pepi/Rudi',
     'https://www.myfonts.com/collections/pepi-rudi-font-suitcase-type-foundry'],
    ['Rubiesque', 'https://www.myfonts.com/collections/rubiesque-font-nootype'],
    ['RT_Vickerman', false],
    ['Rotis Serif',
     'https://www.myfonts.com/collections/rotis-serif-font-monotype-imaging'],
    ['Rotation', 'https://www.myfonts.com/collections/rotation-font-linotype'],
    ['Rooney', 'https://www.myfonts.com/collections/rooney-font-jan-fromm'],
    ['Riccione Serial',
     'https://www.myfonts.com/collections/riccione-serial-font-softmaker'],
    ['RF Dewi', 'https://www.myfonts.com/collections/rf-dewi-font-russian-fonts'],
    ['Resist Sans',
     'https://www.myfonts.com/collections/resist-sans-font-groteskly-yours'],
    ['Reserve', 'https://www.myfonts.com/collections/reserve-font-positype'],
    ['RemingaPro', 'https://www.myfonts.com/collections/reminga-font-fontfont'],
    ['Rational', 'https://www.myfonts.com/collections/rational-font-rene-bieder'],
    ['Quixo Offc Light',
     'https://www.myfonts.com/collections/ff-quixo-font-fontfont'],
    ['Queulat', 'https://www.myfonts.com/collections/queulat-font-latinotype'],
    ['Questa Serif',
     'https://www.myfonts.com/collections/questa-serif-font-questa-foundry'],
    ['Quercus 10', 'https://www.myfonts.com/collections/quercus-ten-font-storm'],
    ['QuaText', 'https://www.myfonts.com/collections/qua-text-font-lucasfonts'],
    ['Quarion', 'https://www.myfonts.com/collections/quarion-font-rene-bieder'],
    ['Quant Text', 'https://www.myfonts.com/collections/quant-text-font-hoftype'],
    ['Qualion', 'https://www.myfonts.com/collections/qualion-font-rohh'],
    ['Qanelas',
     'https://www.myfonts.com/collections/qanelas-font-radomir-tinkov'],
    ['PT Serif Pro',
     'https://www.myfonts.com/collections/pt-serif-pro-font-paratype'],
    ['PT Sans Pro',
     'https://www.myfonts.com/collections/pt-sans-pro-font-paratype'],
    ['Prumo Banner',
     'https://www.myfonts.com/collections/prumo-banner-font-dstype'],
    ['Proza', 'https://www.myfonts.com/collections/proza-font-bureau-roffa'],
    ['Proxima Nova',
     'https://www.myfonts.com/collections/proxima-nova-font-mark-simonson'],
    ['Primeform Pro',
     'https://www.myfonts.com/collections/primeform-pro-font-punchform'],
    ['Prillwitz Pro',
     'https://www.myfonts.com/collections/prillwitz-pro-font-preusstype'],
    ['Prelo Slab', 'https://www.myfonts.com/collections/prelo-slab-font-dstype'],
    ['Prelo', 'https://www.myfonts.com/collections/prelo-font-dstype'],
    ['Pragmatica',
     'https://www.myfonts.com/collections/pragmatica-font-paratype'],
    ['Portada', 'https://www.myfonts.com/collections/portada-font-type-together'],
    ['Pontiac', 'https://www.myfonts.com/collections/pontiac-font-la-goupil'],
    ['Pona Book', 'https://www.myfonts.com/collections/pona-font-tipografies'],
    ['Plantin Std Roman',
     'https://www.myfonts.com/collections/plantin-font-monotype-imaging'],
    ['Planc', 'https://www.myfonts.com/collections/planc-font-taner-ardali'],
    ['PF Adamant Sans Pro',
     'https://www.myfonts.com/collections/pf-adamant-sans-pro-font-parachute'],
    ['PerpetuaMTPro-Regular',
     'https://www.myfonts.com/collections/perpetua-font-monotype-imaging'],
    ['Peri—dico',
     'https://www.myfonts.com/collections/periodico-font-emtype-foundry'],
    ['Pepi/Rudi',
     'https://www.myfonts.com/collections/pepi-rudi-font-suitcase-type-foundry'],
    ['Passenger Serif',
     'https://www.myfonts.com/collections/passenger-serif-font-indian-type-foundry'],
    ['Passenger Sans',
     'https://www.myfonts.com/collections/passenger-sans-font-indian-type-foundry'],
    ['Parisine Std',
     'https://www.myfonts.com/collections/parisine-font-typofonderie'],
    ['Paralex', 'https://www.myfonts.com/collections/paralex-font-tipo-pepel'],
    ['PalmSprings', false],
    ['Palatino', 'https://www.myfonts.com/collections/palatino-font-linotype'],
    ['Oslo', 'https://www.myfonts.com/collections/oslo-font-wilton-foundry'],
    ['Orbi', 'https://www.myfonts.com/collections/orbi-font-paratype'],
    ['Optima Nova',
     'https://www.myfonts.com/collections/optima-nova-lt-font-linotype'],
    ['Okta', 'https://www.myfonts.com/collections/okta-font-groteskly-yours'],
    ['Obliqua ITC Pro', 'https://www.myfonts.com/collections/obliqua-font-itc'],
    ['Novel Sans Pro',
     'https://www.myfonts.com/collections/novel-sans-pro-font-atlasfontfoundry'],
    ['Nova Grotesk',
     'https://www.myfonts.com/collections/nova-grotesk-font-untype'],
    ['FF Nort', 'https://www.myfonts.com/collections/ff-nort-font-fontfont'],
    ['Nomada Slab',
     'https://www.myfonts.com/collections/nomada-slab-font-tipografies'],
    ['Nolan Next',
     'https://www.myfonts.com/collections/nolan-next-font-kastelov'],
    ['Noah', 'https://www.myfonts.com/collections/noah-font-fontfabric'],
    ['NimbusRomNo9T-Reg',
     'https://www.myfonts.com/collections/nimbus-roman-mono-font-urw'],
    ['Nimbus Sans Round',
     'https://www.myfonts.com/collections/nimbus-sans-round-font-urw'],
    ['Nexa Slab',
     'https://www.myfonts.com/collections/nexa-slab-font-fontfabric'],
    ['Nexa', 'https://www.myfonts.com/collections/nexa-font-fontfabric'],
    ['News Gothic',
     'https://www.myfonts.com/collections/news-gothic-font-paratype'],
    ['NewAsterLTStd',
     'https://www.myfonts.com/collections/new-aster-font-linotype'],
    ['Neuzeit Office',
     'https://www.myfonts.com/collections/neuzeit-office-font-linotype'],
    ['Neuville',
     'https://www.myfonts.com/collections/neuville-font-poetic-poetical'],
    ['Neufile Grotesk',
     'https://www.myfonts.com/collections/neufile-grotesk-font-letter-omega'],
    ['Neue Plak',
     'https://www.myfonts.com/collections/neue-plak-font-monotype-imaging'],
    ['Neue Haas Grotesk Text',
     'https://www.myfonts.com/collections/neue-haas-grotesk-text-font-linotype'],
    ['Neue Frutiger',
     'https://www.myfonts.com/collections/neue-frutiger-font-linotype'],
    ['Neue Alte Grotesk',
     'https://www.myfonts.com/collections/neue-alte-grotesk-font-visualworks'],
    ['NCT Larkspur', 'https://www.myfonts.com/collections/larkspur-font-nct'],
    ['NCT Granite', 'https://www.myfonts.com/collections/granite-font-nct'],
    ['Napolitana MF',
     'https://www.myfonts.com/collections/napolitana-mf-font-masterfont'],
    ['Myriad', 'https://www.myfonts.com/collections/myriad-font-adobe'],
    ['Museo Slab',
     'https://www.myfonts.com/collections/museo-slab-font-exljbris'],
    ['Mundo Serif',
     'https://www.myfonts.com/collections/mundo-serif-font-monotype-imaging'],
    ['Mundo Sans',
     'https://www.myfonts.com/collections/mundo-sans-font-monotype-imaging'],
    ['Multiple', 'https://www.myfonts.com/collections/multiple-font-latinotype'],
    ['Muller', 'https://www.myfonts.com/collections/muller-font-fontfabric'],
    ['Motiva Sans',
     'https://www.myfonts.com/collections/motiva-sans-font-niramekko'],
    ['Morn', 'https://www.myfonts.com/collections/morn-font-wahyu-sani-co'],
    ['Mont', 'https://www.myfonts.com/collections/mont-font-fontfabric'],
    ['Monstice',
     'https://www.myfonts.com/collections/monstice-font-seventh-imperium'],
    ['Monsal Gothic',
     'https://www.myfonts.com/collections/monsal-gothic-font-the-northern-block'],
    ['Monotype Sabon',
     'https://www.myfonts.com/collections/sabon-font-monotype-imaging'],
    ['Mirai', 'https://www.myfonts.com/collections/mirai-font-gt-canary'],
    ['Milo Serif Pro',
     'https://www.myfonts.com/collections/milo-serif-font-fontfont'],
    ['Milo Pro', 'https://www.myfonts.com/collections/milo-font-fontfont'],
    ['Miller Text',
     'https://www.myfonts.com/collections/miller-text-font-carter-and-cone-type'],
    ['Micrograma MF',
     'https://www.myfonts.com/collections/micrograma-mf-font-masterfont'],
    ['Metron SSi', false],
    ['MeteorObliqueMF-Bold',
     'https://www.myfonts.com/collections/meteor-condensed-mf-font-masterfont'],
    ['FF Meta Serif',
     'https://www.myfonts.com/collections/meta-serif-font-fontfont'],
    ['Meruba New MF',
     'https://www.myfonts.com/collections/meruba-new-mf-font-masterfont'],
    ['Mentor Sans',
     'https://www.myfonts.com/collections/mentor-sans-font-monotype-imaging'],
    ['Mencken Std',
     'https://www.myfonts.com/collections/mencken-std-font-typofonderie'],
    ['Memphis', 'https://www.myfonts.com/collections/memphis-font-linotype'],
    ['MB Empire',
     'https://www.myfonts.com/collections/mb-empire-font-m-b-creative'],
    ['Monotype test family 4',
     'https://www.myfonts.com/collections/matt-antique-font-tilde'],
    ['Mastro', 'https://www.myfonts.com/collections/mastro-font-ndiscovered'],
    ['Marlin Soft',
     'https://www.myfonts.com/collections/marlin-soft-font-fontmesallc'],
    ['FF Mark', 'https://www.myfonts.com/collections/mark-font-fontfont'],
    ['Marion', 'https://www.myfonts.com/collections/marion-font-typodermic'],
    ['Malnor Sans',
     'https://www.myfonts.com/collections/malnor-sans-font-sikifonts'],
    ['Malden Sans',
     'https://www.myfonts.com/collections/malden-sans-font-monotype-imaging'],
    ['Malaga', 'https://www.myfonts.com/collections/malaga-ot-font-emigre'],
    ['Malabar', 'https://www.myfonts.com/collections/malabar-font-linotype'],
    ['Makozin', 'https://www.myfonts.com/collections/makozin-font-hashtag-type'],
    ['Magneta', 'https://www.myfonts.com/collections/magneta-font-positype'],
    ['Madley', 'https://www.myfonts.com/collections/madley-font-kimmy-design'],
    ['Madison Antiqua',
     'https://www.myfonts.com/collections/madison-antiqua-font-linotype'],
    ['Madera',
     'https://www.myfonts.com/collections/madera-font-monotype-imaging'],
    ['Macklin',
     'https://www.myfonts.com/collections/macklin-font-monotype-imaging'],
    ['Lovelace', 'https://www.myfonts.com/collections/lovelace-font-zetafonts'],
    ['Locke', 'https://www.myfonts.com/collections/locke-font-cdtype'],
    ['Liteweit',
     'https://www.myfonts.com/collections/liteweit-font-typeart-foundry'],
    ['Lina', 'https://www.myfonts.com/collections/lina-font-roy-cole'],
    ['Life', 'https://www.myfonts.com/collections/life-font-linotype'],
    ['Leitura News',
     'https://www.myfonts.com/collections/leitura-news-font-dstype'],
    ['LegacySansITCPro-Book',
     'https://www.myfonts.com/collections/legacy-sans-font-itc'],
    ['Le Monde Livre Std',
     'https://www.myfonts.com/collections/le-monde-livre-std-font-typofonderie'],
    ['LCT Picon', 'https://www.myfonts.com/collections/picon-font-lct'],
    ['Latino', 'https://www.myfonts.com/collections/latino-duplicate-font-urw'],
    ['Latinka',
     'https://www.myfonts.com/collections/latinka-font-jaroslav-zavodny'],
    ['Lasiver', 'https://www.myfonts.com/collections/lasiver-font-typedynamic'],
    ['Larsseit', 'https://www.myfonts.com/collections/larsseit-font-typedynamic'],
    ['Kopius', 'https://www.myfonts.com/collections/kopius-font-kontour-type'],
    ['Kondolarge', 'https://www.myfonts.com/collections/kondolarge-font-typek'],
    ['Komet', 'https://www.myfonts.com/collections/komet-font-jan-fromm'],
    ['Kis Antiqua Pro',
     'https://www.myfonts.com/collections/kis-antiqua-pro-font-rmu'],
    ['FF Kievit Slab',
     'https://www.myfonts.com/collections/kievit-slab-inactive-font-fontfont'],
    ['Kievit Serif W02 Regular',
     'https://www.myfonts.com/collections/ff-kievit-serif-font-fontfont'],
    ['Kepler', 'https://www.myfonts.com/collections/kepler-font-adobe'],
    ['Karela', 'https://www.myfonts.com/collections/karela-font-blancoletters'],
    ['Kanyon',
     'https://www.myfonts.com/collections/kanyon-font-hurufatfont-type-foundry'],
    ['JT Marnie',
     'https://www.myfonts.com/collections/jt-marnie-font-jam-type-design'],
    ['JT Collect',
     'https://www.myfonts.com/collections/jt-collect-font-ogj-type-design'],
    ['Joanna Sans Nova',
     'https://www.myfonts.com/collections/joanna-sans-nova-font-monotype-imaging'],
    ['Joanna Nova',
     'https://www.myfonts.com/collections/joanna-nova-font-monotype-imaging'],
    ['Jasan', 'https://www.myfonts.com/collections/jasan-font-storm'],
    ['Janson Text Roman',
     'https://www.myfonts.com/collections/janson-text-font-linotype'],
    ['Iwata Mincho Old Pro',
     'https://www.myfonts.com/collections/mincho-old-font-iwata'],
    ['ITC Garamond', 'https://www.myfonts.com/collections/garamond-font-itc'],
    ['ITCAvantGardePro-Bk',
     'https://www.myfonts.com/collections/avant-garde-gothic-font-itc'],
    ['ITC Lubalin Graph',
     'https://www.myfonts.com/collections/lubalin-graph-font-itc'],
    ['ITC Giovanni',
     'https://www.myfonts.com/collections/itc-giovanni-font-adobe'],
    ['ITC Galliard Pro Roman',
     'https://www.myfonts.com/collections/galliard-font-itc'],
    ['ITC Franklin Gothic Book',
     'https://www.myfonts.com/collections/itc-franklin-gothic-inactive-font-itc'],
    ['ITC Bookman', 'https://www.myfonts.com/collections/bookman-font-itc'],
    ['Iowan Old Style',
     'https://www.myfonts.com/collections/iowan-old-style-font-paratype'],
    ['Innova', 'https://www.myfonts.com/collections/innova-font-durotype'],
    ['Ingeborg', 'https://www.myfonts.com/collections/ingeborg-font-typejockeys'],
    ['FF Infra', 'https://www.myfonts.com/collections/infra-font-fontfont'],
    ['Imperial', 'https://www.myfonts.com/collections/imperial-font-bitstream'],
    ['Hyperon', 'https://www.myfonts.com/collections/hyperon-font-paratype'],
    ['Humanist Slabserif 712',
     'https://www.myfonts.com/collections/humanist-slabserif-712-font-bitstream'],
    ['Helvetica', 'https://www.myfonts.com/collections/helvetica-font-linotype'],
    ['Helserif', 'https://www.myfonts.com/collections/helserif-font-urw'],
    ['Heisei Mincho',
     'https://www.myfonts.com/collections/heisei-mincho-font-adobe'],
    ['Hefring Slab',
     'https://www.myfonts.com/collections/hefring-slab-font-the-northern-block'],
    ['Hedley New',
     'https://www.myfonts.com/collections/hedley-new-font-moretype'],
    ['H Central', 'https://www.myfonts.com/collections/h-central-font-maccampus'],
    ['Hauteclaire',
     'https://www.myfonts.com/collections/hauteclaire-font-scriptorium'],
    ['Harmonia Sans',
     'https://www.myfonts.com/collections/harmonia-sans-font-monotype-imaging'],
    ['Harfang Pro',
     'https://www.myfonts.com/collections/harfang-pro-font-psy-ops'],
    ['HangulatinEN-Regular',
     'https://www.myfonts.com/collections/hangulatin-en-font-urw'],
    ['Halesworth',
     'https://www.myfonts.com/collections/halesworth-font-monotype-imaging'],
    ['Haboro Soft',
     'https://www.myfonts.com/collections/haboro-soft-font-insigne'],
    ['Monotype Grotesque',
     'https://www.myfonts.com/collections/grotesque-mt-font-monotype-imaging'],
    ['Graublau Sans Pro',
     'https://www.myfonts.com/collections/graublau-sans-pro-font-fdi'],
    ['Gramatika', 'https://www.myfonts.com/collections/gramatika-font-tokotype'],
    ['Gothic 720 W03 Rom',
     'https://www.myfonts.com/collections/gothic-720-font-bitstream'],
    ['Gotham-Book',
     'https://www.myfonts.com/collections/gotham-font-hoefler-and-co'],
    ['Gordita', 'https://www.myfonts.com/collections/gordita-font-type-atelier'],
    ['Golden Sans',
     'https://www.myfonts.com/collections/golden-sans-font-artill-typs'],
    ['Glypha', 'https://www.myfonts.com/collections/glypha-font-linotype'],
    ['Gloucester Pro Regular',
     'https://www.myfonts.com/collections/gloucester-old-style-mt-font-monotype-imaging'],
    ['Gloriola',
     'https://www.myfonts.com/collections/gloriola-font-suitcase-type-foundry'],
    ['Glober', 'https://www.myfonts.com/collections/glober-font-fontfabric'],
    ['Glence', 'https://www.myfonts.com/collections/glence-font-nine-font'],
    ['Ginkgo', 'https://www.myfonts.com/collections/ginkgo-font-linotype'],
    ['Gimbal Egyptian',
     'https://www.myfonts.com/collections/gimbal-egyptian-font-avp'],
    ['Gilroy', 'https://www.myfonts.com/collections/gilroy-font-radomir-tinkov'],
    ['Gill Sans MT Pro Book',
     'https://www.myfonts.com/collections/gill-sans-mt-font-monotype-imaging'],
    ['GHEAAspet',
     'https://www.myfonts.com/collections/ghea-samo-font-edik-ghabuzyan'],
    ['Geometric Slabserif 703',
     'https://www.myfonts.com/collections/geometric-slabserif-703-font-bitstream'],
    ['Georgia',
     'https://www.myfonts.com/collections/georgia-font-microsoft-corporation'],
    ['Gentleman',
     'https://www.myfonts.com/collections/gentleman-font-juraj-chrastina'],
    ['Geneo Std',
     'https://www.myfonts.com/collections/geneo-std-font-typofonderie'],
    ['Geller', 'https://www.myfonts.com/collections/geller-font-ludka-biniek'],
    ['GazetteLTStd-Roman',
     'https://www.myfonts.com/collections/gazette-font-linotype'],
    ['Garvis Pro',
     'https://www.myfonts.com/collections/garvis-pro-font-james-todd'],
    ['Garth Graphic',
     'https://www.myfonts.com/collections/garth-graphic-font-monotype-imaging'],
    ['Galliard', 'https://www.myfonts.com/collections/galliard-font-itc'],
    ['Galano Grotesque',
     'https://www.myfonts.com/collections/galano-grotesque-font-rene-bieder'],
    ['Gabriela',
     'https://www.myfonts.com/collections/gabriela-font-latinotype-mexico'],
    ['Futura Now',
     'https://www.myfonts.com/collections/futura-now-font-monotype-imaging'],
    ['Fuse', 'https://www.myfonts.com/collections/fuse-font-without-foundry'],
    ['FS Me', 'https://www.myfonts.com/collections/fs-me-font-fontsmith'],
    ['FS Elliot Paneuropean',
     'https://www.myfonts.com/collections/fs-elliot-paneuropean-font-fontsmith'],
    ['FS Ostro', 'https://www.myfonts.com/collections/fs-ostro-font-fontsmith'],
    ['FS Koopman',
     'https://www.myfonts.com/collections/fs-koopman-font-fontsmith'],
    ['FS Industrie',
     'https://www.myfonts.com/collections/fs-industrie-font-fontsmith'],
    ['FS Brabo Paneuropean',
     'https://www.myfonts.com/collections/fs-brabo-paneuropean-font-fontsmith'],
    ['Freight Neo Pro',
     'https://www.myfonts.com/collections/freight-neo-pro-font-garagefonts'],
    ['Frasa', 'https://www.myfonts.com/collections/frasa-font-tokotype'],
    ['Franklin Gothic SG',
     'https://www.myfonts.com/collections/franklin-gothic-sg-font-scangraphic-digital-type-collection'],
    ['Foundry Sans',
     'https://www.myfonts.com/collections/foundry-sans-font-the-foundry'],
    ['Foro', 'https://www.myfonts.com/collections/foro-font-hoftype'],
    ['Folio', 'https://www.myfonts.com/collections/folio-font-bitstream'],
    ['Flama Book', false],
    ['Filson Pro',
     'https://www.myfonts.com/collections/filson-pro-font-mostardesign'],
    ['Figgins Sans',
     'https://www.myfonts.com/collections/figgins-sans-font-shinntype'],
    ['FF Scala Sans',
     'https://www.myfonts.com/collections/ff-scala-sans-font-fontfont'],
    ['FF Mark', 'https://www.myfonts.com/collections/mark-font-fontfont'],
    ['FF Franziska',
     'https://www.myfonts.com/collections/franziska-font-fontfont'],
    ['Fact', 'https://www.myfonts.com/collections/fact-font-paratype'],
    ['Excelsior LT Roman',
     'https://www.myfonts.com/collections/excelsior-font-linotype'],
    ['Europa Grotesk No. 2 SB',
     'https://www.myfonts.com/collections/europa-grotesk-no-2-sb-font-scangraphic-digital-type-collection'],
    ['Essonnes', 'https://www.myfonts.com/collections/essonnes-font-james-todd'],
    ['Eskorte Latin', 'https://www.myfonts.com/collections/eskorte-font-rosetta'],
    ['Erato', 'https://www.myfonts.com/collections/erato-font-hoftype'],
    ['Eina', 'https://www.myfonts.com/collections/eina-font-textaxis'],
    ['Egyptienne F',
     'https://www.myfonts.com/collections/egyptienne-f-font-linotype'],
    ['Dutch 801', 'https://www.myfonts.com/collections/dutch-801-font-bitstream'],
    ['Dutch 766', 'https://www.myfonts.com/collections/dutch-766-font-bitstream'],
    ['Dupla', 'https://www.myfonts.com/collections/dupla-font-tipo-pepel'],
    ['Droid Sans',
     'https://www.myfonts.com/collections/droid-sans-pro-font-ascender-corp'],
    ['Dolly Pro', 'https://www.myfonts.com/collections/dolly-font-underware'],
    ['District Pro',
     'https://www.myfonts.com/collections/district-pro-font-garagefonts'],
    ['DIN Next Slab',
     'https://www.myfonts.com/collections/din-next-slab-font-monotype-imaging'],
    ['DIN Next',
     'https://www.myfonts.com/collections/din-next-font-monotype-imaging'],
    ['DF Dejavu Pro',
     'https://www.myfonts.com/collections/df-dejavu-pro-font-dutchfonts'],
    ['Dexa Pro', 'https://www.myfonts.com/collections/dexa-pro-font-artegra'],
    ['Devoid', 'https://www.myfonts.com/collections/devoid-font-dropper'],
    ['Delecta',
     'https://www.myfonts.com/collections/delecta-font-robert-corseanschi'],
    ['Deccan',
     'https://www.myfonts.com/collections/deccan-font-indian-type-foundry'],
    ['Dante MT Pro',
     'https://www.myfonts.com/collections/dante-mt-font-monotype-imaging'],
    ['Daikon', 'https://www.myfonts.com/collections/daikon-font-pepper-type'],
    ['Dagny Offc Pro', 'https://www.myfonts.com/collections/dagny-font-fontfont'],
    ['Creo', 'https://www.myfonts.com/collections/creo-font-wahyu-sani-co'],
    ['Creata', 'https://www.myfonts.com/collections/creata-font-ivan-petrov'],
    ['Cotford',
     'https://www.myfonts.com/collections/cotford-font-monotype-imaging'],
    ['Corporate S', 'https://www.myfonts.com/collections/corporate-s-font-urw'],
    ['Corporate E', 'https://www.myfonts.com/collections/corporate-e-font-urw'],
    ['Core Serif N',
     'https://www.myfonts.com/collections/core-serif-n-font-s-core'],
    ['Core Sans C',
     'https://www.myfonts.com/collections/core-sans-c-font-s-core'],
    ['Corbel', false],
    ['Conamore', 'https://www.myfonts.com/collections/conamore-font-grida'],
    ['Comenia Sans',
     'https://www.myfonts.com/collections/comenia-sans-font-suitcase-type-foundry'],
    ['Coltan Gea', 'https://www.myfonts.com/collections/coltan-gea-font-defharo'],
    ['Codec Pro', 'https://www.myfonts.com/collections/codec-pro-font-zetafonts'],
    ['Cocogoose Pro',
     'https://www.myfonts.com/collections/cocogoose-pro-font-zetafonts'],
    ['Coco Sharp',
     'https://www.myfonts.com/collections/coco-sharp-font-zetafonts'],
    ['Clobber Grotesk',
     'https://www.myfonts.com/collections/clobber-font-wordshape'],
    ['Clifford Six Offc Pro',
     'https://www.myfonts.com/collections/ff-clifford-font-fontfont'],
    ['Classic Sans',
     'https://www.myfonts.com/collections/classic-sans-font-wiescher-design'],
    ['Classic Grotesque',
     'https://www.myfonts.com/collections/classic-grotesque-font-monotype-imaging'],
    ['Clarion',
     'https://www.myfonts.com/collections/clarion-mt-font-monotype-imaging'],
    ['Clarika Pro',
     'https://www.myfonts.com/collections/clarika-pro-font-wild-edge'],
    ['Clarendon',
     'https://www.myfonts.com/collections/clarendon-duplicate-font-urw'],
    ['CG Symphony',
     'https://www.myfonts.com/collections/cg-symphony-font-monotype-imaging'],
    ['Cerebri Sans',
     'https://www.myfonts.com/collections/cerebri-sans-font-hanken-design-co'],
    ['Cera Pro', 'https://www.myfonts.com/collections/cera-font-typemates'],
    ['Century Schoolbook',
     'https://www.myfonts.com/collections/century-schoolbook-font-bitstream'],
    ['Century Gothic Paneuropean',
     'https://www.myfonts.com/collections/century-gothic-paneuropean-font-monotype-imaging'],
    ['Linotype Centennial',
     'https://www.myfonts.com/collections/centennial-2-font-linotype'],
    ['CentaurMTPro-Regular',
     'https://www.myfonts.com/collections/centaur-font-monotype-imaging'],
    ['Celias', 'https://www.myfonts.com/collections/celias-font-typedynamic'],
    ['Causten', 'https://www.myfonts.com/collections/causten-font-trustha'],
    ['Cassia', 'https://www.myfonts.com/collections/cassia-font-hoftype'],
    ['Carrig Pro',
     'https://www.myfonts.com/collections/carrig-pro-font-paulo-goode'],
    ['Carrara', 'https://www.myfonts.com/collections/carrara-font-hoftype'],
    ['Carisma', 'https://www.myfonts.com/collections/carisma-font-castletype'],
    ['Cardium',
     'https://www.myfonts.com/collections/cardium-font-yellow-design-studio'],
    ['Capitolina',
     'https://www.myfonts.com/collections/capitolina-font-typefolio'],
    ['Candida', 'https://www.myfonts.com/collections/candida-font-bitstream'],
    ['Campton', 'https://www.myfonts.com/collections/campton-font-rene-bieder'],
    ['Cambria',
     'https://www.myfonts.com/collections/cambria-math-font-microsoft-corporation'],
    ['Calvert MT Pro Light',
     'https://www.myfonts.com/collections/calvert-font-monotype-imaging'],
    ['Calluna Sans',
     'https://www.myfonts.com/collections/calluna-sans-font-exljbris'],
    ['Calluna', 'https://www.myfonts.com/collections/calluna-font-exljbris'],
    ['CalistoMTPro',
     'https://www.myfonts.com/collections/calisto-mt-font-monotype-imaging'],
    ['Bw Nista', false],
    ['Bw Modelica', false],
    ['Bunyan Pro',
     'https://www.myfonts.com/collections/bunyan-pro-font-canada-type'],
    ['Bruta Global',
     'https://www.myfonts.com/collections/bruta-global-font-ndiscovered'],
    ['Brother 1816',
     'https://www.myfonts.com/collections/brother-1816-font-tipotype'],
    ['Breton', 'https://www.myfonts.com/collections/breton-font-latinotype'],
    ['Brasley', 'https://www.myfonts.com/collections/brasley-font-nicolas-desle'],
    ['Brahma', 'https://www.myfonts.com/collections/brahma-font-tall-chai'],
    ['BR Sonoma', 'https://www.myfonts.com/collections/br-sonoma-font-brink'],
    ['Boutros Angham',
     'https://www.myfonts.com/collections/boutros-angham-font-boutros'],
    ['Boston', 'https://www.myfonts.com/collections/boston-font-latinotype'],
    ['Bookseller Cp',
     'https://www.myfonts.com/collections/bookseller-cp-font-cyanotype'],
    ['Bookmania',
     'https://www.myfonts.com/collections/bookmania-font-mark-simonson'],
    ['Bookman Old Style',
     'https://www.myfonts.com/collections/bookman-old-style-font-monotype-imaging'],
    ['BirkaLTPro-Regular',
     'https://www.myfonts.com/collections/birka-pro-font-linotype'],
    ['JAF Bernini Sans',
     'https://www.myfonts.com/collections/bernini-sans-font-just-another-foundry'],
    ['BerlingLTStd-Roman',
     'https://www.myfonts.com/collections/berling-font-linotype'],
    ['BB Noname (Pro)',
     'https://www.myfonts.com/collections/noname-pro-font-bold-studio'],
    ['Bauen', 'https://www.myfonts.com/collections/bauen-font-tipo-pepel'],
    ['Bau Offc', 'https://www.myfonts.com/collections/bau-pro-font-fontfont'],
    ['Baskerville',
     'https://www.myfonts.com/collections/baskerville-font-bitstream'],
    ['Ballinger', 'https://www.myfonts.com/collections/ballinger-font-signal'],
    ['Badiya', 'https://www.myfonts.com/collections/badiya-font-linotype'],
    ['Axiforma', 'https://www.myfonts.com/collections/axiforma-font-kastelov'],
    ['Averta',
     'https://www.myfonts.com/collections/averta-font-intelligent-foundry'],
    ['Avenir 55 Roman',
     'https://www.myfonts.com/collections/avenir-font-linotype'],
    ['Auto Pro', 'https://www.myfonts.com/collections/auto-pro-font-underware'],
    ['Atwic Regular', false],
    ['Atlan', 'https://www.myfonts.com/collections/atlan-font-latinotype'],
    ['Atenta', 'https://www.myfonts.com/collections/atenta-font-glen-jan'],
    ['Astoria Sans',
     'https://www.myfonts.com/collections/astoria-sans-font-alan-meeks'],
    ['Aspira', 'https://www.myfonts.com/collections/aspira-font-durotype'],
    ['Askan', 'https://www.myfonts.com/collections/askan-font-hoftype'],
    ['Ashbury', 'https://www.myfonts.com/collections/ashbury-font-hoftype'],
    ['Linotype Aroma', 'https://www.myfonts.com/collections/aroma-font-linotype'],
    ['Armin Soft',
     'https://www.myfonts.com/collections/armin-soft-font-without-foundry'],
    ['Aribau Grotesk',
     'https://www.myfonts.com/collections/aribau-grotesk-font-emtype-foundry'],
    ['Arial', 'https://www.myfonts.com/collections/arial-font-monotype-imaging'],
    ['Ardena', 'https://www.myfonts.com/collections/ardena-font-julien-fincker'],
    ['Arboria', 'https://www.myfonts.com/collections/arboria-font-type-o-tones'],
    ['Arazat’', 'https://www.myfonts.com/collections/arazati-font-underground'],
    ['Araboto', 'https://www.myfonts.com/collections/araboto-font-farahatdesign'],
    ['Applied Sans',
     'https://www.myfonts.com/collections/applied-sans-font-monotype-imaging'],
    ['Antona', 'https://www.myfonts.com/collections/antona-font-exljbris'],
    ['Ano', 'https://www.myfonts.com/collections/ano-font-alias'],
    ['Andulka Sans',
     'https://www.myfonts.com/collections/andulka-sans-font-storm'],
    ['Andale Sans Paneuropean',
     'https://www.myfonts.com/collections/andale-sans-paneuropean-font-monotype-imaging'],
    ['Andada-Regular', false],
    ['Analogia',
     'https://www.myfonts.com/collections/analogia-font-george-tulloch'],
    ['Amnesty Trade Gothic W04 Roman',
     'https://www.myfonts.com/collections/trade-gothic-font-linotype'],
    ['Amasis',
     'https://www.myfonts.com/collections/amasis-font-monotype-imaging'],
    ['Altone', 'https://www.myfonts.com/collections/altone-font-eko-bimantara'],
    ['Alliance',
     'https://www.myfonts.com/collections/alliance-font-degarism-studio'],
    ['Alkes', 'https://www.myfonts.com/collections/alkes-font-fontfabric'],
    ['Alilon MF',
     'https://www.myfonts.com/collections/alilon-mf-font-masterfont'],
    ['Alexandra', 'https://www.myfonts.com/collections/alexandra-font-fxtype'],
    ['Aldus', 'https://www.myfonts.com/collections/aldus-font-linotype'],
    ['Aldine 401',
     'https://www.myfonts.com/collections/aldine-401-font-bitstream'],
    ['Albany',
     'https://www.myfonts.com/collections/albany-font-monotype-imaging'],
    ['AkzidenzGroteskBQ-Reg',
     'https://www.myfonts.com/collections/akzidenz-grotesk-font-berthold'],
    ['Akagi', 'https://www.myfonts.com/collections/akagi-font-positype'],
    ['Aetna JY Pro',
     'https://www.myfonts.com/collections/aetna-jy-pro-font-jy-and-a'],
    ['Aestetico',
     'https://www.myfonts.com/collections/aestetico-font-latinotype'],
    ['Adriane Text',
     'https://www.myfonts.com/collections/adriane-text-font-typefolio'],
    ['Adelle', 'https://www.myfonts.com/collections/adelle-font-type-together'],
    ['Acumin', 'https://www.myfonts.com/collections/acumin-font-adobe'],
    ['Acta', 'https://www.myfonts.com/collections/acta-font-dstype'],
    ['Academica', 'https://www.myfonts.com/collections/academica-font-storm'],
    ['Abrade', 'https://www.myfonts.com/collections/abrade-font-greyscale-type'],
    ['Abelard',
     'https://www.myfonts.com/collections/abelard-font-indian-type-foundry'],
    ['2030', 'https://www.myfonts.com/collections/2030-font-noir-typo']]
)
export const HAND_CURATED_PAIR = [
    
    {likedPair : [
        "03ba201f7613be300cec0afc83ee295a",
        "386528d2feb209e45554ed0fa03d81ce",
         "Helvetica",
        "Glypha"
      ]}
    ,
        {likedPair : [
        "9a21e3a1e94c73d3bf7f66ea8fb82613",
        "caee5e6a5eec9cb66a85ac115f2f5c7f",
         "Gilroy",
        "ITC Lubalin Graph"
      ]}
    ,
     {
          likedPair: [
              "fbb9573728984c54a8ca446e19d0972a",
              "b127070b4065a62961b2bf60fb763a76",
              "Proxima Nova",
              "Candida"
          ]
      },
  
      {likedPair : [
        "03ba201f7613be300cec0afc83ee295a",
        "8ebe3248143db352da56805017ca7934",
         "Helvetica",
        "Walbaum"
      ]}
    ,
  
  
      {likedPair : [
        "be5fdca67a94d3db868b73c7eaea39f4",
        "386528d2feb209e45554ed0fa03d81ce",
         "Neue Haas Grotesk Text",
        "Glypha"
      ]}
    ,
  
        {likedPair : [
        "9f05792cccf1711b103d46c9d70e710d",
        "ebe0092b584d62426b03aa84e3d1597c",
         "Univers",
        "Egyptienne F"
      ]}
    ,
  

  
          {
          likedPair: [
              "afb2c306772fbf472d6549a865bf7339",
              "818930a2cf5fa264846d244b38fab798",
              "TT Livret",
              "Trade Gothic"
          ]
      },
  
  
  
          {
          likedPair: [
              "0f9660f1f757f7351b774c0bd7614dcc",
              "3938fddd18b33d1b1549d30049d6e749",
              "TT Commons \u200b\u200bClassic",
              "Schotis Text"
          ]
      },
  
  

  
  
              {
          likedPair: [
              "dc96c9566355e2a1445ab8dad6bf029e",
              "1064c815bebd285f61fa50c097045eaf",
              "FF Mark",
              "Memphis"
          ]
      },
  
  
                  {
          likedPair: [
              "ac04c5328af335b179cf1827997e1774",
              "3f57a43ed54fe91aa92025669be6fe7d",
              "Swiss721 BT Regular",
              "FS Ostro"
          ]
      },

    {likedPair : [
      "1d95d38fa82771b3d0d071f03ce5daa7",
      "1b5bd1add600d0b39ceadc5f7c4dafe3",
       "Gill Sans MT Pro Book",
      "PerpetuaMTPro-Regular"
    ]}
  ,
    {likedPair : [
      "c63e8810388d85594540bb5f6980f611",
      "1d1c5f188947c7c11e7e3c027a150944",
       "LegacySansITCPro-Book",
      "Centaur"
    ]}
  ,
    {likedPair : [
      "d4f0f8030c1d155b3361152e0e4468e8",
      "a0d65f3e06a945602a59f035c4c9edaf",
       "Aetna JY Pro",
      "Freight Neo Pro"
    ]}
  ,
    {likedPair : [
      "9360965dc32616b3be9ca157ebaa44eb",
      "095898e12700edc69d52ecf30ef03e2a",
       "Palatino",
      "Proza"
    ]}
,
  
    {likedPair : [
      "e0d397e073f334bdc40410c8c4093d9b",
      "2f1bd1f8dbef57e0409e2c64f8edc593",
       "Alkes",
      "Mundo sans"
    ]}
  ,
    {likedPair : [
      "8c155b53e011d2a709548865b3edbeaf",
      "9e6867c857655e9d1984390fdf1dde45",
       "PerpetuaMTPro-Regular",
      "Skolar Sans Latin"
    ]}
  ,
    {likedPair : [
      "8dc3a40e423d1f3d09bc6f20e864e5b4",
      "3bc3a738f4507b8feea7502049c474d2",
       "Sanchez slab",
      "Gordita"
    ]}
  ,

    {likedPair : [
      "55c82bba9780601494464838b3ba2c82",
      "c74f77a345edf278a01b806459f255bb",
       "Humanist Slabserif 712",
      "Neufile Grotesk"
    ]}
  ,
  
    {likedPair : [
      "9a56b03fc5c8b9a7e849de833f717ae3",
      "221e3a7024c6097517ac6cab6c79c901",
       "Stempel Garamond LT",
      "FF Scala Sans"
    ]}
  ,
    {likedPair : [
      "3c493435ad297f5d9c9edf1e5dea65e4",
      "38c216ced240e8111b587a31e2fc5794",
       "Solitas Serif",
      "Droid Sans"
    ]}
  ,
  
    {likedPair : [
      "b941ce467c4b7f2846b3226ae7988452",
      "b8515436cf84baf71ab3bfbdf73854f8",
       "Astoria Sans",
      "Eskorte Latin"
    ]}
  ,
  
    {likedPair : [
      "03c630ee6fa2bbc99e8c7cafbb93268f",
      "2f1bd1f8dbef57e0409e2c64f8edc593",
       "ITC Garamond",
      "Mundo sans"
    ]}
  ,


    {likedPair : [
      "a0d65f3e06a945602a59f035c4c9edaf",
      "eca7a3ecbd1738481c08b5132b63e3c9",
       "Freight Neo Pro",
      "Dolly Pro"
    ]}
  ,
  
    
    {likedPair : [
      "b731d0b07ce1287c54b176eb9c0ceaa4",
      "c29fbb04a732bbf8de9fc07f530f7ee8",
       "Din Next",
      "Latino"
    ]}
  ,
    {likedPair : [
      "7e9d0bdb9c9ee63eff98f3572164fef1",
      "d308bf8cc668fecbc3881e69f537c8e4",
       "Monotype Sabon",
      "Syntax"
    ]}
  ,
    {likedPair : [
      "7be0986d9e30fc760c35339e0ebc7b52",
      "2e3ccce51deb13cdcc86517cab6d2874",
       "Alexandra",
      "Myriad"
    ]}
  ,
    {likedPair : [
      "38f28a6682e9d705522a7ac7a715578f",
      "f01435736b8b73793ad270cdf379a860",
       "Essonnes",
      "Araboto"
    ]}
  ,
    {likedPair : [
      "c311a16ee279363b5113cbf699325577",
      "b832321e77d0f1be2c00712330066c3e",
       "Calluna",
      "Obliqua ITC Pro"
    ]}
  ,
    {likedPair : [
      "b127070b4065a62961b2bf60fb763a76",
      "b6d4866801af65300d7fbaa11e6469c2",
       "Candida",
      "Neue Frutiger"
    ]}
  ,
  
    {likedPair : [
      "ef724eada48fbb4a0fc0bdd3c5c918ed",
      "70b18cac6b0b144fda43c97ba9117cb6",
       "Joanna Nova",
      "Multiple"
    ]}
  ,
    {likedPair : [
      "c74f77a345edf278a01b806459f255bb",
      "9b642a5046a3cb501e8121b8f96cea5b",
       "Neufile Grotesk",
      "Miller Text"
    ]}
  ,
    {likedPair : [
      "c6bae55c030fe9df4104274e7fa5df57",
      "b34fc5fd3820759a8808f554191ecaa2",
       "Times new roman",
      "Acumin"
    ]}
  ,  
    {likedPair : [
      "38f28a6682e9d705522a7ac7a715578f",
      "7b6132f5e609e1dd9f5c3024f56ab311",
       "Essonnes",
      "Franklin Gothic SG"
    ]}
  ,
    {likedPair : [
      "7be0986d9e30fc760c35339e0ebc7b52",
      "fbd24e98ffaf0756040342768a621736",
       "Alexandra",
      "Humanist 777"
    ]}
  ,
    {likedPair : [
      "8c155b53e011d2a709548865b3edbeaf",
      "095898e12700edc69d52ecf30ef03e2a",
       "PerpetuaMTPro-Regular",
      "Proza"
    ]}
  ,
    {likedPair : [
      "ef724eada48fbb4a0fc0bdd3c5c918ed",
      "b832321e77d0f1be2c00712330066c3e",
       "Joanna Nova",
      "Obliqua ITC Pro"
    ]}
  ,
    {likedPair : [
      "70c60ffb0aa7fc3a33350d4a61d5873f",
      "392ba6ef4c0939349ecf8e0e89f359f1",
       "Joanna Sans Nova",
      "Iowan Old Style"
    ]}
  ,
    {likedPair : [
      "51eb849300954cdecf9da1310c79beb2",
      "2d0b4f3a328383b8486d150666306efe",
       "Calluna Sans",
      "Sabon Next"
    ]}
  ,
    {likedPair : [
      "1d95d38fa82771b3d0d071f03ce5daa7",
      "a3e574d261f8aef210631e30ad64a4d7",
       "Gill Sans MT Pro Book",
      "Joanna Nova"
    ]}
  ,
    {likedPair : [
      "9360965dc32616b3be9ca157ebaa44eb",
      "7d12c71bfcb798ad9660e885c2f07cb5",
       "Palatino",
      "Optima"
    ]}
  ,
    {likedPair : [
      "e0d397e073f334bdc40410c8c4093d9b",
      "b832321e77d0f1be2c00712330066c3e",
       "Alkes",
      "Obliqua ITC Pro"
    ]}
  ,
    {likedPair : [
      "a0d65f3e06a945602a59f035c4c9edaf",
      "7e9d0bdb9c9ee63eff98f3572164fef1",
       "Freight Neo Pro",
      "Monotype Sabon"
    ]}
  ,
    {likedPair : [
      "70c60ffb0aa7fc3a33350d4a61d5873f",
      "8c155b53e011d2a709548865b3edbeaf",
       "Joanna Sans Nova",
      "PerpetuaMTPro-Regular"
    ]}
  ,
    {likedPair : [
      "51eb849300954cdecf9da1310c79beb2",
      "3d42e5b4eac967ce5300247f880dc1fa",
       "Calluna Sans",
      "BirkaLTPro-Regular"
    ]}
  ,
    {likedPair : [
      "b941ce467c4b7f2846b3226ae7988452",
      "8c155b53e011d2a709548865b3edbeaf",
       "Astoria Sans",
      "PerpetuaMTPro-Regular"
    ]}
  ,
    {likedPair : [
      "18b27dd0e80d2f0a380a185f41e0dfed",
      "aaa60aa8fc5a49a2f846ee2a0507aaa2",
       "Andale Sans Paneuropean",
      "Andada-Regular"
    ]}
  ,
    {likedPair : [
      "7ff70643804e5a751a56a4efdce38b87",
      "85d8f2d0ba0f6b93900052f3b3047991",
       "Aspira",
      "Yorkten slab"
    ]}
  ,
    {likedPair : [
      "96e633e3b54168cc61a1acd1608084d3",
      "7c4a10607b6d2e1343591f90d0c1ebb3",
       "Avenir",
      "Sanchez Slab"
    ]}
  ,
      {likedPair : [
      "7e9d0bdb9c9ee63eff98f3572164fef1",
      "80e1fc90248cfb3f3b54227ab8d1afb1",
       "Monotype Sabon",
      "Arazatí"
    ]}
  ,
    {likedPair : [
      "d87ffd42ab39a3412ab905084e31b782",
      "a0d65f3e06a945602a59f035c4c9edaf",
       "FF Kievit Slab",
      "Freight Neo Pro"
    ]}
  ,
    {likedPair : [
      "d4f0f8030c1d155b3361152e0e4468e8",
      "095898e12700edc69d52ecf30ef03e2a",
       "Aetna JY Pro",
      "Proza"
    ]}
  ,
    {likedPair : [
      "e0d397e073f334bdc40410c8c4093d9b",
      "82550c10af201d56d90be26b8833ac63",
       "Alkes",
      "Makozin"
    ]}
  ,
  
    {likedPair : [
      "96e633e3b54168cc61a1acd1608084d3",
      "adc9e6f8703a21e134aa72d637646fdc",
       "Avenir",
      "Versailles LT Com 55 Roman"
    ]}
  ,
    {likedPair : [
      "d87ffd42ab39a3412ab905084e31b782",
      "4a8d414c86f9aeae1489e72e6293e772",
       "FF Kievit Slab",
      "Conamore"
    ]}
  ,
    {likedPair : [
      "9360965dc32616b3be9ca157ebaa44eb",
      "91f1a74434b4ecc9129239ec3e236b42",
       "Palatino",
      "Mentor Sans"
    ]}
  ,
    {likedPair : [
      "7ff70643804e5a751a56a4efdce38b87",
      "b127070b4065a62961b2bf60fb763a76",
       "Aspira",
      "Candida"
    ]}
  ,
    {likedPair : [
      "b941ce467c4b7f2846b3226ae7988452",
      "d87ffd42ab39a3412ab905084e31b782",
       "Astoria Sans",
      "FF Kievit Slab"
    ]}
  ,  {likedPair : [
      "a319c29b97c3ab98f37d82ca33d64fdc",
      "e28128adc0e75357f447267c07afb6a6",
       "DIN Next",
      "Hyperon"
    ]}
  
]


export const MODEL_GENERATED_PAIR =[
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "d87ffd42ab39a3412ab905084e31b782",
            "Comenia Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Comenia Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Comenia Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "9001cd9b7b209eebef43419463ef6c40",
            "Comenia Sans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Comenia Sans",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Comenia Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Comenia Sans",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Comenia Sans",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Comenia Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Comenia Sans",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "c311a16ee279363b5113cbf699325577",
            "Comenia Sans",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "c638239ea03b75929bff2ce833419ac3",
            "Comenia Sans",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "29093af656f979957ec5d657e96fb363",
            "Comenia Sans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "6badb2797a95a552c53a98a0f20c903b",
            "Comenia Sans",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "d07f2481905eefa80fa98c464d59e260",
            "Comenia Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Comenia Sans",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Comenia Sans",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Comenia Sans",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Comenia Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "001114826556952bb283044f915f1d9c",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Comenia Sans",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Queulat",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "256f7672059f72846d940fbd8c97537d",
            "Queulat",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "be1ed63669d6244408811624d948c116",
            "Queulat",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "627f02177189a33fe40ad427eff5d5bb",
            "Queulat",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Queulat",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "013968ef381969722a37a334b48bbaeb",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Queulat",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "2af66ddecaa7893391cb90362043d37a",
            "Neue Swift",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "c6ff032bd835e2f806009627251b87b6",
            "Neue Swift",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "b832321e77d0f1be2c00712330066c3e",
            "Neue Swift",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Neue Swift",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "c63e8810388d85594540bb5f6980f611",
            "Neue Swift",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "d84e985d428e023bb87368d43461b448",
            "Neue Swift",
            "SST"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "095898e12700edc69d52ecf30ef03e2a",
            "Neue Swift",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "51eb849300954cdecf9da1310c79beb2",
            "Neue Swift",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Neue Swift",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "38c216ced240e8111b587a31e2fc5794",
            "Neue Swift",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Neue Swift",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "9e6867c857655e9d1984390fdf1dde45",
            "Neue Swift",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Neue Swift",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Neue Swift",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Neue Swift",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "d18f103cfa62513f991b0f90a814c333",
            "Neue Swift",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Neue Swift",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "280c82457252f3613b33e3791c375caf",
            "Neue Swift",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Neue Swift",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Neue Swift",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Sebino",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "6d47953bebf6a23dc1d89764632524d8",
            "Sebino",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Sebino",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Sebino",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "73e48b94c08d2015315dbceaf56efb62",
            "Sebino",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Sebino",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "b127070b4065a62961b2bf60fb763a76",
            "Sebino",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "8a84a077e3b47852136fac569923059b",
            "Sebino",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "3319dd949835e43d4bed270f465aff3e",
            "Sebino",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "386528d2feb209e45554ed0fa03d81ce",
            "Sebino",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Sebino",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "Sebino",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Sebino",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "5bd81732a879ba42412c19bd5a33589b",
            "Sebino",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "50441227356a2e75a4737b2cfe84709b",
            "Sebino",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "ef0f22560e30896239545a852fd7f6b4",
            "Sebino",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "013968ef381969722a37a334b48bbaeb",
            "Sebino",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Sebino",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "8006330b215827a8efcd0e4c791bae76",
            "Sebino",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "033528c5f0137b017eff21079bd25a60",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Sebino",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Quercus 10",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "fc2e33377af6aca34a9826245e325cba",
            "Quercus 10",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Quercus 10",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "87791721b0238c72031ce39e346933a8",
            "Quercus 10",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Quercus 10",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Quercus 10",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "9e6867c857655e9d1984390fdf1dde45",
            "Quercus 10",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Quercus 10",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "35641bbe5146f945b85e1e7b34956a73",
            "Quercus 10",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Quercus 10",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Quercus 10",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "2af66ddecaa7893391cb90362043d37a",
            "Quercus 10",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "cdfdc5eeac0bd71254929817415fb502",
            "Quercus 10",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Quercus 10",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "c63e8810388d85594540bb5f6980f611",
            "Quercus 10",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Quercus 10",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Quercus 10",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "b941ce467c4b7f2846b3226ae7988452",
            "Quercus 10",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "147f1bb910d4c3487efd5789736afc3b",
            "Quercus 10",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Quercus 10",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Helvetica",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "3319dd949835e43d4bed270f465aff3e",
            "Helvetica",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "b127070b4065a62961b2bf60fb763a76",
            "Helvetica",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Helvetica",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Helvetica",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "06779a9920e25578b6f504fcbd0ca169",
            "Helvetica",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "e961668cbc083722acbc4a237ca92232",
            "Helvetica",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "afb2c306772fbf472d6549a865bf7339",
            "Helvetica",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "Helvetica",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "5bd81732a879ba42412c19bd5a33589b",
            "Helvetica",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "ef0f22560e30896239545a852fd7f6b4",
            "Helvetica",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "386528d2feb209e45554ed0fa03d81ce",
            "Helvetica",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Helvetica",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Helvetica",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "8a84a077e3b47852136fac569923059b",
            "Helvetica",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Helvetica",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "8ebe3248143db352da56805017ca7934",
            "Helvetica",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Helvetica",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "03ba201f7613be300cec0afc83ee295a",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Helvetica",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "ITC Garamond",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "ITC Garamond",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "ITC Garamond",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "b34fc5fd3820759a8808f554191ecaa2",
            "ITC Garamond",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "fc2e33377af6aca34a9826245e325cba",
            "ITC Garamond",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "ITC Garamond",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "ITC Garamond",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "b24744ca2bf3616294271353ec837099",
            "ITC Garamond",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "ITC Garamond",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "96da2e3b759f10f9970cef587bf11069",
            "ITC Garamond",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "c0351a7e9af75205fea41a3719573876",
            "ITC Garamond",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "ITC Garamond",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "c2244758e73a4caacb7f2916afe5f38f",
            "ITC Garamond",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "c63e8810388d85594540bb5f6980f611",
            "ITC Garamond",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "b941ce467c4b7f2846b3226ae7988452",
            "ITC Garamond",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Clobber Grotesk",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "8ebe3248143db352da56805017ca7934",
            "Clobber Grotesk",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "5bd81732a879ba42412c19bd5a33589b",
            "Clobber Grotesk",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Clobber Grotesk",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Clobber Grotesk",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "b74bf78a743785e3df7e3f14477a1390",
            "Clobber Grotesk",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "cc3e79c959420501e528f6b20113c185",
            "Clobber Grotesk",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "0479b8290fcc80d89af2b6f72ff681e3",
            "bad316ad74318a9f95d0749417edfa04",
            "Clobber Grotesk",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Rotation",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Rotation",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "fc2e33377af6aca34a9826245e325cba",
            "Rotation",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "35641bbe5146f945b85e1e7b34956a73",
            "Rotation",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "87791721b0238c72031ce39e346933a8",
            "Rotation",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "b832321e77d0f1be2c00712330066c3e",
            "Rotation",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Rotation",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Rotation",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Rotation",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "9e6867c857655e9d1984390fdf1dde45",
            "Rotation",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "b941ce467c4b7f2846b3226ae7988452",
            "Rotation",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "2af66ddecaa7893391cb90362043d37a",
            "Rotation",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Rotation",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Rotation",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "c63e8810388d85594540bb5f6980f611",
            "Rotation",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "Rotation",
            "Gill Sans MT Pro Book"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "095898e12700edc69d52ecf30ef03e2a",
            "Rotation",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "82550c10af201d56d90be26b8833ac63",
            "Rotation",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Rotation",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "0638a6154647ef8a772e7b46dd1d966d",
            "147f1bb910d4c3487efd5789736afc3b",
            "Rotation",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Mencken Std",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "8223719dee533eb7e895e0a101f4472c",
            "Mencken Std",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "f0249a1bec67973885bada20741c70c2",
            "Mencken Std",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "264a4ae29758ba917346fe9763531666",
            "Mencken Std",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "f01435736b8b73793ad270cdf379a860",
            "Mencken Std",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "ea90949476110422d67b9af4f8ace3a2",
            "Mencken Std",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Mencken Std",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Mencken Std",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Mencken Std",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Mencken Std",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Mencken Std",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Mencken Std",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Mencken Std",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "650bcadc2c69543d997704b29b7c50d2",
            "Mencken Std",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "d3caacfedf638f98ba7b0046f297f421",
            "Mencken Std",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Mencken Std",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Mencken Std",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "2af66ddecaa7893391cb90362043d37a",
            "Mencken Std",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "38b203ce41804d19e934461faf557ecb",
            "Mencken Std",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "06510c0260d17a867a598617cc3f59e9",
            "fc2e33377af6aca34a9826245e325cba",
            "Mencken Std",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "afb2c306772fbf472d6549a865bf7339",
            "Haboro Soft",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Haboro Soft",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "b127070b4065a62961b2bf60fb763a76",
            "Haboro Soft",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Haboro Soft",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Haboro Soft",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "8ebe3248143db352da56805017ca7934",
            "Haboro Soft",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Haboro Soft",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Haboro Soft",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Haboro Soft",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "50441227356a2e75a4737b2cfe84709b",
            "Haboro Soft",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Haboro Soft",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "5bd81732a879ba42412c19bd5a33589b",
            "Haboro Soft",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "8006330b215827a8efcd0e4c791bae76",
            "Haboro Soft",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "0669f30b065ee82a0ad8a34acb8af511",
            "013968ef381969722a37a334b48bbaeb",
            "Haboro Soft",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "b832321e77d0f1be2c00712330066c3e",
            "Trola",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "f01435736b8b73793ad270cdf379a860",
            "Trola",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "280c82457252f3613b33e3791c375caf",
            "Trola",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Trola",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Trola",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Trola",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Trola",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "264a4ae29758ba917346fe9763531666",
            "Trola",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "2af66ddecaa7893391cb90362043d37a",
            "Trola",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Trola",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "650bcadc2c69543d997704b29b7c50d2",
            "Trola",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Trola",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "9e6867c857655e9d1984390fdf1dde45",
            "Trola",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Trola",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "87791721b0238c72031ce39e346933a8",
            "Trola",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Trola",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "c63e8810388d85594540bb5f6980f611",
            "Trola",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "38c216ced240e8111b587a31e2fc5794",
            "Trola",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "b941ce467c4b7f2846b3226ae7988452",
            "Trola",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "06779a9920e25578b6f504fcbd0ca169",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Trola",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Le Monde Livre Std",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "b832321e77d0f1be2c00712330066c3e",
            "Le Monde Livre Std",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "c6ff032bd835e2f806009627251b87b6",
            "Le Monde Livre Std",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Le Monde Livre Std",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "033528c5f0137b017eff21079bd25a60",
            "Le Monde Livre Std",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "280c82457252f3613b33e3791c375caf",
            "Le Monde Livre Std",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Le Monde Livre Std",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "9e6867c857655e9d1984390fdf1dde45",
            "Le Monde Livre Std",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Le Monde Livre Std",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Le Monde Livre Std",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Le Monde Livre Std",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Le Monde Livre Std",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Le Monde Livre Std",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "35641bbe5146f945b85e1e7b34956a73",
            "Le Monde Livre Std",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "2af66ddecaa7893391cb90362043d37a",
            "Le Monde Livre Std",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "3d295205229224442c34a365d6b885d1",
            "Le Monde Livre Std",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "fbb9573728984c54a8ca446e19d0972a",
            "Le Monde Livre Std",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Le Monde Livre Std",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "51eb849300954cdecf9da1310c79beb2",
            "Le Monde Livre Std",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "073081f11751cb576e2b13de664766f6",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Le Monde Livre Std",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Averta",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Averta",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Averta",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Averta",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "b127070b4065a62961b2bf60fb763a76",
            "Averta",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "737e1d3f1693de9fd863057622d1bb02",
            "Averta",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "8ebe3248143db352da56805017ca7934",
            "Averta",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "3319dd949835e43d4bed270f465aff3e",
            "Averta",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Averta",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "cc3e79c959420501e528f6b20113c185",
            "Averta",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "c2722fea792cde12a9117da6e0d70f74",
            "Averta",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Averta",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "bad316ad74318a9f95d0749417edfa04",
            "Averta",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Averta",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Averta",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "b74bf78a743785e3df7e3f14477a1390",
            "Averta",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Averta",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "075ee4d8b4b2f2be685deae392ee79a8",
            "5bd81732a879ba42412c19bd5a33589b",
            "Averta",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Syntax",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Syntax",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Syntax",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "0a5055aaaa561e80e2b0d966a4db0190",
            "Syntax",
            "Hauteclaire"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "09d88839ee48108d4891334024ee38d1",
            "Syntax",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "c311a16ee279363b5113cbf699325577",
            "Syntax",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Syntax",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "73138474522e9719f1a246b6fff9af38",
            "Syntax",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "9001cd9b7b209eebef43419463ef6c40",
            "Syntax",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "88950808c1357581d744cc4f308d9f94",
            "Syntax",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "c638239ea03b75929bff2ce833419ac3",
            "Syntax",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Syntax",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "d87ffd42ab39a3412ab905084e31b782",
            "Syntax",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "Syntax",
            "Clifford Six Offc Pro"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "0f41ebd3d659da540745d00b52334eb0",
            "Syntax",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Syntax",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Syntax",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Syntax",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "d4df1a651052c6bd88be57660da085ac",
            "Syntax",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "090f944a52ed426dbc544297d0fb9442",
            "50441227356a2e75a4737b2cfe84709b",
            "Syntax",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "8ebe3248143db352da56805017ca7934",
            "Suprema",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Suprema",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "737e1d3f1693de9fd863057622d1bb02",
            "Suprema",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Suprema",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Suprema",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Suprema",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "9da983bd95342b2184596f18ef3fff34",
            "Suprema",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Suprema",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "b127070b4065a62961b2bf60fb763a76",
            "Suprema",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "d4df1a651052c6bd88be57660da085ac",
            "Suprema",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Suprema",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Suprema",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "c04f563b6a1457ae02100e98a49654c6",
            "Suprema",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "cd92499f5905694f796be4b7b3406e49",
            "Suprema",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Suprema",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Suprema",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "cc3e79c959420501e528f6b20113c185",
            "Suprema",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "c2722fea792cde12a9117da6e0d70f74",
            "Suprema",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Suprema",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "0948bcac8c88566853911db4a5ea95e7",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Suprema",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "103510159c0a328260730731e27eabe1",
            "Proza",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Proza",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Proza",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "2d0b4f3a328383b8486d150666306efe",
            "Proza",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Proza",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Proza",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "820a3fdbd8299ef1a164763cba53587e",
            "Proza",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "8c155b53e011d2a709548865b3edbeaf",
            "Proza",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "29093af656f979957ec5d657e96fb363",
            "Proza",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "d07f2481905eefa80fa98c464d59e260",
            "Proza",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "71ce2a4123e21bfb630f651363b756f3",
            "Proza",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "09d88839ee48108d4891334024ee38d1",
            "Proza",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Proza",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "Proza",
            "Malabar"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "34a814f80a793fa3eacde02882fa9faa",
            "Proza",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "623b4e42d48a5d620464ccf3c37cab13",
            "Proza",
            "Tabac Slab"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Proza",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "3d42e5b4eac967ce5300247f880dc1fa",
            "Proza",
            "BirkaLTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "7385300fc2a1109d8d286432af1fcb85",
            "Proza",
            "Garvis Pro"
        ]
    },
    {
        "likedPair": [
            "095898e12700edc69d52ecf30ef03e2a",
            "d87ffd42ab39a3412ab905084e31b782",
            "Proza",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "c7117e8442a401bc7dd78049829ef83b",
            "Delecta",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Delecta",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Delecta",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Delecta",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Delecta",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "b127070b4065a62961b2bf60fb763a76",
            "Delecta",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Delecta",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Delecta",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "095d77ca120193cc9eb748f725f54dc3",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Delecta",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "b832321e77d0f1be2c00712330066c3e",
            "Erato",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Erato",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "9e6867c857655e9d1984390fdf1dde45",
            "Erato",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "2af66ddecaa7893391cb90362043d37a",
            "Erato",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Erato",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Erato",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Erato",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "35641bbe5146f945b85e1e7b34956a73",
            "Erato",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "3d295205229224442c34a365d6b885d1",
            "Erato",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Erato",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Erato",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Erato",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Erato",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "c63e8810388d85594540bb5f6980f611",
            "Erato",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Erato",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Erato",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "b941ce467c4b7f2846b3226ae7988452",
            "Erato",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "095898e12700edc69d52ecf30ef03e2a",
            "Erato",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "fc2e33377af6aca34a9826245e325cba",
            "Erato",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "09d88839ee48108d4891334024ee38d1",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Erato",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "650bcadc2c69543d997704b29b7c50d2",
            "Cotford",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Cotford",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "fc2e33377af6aca34a9826245e325cba",
            "Cotford",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Cotford",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Cotford",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Cotford",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "de9599121cf31a08904a48495fadcf4a",
            "Cotford",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "38b203ce41804d19e934461faf557ecb",
            "Cotford",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Cotford",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "f01435736b8b73793ad270cdf379a860",
            "Cotford",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Cotford",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Cotford",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "d3caacfedf638f98ba7b0046f297f421",
            "Cotford",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "ea90949476110422d67b9af4f8ace3a2",
            "Cotford",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "f0249a1bec67973885bada20741c70c2",
            "Cotford",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Cotford",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "da5723a234527888e7dc5e19548f1abb",
            "Cotford",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "147f1bb910d4c3487efd5789736afc3b",
            "Cotford",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "ac04c5328af335b179cf1827997e1774",
            "Cotford",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "cae0af484abd406422956f9621c58b5f",
            "Cotford",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "033528c5f0137b017eff21079bd25a60",
            "Hauteclaire",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "de9599121cf31a08904a48495fadcf4a",
            "Hauteclaire",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Hauteclaire",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "f01435736b8b73793ad270cdf379a860",
            "Hauteclaire",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Hauteclaire",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "fc2e33377af6aca34a9826245e325cba",
            "Hauteclaire",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Hauteclaire",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "b24744ca2bf3616294271353ec837099",
            "Hauteclaire",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "264a4ae29758ba917346fe9763531666",
            "Hauteclaire",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Hauteclaire",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "9e6867c857655e9d1984390fdf1dde45",
            "Hauteclaire",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Hauteclaire",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Hauteclaire",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "147f1bb910d4c3487efd5789736afc3b",
            "Hauteclaire",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "c63e8810388d85594540bb5f6980f611",
            "Hauteclaire",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "b941ce467c4b7f2846b3226ae7988452",
            "Hauteclaire",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0a5055aaaa561e80e2b0d966a4db0190",
            "82550c10af201d56d90be26b8833ac63",
            "Hauteclaire",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "8ebe3248143db352da56805017ca7934",
            "Europa Grotesk No. 2 SB",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "737e1d3f1693de9fd863057622d1bb02",
            "Europa Grotesk No. 2 SB",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Europa Grotesk No. 2 SB",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "6d47953bebf6a23dc1d89764632524d8",
            "Europa Grotesk No. 2 SB",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Europa Grotesk No. 2 SB",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Europa Grotesk No. 2 SB",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Europa Grotesk No. 2 SB",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "5bd81732a879ba42412c19bd5a33589b",
            "Europa Grotesk No. 2 SB",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "955b9a400ce5accf68307eaad62c4f62",
            "Europa Grotesk No. 2 SB",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "386528d2feb209e45554ed0fa03d81ce",
            "Europa Grotesk No. 2 SB",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "3938fddd18b33d1b1549d30049d6e749",
            "Europa Grotesk No. 2 SB",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "b74bf78a743785e3df7e3f14477a1390",
            "Europa Grotesk No. 2 SB",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "ef0f22560e30896239545a852fd7f6b4",
            "Europa Grotesk No. 2 SB",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "cc3e79c959420501e528f6b20113c185",
            "Europa Grotesk No. 2 SB",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "bad316ad74318a9f95d0749417edfa04",
            "Europa Grotesk No. 2 SB",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Europa Grotesk No. 2 SB",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "0a990399fe7f1b376e846e602e3307bb",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Europa Grotesk No. 2 SB",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Analogia",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "b832321e77d0f1be2c00712330066c3e",
            "Analogia",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Analogia",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Analogia",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "b941ce467c4b7f2846b3226ae7988452",
            "Analogia",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Analogia",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "9e6867c857655e9d1984390fdf1dde45",
            "Analogia",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Analogia",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Analogia",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "c63e8810388d85594540bb5f6980f611",
            "Analogia",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "2af66ddecaa7893391cb90362043d37a",
            "Analogia",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Bookseller Cp",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Bookseller Cp",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Bookseller Cp",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "264a4ae29758ba917346fe9763531666",
            "Bookseller Cp",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "d3caacfedf638f98ba7b0046f297f421",
            "Bookseller Cp",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Bookseller Cp",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "650bcadc2c69543d997704b29b7c50d2",
            "Bookseller Cp",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "ea90949476110422d67b9af4f8ace3a2",
            "Bookseller Cp",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "fc2e33377af6aca34a9826245e325cba",
            "Bookseller Cp",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "87791721b0238c72031ce39e346933a8",
            "Bookseller Cp",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "2af66ddecaa7893391cb90362043d37a",
            "Bookseller Cp",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Bookseller Cp",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "c63e8810388d85594540bb5f6980f611",
            "Bookseller Cp",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0c9323cdeef74cc3aa89d65876366265",
            "147f1bb910d4c3487efd5789736afc3b",
            "Bookseller Cp",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "8ebe3248143db352da56805017ca7934",
            "Galano Grotesque",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Galano Grotesque",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Galano Grotesque",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "737e1d3f1693de9fd863057622d1bb02",
            "Galano Grotesque",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "b127070b4065a62961b2bf60fb763a76",
            "Galano Grotesque",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "6d47953bebf6a23dc1d89764632524d8",
            "Galano Grotesque",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Galano Grotesque",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "3319dd949835e43d4bed270f465aff3e",
            "Galano Grotesque",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Galano Grotesque",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "5bd81732a879ba42412c19bd5a33589b",
            "Galano Grotesque",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "cc3e79c959420501e528f6b20113c185",
            "Galano Grotesque",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "955b9a400ce5accf68307eaad62c4f62",
            "Galano Grotesque",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Galano Grotesque",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "b74bf78a743785e3df7e3f14477a1390",
            "Galano Grotesque",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "0db105f867c7eb2e491db586cc26b417",
            "bad316ad74318a9f95d0749417edfa04",
            "Galano Grotesque",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Aldine 401",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Aldine 401",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Aldine 401",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "fc2e33377af6aca34a9826245e325cba",
            "Aldine 401",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "35641bbe5146f945b85e1e7b34956a73",
            "Aldine 401",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "9e6867c857655e9d1984390fdf1dde45",
            "Aldine 401",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Aldine 401",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "51eb849300954cdecf9da1310c79beb2",
            "Aldine 401",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Aldine 401",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Aldine 401",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Aldine 401",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "2af66ddecaa7893391cb90362043d37a",
            "Aldine 401",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "c63e8810388d85594540bb5f6980f611",
            "Aldine 401",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "095898e12700edc69d52ecf30ef03e2a",
            "Aldine 401",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Aldine 401",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "b941ce467c4b7f2846b3226ae7988452",
            "Aldine 401",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0e157f1d6604d94abd495cc244aaf2cf",
            "82550c10af201d56d90be26b8833ac63",
            "Aldine 401",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "033528c5f0137b017eff21079bd25a60",
            "Bookmania",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Bookmania",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Bookmania",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Bookmania",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "f01435736b8b73793ad270cdf379a860",
            "Bookmania",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "fc2e33377af6aca34a9826245e325cba",
            "Bookmania",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "f0249a1bec67973885bada20741c70c2",
            "Bookmania",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Bookmania",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Bookmania",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Bookmania",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "264a4ae29758ba917346fe9763531666",
            "Bookmania",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Bookmania",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "38b203ce41804d19e934461faf557ecb",
            "Bookmania",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Bookmania",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Bookmania",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Bookmania",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "d159582398d0de4d0b367233acf587ee",
            "Bookmania",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "b941ce467c4b7f2846b3226ae7988452",
            "Bookmania",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "cae0af484abd406422956f9621c58b5f",
            "Bookmania",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "0f41ebd3d659da540745d00b52334eb0",
            "c74f77a345edf278a01b806459f255bb",
            "Bookmania",
            "Neufile Grotesk"
        ]
    },
    {
        "likedPair": [
            "0fac18b9ac2c906afd62d20f97322db7",
            "50441227356a2e75a4737b2cfe84709b",
            "Parisine Std",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "0fac18b9ac2c906afd62d20f97322db7",
            "c7117e8442a401bc7dd78049829ef83b",
            "Parisine Std",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "0fac18b9ac2c906afd62d20f97322db7",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Parisine Std",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Baskerville",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "033528c5f0137b017eff21079bd25a60",
            "Baskerville",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Baskerville",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Baskerville",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Baskerville",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Baskerville",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "fc2e33377af6aca34a9826245e325cba",
            "Baskerville",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "9e6867c857655e9d1984390fdf1dde45",
            "Baskerville",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "b24744ca2bf3616294271353ec837099",
            "Baskerville",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Baskerville",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "2af66ddecaa7893391cb90362043d37a",
            "Baskerville",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "51eb849300954cdecf9da1310c79beb2",
            "Baskerville",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Baskerville",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Baskerville",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "264a4ae29758ba917346fe9763531666",
            "Baskerville",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Baskerville",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Baskerville",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Baskerville",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "c63e8810388d85594540bb5f6980f611",
            "Baskerville",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "103510159c0a328260730731e27eabe1",
            "b941ce467c4b7f2846b3226ae7988452",
            "Baskerville",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "8ebe3248143db352da56805017ca7934",
            "Cerebri Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Cerebri Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "737e1d3f1693de9fd863057622d1bb02",
            "Cerebri Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Cerebri Sans",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Cerebri Sans",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Cerebri Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Cerebri Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Cerebri Sans",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "3319dd949835e43d4bed270f465aff3e",
            "Cerebri Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "9da983bd95342b2184596f18ef3fff34",
            "Cerebri Sans",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Cerebri Sans",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "b127070b4065a62961b2bf60fb763a76",
            "Cerebri Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "38f28a6682e9d705522a7ac7a715578f",
            "Cerebri Sans",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Cerebri Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "73e48b94c08d2015315dbceaf56efb62",
            "Cerebri Sans",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Cerebri Sans",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "6d47953bebf6a23dc1d89764632524d8",
            "Cerebri Sans",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "5bd81732a879ba42412c19bd5a33589b",
            "Cerebri Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Cerebri Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "10b488d59515233c5fd8a7f7a2ba3854",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Cerebri Sans",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "386528d2feb209e45554ed0fa03d81ce",
            "Ballinger",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "2c055a7f717a969a129cf78e586c2d39",
            "Ballinger",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "5bd81732a879ba42412c19bd5a33589b",
            "Ballinger",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "50441227356a2e75a4737b2cfe84709b",
            "Ballinger",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "8006330b215827a8efcd0e4c791bae76",
            "Ballinger",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "11a56cbb71e23af5abcff867473f961a",
            "013968ef381969722a37a334b48bbaeb",
            "Ballinger",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "033528c5f0137b017eff21079bd25a60",
            "QuaText",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "f0249a1bec67973885bada20741c70c2",
            "QuaText",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "QuaText",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "b24744ca2bf3616294271353ec837099",
            "QuaText",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "QuaText",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "264a4ae29758ba917346fe9763531666",
            "QuaText",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "b34fc5fd3820759a8808f554191ecaa2",
            "QuaText",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "QuaText",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "e1864ebcfe34672f435c3bedacde5d63",
            "QuaText",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "2af66ddecaa7893391cb90362043d37a",
            "QuaText",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "82550c10af201d56d90be26b8833ac63",
            "QuaText",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "fc2e33377af6aca34a9826245e325cba",
            "QuaText",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "QuaText",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "9e6867c857655e9d1984390fdf1dde45",
            "QuaText",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "c63e8810388d85594540bb5f6980f611",
            "QuaText",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "b941ce467c4b7f2846b3226ae7988452",
            "QuaText",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "51eb849300954cdecf9da1310c79beb2",
            "QuaText",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "095898e12700edc69d52ecf30ef03e2a",
            "QuaText",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "QuaText",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "c2244758e73a4caacb7f2916afe5f38f",
            "QuaText",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Monotype test family 4",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Monotype test family 4",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Monotype test family 4",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Monotype test family 4",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Monotype test family 4",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Monotype test family 4",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Monotype test family 4",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "d159582398d0de4d0b367233acf587ee",
            "Monotype test family 4",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "fbb9573728984c54a8ca446e19d0972a",
            "Monotype test family 4",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "b6249de3d08e3971282740ee906b6a8f",
            "Monotype test family 4",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "be1ed63669d6244408811624d948c116",
            "Monotype test family 4",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Monotype test family 4",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Monotype test family 4",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Monotype test family 4",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Monotype test family 4",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Monotype test family 4",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "d3caacfedf638f98ba7b0046f297f421",
            "Monotype test family 4",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "3bc3a738f4507b8feea7502049c474d2",
            "Monotype test family 4",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Monotype test family 4",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "11c4ab6960ee47d6066b255cd7f1b291",
            "da5723a234527888e7dc5e19548f1abb",
            "Monotype test family 4",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Brahma",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Brahma",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Brahma",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Brahma",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "b127070b4065a62961b2bf60fb763a76",
            "Brahma",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Brahma",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Brahma",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "b74bf78a743785e3df7e3f14477a1390",
            "Brahma",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "11d514603eca39c0093336bca857f707",
            "cc3e79c959420501e528f6b20113c185",
            "Brahma",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "3319dd949835e43d4bed270f465aff3e",
            "Resist Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Resist Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "5bd81732a879ba42412c19bd5a33589b",
            "Resist Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "386528d2feb209e45554ed0fa03d81ce",
            "Resist Sans",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Resist Sans",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "147f1bb910d4c3487efd5789736afc3b",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Resist Sans",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "TT Fors",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "cc3e79c959420501e528f6b20113c185",
            "TT Fors",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "TT Fors",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "b74bf78a743785e3df7e3f14477a1390",
            "TT Fors",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "TT Fors",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "cfbb9acb121612b62a247f211e51cb3e",
            "TT Fors",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "TT Fors",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "TT Fors",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "TT Fors",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "b127070b4065a62961b2bf60fb763a76",
            "TT Fors",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "8ebe3248143db352da56805017ca7934",
            "TT Fors",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "bad316ad74318a9f95d0749417edfa04",
            "TT Fors",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "3319dd949835e43d4bed270f465aff3e",
            "TT Fors",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "15a9cc3372552e8aca5c62396c19680c",
            "d515a6ca361cc9d1340762f79d8263dd",
            "TT Fors",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "HangulatinEN-Regular",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "8ebe3248143db352da56805017ca7934",
            "HangulatinEN-Regular",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "386528d2feb209e45554ed0fa03d81ce",
            "HangulatinEN-Regular",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "5bd81732a879ba42412c19bd5a33589b",
            "HangulatinEN-Regular",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "HangulatinEN-Regular",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "cc3e79c959420501e528f6b20113c185",
            "HangulatinEN-Regular",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "b74bf78a743785e3df7e3f14477a1390",
            "HangulatinEN-Regular",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "HangulatinEN-Regular",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "15f6440060216b78f6e867d5cf13fd85",
            "bad316ad74318a9f95d0749417edfa04",
            "HangulatinEN-Regular",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Yorkten",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "386528d2feb209e45554ed0fa03d81ce",
            "Yorkten",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "b127070b4065a62961b2bf60fb763a76",
            "Yorkten",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "2c055a7f717a969a129cf78e586c2d39",
            "Yorkten",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Yorkten",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "73e48b94c08d2015315dbceaf56efb62",
            "Yorkten",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Yorkten",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Yorkten",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Yorkten",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Yorkten",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "50441227356a2e75a4737b2cfe84709b",
            "Yorkten",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "Yorkten",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "cd92499f5905694f796be4b7b3406e49",
            "Yorkten",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "c7117e8442a401bc7dd78049829ef83b",
            "Yorkten",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "5bd81732a879ba42412c19bd5a33589b",
            "Yorkten",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Yorkten",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "8006330b215827a8efcd0e4c791bae76",
            "Yorkten",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "013968ef381969722a37a334b48bbaeb",
            "Yorkten",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Motiva Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "d4df1a651052c6bd88be57660da085ac",
            "Motiva Sans",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Motiva Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "0f41ebd3d659da540745d00b52334eb0",
            "Motiva Sans",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Motiva Sans",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Motiva Sans",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Motiva Sans",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "88950808c1357581d744cc4f308d9f94",
            "Motiva Sans",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Motiva Sans",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "2c055a7f717a969a129cf78e586c2d39",
            "Motiva Sans",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "b127070b4065a62961b2bf60fb763a76",
            "Motiva Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Motiva Sans",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "535f79f088e3c680b94a53258330a712",
            "Motiva Sans",
            "Cambria"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Motiva Sans",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Motiva Sans",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "73e48b94c08d2015315dbceaf56efb62",
            "Motiva Sans",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "06779a9920e25578b6f504fcbd0ca169",
            "Motiva Sans",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Motiva Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "e208cca764688975f3d7d3839228dea0",
            "Motiva Sans",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "185f07766a2c7cd46ff339e5993e5cac",
            "afb2c306772fbf472d6549a865bf7339",
            "Motiva Sans",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Supra Mezzo",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Supra Mezzo",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Supra Mezzo",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Supra Mezzo",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "Supra Mezzo",
            "Stempel Garamond LT"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Supra Mezzo",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Supra Mezzo",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Supra Mezzo",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "0a5055aaaa561e80e2b0d966a4db0190",
            "Supra Mezzo",
            "Hauteclaire"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "Supra Mezzo",
            "Life"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Supra Mezzo",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "29093af656f979957ec5d657e96fb363",
            "Supra Mezzo",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "afb2c306772fbf472d6549a865bf7339",
            "Supra Mezzo",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "Supra Mezzo",
            "Clifford Six Offc Pro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "5a7d711a8f8b9976093b3300e8961b83",
            "Supra Mezzo",
            "Harfang Pro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Supra Mezzo",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Supra Mezzo",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "09d88839ee48108d4891334024ee38d1",
            "Supra Mezzo",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Supra Mezzo",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "18a6d3e5a988d69effe05c4c405ce8db",
            "73e48b94c08d2015315dbceaf56efb62",
            "Supra Mezzo",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "18b27dd0e80d2f0a380a185f41e0dfed",
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "Andale Sans Paneuropean",
            "Urge Text"
        ]
    },
    {
        "likedPair": [
            "18b27dd0e80d2f0a380a185f41e0dfed",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Andale Sans Paneuropean",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "18b27dd0e80d2f0a380a185f41e0dfed",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Andale Sans Paneuropean",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "18b27dd0e80d2f0a380a185f41e0dfed",
            "8006330b215827a8efcd0e4c791bae76",
            "Andale Sans Paneuropean",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "PMN Caecilia",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "PMN Caecilia",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "3a2f35b17543f0f3464b26e080b16634",
            "PMN Caecilia",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "565f10ac096eb5d75c4400509e23cdc1",
            "PMN Caecilia",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "PMN Caecilia",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "952a354643df6c41226431ae4990f41e",
            "PMN Caecilia",
            "LCT Picon"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "c63e8810388d85594540bb5f6980f611",
            "PMN Caecilia",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "PMN Caecilia",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "PMN Caecilia",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "d84e985d428e023bb87368d43461b448",
            "PMN Caecilia",
            "SST"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "PMN Caecilia",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "47e848f1f1b998207926dfb024fa4a48",
            "PMN Caecilia",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "fbb9573728984c54a8ca446e19d0972a",
            "PMN Caecilia",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "c6ff032bd835e2f806009627251b87b6",
            "PMN Caecilia",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "d485fcb548b17f767a22bd95356d6208",
            "PMN Caecilia",
            "Albany"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "PMN Caecilia",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "PMN Caecilia",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "PMN Caecilia",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "095d77ca120193cc9eb748f725f54dc3",
            "PMN Caecilia",
            "Delecta"
        ]
    },
    {
        "likedPair": [
            "1a365ce6a76c9cbfa452f83d9946d984",
            "4a8d414c86f9aeae1489e72e6293e772",
            "PMN Caecilia",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "8ebe3248143db352da56805017ca7934",
            "Marlin Soft",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "737e1d3f1693de9fd863057622d1bb02",
            "Marlin Soft",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "3319dd949835e43d4bed270f465aff3e",
            "Marlin Soft",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Marlin Soft",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Marlin Soft",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Marlin Soft",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "b127070b4065a62961b2bf60fb763a76",
            "Marlin Soft",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "cc3e79c959420501e528f6b20113c185",
            "Marlin Soft",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Marlin Soft",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "5bd81732a879ba42412c19bd5a33589b",
            "Marlin Soft",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "1a4aadc1e9cfd1d4f9e3013e47a1c1a7",
            "bad316ad74318a9f95d0749417edfa04",
            "Marlin Soft",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "FF Infra",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "cfbb9acb121612b62a247f211e51cb3e",
            "FF Infra",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "b127070b4065a62961b2bf60fb763a76",
            "FF Infra",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FF Infra",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "FF Infra",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "FF Infra",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "3319dd949835e43d4bed270f465aff3e",
            "FF Infra",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "FF Infra",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "8ebe3248143db352da56805017ca7934",
            "FF Infra",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "FF Infra",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "FF Infra",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "d515a6ca361cc9d1340762f79d8263dd",
            "FF Infra",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "386528d2feb209e45554ed0fa03d81ce",
            "FF Infra",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "FF Infra",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "cc3e79c959420501e528f6b20113c185",
            "FF Infra",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "b74bf78a743785e3df7e3f14477a1390",
            "FF Infra",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "5bd81732a879ba42412c19bd5a33589b",
            "FF Infra",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "50441227356a2e75a4737b2cfe84709b",
            "FF Infra",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "bad316ad74318a9f95d0749417edfa04",
            "FF Infra",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "FF Infra",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Adriane Text",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Adriane Text",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Adriane Text",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Adriane Text",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "c63e8810388d85594540bb5f6980f611",
            "Adriane Text",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "fc2e33377af6aca34a9826245e325cba",
            "Adriane Text",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "cae0af484abd406422956f9621c58b5f",
            "Adriane Text",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "9e6867c857655e9d1984390fdf1dde45",
            "Adriane Text",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Adriane Text",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Adriane Text",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "82550c10af201d56d90be26b8833ac63",
            "Adriane Text",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "b941ce467c4b7f2846b3226ae7988452",
            "Adriane Text",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "095898e12700edc69d52ecf30ef03e2a",
            "Adriane Text",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Adriane Text",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "51eb849300954cdecf9da1310c79beb2",
            "Adriane Text",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "1c387720f951cd007d1fb579f87bdd9c",
            "386528d2feb209e45554ed0fa03d81ce",
            "Weissenhof Grotesk",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "1c387720f951cd007d1fb579f87bdd9c",
            "3319dd949835e43d4bed270f465aff3e",
            "Weissenhof Grotesk",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "1c387720f951cd007d1fb579f87bdd9c",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Weissenhof Grotesk",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "1c387720f951cd007d1fb579f87bdd9c",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Weissenhof Grotesk",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "b941ce467c4b7f2846b3226ae7988452",
            "Frasa",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "c63e8810388d85594540bb5f6980f611",
            "Frasa",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Frasa",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Frasa",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "b832321e77d0f1be2c00712330066c3e",
            "Frasa",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Frasa",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "c74f77a345edf278a01b806459f255bb",
            "Frasa",
            "Neufile Grotesk"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Frasa",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Frasa",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "095898e12700edc69d52ecf30ef03e2a",
            "Frasa",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Frasa",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Frasa",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Frasa",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "51eb849300954cdecf9da1310c79beb2",
            "Frasa",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "fc2e33377af6aca34a9826245e325cba",
            "Frasa",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "82550c10af201d56d90be26b8833ac63",
            "Frasa",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Frasa",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Frasa",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Frasa",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "1da195e3a02574262794aed0d1fdb6a3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Frasa",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "b832321e77d0f1be2c00712330066c3e",
            "Kievit Serif W02 Regular",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Kievit Serif W02 Regular",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Kievit Serif W02 Regular",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "b941ce467c4b7f2846b3226ae7988452",
            "Kievit Serif W02 Regular",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Kievit Serif W02 Regular",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Kievit Serif W02 Regular",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "2af66ddecaa7893391cb90362043d37a",
            "Kievit Serif W02 Regular",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "38c216ced240e8111b587a31e2fc5794",
            "Kievit Serif W02 Regular",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "c63e8810388d85594540bb5f6980f611",
            "Kievit Serif W02 Regular",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Kievit Serif W02 Regular",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "35641bbe5146f945b85e1e7b34956a73",
            "Kievit Serif W02 Regular",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "9e6867c857655e9d1984390fdf1dde45",
            "Kievit Serif W02 Regular",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Kievit Serif W02 Regular",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "095898e12700edc69d52ecf30ef03e2a",
            "Kievit Serif W02 Regular",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Kievit Serif W02 Regular",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Kievit Serif W02 Regular",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "fc2e33377af6aca34a9826245e325cba",
            "Kievit Serif W02 Regular",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "51eb849300954cdecf9da1310c79beb2",
            "Kievit Serif W02 Regular",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Kievit Serif W02 Regular",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Kievit Serif W02 Regular",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "8c155b53e011d2a709548865b3edbeaf",
            "Clarika Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Clarika Pro",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Clarika Pro",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "73138474522e9719f1a246b6fff9af38",
            "Clarika Pro",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Clarika Pro",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Clarika Pro",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "afb2c306772fbf472d6549a865bf7339",
            "Clarika Pro",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Clarika Pro",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Clarika Pro",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Clarika Pro",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "9001cd9b7b209eebef43419463ef6c40",
            "Clarika Pro",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "103510159c0a328260730731e27eabe1",
            "Clarika Pro",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "dfa259ce11399457b3760878b733756c",
            "Clarika Pro",
            "BerlingLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "d87ffd42ab39a3412ab905084e31b782",
            "Clarika Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Clarika Pro",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "b127070b4065a62961b2bf60fb763a76",
            "Clarika Pro",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Clarika Pro",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "29093af656f979957ec5d657e96fb363",
            "Clarika Pro",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "858170a34ed4538c4ce46be2fa57f670",
            "Clarika Pro",
            "MVB Verdigris Pro"
        ]
    },
    {
        "likedPair": [
            "1ef83e490f20960c356d5bc893c42abe",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Clarika Pro",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "b832321e77d0f1be2c00712330066c3e",
            "Rotis Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "2b443d68adf1ec97623afac779dc9572",
            "Rotis Serif",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "38c216ced240e8111b587a31e2fc5794",
            "Rotis Serif",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "87791721b0238c72031ce39e346933a8",
            "Rotis Serif",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "9e6867c857655e9d1984390fdf1dde45",
            "Rotis Serif",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Rotis Serif",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Rotis Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "2af66ddecaa7893391cb90362043d37a",
            "Rotis Serif",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "c63e8810388d85594540bb5f6980f611",
            "Rotis Serif",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "1f3274d316974b1bdeb5130953af9049",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Rotis Serif",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "2c055a7f717a969a129cf78e586c2d39",
            "Specify",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Specify",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "386528d2feb209e45554ed0fa03d81ce",
            "Specify",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Specify",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "ef0f22560e30896239545a852fd7f6b4",
            "Specify",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "Specify",
            "FF Franziska"
        ]
    },
    {
        "likedPair": [
            "207f1b88d937a2dd587e13d9edc6cb57",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Specify",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "2af66ddecaa7893391cb90362043d37a",
            "Malabar",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "c6ff032bd835e2f806009627251b87b6",
            "Malabar",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "c63e8810388d85594540bb5f6980f611",
            "Malabar",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "b941ce467c4b7f2846b3226ae7988452",
            "Malabar",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "b832321e77d0f1be2c00712330066c3e",
            "Malabar",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "952a354643df6c41226431ae4990f41e",
            "Malabar",
            "LCT Picon"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Malabar",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Malabar",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "51eb849300954cdecf9da1310c79beb2",
            "Malabar",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "280c82457252f3613b33e3791c375caf",
            "Malabar",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "095898e12700edc69d52ecf30ef03e2a",
            "Malabar",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "9e6867c857655e9d1984390fdf1dde45",
            "Malabar",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Malabar",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "82550c10af201d56d90be26b8833ac63",
            "Malabar",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Malabar",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Malabar",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Malabar",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Malabar",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Malabar",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "87791721b0238c72031ce39e346933a8",
            "Malabar",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "CentaurMTPro-Regular",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "CentaurMTPro-Regular",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "fc2e33377af6aca34a9826245e325cba",
            "CentaurMTPro-Regular",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "CentaurMTPro-Regular",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "9e6867c857655e9d1984390fdf1dde45",
            "CentaurMTPro-Regular",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "c63e8810388d85594540bb5f6980f611",
            "CentaurMTPro-Regular",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "c2244758e73a4caacb7f2916afe5f38f",
            "CentaurMTPro-Regular",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "91f1a74434b4ecc9129239ec3e236b42",
            "CentaurMTPro-Regular",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "220ceb5c6cb3ba824b8297fe8e2c9f3b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "CentaurMTPro-Regular",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "RemingaPro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "RemingaPro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "033528c5f0137b017eff21079bd25a60",
            "RemingaPro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "RemingaPro",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "b34fc5fd3820759a8808f554191ecaa2",
            "RemingaPro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "4a8d414c86f9aeae1489e72e6293e772",
            "RemingaPro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "b24744ca2bf3616294271353ec837099",
            "RemingaPro",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "b832321e77d0f1be2c00712330066c3e",
            "RemingaPro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "9e6867c857655e9d1984390fdf1dde45",
            "RemingaPro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "RemingaPro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "RemingaPro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "3d295205229224442c34a365d6b885d1",
            "RemingaPro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "2af66ddecaa7893391cb90362043d37a",
            "RemingaPro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "b941ce467c4b7f2846b3226ae7988452",
            "RemingaPro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "RemingaPro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "RemingaPro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "RemingaPro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "095898e12700edc69d52ecf30ef03e2a",
            "RemingaPro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "91f1a74434b4ecc9129239ec3e236b42",
            "RemingaPro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "22556e70e77a4ba87864ff6dbd2862cc",
            "c2244758e73a4caacb7f2916afe5f38f",
            "RemingaPro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "8ebe3248143db352da56805017ca7934",
            "Figgins Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Figgins Sans",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Figgins Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Figgins Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "3319dd949835e43d4bed270f465aff3e",
            "Figgins Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Figgins Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "b74bf78a743785e3df7e3f14477a1390",
            "Figgins Sans",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "5bd81732a879ba42412c19bd5a33589b",
            "Figgins Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Figgins Sans",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "238bab934db66c57e475fb05d567c3b1",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Figgins Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "c6ff032bd835e2f806009627251b87b6",
            "Rooney",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Rooney",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "b941ce467c4b7f2846b3226ae7988452",
            "Rooney",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Rooney",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "d84e985d428e023bb87368d43461b448",
            "Rooney",
            "SST"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "095898e12700edc69d52ecf30ef03e2a",
            "Rooney",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Rooney",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Rooney",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "b832321e77d0f1be2c00712330066c3e",
            "Rooney",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Rooney",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Rooney",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "9e6867c857655e9d1984390fdf1dde45",
            "Rooney",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Rooney",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Rooney",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "d18f103cfa62513f991b0f90a814c333",
            "Rooney",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Rooney",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Rooney",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "2b443d68adf1ec97623afac779dc9572",
            "Rooney",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Rooney",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Rooney",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Gramatika",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "737e1d3f1693de9fd863057622d1bb02",
            "Gramatika",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gramatika",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "9da983bd95342b2184596f18ef3fff34",
            "Gramatika",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Gramatika",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "c7117e8442a401bc7dd78049829ef83b",
            "Gramatika",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Gramatika",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "6d47953bebf6a23dc1d89764632524d8",
            "Gramatika",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gramatika",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Gramatika",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Gramatika",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Gramatika",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "8ebe3248143db352da56805017ca7934",
            "Gramatika",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "5bd81732a879ba42412c19bd5a33589b",
            "Gramatika",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Gramatika",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Gramatika",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "c2722fea792cde12a9117da6e0d70f74",
            "Gramatika",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "cd92499f5905694f796be4b7b3406e49",
            "Gramatika",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "b127070b4065a62961b2bf60fb763a76",
            "Gramatika",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "24a0ecdd21c41c5d04a52d5a90e3bfa0",
            "955b9a400ce5accf68307eaad62c4f62",
            "Gramatika",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Zapf Calligraphic 801",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Zapf Calligraphic 801",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Zapf Calligraphic 801",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Zapf Calligraphic 801",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "033528c5f0137b017eff21079bd25a60",
            "Zapf Calligraphic 801",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "b832321e77d0f1be2c00712330066c3e",
            "Zapf Calligraphic 801",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Zapf Calligraphic 801",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Zapf Calligraphic 801",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Zapf Calligraphic 801",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "35641bbe5146f945b85e1e7b34956a73",
            "Zapf Calligraphic 801",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Zapf Calligraphic 801",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Zapf Calligraphic 801",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Zapf Calligraphic 801",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "7ff70643804e5a751a56a4efdce38b87",
            "Zapf Calligraphic 801",
            "Aspira"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "9e6867c857655e9d1984390fdf1dde45",
            "Zapf Calligraphic 801",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Zapf Calligraphic 801",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Zapf Calligraphic 801",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "c63e8810388d85594540bb5f6980f611",
            "Zapf Calligraphic 801",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Zapf Calligraphic 801",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "3d295205229224442c34a365d6b885d1",
            "Zapf Calligraphic 801",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Mundo Serif",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Mundo Serif",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Mundo Serif",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "3a2f35b17543f0f3464b26e080b16634",
            "Mundo Serif",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Mundo Serif",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Mundo Serif",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Mundo Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Mundo Serif",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "b832321e77d0f1be2c00712330066c3e",
            "Mundo Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Mundo Serif",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Mundo Serif",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "001114826556952bb283044f915f1d9c",
            "Mundo Serif",
            "Comenia Sans"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Mundo Serif",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "280c82457252f3613b33e3791c375caf",
            "Mundo Serif",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Mundo Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Mundo Serif",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "c63e8810388d85594540bb5f6980f611",
            "Mundo Serif",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Mundo Serif",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "b941ce467c4b7f2846b3226ae7988452",
            "Mundo Serif",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "24d5d362d6d70239379cd1f356e168ec",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Mundo Serif",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "737e1d3f1693de9fd863057622d1bb02",
            "Quarion",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "6d47953bebf6a23dc1d89764632524d8",
            "Quarion",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Quarion",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Quarion",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "8ebe3248143db352da56805017ca7934",
            "Quarion",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Quarion",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "5bd81732a879ba42412c19bd5a33589b",
            "Quarion",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Quarion",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "c2722fea792cde12a9117da6e0d70f74",
            "Quarion",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "b74bf78a743785e3df7e3f14477a1390",
            "Quarion",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Quarion",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "955b9a400ce5accf68307eaad62c4f62",
            "Quarion",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "b127070b4065a62961b2bf60fb763a76",
            "Quarion",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Quarion",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "cc3e79c959420501e528f6b20113c185",
            "Quarion",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "256f7672059f72846d940fbd8c97537d",
            "bad316ad74318a9f95d0749417edfa04",
            "Quarion",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "fc2e33377af6aca34a9826245e325cba",
            "Utopia",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "8223719dee533eb7e895e0a101f4472c",
            "Utopia",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "de9599121cf31a08904a48495fadcf4a",
            "Utopia",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Utopia",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "f0249a1bec67973885bada20741c70c2",
            "Utopia",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Utopia",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "d3caacfedf638f98ba7b0046f297f421",
            "Utopia",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "650bcadc2c69543d997704b29b7c50d2",
            "Utopia",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "11a56cbb71e23af5abcff867473f961a",
            "Utopia",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Utopia",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Utopia",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Utopia",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "f01435736b8b73793ad270cdf379a860",
            "Utopia",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Utopia",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Utopia",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "38b203ce41804d19e934461faf557ecb",
            "Utopia",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "87791721b0238c72031ce39e346933a8",
            "Utopia",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "ea90949476110422d67b9af4f8ace3a2",
            "Utopia",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "264a4ae29758ba917346fe9763531666",
            "Utopia",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Utopia",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "de9599121cf31a08904a48495fadcf4a",
            "Kepler",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "033528c5f0137b017eff21079bd25a60",
            "Kepler",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "fc2e33377af6aca34a9826245e325cba",
            "Kepler",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Kepler",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Kepler",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Kepler",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Kepler",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Kepler",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "f0249a1bec67973885bada20741c70c2",
            "Kepler",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Kepler",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "87791721b0238c72031ce39e346933a8",
            "Kepler",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Kepler",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "d3caacfedf638f98ba7b0046f297f421",
            "Kepler",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "f01435736b8b73793ad270cdf379a860",
            "Kepler",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "650bcadc2c69543d997704b29b7c50d2",
            "Kepler",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "38b203ce41804d19e934461faf557ecb",
            "Kepler",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Kepler",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Kepler",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "d159582398d0de4d0b367233acf587ee",
            "Kepler",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "263b7ffd57470af21ec49d7a144c4f23",
            "9e6867c857655e9d1984390fdf1dde45",
            "Kepler",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "e208cca764688975f3d7d3839228dea0",
            "News Gothic",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "e28128adc0e75357f447267c07afb6a6",
            "News Gothic",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "88950808c1357581d744cc4f308d9f94",
            "News Gothic",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "50441227356a2e75a4737b2cfe84709b",
            "News Gothic",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "News Gothic",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "6e4bf0177f0e1b459e2b159545de1181",
            "News Gothic",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "bbce3951159f83e9c2239d39fd666ce5",
            "News Gothic",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "c6bae55c030fe9df4104274e7fa5df57",
            "News Gothic",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "336870775fb3762c36c707da37eabadf",
            "News Gothic",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "06510c0260d17a867a598617cc3f59e9",
            "News Gothic",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "News Gothic",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "News Gothic",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "News Gothic",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "9ab5daa5796d80adb55febe5da072e8a",
            "News Gothic",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "06779a9920e25578b6f504fcbd0ca169",
            "News Gothic",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "263b7ffd57470af21ec49d7a144c4f23",
            "News Gothic",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "36ca5bc123f848ac643b6d50602259b7",
            "News Gothic",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "4b69cc4ce483966efd99a637882c74a5",
            "News Gothic",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "News Gothic",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "264a4ae29758ba917346fe9763531666",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "News Gothic",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "26830556eeeb7d475fc5a6e1f5ee3c84",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Prelo",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "c6ff032bd835e2f806009627251b87b6",
            "Sirba",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "b832321e77d0f1be2c00712330066c3e",
            "Sirba",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "d84e985d428e023bb87368d43461b448",
            "Sirba",
            "SST"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "38c216ced240e8111b587a31e2fc5794",
            "Sirba",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "2af66ddecaa7893391cb90362043d37a",
            "Sirba",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "280c82457252f3613b33e3791c375caf",
            "Sirba",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Sirba",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Sirba",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Sirba",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "3a2f35b17543f0f3464b26e080b16634",
            "Sirba",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "9e6867c857655e9d1984390fdf1dde45",
            "Sirba",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Sirba",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Sirba",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Sirba",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Sirba",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "c63e8810388d85594540bb5f6980f611",
            "Sirba",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Sirba",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Sirba",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Sirba",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "2721d6b75a2c057ffe99cad685d1da58",
            "b941ce467c4b7f2846b3226ae7988452",
            "Sirba",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "0f41ebd3d659da540745d00b52334eb0",
            "DF Dejavu Pro",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "e208cca764688975f3d7d3839228dea0",
            "DF Dejavu Pro",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "8171bb293a9276179ab81d26551b93c1",
            "DF Dejavu Pro",
            "Passenger Serif"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "DF Dejavu Pro",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "06510c0260d17a867a598617cc3f59e9",
            "DF Dejavu Pro",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "DF Dejavu Pro",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "c7117e8442a401bc7dd78049829ef83b",
            "DF Dejavu Pro",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "9ab5daa5796d80adb55febe5da072e8a",
            "DF Dejavu Pro",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "50441227356a2e75a4737b2cfe84709b",
            "DF Dejavu Pro",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "DF Dejavu Pro",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "DF Dejavu Pro",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "DF Dejavu Pro",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "06779a9920e25578b6f504fcbd0ca169",
            "DF Dejavu Pro",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "DF Dejavu Pro",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "DF Dejavu Pro",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "be483d1a100a556f9456d2ab176fd0c9",
            "DF Dejavu Pro",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "0638a6154647ef8a772e7b46dd1d966d",
            "DF Dejavu Pro",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "36c50039d788bccb71ca83a792b63c1c",
            "DF Dejavu Pro",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "DF Dejavu Pro",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "273eda1510f145ddc8cfd8bc72824d1c",
            "6e4bf0177f0e1b459e2b159545de1181",
            "DF Dejavu Pro",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "27f7de8b2e836231f2c4d0c3785748d8",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Gloriola",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "27f7de8b2e836231f2c4d0c3785748d8",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Gloriola",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "27f7de8b2e836231f2c4d0c3785748d8",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Gloriola",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Wayfinding Sans Pro",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "09d88839ee48108d4891334024ee38d1",
            "Wayfinding Sans Pro",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Wayfinding Sans Pro",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "d07f2481905eefa80fa98c464d59e260",
            "Wayfinding Sans Pro",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Wayfinding Sans Pro",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Wayfinding Sans Pro",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Wayfinding Sans Pro",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "73e48b94c08d2015315dbceaf56efb62",
            "Wayfinding Sans Pro",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Wayfinding Sans Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Wayfinding Sans Pro",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "d87ffd42ab39a3412ab905084e31b782",
            "Wayfinding Sans Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "c311a16ee279363b5113cbf699325577",
            "Wayfinding Sans Pro",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Wayfinding Sans Pro",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "73138474522e9719f1a246b6fff9af38",
            "Wayfinding Sans Pro",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Wayfinding Sans Pro",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "8c155b53e011d2a709548865b3edbeaf",
            "Wayfinding Sans Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "cd92499f5905694f796be4b7b3406e49",
            "Wayfinding Sans Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "c638239ea03b75929bff2ce833419ac3",
            "Wayfinding Sans Pro",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "9001cd9b7b209eebef43419463ef6c40",
            "Wayfinding Sans Pro",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "280c82457252f3613b33e3791c375caf",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Wayfinding Sans Pro",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "8c155b53e011d2a709548865b3edbeaf",
            "Typold",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "cd92499f5905694f796be4b7b3406e49",
            "Typold",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Typold",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Typold",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Typold",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Typold",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "67aadae90ce6049659422a925a8a23d4",
            "Typold",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "c2722fea792cde12a9117da6e0d70f74",
            "Typold",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Typold",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Typold",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "013968ef381969722a37a334b48bbaeb",
            "Typold",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "cc3e79c959420501e528f6b20113c185",
            "Typold",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "b74bf78a743785e3df7e3f14477a1390",
            "Typold",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "bad316ad74318a9f95d0749417edfa04",
            "Typold",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "2836c06f795c236900263fe1e17d245a",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Typold",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "ab8c8aff3daa79ef0b99a7365b29875b",
            "Pepi/Rudi",
            "Qanelas"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Pepi/Rudi",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "a0738796db0c7d83d8ba2c54fde1bbaf",
            "Pepi/Rudi",
            "Eina"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "7baec41a3ec1d0673c5a53cff12839b2",
            "Pepi/Rudi",
            "Applied Sans"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Pepi/Rudi",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "03ba201f7613be300cec0afc83ee295a",
            "Pepi/Rudi",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Pepi/Rudi",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "256f7672059f72846d940fbd8c97537d",
            "Pepi/Rudi",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "cae0af484abd406422956f9621c58b5f",
            "Pepi/Rudi",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Pepi/Rudi",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "d159582398d0de4d0b367233acf587ee",
            "Pepi/Rudi",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Pepi/Rudi",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "3bc3a738f4507b8feea7502049c474d2",
            "Pepi/Rudi",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "ac04c5328af335b179cf1827997e1774",
            "Pepi/Rudi",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Pepi/Rudi",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Pepi/Rudi",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Pepi/Rudi",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Pepi/Rudi",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "57cdd235481768dc73076d8a49a44353",
            "Pepi/Rudi",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "284341274e9b9e7088536bfd0b0fe5c9",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Pepi/Rudi",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Gill Sans MT Pro Book",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Gill Sans MT Pro Book",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gill Sans MT Pro Book",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Gill Sans MT Pro Book",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "b127070b4065a62961b2bf60fb763a76",
            "Gill Sans MT Pro Book",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gill Sans MT Pro Book",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Gill Sans MT Pro Book",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Gill Sans MT Pro Book",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Gill Sans MT Pro Book",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "c7117e8442a401bc7dd78049829ef83b",
            "Gill Sans MT Pro Book",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "c04f563b6a1457ae02100e98a49654c6",
            "Gill Sans MT Pro Book",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "0f41ebd3d659da540745d00b52334eb0",
            "Gill Sans MT Pro Book",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "8c155b53e011d2a709548865b3edbeaf",
            "Gill Sans MT Pro Book",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Gill Sans MT Pro Book",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Gill Sans MT Pro Book",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "d87ffd42ab39a3412ab905084e31b782",
            "Gill Sans MT Pro Book",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Gill Sans MT Pro Book",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "3319dd949835e43d4bed270f465aff3e",
            "Gill Sans MT Pro Book",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "c2722fea792cde12a9117da6e0d70f74",
            "Gill Sans MT Pro Book",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "Gill Sans MT Pro Book",
            "Urge Text"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "CalistoMTPro",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "de9599121cf31a08904a48495fadcf4a",
            "CalistoMTPro",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "033528c5f0137b017eff21079bd25a60",
            "CalistoMTPro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "CalistoMTPro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "b34fc5fd3820759a8808f554191ecaa2",
            "CalistoMTPro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "CalistoMTPro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "4a8d414c86f9aeae1489e72e6293e772",
            "CalistoMTPro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "9e6867c857655e9d1984390fdf1dde45",
            "CalistoMTPro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "35641bbe5146f945b85e1e7b34956a73",
            "CalistoMTPro",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "b24744ca2bf3616294271353ec837099",
            "CalistoMTPro",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "CalistoMTPro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "3d295205229224442c34a365d6b885d1",
            "CalistoMTPro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "e1864ebcfe34672f435c3bedacde5d63",
            "CalistoMTPro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "fc2e33377af6aca34a9826245e325cba",
            "CalistoMTPro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "2af66ddecaa7893391cb90362043d37a",
            "CalistoMTPro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "CalistoMTPro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "CalistoMTPro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "264a4ae29758ba917346fe9763531666",
            "CalistoMTPro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "51eb849300954cdecf9da1310c79beb2",
            "CalistoMTPro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "29093af656f979957ec5d657e96fb363",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "CalistoMTPro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "2af66ddecaa7893391cb90362043d37a",
            "Mastro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "c6ff032bd835e2f806009627251b87b6",
            "Mastro",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "d84e985d428e023bb87368d43461b448",
            "Mastro",
            "SST"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "b832321e77d0f1be2c00712330066c3e",
            "Mastro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "c63e8810388d85594540bb5f6980f611",
            "Mastro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Mastro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "095898e12700edc69d52ecf30ef03e2a",
            "Mastro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Mastro",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Mastro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Mastro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "b941ce467c4b7f2846b3226ae7988452",
            "Mastro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "9e6867c857655e9d1984390fdf1dde45",
            "Mastro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "280c82457252f3613b33e3791c375caf",
            "Mastro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "3a2f35b17543f0f3464b26e080b16634",
            "Mastro",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Mastro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Mastro",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "2980338e1101915cd8cf85fec19fd126",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Mastro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "cd92499f5905694f796be4b7b3406e49",
            "Bw Modelica",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Bw Modelica",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Bw Modelica",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "8c155b53e011d2a709548865b3edbeaf",
            "Bw Modelica",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Bw Modelica",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Bw Modelica",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "2e21709bc8f416319384ac99bb85cfeb",
            "Bw Modelica",
            "ITC Giovanni"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "103510159c0a328260730731e27eabe1",
            "Bw Modelica",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "73e48b94c08d2015315dbceaf56efb62",
            "Bw Modelica",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Bw Modelica",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Bw Modelica",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "34a814f80a793fa3eacde02882fa9faa",
            "Bw Modelica",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Bw Modelica",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "dfa259ce11399457b3760878b733756c",
            "Bw Modelica",
            "BerlingLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Bw Modelica",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Bw Modelica",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Bw Modelica",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "6d47953bebf6a23dc1d89764632524d8",
            "Bw Modelica",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "820a3fdbd8299ef1a164763cba53587e",
            "Bw Modelica",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "29a6581b869f16aa3cabe07a44fe75b1",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Bw Modelica",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "d87ffd42ab39a3412ab905084e31b782",
            "Multiple",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "6badb2797a95a552c53a98a0f20c903b",
            "Multiple",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "9ded3c33a83728124405e311fff63b40",
            "Multiple",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Multiple",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Multiple",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Multiple",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Multiple",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Multiple",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "c638239ea03b75929bff2ce833419ac3",
            "Multiple",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Multiple",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "c311a16ee279363b5113cbf699325577",
            "Multiple",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Multiple",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Multiple",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Multiple",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Multiple",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Multiple",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Multiple",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "cd92499f5905694f796be4b7b3406e49",
            "Multiple",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "24d5d362d6d70239379cd1f356e168ec",
            "Multiple",
            "Mundo Serif"
        ]
    },
    {
        "likedPair": [
            "2a952aa3d79c1da6126e5a070654b0b5",
            "1f3274d316974b1bdeb5130953af9049",
            "Multiple",
            "Rotis Serif"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Foundry Sans",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Foundry Sans",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "e208cca764688975f3d7d3839228dea0",
            "Foundry Sans",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "afb2c306772fbf472d6549a865bf7339",
            "Foundry Sans",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "c04f563b6a1457ae02100e98a49654c6",
            "Foundry Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Foundry Sans",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Foundry Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "35ffcac4445202ebcfefa85630823de6",
            "Foundry Sans",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Foundry Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "ef71628ba1ab6310365a78c263679726",
            "Foundry Sans",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "d07f2481905eefa80fa98c464d59e260",
            "Foundry Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Foundry Sans",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "2980338e1101915cd8cf85fec19fd126",
            "Foundry Sans",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "336870775fb3762c36c707da37eabadf",
            "Foundry Sans",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "20a4f61e68e7f6cf6c9801b39b2c8234",
            "Foundry Sans",
            "Malabar"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Foundry Sans",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "6f624e656d641d366084d9fabaa1fd6a",
            "Foundry Sans",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Foundry Sans",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Foundry Sans",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "2af66ddecaa7893391cb90362043d37a",
            "06779a9920e25578b6f504fcbd0ca169",
            "Foundry Sans",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Akagi",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "d87ffd42ab39a3412ab905084e31b782",
            "Akagi",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Akagi",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Akagi",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Akagi",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Akagi",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Akagi",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "c87f74a6084f73fdad817b1589a48a08",
            "Akagi",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "e28128adc0e75357f447267c07afb6a6",
            "Akagi",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "Akagi",
            "Synerga Pro"
        ]
    },
    {
        "likedPair": [
            "2b443d68adf1ec97623afac779dc9572",
            "e0d397e073f334bdc40410c8c4093d9b",
            "Akagi",
            "Alkes"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Corporate E",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "38b203ce41804d19e934461faf557ecb",
            "Corporate E",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "033528c5f0137b017eff21079bd25a60",
            "Corporate E",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Corporate E",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Corporate E",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Corporate E",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Corporate E",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Corporate E",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Corporate E",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Corporate E",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "de9599121cf31a08904a48495fadcf4a",
            "Corporate E",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "93b4e55aa9798f96b3a365a441a2238d",
            "Corporate E",
            "Oslo"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Corporate E",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Corporate E",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "090f944a52ed426dbc544297d0fb9442",
            "Corporate E",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Corporate E",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "5efbd0a384381addc2263997954251be",
            "Corporate E",
            "Tazugane Gothic"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Corporate E",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "fbb9573728984c54a8ca446e19d0972a",
            "Corporate E",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "2c055a7f717a969a129cf78e586c2d39",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Corporate E",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Celias",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "8ebe3248143db352da56805017ca7934",
            "Celias",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "67aadae90ce6049659422a925a8a23d4",
            "Celias",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "c2722fea792cde12a9117da6e0d70f74",
            "Celias",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Celias",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "cd92499f5905694f796be4b7b3406e49",
            "Celias",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "8c155b53e011d2a709548865b3edbeaf",
            "Celias",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "cc3e79c959420501e528f6b20113c185",
            "Celias",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "6d47953bebf6a23dc1d89764632524d8",
            "Celias",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Celias",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "2c3e98d17368b0b428cff1d0c384d032",
            "bad316ad74318a9f95d0749417edfa04",
            "Celias",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Sabon Next",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "b832321e77d0f1be2c00712330066c3e",
            "Sabon Next",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Sabon Next",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "b941ce467c4b7f2846b3226ae7988452",
            "Sabon Next",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Sabon Next",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Sabon Next",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "9e6867c857655e9d1984390fdf1dde45",
            "Sabon Next",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "2af66ddecaa7893391cb90362043d37a",
            "Sabon Next",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Sabon Next",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "c63e8810388d85594540bb5f6980f611",
            "Sabon Next",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Sabon Next",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "82550c10af201d56d90be26b8833ac63",
            "Sabon Next",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "2d0b4f3a328383b8486d150666306efe",
            "147f1bb910d4c3487efd5789736afc3b",
            "Sabon Next",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "e850c1a19f5dd604e85d62b658f34d62",
            "V&W Syntax (Adobe)",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "0a5055aaaa561e80e2b0d966a4db0190",
            "V&W Syntax (Adobe)",
            "Hauteclaire"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "09d88839ee48108d4891334024ee38d1",
            "V&W Syntax (Adobe)",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "73138474522e9719f1a246b6fff9af38",
            "V&W Syntax (Adobe)",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "9001cd9b7b209eebef43419463ef6c40",
            "V&W Syntax (Adobe)",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "c638239ea03b75929bff2ce833419ac3",
            "V&W Syntax (Adobe)",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "88950808c1357581d744cc4f308d9f94",
            "V&W Syntax (Adobe)",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "V&W Syntax (Adobe)",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "7385300fc2a1109d8d286432af1fcb85",
            "V&W Syntax (Adobe)",
            "Garvis Pro"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "V&W Syntax (Adobe)",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "0638a6154647ef8a772e7b46dd1d966d",
            "V&W Syntax (Adobe)",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "V&W Syntax (Adobe)",
            "Clifford Six Offc Pro"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "V&W Syntax (Adobe)",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "50441227356a2e75a4737b2cfe84709b",
            "V&W Syntax (Adobe)",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "0f41ebd3d659da540745d00b52334eb0",
            "V&W Syntax (Adobe)",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "d87ffd42ab39a3412ab905084e31b782",
            "V&W Syntax (Adobe)",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "d4df1a651052c6bd88be57660da085ac",
            "V&W Syntax (Adobe)",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "8c155b53e011d2a709548865b3edbeaf",
            "V&W Syntax (Adobe)",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "V&W Syntax (Adobe)",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "8ec787f27be4c31cf8c185b0f1310703",
            "V&W Syntax (Adobe)",
            "Skema Pro"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "ITC Giovanni",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "ITC Giovanni",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "ITC Giovanni",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "ITC Giovanni",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "565f10ac096eb5d75c4400509e23cdc1",
            "ITC Giovanni",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "033528c5f0137b017eff21079bd25a60",
            "ITC Giovanni",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "b832321e77d0f1be2c00712330066c3e",
            "ITC Giovanni",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "4a8d414c86f9aeae1489e72e6293e772",
            "ITC Giovanni",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "ITC Giovanni",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "ITC Giovanni",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "9e6867c857655e9d1984390fdf1dde45",
            "ITC Giovanni",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "fbb9573728984c54a8ca446e19d0972a",
            "ITC Giovanni",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "ITC Giovanni",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "3d295205229224442c34a365d6b885d1",
            "ITC Giovanni",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "b941ce467c4b7f2846b3226ae7988452",
            "ITC Giovanni",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "ITC Giovanni",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "51eb849300954cdecf9da1310c79beb2",
            "ITC Giovanni",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "ITC Giovanni",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "ITC Giovanni",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "2e21709bc8f416319384ac99bb85cfeb",
            "c63e8810388d85594540bb5f6980f611",
            "ITC Giovanni",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Sailec",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "bad316ad74318a9f95d0749417edfa04",
            "Sailec",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "8c155b53e011d2a709548865b3edbeaf",
            "Noah",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Noah",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "c2722fea792cde12a9117da6e0d70f74",
            "Noah",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Noah",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Noah",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Noah",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "b127070b4065a62961b2bf60fb763a76",
            "Noah",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Noah",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Noah",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "b74bf78a743785e3df7e3f14477a1390",
            "Noah",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "cc3e79c959420501e528f6b20113c185",
            "Noah",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "bad316ad74318a9f95d0749417edfa04",
            "Noah",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "264a4ae29758ba917346fe9763531666",
            "FF Franziska",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "FF Franziska",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FF Franziska",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "8223719dee533eb7e895e0a101f4472c",
            "FF Franziska",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "b832321e77d0f1be2c00712330066c3e",
            "FF Franziska",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "FF Franziska",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "ea90949476110422d67b9af4f8ace3a2",
            "FF Franziska",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "899d5f15480b4c036d5ec3eabac9e398",
            "FF Franziska",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "d3caacfedf638f98ba7b0046f297f421",
            "FF Franziska",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "650bcadc2c69543d997704b29b7c50d2",
            "FF Franziska",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "87791721b0238c72031ce39e346933a8",
            "FF Franziska",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "fc2e33377af6aca34a9826245e325cba",
            "FF Franziska",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "cae0af484abd406422956f9621c58b5f",
            "FF Franziska",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "2af66ddecaa7893391cb90362043d37a",
            "FF Franziska",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "38b203ce41804d19e934461faf557ecb",
            "FF Franziska",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "FF Franziska",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "FF Franziska",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "207f1b88d937a2dd587e13d9edc6cb57",
            "FF Franziska",
            "Specify"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "cdf497f40577c236216ef39ba5a1ef35",
            "FF Franziska",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "9e6867c857655e9d1984390fdf1dde45",
            "FF Franziska",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "103510159c0a328260730731e27eabe1",
            "Mundo Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "8ebe3248143db352da56805017ca7934",
            "Mundo Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "737e1d3f1693de9fd863057622d1bb02",
            "Mundo Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Mundo Sans",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Mundo Sans",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "c04f563b6a1457ae02100e98a49654c6",
            "Mundo Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Mundo Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "4b69cc4ce483966efd99a637882c74a5",
            "Mundo Sans",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Mundo Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "35ffcac4445202ebcfefa85630823de6",
            "Mundo Sans",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "73e48b94c08d2015315dbceaf56efb62",
            "Mundo Sans",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Mundo Sans",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "36ca5bc123f848ac643b6d50602259b7",
            "Mundo Sans",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Mundo Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Mundo Sans",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Mundo Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Mundo Sans",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Mundo Sans",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "88950808c1357581d744cc4f308d9f94",
            "Mundo Sans",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "Mundo Sans",
            "Life"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Synerga Pro",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "26830556eeeb7d475fc5a6e1f5ee3c84",
            "Synerga Pro",
            "Prelo"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "2b443d68adf1ec97623afac779dc9572",
            "Synerga Pro",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "264a4ae29758ba917346fe9763531666",
            "Synerga Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Synerga Pro",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Synerga Pro",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "147f1bb910d4c3487efd5789736afc3b",
            "Synerga Pro",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "c63e8810388d85594540bb5f6980f611",
            "Synerga Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Rational",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "8ebe3248143db352da56805017ca7934",
            "Rational",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "737e1d3f1693de9fd863057622d1bb02",
            "Rational",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "6d47953bebf6a23dc1d89764632524d8",
            "Rational",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "5bd81732a879ba42412c19bd5a33589b",
            "Rational",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "386528d2feb209e45554ed0fa03d81ce",
            "Rational",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "ef0f22560e30896239545a852fd7f6b4",
            "Rational",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "bad316ad74318a9f95d0749417edfa04",
            "Rational",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "2fd0aae6df9bf4e7128e124a35593a38",
            "8006330b215827a8efcd0e4c791bae76",
            "Rational",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Brasley",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Brasley",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Brasley",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "8ebe3248143db352da56805017ca7934",
            "Brasley",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "737e1d3f1693de9fd863057622d1bb02",
            "Brasley",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "67aadae90ce6049659422a925a8a23d4",
            "Brasley",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Brasley",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Brasley",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Brasley",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Brasley",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "b74bf78a743785e3df7e3f14477a1390",
            "Brasley",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "cc3e79c959420501e528f6b20113c185",
            "Brasley",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "c2722fea792cde12a9117da6e0d70f74",
            "Brasley",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "bad316ad74318a9f95d0749417edfa04",
            "Brasley",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Brasley",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3287cbe774bfc2e3cd080051a334dad7",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Brasley",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "d3caacfedf638f98ba7b0046f297f421",
            "Metron SSi",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "650bcadc2c69543d997704b29b7c50d2",
            "Metron SSi",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Metron SSi",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Metron SSi",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "f0249a1bec67973885bada20741c70c2",
            "Metron SSi",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Metron SSi",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Metron SSi",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "cae0af484abd406422956f9621c58b5f",
            "Metron SSi",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "627f02177189a33fe40ad427eff5d5bb",
            "Metron SSi",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Metron SSi",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Metron SSi",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "d159582398d0de4d0b367233acf587ee",
            "Metron SSi",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "38b203ce41804d19e934461faf557ecb",
            "Metron SSi",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Metron SSi",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Metron SSi",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Metron SSi",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "256f7672059f72846d940fbd8c97537d",
            "Metron SSi",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "ac04c5328af335b179cf1827997e1774",
            "Metron SSi",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "dfa1317c450784d1f09730737065a19b",
            "Metron SSi",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "3319dd949835e43d4bed270f465aff3e",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Metron SSi",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Galliard",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Galliard",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Galliard",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Galliard",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "9e6867c857655e9d1984390fdf1dde45",
            "Galliard",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Galliard",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "c63e8810388d85594540bb5f6980f611",
            "Galliard",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "2af66ddecaa7893391cb90362043d37a",
            "Galliard",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "b941ce467c4b7f2846b3226ae7988452",
            "Galliard",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Galliard",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "336870775fb3762c36c707da37eabadf",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Galliard",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "344c8c63c69f34a1faf93be5ec936db8",
            "3319dd949835e43d4bed270f465aff3e",
            "ITCAvantGardePro-Bk",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "344c8c63c69f34a1faf93be5ec936db8",
            "d515a6ca361cc9d1340762f79d8263dd",
            "ITCAvantGardePro-Bk",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "d87ffd42ab39a3412ab905084e31b782",
            "Graublau Sans Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Graublau Sans Pro",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Graublau Sans Pro",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Graublau Sans Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Graublau Sans Pro",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "c7117e8442a401bc7dd78049829ef83b",
            "Graublau Sans Pro",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "Graublau Sans Pro",
            "Synerga Pro"
        ]
    },
    {
        "likedPair": [
            "3454b36dbe2f20db2fd2966afc213a6c",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Graublau Sans Pro",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "b832321e77d0f1be2c00712330066c3e",
            "Aldus",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "2af66ddecaa7893391cb90362043d37a",
            "Aldus",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "280c82457252f3613b33e3791c375caf",
            "Aldus",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "d84e985d428e023bb87368d43461b448",
            "Aldus",
            "SST"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Aldus",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "3d295205229224442c34a365d6b885d1",
            "Aldus",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "b941ce467c4b7f2846b3226ae7988452",
            "Aldus",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Aldus",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Aldus",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "095898e12700edc69d52ecf30ef03e2a",
            "Aldus",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Aldus",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "9e6867c857655e9d1984390fdf1dde45",
            "Aldus",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Aldus",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Aldus",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "c63e8810388d85594540bb5f6980f611",
            "Aldus",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "34a814f80a793fa3eacde02882fa9faa",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Aldus",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "103510159c0a328260730731e27eabe1",
            "FF Scala Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "FF Scala Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "FF Scala Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "2d0b4f3a328383b8486d150666306efe",
            "FF Scala Sans",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "29093af656f979957ec5d657e96fb363",
            "FF Scala Sans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "FF Scala Sans",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "FF Scala Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "FF Scala Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "c3c0b5f23e63fcc31f434604265321d6",
            "FF Scala Sans",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "09d88839ee48108d4891334024ee38d1",
            "FF Scala Sans",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "d87ffd42ab39a3412ab905084e31b782",
            "FF Scala Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "FF Scala Sans",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "820a3fdbd8299ef1a164763cba53587e",
            "FF Scala Sans",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "d07f2481905eefa80fa98c464d59e260",
            "FF Scala Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "bbce3951159f83e9c2239d39fd666ce5",
            "FF Scala Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "623b4e42d48a5d620464ccf3c37cab13",
            "FF Scala Sans",
            "Tabac Slab"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "FF Scala Sans",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "58e4e08973787c63acc54d369a60ef59",
            "FF Scala Sans",
            "Karela"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "FF Scala Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "35641bbe5146f945b85e1e7b34956a73",
            "7385300fc2a1109d8d286432af1fcb85",
            "FF Scala Sans",
            "Garvis Pro"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "3774b4df0b2cb612124f851d40399d26",
            "Adelle",
            "Lina"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Adelle",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Adelle",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "c6ff032bd835e2f806009627251b87b6",
            "Adelle",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Adelle",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "3a2f35b17543f0f3464b26e080b16634",
            "Adelle",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "d84e985d428e023bb87368d43461b448",
            "Adelle",
            "SST"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "d18f103cfa62513f991b0f90a814c333",
            "Adelle",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Adelle",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "7530f20bfafbb946172b6f36a47d48c0",
            "Adelle",
            "Zapf Humanist 601"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Adelle",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "b832321e77d0f1be2c00712330066c3e",
            "Adelle",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Adelle",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "db2e42ddf6a123ca85bba4367802332d",
            "Adelle",
            "RT_Vickerman"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Adelle",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "2af66ddecaa7893391cb90362043d37a",
            "Adelle",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Adelle",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "2b443d68adf1ec97623afac779dc9572",
            "Adelle",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "952a354643df6c41226431ae4990f41e",
            "Adelle",
            "LCT Picon"
        ]
    },
    {
        "likedPair": [
            "35fa420174ab6d0dc90b1a38613e8af0",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Adelle",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Meruba New MF",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "de9599121cf31a08904a48495fadcf4a",
            "Meruba New MF",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "8223719dee533eb7e895e0a101f4472c",
            "Meruba New MF",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Meruba New MF",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "ea90949476110422d67b9af4f8ace3a2",
            "Meruba New MF",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Meruba New MF",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Meruba New MF",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "650bcadc2c69543d997704b29b7c50d2",
            "Meruba New MF",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "f01435736b8b73793ad270cdf379a860",
            "Meruba New MF",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "f0249a1bec67973885bada20741c70c2",
            "Meruba New MF",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "d3caacfedf638f98ba7b0046f297f421",
            "Meruba New MF",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "fc2e33377af6aca34a9826245e325cba",
            "Meruba New MF",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "38b203ce41804d19e934461faf557ecb",
            "Meruba New MF",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Meruba New MF",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "264a4ae29758ba917346fe9763531666",
            "Meruba New MF",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Meruba New MF",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "87791721b0238c72031ce39e346933a8",
            "Meruba New MF",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Meruba New MF",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Meruba New MF",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "35ffcac4445202ebcfefa85630823de6",
            "d159582398d0de4d0b367233acf587ee",
            "Meruba New MF",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "737e1d3f1693de9fd863057622d1bb02",
            "Aestetico",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Aestetico",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Aestetico",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Aestetico",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Aestetico",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "38f28a6682e9d705522a7ac7a715578f",
            "Aestetico",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Aestetico",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Aestetico",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "8ebe3248143db352da56805017ca7934",
            "Aestetico",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "Aestetico",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "c04f563b6a1457ae02100e98a49654c6",
            "Aestetico",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Aestetico",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Aestetico",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Aestetico",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Aestetico",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "36ca5bc123f848ac643b6d50602259b7",
            "Aestetico",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Aestetico",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Aestetico",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Aestetico",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Aestetico",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "d3caacfedf638f98ba7b0046f297f421",
            "Humanist Slabserif 712",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Humanist Slabserif 712",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Humanist Slabserif 712",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "650bcadc2c69543d997704b29b7c50d2",
            "Humanist Slabserif 712",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "fc2e33377af6aca34a9826245e325cba",
            "Humanist Slabserif 712",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "ea90949476110422d67b9af4f8ace3a2",
            "Humanist Slabserif 712",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Humanist Slabserif 712",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "38b203ce41804d19e934461faf557ecb",
            "Humanist Slabserif 712",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "ac04c5328af335b179cf1827997e1774",
            "Humanist Slabserif 712",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "d159582398d0de4d0b367233acf587ee",
            "Humanist Slabserif 712",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Humanist Slabserif 712",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "da5723a234527888e7dc5e19548f1abb",
            "Humanist Slabserif 712",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "Humanist Slabserif 712",
            "Nimbus Sans Round"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "cc764ebb17c10db21cd67451fce38448",
            "Humanist Slabserif 712",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Humanist Slabserif 712",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "36c50039d788bccb71ca83a792b63c1c",
            "147f1bb910d4c3487efd5789736afc3b",
            "Humanist Slabserif 712",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "NimbusRomNo9T-Reg",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "de9599121cf31a08904a48495fadcf4a",
            "NimbusRomNo9T-Reg",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "033528c5f0137b017eff21079bd25a60",
            "NimbusRomNo9T-Reg",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "e1351e92b91e4de955c73093b43ae8e2",
            "NimbusRomNo9T-Reg",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "b34fc5fd3820759a8808f554191ecaa2",
            "NimbusRomNo9T-Reg",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "8223719dee533eb7e895e0a101f4472c",
            "NimbusRomNo9T-Reg",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "d3caacfedf638f98ba7b0046f297f421",
            "NimbusRomNo9T-Reg",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "f0249a1bec67973885bada20741c70c2",
            "NimbusRomNo9T-Reg",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "NimbusRomNo9T-Reg",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "f01435736b8b73793ad270cdf379a860",
            "NimbusRomNo9T-Reg",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "650bcadc2c69543d997704b29b7c50d2",
            "NimbusRomNo9T-Reg",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "fc2e33377af6aca34a9826245e325cba",
            "NimbusRomNo9T-Reg",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "NimbusRomNo9T-Reg",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "38b203ce41804d19e934461faf557ecb",
            "NimbusRomNo9T-Reg",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "ebdc49d2fe55718bce1a53f10769e589",
            "NimbusRomNo9T-Reg",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "b24744ca2bf3616294271353ec837099",
            "NimbusRomNo9T-Reg",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "NimbusRomNo9T-Reg",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "NimbusRomNo9T-Reg",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "264a4ae29758ba917346fe9763531666",
            "NimbusRomNo9T-Reg",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "36ca5bc123f848ac643b6d50602259b7",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "NimbusRomNo9T-Reg",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "376c5f17a780394b8b584636a3695ccc",
            "147f1bb910d4c3487efd5789736afc3b",
            "Nomada Slab",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "3774b4df0b2cb612124f851d40399d26",
            "d87ffd42ab39a3412ab905084e31b782",
            "Lina",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "3774b4df0b2cb612124f851d40399d26",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Lina",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Corbel",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "c7117e8442a401bc7dd78049829ef83b",
            "Corbel",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Corbel",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Corbel",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Corbel",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "38296e69914b73ef3a2786f8da0e19c8",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Corbel",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Glypha",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Glypha",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "f01435736b8b73793ad270cdf379a860",
            "Glypha",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Glypha",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "f0249a1bec67973885bada20741c70c2",
            "Glypha",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "15f6440060216b78f6e867d5cf13fd85",
            "Glypha",
            "HangulatinEN-Regular"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Glypha",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Glypha",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Glypha",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "ea90949476110422d67b9af4f8ace3a2",
            "Glypha",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "0a990399fe7f1b376e846e602e3307bb",
            "Glypha",
            "Europa Grotesk No. 2 SB"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "Glypha",
            "Aestetico"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Glypha",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "d159582398d0de4d0b367233acf587ee",
            "Glypha",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Glypha",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "d3caacfedf638f98ba7b0046f297f421",
            "Glypha",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "650bcadc2c69543d997704b29b7c50d2",
            "Glypha",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "42242b3d0731f05814ed723a957a1ca2",
            "Glypha",
            "FF Nort"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Glypha",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "386528d2feb209e45554ed0fa03d81ce",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Glypha",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "8ebe3248143db352da56805017ca7934",
            "FS Koopman",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "737e1d3f1693de9fd863057622d1bb02",
            "FS Koopman",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "263b7ffd57470af21ec49d7a144c4f23",
            "FS Koopman",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "c04f563b6a1457ae02100e98a49654c6",
            "FS Koopman",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "3319dd949835e43d4bed270f465aff3e",
            "FS Koopman",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FS Koopman",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "FS Koopman",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "36ca5bc123f848ac643b6d50602259b7",
            "FS Koopman",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "0638a6154647ef8a772e7b46dd1d966d",
            "FS Koopman",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "0f41ebd3d659da540745d00b52334eb0",
            "FS Koopman",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "38f28a6682e9d705522a7ac7a715578f",
            "FS Koopman",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "6e4bf0177f0e1b459e2b159545de1181",
            "FS Koopman",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "c6bae55c030fe9df4104274e7fa5df57",
            "FS Koopman",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "FS Koopman",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "b127070b4065a62961b2bf60fb763a76",
            "FS Koopman",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "FS Koopman",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "e093c040c71b04f76b2b181a6dd3acea",
            "FS Koopman",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "88950808c1357581d744cc4f308d9f94",
            "FS Koopman",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "FS Koopman",
            "Adriane Text"
        ]
    },
    {
        "likedPair": [
            "38b203ce41804d19e934461faf557ecb",
            "9ab5daa5796d80adb55febe5da072e8a",
            "FS Koopman",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "d87ffd42ab39a3412ab905084e31b782",
            "Droid Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "6badb2797a95a552c53a98a0f20c903b",
            "Droid Sans",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "9ded3c33a83728124405e311fff63b40",
            "Droid Sans",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Droid Sans",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Droid Sans",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "535f79f088e3c680b94a53258330a712",
            "Droid Sans",
            "Cambria"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "6b75a9583274793e20e232032200c56d",
            "Droid Sans",
            "Foro"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Droid Sans",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Droid Sans",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "c311a16ee279363b5113cbf699325577",
            "Droid Sans",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Droid Sans",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "c638239ea03b75929bff2ce833419ac3",
            "Droid Sans",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "8d9fd883298c86eeb3d614b7311f8431",
            "Droid Sans",
            "Milo Serif Pro"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Droid Sans",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Droid Sans",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Droid Sans",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Droid Sans",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "9d4006b028ee37610307e9af03bfdf54",
            "Droid Sans",
            "DIN Next Slab"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "c87f74a6084f73fdad817b1589a48a08",
            "Droid Sans",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "38c216ced240e8111b587a31e2fc5794",
            "e28128adc0e75357f447267c07afb6a6",
            "Droid Sans",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Essonnes",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Essonnes",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "f01435736b8b73793ad270cdf379a860",
            "Essonnes",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "fc2e33377af6aca34a9826245e325cba",
            "Essonnes",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "87791721b0238c72031ce39e346933a8",
            "Essonnes",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Essonnes",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Essonnes",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "9e6867c857655e9d1984390fdf1dde45",
            "Essonnes",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Essonnes",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Essonnes",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "c63e8810388d85594540bb5f6980f611",
            "Essonnes",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Essonnes",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Essonnes",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Essonnes",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "b941ce467c4b7f2846b3226ae7988452",
            "Essonnes",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "82550c10af201d56d90be26b8833ac63",
            "Essonnes",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "c0351a7e9af75205fea41a3719573876",
            "Essonnes",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Essonnes",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Essonnes",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "38f28a6682e9d705522a7ac7a715578f",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Essonnes",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Iowan Old Style",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "2af66ddecaa7893391cb90362043d37a",
            "Iowan Old Style",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Iowan Old Style",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Iowan Old Style",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "35641bbe5146f945b85e1e7b34956a73",
            "Iowan Old Style",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Iowan Old Style",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Iowan Old Style",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Iowan Old Style",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "fbb9573728984c54a8ca446e19d0972a",
            "Iowan Old Style",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "9e6867c857655e9d1984390fdf1dde45",
            "Iowan Old Style",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Iowan Old Style",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "b832321e77d0f1be2c00712330066c3e",
            "Iowan Old Style",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "280c82457252f3613b33e3791c375caf",
            "Iowan Old Style",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "b941ce467c4b7f2846b3226ae7988452",
            "Iowan Old Style",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Iowan Old Style",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Iowan Old Style",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "095898e12700edc69d52ecf30ef03e2a",
            "Iowan Old Style",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "51eb849300954cdecf9da1310c79beb2",
            "Iowan Old Style",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "3d295205229224442c34a365d6b885d1",
            "Iowan Old Style",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "c63e8810388d85594540bb5f6980f611",
            "Iowan Old Style",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Schotis Text",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "033528c5f0137b017eff21079bd25a60",
            "Schotis Text",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "8223719dee533eb7e895e0a101f4472c",
            "Schotis Text",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "fc2e33377af6aca34a9826245e325cba",
            "Schotis Text",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "de9599121cf31a08904a48495fadcf4a",
            "Schotis Text",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Schotis Text",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "f0249a1bec67973885bada20741c70c2",
            "Schotis Text",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "d3caacfedf638f98ba7b0046f297f421",
            "Schotis Text",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "650bcadc2c69543d997704b29b7c50d2",
            "Schotis Text",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Schotis Text",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "38b203ce41804d19e934461faf557ecb",
            "Schotis Text",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "f01435736b8b73793ad270cdf379a860",
            "Schotis Text",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Schotis Text",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Schotis Text",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Schotis Text",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Schotis Text",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "ea90949476110422d67b9af4f8ace3a2",
            "Schotis Text",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Schotis Text",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "264a4ae29758ba917346fe9763531666",
            "Schotis Text",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "3938fddd18b33d1b1549d30049d6e749",
            "87791721b0238c72031ce39e346933a8",
            "Schotis Text",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Museo Slab",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Museo Slab",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Museo Slab",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Museo Slab",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "b6249de3d08e3971282740ee906b6a8f",
            "Museo Slab",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "Museo Slab",
            "Primeform Pro"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "0db105f867c7eb2e491db586cc26b417",
            "Museo Slab",
            "Galano Grotesque"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Museo Slab",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Museo Slab",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Museo Slab",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "f02646f18604d6ce339590291ba509e0",
            "Museo Slab",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "868fc2017554528c8ca4e20974e19480",
            "Museo Slab",
            "Codec Pro"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "f5a49aa2213d4997def8db2e67ea89b3",
            "Museo Slab",
            "Gentleman"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Museo Slab",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Museo Slab",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "80e2d3f71380d7613412a147ecc407d7",
            "Museo Slab",
            "Kanyon"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "256f7672059f72846d940fbd8c97537d",
            "Museo Slab",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Museo Slab",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Museo Slab",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "39c6824c053d9eaf11e996a26ad2eba3",
            "54e3a21131de6eef0e771cba2f51e359",
            "Museo Slab",
            "Sofia Pro"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "d87ffd42ab39a3412ab905084e31b782",
            "PT Sans Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "PT Sans Pro",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "PT Sans Pro",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "PT Sans Pro",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "e850c1a19f5dd604e85d62b658f34d62",
            "PT Sans Pro",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "6badb2797a95a552c53a98a0f20c903b",
            "PT Sans Pro",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "PT Sans Pro",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "c638239ea03b75929bff2ce833419ac3",
            "PT Sans Pro",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "PT Sans Pro",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "PT Sans Pro",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "9ded3c33a83728124405e311fff63b40",
            "PT Sans Pro",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "PT Sans Pro",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "PT Sans Pro",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "2980338e1101915cd8cf85fec19fd126",
            "PT Sans Pro",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "PT Sans Pro",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "bbce3951159f83e9c2239d39fd666ce5",
            "PT Sans Pro",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "PT Sans Pro",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "PT Sans Pro",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "c311a16ee279363b5113cbf699325577",
            "PT Sans Pro",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "3a2f35b17543f0f3464b26e080b16634",
            "a7ed66c67894164f8aee8e7069688a0d",
            "PT Sans Pro",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "3aa67add39bd085c00649dcc61f0b368",
            "9e6867c857655e9d1984390fdf1dde45",
            "Ginkgo",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "3aa67add39bd085c00649dcc61f0b368",
            "c63e8810388d85594540bb5f6980f611",
            "Ginkgo",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3aa67add39bd085c00649dcc61f0b368",
            "b941ce467c4b7f2846b3226ae7988452",
            "Ginkgo",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "3aa67add39bd085c00649dcc61f0b368",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Ginkgo",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "3aa67add39bd085c00649dcc61f0b368",
            "35641bbe5146f945b85e1e7b34956a73",
            "Ginkgo",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "3ab7bb3ba597a9d55631fcbe701b8440",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Dupla",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "3ab7bb3ba597a9d55631fcbe701b8440",
            "9ded3c33a83728124405e311fff63b40",
            "Dupla",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "3ab7bb3ba597a9d55631fcbe701b8440",
            "d87ffd42ab39a3412ab905084e31b782",
            "Dupla",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "3ab7bb3ba597a9d55631fcbe701b8440",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Dupla",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "3ab7bb3ba597a9d55631fcbe701b8440",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Dupla",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "3b412efdb8ef121a6bec26d0231f8488",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Flama Book",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Garth Graphic",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Garth Graphic",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Garth Graphic",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Garth Graphic",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "b24744ca2bf3616294271353ec837099",
            "Garth Graphic",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Garth Graphic",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "82550c10af201d56d90be26b8833ac63",
            "Garth Graphic",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "cae0af484abd406422956f9621c58b5f",
            "Garth Graphic",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "264a4ae29758ba917346fe9763531666",
            "Garth Graphic",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "2af66ddecaa7893391cb90362043d37a",
            "Garth Graphic",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "fc2e33377af6aca34a9826245e325cba",
            "Garth Graphic",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "c63e8810388d85594540bb5f6980f611",
            "Garth Graphic",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "b941ce467c4b7f2846b3226ae7988452",
            "Garth Graphic",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Garth Graphic",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Garth Graphic",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "9e6867c857655e9d1984390fdf1dde45",
            "Garth Graphic",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Garth Graphic",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "51eb849300954cdecf9da1310c79beb2",
            "Garth Graphic",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "095898e12700edc69d52ecf30ef03e2a",
            "Garth Graphic",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "3bc217606a2f4a22131f20c24de7ac75",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Garth Graphic",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "8ebe3248143db352da56805017ca7934",
            "Gordita",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Gordita",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Gordita",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "5bd81732a879ba42412c19bd5a33589b",
            "Gordita",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "6d47953bebf6a23dc1d89764632524d8",
            "Gordita",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "9da983bd95342b2184596f18ef3fff34",
            "Gordita",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gordita",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gordita",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Gordita",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "67aadae90ce6049659422a925a8a23d4",
            "Gordita",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Gordita",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Gordita",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "b74bf78a743785e3df7e3f14477a1390",
            "Gordita",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "cc3e79c959420501e528f6b20113c185",
            "Gordita",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "c2722fea792cde12a9117da6e0d70f74",
            "Gordita",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Gordita",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "bad316ad74318a9f95d0749417edfa04",
            "Gordita",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "3bc3a738f4507b8feea7502049c474d2",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Gordita",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "c6ff032bd835e2f806009627251b87b6",
            "Solitas Serif",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "b832321e77d0f1be2c00712330066c3e",
            "Solitas Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "3774b4df0b2cb612124f851d40399d26",
            "Solitas Serif",
            "Lina"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "38c216ced240e8111b587a31e2fc5794",
            "Solitas Serif",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "2af66ddecaa7893391cb90362043d37a",
            "Solitas Serif",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Solitas Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Solitas Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Solitas Serif",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Solitas Serif",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "280c82457252f3613b33e3791c375caf",
            "Solitas Serif",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Solitas Serif",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Solitas Serif",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "c63e8810388d85594540bb5f6980f611",
            "Solitas Serif",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "d18f103cfa62513f991b0f90a814c333",
            "Solitas Serif",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Solitas Serif",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Solitas Serif",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "3a2f35b17543f0f3464b26e080b16634",
            "Solitas Serif",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Solitas Serif",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "d84e985d428e023bb87368d43461b448",
            "Solitas Serif",
            "SST"
        ]
    },
    {
        "likedPair": [
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Solitas Serif",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "6d47953bebf6a23dc1d89764632524d8",
            "Mirai",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "38f28a6682e9d705522a7ac7a715578f",
            "Mirai",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "c04f563b6a1457ae02100e98a49654c6",
            "Mirai",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Mirai",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Mirai",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Mirai",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Mirai",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "737e1d3f1693de9fd863057622d1bb02",
            "Mirai",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "8ebe3248143db352da56805017ca7934",
            "Mirai",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "9da983bd95342b2184596f18ef3fff34",
            "Mirai",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Mirai",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "5bd81732a879ba42412c19bd5a33589b",
            "Mirai",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "3938fddd18b33d1b1549d30049d6e749",
            "Mirai",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Mirai",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "955b9a400ce5accf68307eaad62c4f62",
            "Mirai",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Mirai",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "c2722fea792cde12a9117da6e0d70f74",
            "Mirai",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Mirai",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Morn",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Morn",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "737e1d3f1693de9fd863057622d1bb02",
            "Morn",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "8c155b53e011d2a709548865b3edbeaf",
            "Morn",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "8ebe3248143db352da56805017ca7934",
            "Morn",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "c2722fea792cde12a9117da6e0d70f74",
            "Morn",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Morn",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Morn",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "b74bf78a743785e3df7e3f14477a1390",
            "Morn",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "cc3e79c959420501e528f6b20113c185",
            "Morn",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Morn",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "67aadae90ce6049659422a925a8a23d4",
            "Morn",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "b127070b4065a62961b2bf60fb763a76",
            "Morn",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Morn",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Morn",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Morn",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "bad316ad74318a9f95d0749417edfa04",
            "Morn",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "3d19a94899ee585eac610b7aa873fe9e",
            "955b9a400ce5accf68307eaad62c4f62",
            "Morn",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "3d295205229224442c34a365d6b885d1",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Boutros Angham",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "BirkaLTPro-Regular",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "BirkaLTPro-Regular",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "BirkaLTPro-Regular",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "BirkaLTPro-Regular",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "9e6867c857655e9d1984390fdf1dde45",
            "BirkaLTPro-Regular",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "BirkaLTPro-Regular",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "3a2f35b17543f0f3464b26e080b16634",
            "BirkaLTPro-Regular",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "c2244758e73a4caacb7f2916afe5f38f",
            "BirkaLTPro-Regular",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "91f1a74434b4ecc9129239ec3e236b42",
            "BirkaLTPro-Regular",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "b941ce467c4b7f2846b3226ae7988452",
            "BirkaLTPro-Regular",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "3d42e5b4eac967ce5300247f880dc1fa",
            "c63e8810388d85594540bb5f6980f611",
            "BirkaLTPro-Regular",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Gabriela",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Gabriela",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Gabriela",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Gabriela",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "9e6867c857655e9d1984390fdf1dde45",
            "Gabriela",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "3d295205229224442c34a365d6b885d1",
            "Gabriela",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "b941ce467c4b7f2846b3226ae7988452",
            "Gabriela",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Gabriela",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Gabriela",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "c63e8810388d85594540bb5f6980f611",
            "Gabriela",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Gabriela",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "3d57925d7a1616344452a7eefb8f5e51",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Gabriela",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Zurich",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Zurich",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Zurich",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Zurich",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Zurich",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "3319dd949835e43d4bed270f465aff3e",
            "Zurich",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Zurich",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "8ebe3248143db352da56805017ca7934",
            "Zurich",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "b127070b4065a62961b2bf60fb763a76",
            "Zurich",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Zurich",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "737e1d3f1693de9fd863057622d1bb02",
            "Zurich",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Zurich",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Zurich",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "3938fddd18b33d1b1549d30049d6e749",
            "Zurich",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Zurich",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "6d47953bebf6a23dc1d89764632524d8",
            "Zurich",
            "Macklin"
        ]
    },
    {likedPair : [
      "03ba201f7613be300cec0afc83ee295a",
      "386528d2feb209e45554ed0fa03d81ce",
       "Helvetica",
      "Glypha"
    ]}
  ,
      {likedPair : [
      "9a21e3a1e94c73d3bf7f66ea8fb82613",
      "caee5e6a5eec9cb66a85ac115f2f5c7f",
       "Gilroy",
      "ITC Lubalin Graph"
    ]}
  ,
   {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "b127070b4065a62961b2bf60fb763a76",
            "Proxima Nova",
            "Candida"
        ]
    },

    {likedPair : [
      "03ba201f7613be300cec0afc83ee295a",
      "8ebe3248143db352da56805017ca7934",
       "Helvetica",
      "Walbaum"
    ]}
  ,


    {likedPair : [
      "be5fdca67a94d3db868b73c7eaea39f4",
      "386528d2feb209e45554ed0fa03d81ce",
       "Neue Haas Grotesk Text",
      "Glypha"
    ]}
  ,

      {likedPair : [
      "9f05792cccf1711b103d46c9d70e710d",
      "ebe0092b584d62426b03aa84e3d1597c",
       "Univers",
      "Egyptienne F"
    ]}
  ,




        {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "818930a2cf5fa264846d244b38fab798",
            "TT Livret",
            "Trade Gothic"
        ]
    },



        {
        "likedPair": [
            "0f9660f1f757f7351b774c0bd7614dcc",
            "3938fddd18b33d1b1549d30049d6e749",
            "TT Commons Classic",
            "Schotis Text"
        ]
    },




            {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "1064c815bebd285f61fa50c097045eaf",
            "FF Mark",
            "Memphis"
        ]
    },


                {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Swiss721 BT Regular",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Zurich",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "d4df1a651052c6bd88be57660da085ac",
            "Zurich",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "Zurich",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "3dba1a3608c4e2faba9528b4451fa027",
            "e961668cbc083722acbc4a237ca92232",
            "Zurich",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Muller",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Muller",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Muller",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Muller",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "8c155b53e011d2a709548865b3edbeaf",
            "Muller",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "c7117e8442a401bc7dd78049829ef83b",
            "Muller",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Muller",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Muller",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "c2722fea792cde12a9117da6e0d70f74",
            "Muller",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "3e2f48d6755b222ba6a508b152c53dd0",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Muller",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Classic Grotesque",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Classic Grotesque",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "88950808c1357581d744cc4f308d9f94",
            "Classic Grotesque",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Classic Grotesque",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "36ca5bc123f848ac643b6d50602259b7",
            "Classic Grotesque",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Classic Grotesque",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Classic Grotesque",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Classic Grotesque",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "45f11e2ac1181359f4004a104c49f31d",
            "Classic Grotesque",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "35ffcac4445202ebcfefa85630823de6",
            "Classic Grotesque",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Classic Grotesque",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Classic Grotesque",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "c04f563b6a1457ae02100e98a49654c6",
            "Classic Grotesque",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "06510c0260d17a867a598617cc3f59e9",
            "Classic Grotesque",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "afb2c306772fbf472d6549a865bf7339",
            "Classic Grotesque",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Classic Grotesque",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "06779a9920e25578b6f504fcbd0ca169",
            "Classic Grotesque",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Classic Grotesque",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Classic Grotesque",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "5bd81732a879ba42412c19bd5a33589b",
            "Classic Grotesque",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FS Ostro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "FS Ostro",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "fc2e33377af6aca34a9826245e325cba",
            "FS Ostro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "87791721b0238c72031ce39e346933a8",
            "FS Ostro",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "b34fc5fd3820759a8808f554191ecaa2",
            "FS Ostro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "f01435736b8b73793ad270cdf379a860",
            "FS Ostro",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "FS Ostro",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "f0249a1bec67973885bada20741c70c2",
            "FS Ostro",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "FS Ostro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "9e6867c857655e9d1984390fdf1dde45",
            "FS Ostro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "FS Ostro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "2af66ddecaa7893391cb90362043d37a",
            "FS Ostro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "FS Ostro",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "c63e8810388d85594540bb5f6980f611",
            "FS Ostro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "c0351a7e9af75205fea41a3719573876",
            "FS Ostro",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "FS Ostro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "147f1bb910d4c3487efd5789736afc3b",
            "FS Ostro",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "FS Ostro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "b941ce467c4b7f2846b3226ae7988452",
            "FS Ostro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "3f57a43ed54fe91aa92025669be6fe7d",
            "82550c10af201d56d90be26b8833ac63",
            "FS Ostro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "8c155b53e011d2a709548865b3edbeaf",
            "TT Norms Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "cfbb9acb121612b62a247f211e51cb3e",
            "TT Norms Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "TT Norms Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "TT Norms Pro",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "6d47953bebf6a23dc1d89764632524d8",
            "TT Norms Pro",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "c2722fea792cde12a9117da6e0d70f74",
            "TT Norms Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "737e1d3f1693de9fd863057622d1bb02",
            "TT Norms Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "TT Norms Pro",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "cd92499f5905694f796be4b7b3406e49",
            "TT Norms Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "cc3e79c959420501e528f6b20113c185",
            "TT Norms Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "c7117e8442a401bc7dd78049829ef83b",
            "TT Norms Pro",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "b74bf78a743785e3df7e3f14477a1390",
            "TT Norms Pro",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "TT Norms Pro",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "8ebe3248143db352da56805017ca7934",
            "TT Norms Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "TT Norms Pro",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "67aadae90ce6049659422a925a8a23d4",
            "TT Norms Pro",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "TT Norms Pro",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "6bfb91fb426b2fab33652163c2f538c2",
            "TT Norms Pro",
            "TT Jenevers"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "TT Norms Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "411e30ddd318c0fdf64abd6886591d95",
            "bad316ad74318a9f95d0749417edfa04",
            "TT Norms Pro",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "386528d2feb209e45554ed0fa03d81ce",
            "FF Nort",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "50441227356a2e75a4737b2cfe84709b",
            "FF Nort",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "FF Nort",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "5bd81732a879ba42412c19bd5a33589b",
            "FF Nort",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "d515a6ca361cc9d1340762f79d8263dd",
            "FF Nort",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "FF Nort",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "FF Nort",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "42242b3d0731f05814ed723a957a1ca2",
            "b74bf78a743785e3df7e3f14477a1390",
            "FF Nort",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Monsal Gothic",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Monsal Gothic",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Monsal Gothic",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "6badb2797a95a552c53a98a0f20c903b",
            "Monsal Gothic",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Monsal Gothic",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Monsal Gothic",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "73138474522e9719f1a246b6fff9af38",
            "Monsal Gothic",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "d07f2481905eefa80fa98c464d59e260",
            "Monsal Gothic",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "c311a16ee279363b5113cbf699325577",
            "Monsal Gothic",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "d87ffd42ab39a3412ab905084e31b782",
            "Monsal Gothic",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Monsal Gothic",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Monsal Gothic",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "Monsal Gothic",
            "NCT Granite"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Monsal Gothic",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Monsal Gothic",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "c638239ea03b75929bff2ce833419ac3",
            "Monsal Gothic",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Monsal Gothic",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Monsal Gothic",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Monsal Gothic",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "43198f9d8420d1913accd8c5f0ee2e33",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Monsal Gothic",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Bookman Old Style",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "fc2e33377af6aca34a9826245e325cba",
            "Bookman Old Style",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Bookman Old Style",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Bookman Old Style",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Bookman Old Style",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "fbb9573728984c54a8ca446e19d0972a",
            "Bookman Old Style",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "c63e8810388d85594540bb5f6980f611",
            "Bookman Old Style",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "b6249de3d08e3971282740ee906b6a8f",
            "Bookman Old Style",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "b0f799383351d9ef86939c76bff5bafc",
            "Bookman Old Style",
            "Causten"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Bookman Old Style",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Bookman Old Style",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Bookman Old Style",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Bookman Old Style",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Bookman Old Style",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "f02646f18604d6ce339590291ba509e0",
            "Bookman Old Style",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "f27264442e7df065b3c26373505c38b6",
            "Bookman Old Style",
            "Brother 1816"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "47e848f1f1b998207926dfb024fa4a48",
            "Bookman Old Style",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "3bc3a738f4507b8feea7502049c474d2",
            "Bookman Old Style",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Bookman Old Style",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "f5a49aa2213d4997def8db2e67ea89b3",
            "Bookman Old Style",
            "Gentleman"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Riccione Serial",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "8223719dee533eb7e895e0a101f4472c",
            "Riccione Serial",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "fc2e33377af6aca34a9826245e325cba",
            "Riccione Serial",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Riccione Serial",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "de9599121cf31a08904a48495fadcf4a",
            "Riccione Serial",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "f0249a1bec67973885bada20741c70c2",
            "Riccione Serial",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "650bcadc2c69543d997704b29b7c50d2",
            "Riccione Serial",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "38b203ce41804d19e934461faf557ecb",
            "Riccione Serial",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Riccione Serial",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Riccione Serial",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "d3caacfedf638f98ba7b0046f297f421",
            "Riccione Serial",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Riccione Serial",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "ea90949476110422d67b9af4f8ace3a2",
            "Riccione Serial",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Riccione Serial",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "f01435736b8b73793ad270cdf379a860",
            "Riccione Serial",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "87791721b0238c72031ce39e346933a8",
            "Riccione Serial",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Riccione Serial",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "264a4ae29758ba917346fe9763531666",
            "Riccione Serial",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Riccione Serial",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "45f11e2ac1181359f4004a104c49f31d",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Riccione Serial",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "b127070b4065a62961b2bf60fb763a76",
            "FS Elliot Paneuropean",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "FS Elliot Paneuropean",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "cfbb9acb121612b62a247f211e51cb3e",
            "FS Elliot Paneuropean",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "FS Elliot Paneuropean",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FS Elliot Paneuropean",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "FS Elliot Paneuropean",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "c7117e8442a401bc7dd78049829ef83b",
            "FS Elliot Paneuropean",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "FS Elliot Paneuropean",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "FS Elliot Paneuropean",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "47e848f1f1b998207926dfb024fa4a48",
            "50441227356a2e75a4737b2cfe84709b",
            "FS Elliot Paneuropean",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "8ebe3248143db352da56805017ca7934",
            "Glence",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Glence",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "737e1d3f1693de9fd863057622d1bb02",
            "Glence",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "6d47953bebf6a23dc1d89764632524d8",
            "Glence",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "3319dd949835e43d4bed270f465aff3e",
            "Glence",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Glence",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Glence",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Glence",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "5bd81732a879ba42412c19bd5a33589b",
            "Glence",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "cc3e79c959420501e528f6b20113c185",
            "Glence",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Glence",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Glence",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "955b9a400ce5accf68307eaad62c4f62",
            "Glence",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "bad316ad74318a9f95d0749417edfa04",
            "Glence",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Tabac Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "103510159c0a328260730731e27eabe1",
            "Tabac Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Tabac Sans",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Tabac Sans",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Tabac Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Tabac Sans",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "73e48b94c08d2015315dbceaf56efb62",
            "Tabac Sans",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Tabac Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "cd92499f5905694f796be4b7b3406e49",
            "Tabac Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "d07f2481905eefa80fa98c464d59e260",
            "Tabac Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Tabac Sans",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Tabac Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "8c155b53e011d2a709548865b3edbeaf",
            "Tabac Sans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Tabac Sans",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Tabac Sans",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "Tabac Sans",
            "NCT Granite"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "ef71628ba1ab6310365a78c263679726",
            "Tabac Sans",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "71ce2a4123e21bfb630f651363b756f3",
            "Tabac Sans",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Tabac Sans",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "820a3fdbd8299ef1a164763cba53587e",
            "Tabac Sans",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "8c155b53e011d2a709548865b3edbeaf",
            "Conamore",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Conamore",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Conamore",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "d87ffd42ab39a3412ab905084e31b782",
            "Conamore",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Conamore",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Conamore",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "d07f2481905eefa80fa98c464d59e260",
            "Conamore",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Conamore",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Conamore",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "9ded3c33a83728124405e311fff63b40",
            "Conamore",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "c311a16ee279363b5113cbf699325577",
            "Conamore",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Conamore",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Conamore",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Conamore",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Conamore",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Conamore",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Conamore",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Conamore",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "c638239ea03b75929bff2ce833419ac3",
            "Conamore",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "4a8d414c86f9aeae1489e72e6293e772",
            "cd92499f5905694f796be4b7b3406e49",
            "Conamore",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Dutch 801",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Dutch 801",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "f0249a1bec67973885bada20741c70c2",
            "Dutch 801",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "de9599121cf31a08904a48495fadcf4a",
            "Dutch 801",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "8223719dee533eb7e895e0a101f4472c",
            "Dutch 801",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Dutch 801",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "fc2e33377af6aca34a9826245e325cba",
            "Dutch 801",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "650bcadc2c69543d997704b29b7c50d2",
            "Dutch 801",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Dutch 801",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "d3caacfedf638f98ba7b0046f297f421",
            "Dutch 801",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Dutch 801",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Dutch 801",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "ea90949476110422d67b9af4f8ace3a2",
            "Dutch 801",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "f01435736b8b73793ad270cdf379a860",
            "Dutch 801",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "264a4ae29758ba917346fe9763531666",
            "Dutch 801",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "38b203ce41804d19e934461faf557ecb",
            "Dutch 801",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Dutch 801",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Dutch 801",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Dutch 801",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "4b69cc4ce483966efd99a637882c74a5",
            "87791721b0238c72031ce39e346933a8",
            "Dutch 801",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "522423ab26a3b1f5bb0d40a81ec91262",
            "Madley",
            "Creo"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Madley",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Madley",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "93b4e55aa9798f96b3a365a441a2238d",
            "Madley",
            "Oslo"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Madley",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "b941ce467c4b7f2846b3226ae7988452",
            "Madley",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Madley",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Madley",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "82550c10af201d56d90be26b8833ac63",
            "Madley",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "Madley",
            "Joanna Sans Nova"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "NCT Granite",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "b941ce467c4b7f2846b3226ae7988452",
            "NCT Granite",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "NCT Granite",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "NCT Granite",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "b832321e77d0f1be2c00712330066c3e",
            "NCT Granite",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "35641bbe5146f945b85e1e7b34956a73",
            "NCT Granite",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "51eb849300954cdecf9da1310c79beb2",
            "NCT Granite",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "2af66ddecaa7893391cb90362043d37a",
            "NCT Granite",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "9e6867c857655e9d1984390fdf1dde45",
            "NCT Granite",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "NCT Granite",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "NCT Granite",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "c2244758e73a4caacb7f2916afe5f38f",
            "NCT Granite",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "095898e12700edc69d52ecf30ef03e2a",
            "NCT Granite",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "NCT Granite",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "NCT Granite",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "91f1a74434b4ecc9129239ec3e236b42",
            "NCT Granite",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "NCT Granite",
            "Joanna Sans Nova"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "c63e8810388d85594540bb5f6980f611",
            "NCT Granite",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "cdf497f40577c236216ef39ba5a1ef35",
            "NCT Granite",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "fc2e33377af6aca34a9826245e325cba",
            "NCT Granite",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Peri\u00f3dico",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Peri\u00f3dico",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "f0249a1bec67973885bada20741c70c2",
            "Peri\u00f3dico",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "264a4ae29758ba917346fe9763531666",
            "Peri\u00f3dico",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Peri\u00f3dico",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "87791721b0238c72031ce39e346933a8",
            "Peri\u00f3dico",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "fc2e33377af6aca34a9826245e325cba",
            "Peri\u00f3dico",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "2af66ddecaa7893391cb90362043d37a",
            "Peri\u00f3dico",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "d3caacfedf638f98ba7b0046f297f421",
            "Peri\u00f3dico",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Peri\u00f3dico",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "b941ce467c4b7f2846b3226ae7988452",
            "Peri\u00f3dico",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "9e6867c857655e9d1984390fdf1dde45",
            "Peri\u00f3dico",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Peri\u00f3dico",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "c63e8810388d85594540bb5f6980f611",
            "Peri\u00f3dico",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "82550c10af201d56d90be26b8833ac63",
            "Peri\u00f3dico",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "Peri\u00f3dico",
            "Bruta Global"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Peri\u00f3dico",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "147f1bb910d4c3487efd5789736afc3b",
            "Peri\u00f3dico",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "4dac2d953bdd6df6fb693c25fc31805c",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Peri\u00f3dico",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "c6ff032bd835e2f806009627251b87b6",
            "Malaga",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "2af66ddecaa7893391cb90362043d37a",
            "Malaga",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "b832321e77d0f1be2c00712330066c3e",
            "Malaga",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "d84e985d428e023bb87368d43461b448",
            "Malaga",
            "SST"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Malaga",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Malaga",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Malaga",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "38c216ced240e8111b587a31e2fc5794",
            "Malaga",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "d18f103cfa62513f991b0f90a814c333",
            "Malaga",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Malaga",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Malaga",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "3a2f35b17543f0f3464b26e080b16634",
            "Malaga",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "280c82457252f3613b33e3791c375caf",
            "Malaga",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "c63e8810388d85594540bb5f6980f611",
            "Malaga",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Malaga",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Malaga",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Malaga",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Malaga",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "9e6867c857655e9d1984390fdf1dde45",
            "Malaga",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "4e5e667f9c0976af5022f8d80ee481c1",
            "51eb849300954cdecf9da1310c79beb2",
            "Malaga",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "737e1d3f1693de9fd863057622d1bb02",
            "Pragmatica",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Pragmatica",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "36ca5bc123f848ac643b6d50602259b7",
            "Pragmatica",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Pragmatica",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Pragmatica",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "8ebe3248143db352da56805017ca7934",
            "Pragmatica",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Pragmatica",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "4b69cc4ce483966efd99a637882c74a5",
            "Pragmatica",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "88950808c1357581d744cc4f308d9f94",
            "Pragmatica",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Pragmatica",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "c04f563b6a1457ae02100e98a49654c6",
            "Pragmatica",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Pragmatica",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Pragmatica",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Pragmatica",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Pragmatica",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Pragmatica",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "45f11e2ac1181359f4004a104c49f31d",
            "Pragmatica",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Pragmatica",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Pragmatica",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "35ffcac4445202ebcfefa85630823de6",
            "Pragmatica",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "e208cca764688975f3d7d3839228dea0",
            "Atenta",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Atenta",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Atenta",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "50441227356a2e75a4737b2cfe84709b",
            "Atenta",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "88950808c1357581d744cc4f308d9f94",
            "Atenta",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Atenta",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "06510c0260d17a867a598617cc3f59e9",
            "Atenta",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "35ffcac4445202ebcfefa85630823de6",
            "Atenta",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Atenta",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Atenta",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "06779a9920e25578b6f504fcbd0ca169",
            "Atenta",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "e28128adc0e75357f447267c07afb6a6",
            "Atenta",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Atenta",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "ac3bae306ba295282462c4e44068b38a",
            "Atenta",
            "Geller"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Atenta",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "36ca5bc123f848ac643b6d50602259b7",
            "Atenta",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Atenta",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "73138474522e9719f1a246b6fff9af38",
            "Atenta",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "c87f74a6084f73fdad817b1589a48a08",
            "Atenta",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "502b3e710c282368c44bf788cb2c7ed2",
            "4b69cc4ce483966efd99a637882c74a5",
            "Atenta",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "fc2e33377af6aca34a9826245e325cba",
            "Heisei Mincho",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Heisei Mincho",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "f0249a1bec67973885bada20741c70c2",
            "Heisei Mincho",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Heisei Mincho",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Heisei Mincho",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Heisei Mincho",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "d3caacfedf638f98ba7b0046f297f421",
            "Heisei Mincho",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "87791721b0238c72031ce39e346933a8",
            "Heisei Mincho",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Heisei Mincho",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Heisei Mincho",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Heisei Mincho",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "9e6867c857655e9d1984390fdf1dde45",
            "Heisei Mincho",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Heisei Mincho",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Heisei Mincho",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "c63e8810388d85594540bb5f6980f611",
            "Heisei Mincho",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Heisei Mincho",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "147f1bb910d4c3487efd5789736afc3b",
            "Heisei Mincho",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "50441227356a2e75a4737b2cfe84709b",
            "cc764ebb17c10db21cd67451fce38448",
            "Heisei Mincho",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "8ebe3248143db352da56805017ca7934",
            "TG Aqsa Grotesque Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "TG Aqsa Grotesque Pro",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "cfbb9acb121612b62a247f211e51cb3e",
            "TG Aqsa Grotesque Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "8c155b53e011d2a709548865b3edbeaf",
            "TG Aqsa Grotesque Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "adc9e6f8703a21e134aa72d637646fdc",
            "TG Aqsa Grotesque Pro",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "737e1d3f1693de9fd863057622d1bb02",
            "TG Aqsa Grotesque Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "c04f563b6a1457ae02100e98a49654c6",
            "TG Aqsa Grotesque Pro",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "TG Aqsa Grotesque Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "TG Aqsa Grotesque Pro",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "d4df1a651052c6bd88be57660da085ac",
            "TG Aqsa Grotesque Pro",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "TG Aqsa Grotesque Pro",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "3bc217606a2f4a22131f20c24de7ac75",
            "TG Aqsa Grotesque Pro",
            "Garth Graphic"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "9da983bd95342b2184596f18ef3fff34",
            "TG Aqsa Grotesque Pro",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "e093c040c71b04f76b2b181a6dd3acea",
            "TG Aqsa Grotesque Pro",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "TG Aqsa Grotesque Pro",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "TG Aqsa Grotesque Pro",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "c2722fea792cde12a9117da6e0d70f74",
            "TG Aqsa Grotesque Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "TG Aqsa Grotesque Pro",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "TG Aqsa Grotesque Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "5067a55cd4114cbf808adbf3b4676e1a",
            "38f28a6682e9d705522a7ac7a715578f",
            "TG Aqsa Grotesque Pro",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Calluna Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Calluna Sans",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "c04f563b6a1457ae02100e98a49654c6",
            "Calluna Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Calluna Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Calluna Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Calluna Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Calluna Sans",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "103510159c0a328260730731e27eabe1",
            "Calluna Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "3d42e5b4eac967ce5300247f880dc1fa",
            "Calluna Sans",
            "BirkaLTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "d87ffd42ab39a3412ab905084e31b782",
            "Calluna Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Calluna Sans",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "6f624e656d641d366084d9fabaa1fd6a",
            "Calluna Sans",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Calluna Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Calluna Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "2d0b4f3a328383b8486d150666306efe",
            "Calluna Sans",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Calluna Sans",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "9001cd9b7b209eebef43419463ef6c40",
            "Calluna Sans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "3bc217606a2f4a22131f20c24de7ac75",
            "Calluna Sans",
            "Garth Graphic"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "820a3fdbd8299ef1a164763cba53587e",
            "Calluna Sans",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "51eb849300954cdecf9da1310c79beb2",
            "73138474522e9719f1a246b6fff9af38",
            "Calluna Sans",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Creo",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Creo",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "8c155b53e011d2a709548865b3edbeaf",
            "Creo",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Creo",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Creo",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "c7117e8442a401bc7dd78049829ef83b",
            "Creo",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "b127070b4065a62961b2bf60fb763a76",
            "Creo",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Creo",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Creo",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Creo",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Creo",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "c2722fea792cde12a9117da6e0d70f74",
            "Creo",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "b74bf78a743785e3df7e3f14477a1390",
            "Creo",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "cc3e79c959420501e528f6b20113c185",
            "Creo",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "522423ab26a3b1f5bb0d40a81ec91262",
            "bad316ad74318a9f95d0749417edfa04",
            "Creo",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "2af66ddecaa7893391cb90362043d37a",
            "GazetteLTStd-Roman",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "GazetteLTStd-Roman",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "GazetteLTStd-Roman",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "GazetteLTStd-Roman",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "033528c5f0137b017eff21079bd25a60",
            "GazetteLTStd-Roman",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "e1351e92b91e4de955c73093b43ae8e2",
            "GazetteLTStd-Roman",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "GazetteLTStd-Roman",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "f0249a1bec67973885bada20741c70c2",
            "GazetteLTStd-Roman",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "de9599121cf31a08904a48495fadcf4a",
            "GazetteLTStd-Roman",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "f01435736b8b73793ad270cdf379a860",
            "GazetteLTStd-Roman",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "GazetteLTStd-Roman",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "b24744ca2bf3616294271353ec837099",
            "GazetteLTStd-Roman",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "GazetteLTStd-Roman",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "GazetteLTStd-Roman",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "GazetteLTStd-Roman",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "11a56cbb71e23af5abcff867473f961a",
            "GazetteLTStd-Roman",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "fc2e33377af6aca34a9826245e325cba",
            "GazetteLTStd-Roman",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "GazetteLTStd-Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "GazetteLTStd-Roman",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "264a4ae29758ba917346fe9763531666",
            "GazetteLTStd-Roman",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Neue Frutiger",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Neue Frutiger",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "b127070b4065a62961b2bf60fb763a76",
            "Neue Frutiger",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Neue Frutiger",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Neue Frutiger",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Neue Frutiger",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "73e48b94c08d2015315dbceaf56efb62",
            "Neue Frutiger",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "3319dd949835e43d4bed270f465aff3e",
            "Neue Frutiger",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "Neue Frutiger",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Neue Frutiger",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "5bd81732a879ba42412c19bd5a33589b",
            "Neue Frutiger",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Neue Frutiger",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "50441227356a2e75a4737b2cfe84709b",
            "Neue Frutiger",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "c2722fea792cde12a9117da6e0d70f74",
            "Neue Frutiger",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Neue Frutiger",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Acta",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "b832321e77d0f1be2c00712330066c3e",
            "Acta",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Acta",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Acta",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Acta",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Acta",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Acta",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "c63e8810388d85594540bb5f6980f611",
            "Acta",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Acta",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Acta",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "b941ce467c4b7f2846b3226ae7988452",
            "Acta",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Acta",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Acta",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "9e6867c857655e9d1984390fdf1dde45",
            "Acta",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "095898e12700edc69d52ecf30ef03e2a",
            "Acta",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Acta",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Acta",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Acta",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "533d9bed7b774dc03d7071032340f9c5",
            "82550c10af201d56d90be26b8833ac63",
            "Acta",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "c6ff032bd835e2f806009627251b87b6",
            "Cambria",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "b832321e77d0f1be2c00712330066c3e",
            "Cambria",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Cambria",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Cambria",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "264a4ae29758ba917346fe9763531666",
            "Cambria",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Cambria",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "280c82457252f3613b33e3791c375caf",
            "Cambria",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "2b443d68adf1ec97623afac779dc9572",
            "Cambria",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Cambria",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Cambria",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Cambria",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Cambria",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Cambria",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "38c216ced240e8111b587a31e2fc5794",
            "Cambria",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Cambria",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Cambria",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "3a2f35b17543f0f3464b26e080b16634",
            "Cambria",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "9e6867c857655e9d1984390fdf1dde45",
            "Cambria",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "2af66ddecaa7893391cb90362043d37a",
            "Cambria",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "535f79f088e3c680b94a53258330a712",
            "cdfdc5eeac0bd71254929817415fb502",
            "Cambria",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "5392c3a915aaad224a94a891d3b3b4da",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "BR Sonoma",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "54e3a21131de6eef0e771cba2f51e359",
            "8ebe3248143db352da56805017ca7934",
            "Sofia Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "ea90949476110422d67b9af4f8ace3a2",
            "NCT Larkspur",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "NCT Larkspur",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "NCT Larkspur",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "650bcadc2c69543d997704b29b7c50d2",
            "NCT Larkspur",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "d3caacfedf638f98ba7b0046f297f421",
            "NCT Larkspur",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "38b203ce41804d19e934461faf557ecb",
            "NCT Larkspur",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "147f1bb910d4c3487efd5789736afc3b",
            "NCT Larkspur",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "562b6ef730de2f21045076a67ebe852c",
            "cc764ebb17c10db21cd67451fce38448",
            "NCT Larkspur",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "565f10ac096eb5d75c4400509e23cdc1",
            "50441227356a2e75a4737b2cfe84709b",
            "Schnebel Sans Pro",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "565f10ac096eb5d75c4400509e23cdc1",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Schnebel Sans Pro",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "565f10ac096eb5d75c4400509e23cdc1",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Schnebel Sans Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "565f10ac096eb5d75c4400509e23cdc1",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Schnebel Sans Pro",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Liteweit",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "5bd81732a879ba42412c19bd5a33589b",
            "Liteweit",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "8ebe3248143db352da56805017ca7934",
            "Liteweit",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Liteweit",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "386528d2feb209e45554ed0fa03d81ce",
            "Liteweit",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "c2722fea792cde12a9117da6e0d70f74",
            "Liteweit",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Liteweit",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "cc3e79c959420501e528f6b20113c185",
            "Liteweit",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "b74bf78a743785e3df7e3f14477a1390",
            "Liteweit",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "b127070b4065a62961b2bf60fb763a76",
            "Liteweit",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Liteweit",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "56c3f876c94309082e50dc3c7967bdde",
            "bad316ad74318a9f95d0749417edfa04",
            "Liteweit",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "8ebe3248143db352da56805017ca7934",
            "Campton",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "737e1d3f1693de9fd863057622d1bb02",
            "Campton",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Campton",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "c2722fea792cde12a9117da6e0d70f74",
            "Campton",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "b74bf78a743785e3df7e3f14477a1390",
            "Campton",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Campton",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Campton",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "cc3e79c959420501e528f6b20113c185",
            "Campton",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Neue Alte Grotesk",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Neue Alte Grotesk",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "b127070b4065a62961b2bf60fb763a76",
            "Neue Alte Grotesk",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "0f41ebd3d659da540745d00b52334eb0",
            "Neue Alte Grotesk",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Neue Alte Grotesk",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Neue Alte Grotesk",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Neue Alte Grotesk",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "737e1d3f1693de9fd863057622d1bb02",
            "Neue Alte Grotesk",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Neue Alte Grotesk",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Neue Alte Grotesk",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Neue Alte Grotesk",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "8ebe3248143db352da56805017ca7934",
            "Neue Alte Grotesk",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "Neue Alte Grotesk",
            "Adriane Text"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "5f2166fea2000a7b2f6e361c76edeef4",
            "Neue Alte Grotesk",
            "URW Antiqua"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "38f28a6682e9d705522a7ac7a715578f",
            "Neue Alte Grotesk",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "6d47953bebf6a23dc1d89764632524d8",
            "Neue Alte Grotesk",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "3319dd949835e43d4bed270f465aff3e",
            "Neue Alte Grotesk",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Neue Alte Grotesk",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Neue Alte Grotesk",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "57cdd235481768dc73076d8a49a44353",
            "88950808c1357581d744cc4f308d9f94",
            "Neue Alte Grotesk",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Deccan",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Deccan",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Deccan",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "b24744ca2bf3616294271353ec837099",
            "Deccan",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Deccan",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Deccan",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "3a2f35b17543f0f3464b26e080b16634",
            "Deccan",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Deccan",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "b941ce467c4b7f2846b3226ae7988452",
            "Deccan",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Deccan",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "c63e8810388d85594540bb5f6980f611",
            "Deccan",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "5843b72473159a2bd66bc2f0687792a3",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Deccan",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "26830556eeeb7d475fc5a6e1f5ee3c84",
            "Karela",
            "Prelo"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "264a4ae29758ba917346fe9763531666",
            "Karela",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "cdfdc5eeac0bd71254929817415fb502",
            "Karela",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Karela",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "38c216ced240e8111b587a31e2fc5794",
            "Karela",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "fc2e33377af6aca34a9826245e325cba",
            "Karela",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Karela",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Karela",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "9e6867c857655e9d1984390fdf1dde45",
            "Karela",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "147f1bb910d4c3487efd5789736afc3b",
            "Karela",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "58e4e08973787c63acc54d369a60ef59",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "Karela",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Harfang Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Harfang Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Harfang Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "fc2e33377af6aca34a9826245e325cba",
            "Harfang Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Harfang Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "9e6867c857655e9d1984390fdf1dde45",
            "Harfang Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "b941ce467c4b7f2846b3226ae7988452",
            "Harfang Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Harfang Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "c63e8810388d85594540bb5f6980f611",
            "Harfang Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Harfang Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Harfang Pro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "82550c10af201d56d90be26b8833ac63",
            "Harfang Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Harfang Pro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "5a7d711a8f8b9976093b3300e8961b83",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Harfang Pro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Cera Pro",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "67aadae90ce6049659422a925a8a23d4",
            "Cera Pro",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "8ebe3248143db352da56805017ca7934",
            "Cera Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "8c155b53e011d2a709548865b3edbeaf",
            "Cera Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Cera Pro",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Cera Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Cera Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "c2722fea792cde12a9117da6e0d70f74",
            "Cera Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Cera Pro",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Cera Pro",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "b74bf78a743785e3df7e3f14477a1390",
            "Cera Pro",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "cc3e79c959420501e528f6b20113c185",
            "Cera Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Cera Pro",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "6bfb91fb426b2fab33652163c2f538c2",
            "Cera Pro",
            "TT Jenevers"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "bad316ad74318a9f95d0749417edfa04",
            "Cera Pro",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "5b0c3643b9240dd5ab5dd056575c6550",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Cera Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "d87ffd42ab39a3412ab905084e31b782",
            "Hedley New",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "6badb2797a95a552c53a98a0f20c903b",
            "Hedley New",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Hedley New",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Hedley New",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Hedley New",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "e28128adc0e75357f447267c07afb6a6",
            "Hedley New",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Hedley New",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "9ded3c33a83728124405e311fff63b40",
            "Hedley New",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Hedley New",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Hedley New",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Hedley New",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "c638239ea03b75929bff2ce833419ac3",
            "Hedley New",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "c87f74a6084f73fdad817b1589a48a08",
            "Hedley New",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "6b75a9583274793e20e232032200c56d",
            "Hedley New",
            "Foro"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Hedley New",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Hedley New",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Hedley New",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "Hedley New",
            "Synerga Pro"
        ]
    },
    {
        "likedPair": [
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "e0d397e073f334bdc40410c8c4093d9b",
            "Hedley New",
            "Alkes"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Sirius",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Sirius",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Sirius",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "fc2e33377af6aca34a9826245e325cba",
            "Sirius",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Sirius",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Sirius",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "9e6867c857655e9d1984390fdf1dde45",
            "Sirius",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "82550c10af201d56d90be26b8833ac63",
            "Sirius",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "2af66ddecaa7893391cb90362043d37a",
            "Sirius",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "b941ce467c4b7f2846b3226ae7988452",
            "Sirius",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "264a4ae29758ba917346fe9763531666",
            "Sirius",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "095898e12700edc69d52ecf30ef03e2a",
            "Sirius",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "c63e8810388d85594540bb5f6980f611",
            "Sirius",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "51eb849300954cdecf9da1310c79beb2",
            "Sirius",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Sirius",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Sirius",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "5bc11ee6e70bd324d1e9e42d32350841",
            "147f1bb910d4c3487efd5789736afc3b",
            "Sirius",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "TT Rationalist",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "fc2e33377af6aca34a9826245e325cba",
            "TT Rationalist",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "TT Rationalist",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "650bcadc2c69543d997704b29b7c50d2",
            "TT Rationalist",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "TT Rationalist",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "b34fc5fd3820759a8808f554191ecaa2",
            "TT Rationalist",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "627f02177189a33fe40ad427eff5d5bb",
            "TT Rationalist",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "be1ed63669d6244408811624d948c116",
            "TT Rationalist",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "411e30ddd318c0fdf64abd6886591d95",
            "TT Rationalist",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "5ed60e2a7db59ce2fef37170ca825424",
            "TT Rationalist",
            "Coco Sharp"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "7247fda75e05fa32ad9c90b669e3a46b",
            "TT Rationalist",
            "Santral"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "TT Rationalist",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "TT Rationalist",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "TT Rationalist",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "f0249a1bec67973885bada20741c70c2",
            "TT Rationalist",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "TT Rationalist",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "TT Rationalist",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "TT Rationalist",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "cae0af484abd406422956f9621c58b5f",
            "TT Rationalist",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "5bd81732a879ba42412c19bd5a33589b",
            "5067a55cd4114cbf808adbf3b4676e1a",
            "TT Rationalist",
            "TG Aqsa Grotesque Pro"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Novel Sans Pro",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Novel Sans Pro",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Novel Sans Pro",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "d07f2481905eefa80fa98c464d59e260",
            "Novel Sans Pro",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "d87ffd42ab39a3412ab905084e31b782",
            "Novel Sans Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Novel Sans Pro",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Novel Sans Pro",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "c311a16ee279363b5113cbf699325577",
            "Novel Sans Pro",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Novel Sans Pro",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Novel Sans Pro",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "8c155b53e011d2a709548865b3edbeaf",
            "Novel Sans Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Novel Sans Pro",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Novel Sans Pro",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Novel Sans Pro",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Novel Sans Pro",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "cd92499f5905694f796be4b7b3406e49",
            "Novel Sans Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Novel Sans Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Novel Sans Pro",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "24d5d362d6d70239379cd1f356e168ec",
            "Novel Sans Pro",
            "Mundo Serif"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Linotype Centennial",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Linotype Centennial",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "650bcadc2c69543d997704b29b7c50d2",
            "Linotype Centennial",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "f0249a1bec67973885bada20741c70c2",
            "Linotype Centennial",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "d3caacfedf638f98ba7b0046f297f421",
            "Linotype Centennial",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "8223719dee533eb7e895e0a101f4472c",
            "Linotype Centennial",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Linotype Centennial",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "fc2e33377af6aca34a9826245e325cba",
            "Linotype Centennial",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Linotype Centennial",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "f01435736b8b73793ad270cdf379a860",
            "Linotype Centennial",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "de9599121cf31a08904a48495fadcf4a",
            "Linotype Centennial",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "ea90949476110422d67b9af4f8ace3a2",
            "Linotype Centennial",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Linotype Centennial",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Linotype Centennial",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "38b203ce41804d19e934461faf557ecb",
            "Linotype Centennial",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "264a4ae29758ba917346fe9763531666",
            "Linotype Centennial",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Linotype Centennial",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "d159582398d0de4d0b367233acf587ee",
            "Linotype Centennial",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "ac04c5328af335b179cf1827997e1774",
            "Linotype Centennial",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "5deef3f01e195e1ed663c9b01d334f7a",
            "cae0af484abd406422956f9621c58b5f",
            "Linotype Centennial",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Coco Sharp",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Coco Sharp",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Coco Sharp",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "b127070b4065a62961b2bf60fb763a76",
            "Coco Sharp",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "8ebe3248143db352da56805017ca7934",
            "Coco Sharp",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "3319dd949835e43d4bed270f465aff3e",
            "Coco Sharp",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "737e1d3f1693de9fd863057622d1bb02",
            "Coco Sharp",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Coco Sharp",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Coco Sharp",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Coco Sharp",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "c2722fea792cde12a9117da6e0d70f74",
            "Coco Sharp",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Coco Sharp",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "cc3e79c959420501e528f6b20113c185",
            "Coco Sharp",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "b74bf78a743785e3df7e3f14477a1390",
            "Coco Sharp",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "5ed60e2a7db59ce2fef37170ca825424",
            "5bd81732a879ba42412c19bd5a33589b",
            "Coco Sharp",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Tazugane Gothic",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "b127070b4065a62961b2bf60fb763a76",
            "Tazugane Gothic",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Tazugane Gothic",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Tazugane Gothic",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Tazugane Gothic",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Tazugane Gothic",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "386528d2feb209e45554ed0fa03d81ce",
            "Tazugane Gothic",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "Tazugane Gothic",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "3319dd949835e43d4bed270f465aff3e",
            "Tazugane Gothic",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "5bd81732a879ba42412c19bd5a33589b",
            "Tazugane Gothic",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Tazugane Gothic",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "50441227356a2e75a4737b2cfe84709b",
            "Tazugane Gothic",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Tazugane Gothic",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "5efbd0a384381addc2263997954251be",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Tazugane Gothic",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "URW Antiqua",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "fc2e33377af6aca34a9826245e325cba",
            "URW Antiqua",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "URW Antiqua",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "URW Antiqua",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "URW Antiqua",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "b34fc5fd3820759a8808f554191ecaa2",
            "URW Antiqua",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "ebdc49d2fe55718bce1a53f10769e589",
            "URW Antiqua",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "URW Antiqua",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "d159582398d0de4d0b367233acf587ee",
            "URW Antiqua",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "URW Antiqua",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "96da2e3b759f10f9970cef587bf11069",
            "URW Antiqua",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "cae0af484abd406422956f9621c58b5f",
            "URW Antiqua",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "c0351a7e9af75205fea41a3719573876",
            "URW Antiqua",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "URW Antiqua",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "URW Antiqua",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "c2244758e73a4caacb7f2916afe5f38f",
            "URW Antiqua",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "5f2166fea2000a7b2f6e361c76edeef4",
            "82550c10af201d56d90be26b8833ac63",
            "URW Antiqua",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Schulbuch Nord Offc Pro",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "b127070b4065a62961b2bf60fb763a76",
            "Schulbuch Nord Offc Pro",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "e961668cbc083722acbc4a237ca92232",
            "Schulbuch Nord Offc Pro",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Schulbuch Nord Offc Pro",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "3319dd949835e43d4bed270f465aff3e",
            "Schulbuch Nord Offc Pro",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Schulbuch Nord Offc Pro",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "737e1d3f1693de9fd863057622d1bb02",
            "Schulbuch Nord Offc Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Schulbuch Nord Offc Pro",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Schulbuch Nord Offc Pro",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Schulbuch Nord Offc Pro",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "8ebe3248143db352da56805017ca7934",
            "Schulbuch Nord Offc Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "d4df1a651052c6bd88be57660da085ac",
            "Schulbuch Nord Offc Pro",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "45f11e2ac1181359f4004a104c49f31d",
            "Schulbuch Nord Offc Pro",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Schulbuch Nord Offc Pro",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Schulbuch Nord Offc Pro",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Schulbuch Nord Offc Pro",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "88950808c1357581d744cc4f308d9f94",
            "Schulbuch Nord Offc Pro",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Schulbuch Nord Offc Pro",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Schulbuch Nord Offc Pro",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "5f8ffd4c02d5c4f7539a7bd2b7c85970",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Schulbuch Nord Offc Pro",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "8c155b53e011d2a709548865b3edbeaf",
            "Qualion",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Qualion",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "67aadae90ce6049659422a925a8a23d4",
            "Qualion",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Qualion",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Qualion",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Qualion",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "b74bf78a743785e3df7e3f14477a1390",
            "Qualion",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Qualion",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "cc3e79c959420501e528f6b20113c185",
            "Qualion",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "013968ef381969722a37a334b48bbaeb",
            "Qualion",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "c2722fea792cde12a9117da6e0d70f74",
            "Qualion",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "bad316ad74318a9f95d0749417edfa04",
            "Qualion",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "d84e985d428e023bb87368d43461b448",
            "Tabac Slab",
            "SST"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Tabac Slab",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Tabac Slab",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Tabac Slab",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "952a354643df6c41226431ae4990f41e",
            "Tabac Slab",
            "LCT Picon"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "090f944a52ed426dbc544297d0fb9442",
            "Tabac Slab",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Tabac Slab",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Tabac Slab",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "7530f20bfafbb946172b6f36a47d48c0",
            "Tabac Slab",
            "Zapf Humanist 601"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Tabac Slab",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Tabac Slab",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "b832321e77d0f1be2c00712330066c3e",
            "Tabac Slab",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "3a2f35b17543f0f3464b26e080b16634",
            "Tabac Slab",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Tabac Slab",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Tabac Slab",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "c63e8810388d85594540bb5f6980f611",
            "Tabac Slab",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Tabac Slab",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "d485fcb548b17f767a22bd95356d6208",
            "Tabac Slab",
            "Albany"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "9b10e22dac5a2f03af2382f42b609efd",
            "Tabac Slab",
            "ITC Stone Sans II"
        ]
    },
    {
        "likedPair": [
            "623b4e42d48a5d620464ccf3c37cab13",
            "280c82457252f3613b33e3791c375caf",
            "Tabac Slab",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "8ebe3248143db352da56805017ca7934",
            "Pepi/Rudi",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "737e1d3f1693de9fd863057622d1bb02",
            "Pepi/Rudi",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Pepi/Rudi",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Pepi/Rudi",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Pepi/Rudi",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "9da983bd95342b2184596f18ef3fff34",
            "Pepi/Rudi",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "d4df1a651052c6bd88be57660da085ac",
            "Pepi/Rudi",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Pepi/Rudi",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Pepi/Rudi",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "6d47953bebf6a23dc1d89764632524d8",
            "Pepi/Rudi",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Pepi/Rudi",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Pepi/Rudi",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Pepi/Rudi",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "3938fddd18b33d1b1549d30049d6e749",
            "Pepi/Rudi",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Pepi/Rudi",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Pepi/Rudi",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "5bd81732a879ba42412c19bd5a33589b",
            "Pepi/Rudi",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "67aadae90ce6049659422a925a8a23d4",
            "Pepi/Rudi",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Pepi/Rudi",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "627f02177189a33fe40ad427eff5d5bb",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Pepi/Rudi",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Arial",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "b127070b4065a62961b2bf60fb763a76",
            "Arial",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Arial",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Arial",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Arial",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "0f41ebd3d659da540745d00b52334eb0",
            "Arial",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Arial",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "3319dd949835e43d4bed270f465aff3e",
            "Arial",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "737e1d3f1693de9fd863057622d1bb02",
            "Arial",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "c04f563b6a1457ae02100e98a49654c6",
            "Arial",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Arial",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Arial",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Arial",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "88950808c1357581d744cc4f308d9f94",
            "Arial",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Arial",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Arial",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Arial",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "36ca5bc123f848ac643b6d50602259b7",
            "Arial",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Arial",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Arial",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "638083ada0fda5cbe6fe29ed7f5735a9",
            "8c155b53e011d2a709548865b3edbeaf",
            "Bauen",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "638083ada0fda5cbe6fe29ed7f5735a9",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Bauen",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "638083ada0fda5cbe6fe29ed7f5735a9",
            "8ebe3248143db352da56805017ca7934",
            "Bauen",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "638083ada0fda5cbe6fe29ed7f5735a9",
            "c2722fea792cde12a9117da6e0d70f74",
            "Bauen",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "0f41ebd3d659da540745d00b52334eb0",
            "Passenger Sans",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "06510c0260d17a867a598617cc3f59e9",
            "Passenger Sans",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "88950808c1357581d744cc4f308d9f94",
            "Passenger Sans",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Passenger Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Passenger Sans",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Passenger Sans",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Passenger Sans",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "36ca5bc123f848ac643b6d50602259b7",
            "Passenger Sans",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Passenger Sans",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Passenger Sans",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "8171bb293a9276179ab81d26551b93c1",
            "Passenger Sans",
            "Passenger Serif"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Passenger Sans",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "45f11e2ac1181359f4004a104c49f31d",
            "Passenger Sans",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Passenger Sans",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Passenger Sans",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "e208cca764688975f3d7d3839228dea0",
            "Passenger Sans",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Passenger Sans",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Passenger Sans",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Passenger Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "650bcadc2c69543d997704b29b7c50d2",
            "4b69cc4ce483966efd99a637882c74a5",
            "Passenger Sans",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Sonus",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "336870775fb3762c36c707da37eabadf",
            "Sonus",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Sonus",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Sonus",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Sonus",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Sonus",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "09d88839ee48108d4891334024ee38d1",
            "Sonus",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Sonus",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "2d0b4f3a328383b8486d150666306efe",
            "Sonus",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "Sonus",
            "Life"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Sonus",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Sonus",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Sonus",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Sonus",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Sonus",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "c311a16ee279363b5113cbf699325577",
            "Sonus",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "820a3fdbd8299ef1a164763cba53587e",
            "Sonus",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "d07f2481905eefa80fa98c464d59e260",
            "Sonus",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "29093af656f979957ec5d657e96fb363",
            "Sonus",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "651b680c8a811fc64e09ce7cfb1ba58b",
            "623b4e42d48a5d620464ccf3c37cab13",
            "Sonus",
            "Tabac Slab"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "e28128adc0e75357f447267c07afb6a6",
            "Amnesty Trade Gothic W04 Roman",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Amnesty Trade Gothic W04 Roman",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "06510c0260d17a867a598617cc3f59e9",
            "Amnesty Trade Gothic W04 Roman",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "35ffcac4445202ebcfefa85630823de6",
            "Amnesty Trade Gothic W04 Roman",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Amnesty Trade Gothic W04 Roman",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "2c055a7f717a969a129cf78e586c2d39",
            "Amnesty Trade Gothic W04 Roman",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "06779a9920e25578b6f504fcbd0ca169",
            "Amnesty Trade Gothic W04 Roman",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "50441227356a2e75a4737b2cfe84709b",
            "Amnesty Trade Gothic W04 Roman",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Amnesty Trade Gothic W04 Roman",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "afb2c306772fbf472d6549a865bf7339",
            "Amnesty Trade Gothic W04 Roman",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Amnesty Trade Gothic W04 Roman",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "651d20bfc43c6f0cd778bc11d04acad7",
            "8006330b215827a8efcd0e4c791bae76",
            "Amnesty Trade Gothic W04 Roman",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "5bd81732a879ba42412c19bd5a33589b",
            "Antona",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "013968ef381969722a37a334b48bbaeb",
            "Antona",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "50441227356a2e75a4737b2cfe84709b",
            "Antona",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "8006330b215827a8efcd0e4c791bae76",
            "Antona",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Kopius",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Kopius",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Kopius",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Kopius",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Kopius",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "2c3e98d17368b0b428cff1d0c384d032",
            "Kopius",
            "Celias"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "b6249de3d08e3971282740ee906b6a8f",
            "Kopius",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Kopius",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Kopius",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Kopius",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Kopius",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Kopius",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Kopius",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Kopius",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Kopius",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "c0351a7e9af75205fea41a3719573876",
            "Kopius",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "3bc3a738f4507b8feea7502049c474d2",
            "Kopius",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "033528c5f0137b017eff21079bd25a60",
            "Kopius",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "fc2e33377af6aca34a9826245e325cba",
            "Kopius",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "66e1cd5cea19e3f67aab21e8782273c9",
            "fbb9573728984c54a8ca446e19d0972a",
            "Kopius",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Carrig Pro",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Carrig Pro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Carrig Pro",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "9e6867c857655e9d1984390fdf1dde45",
            "Carrig Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Carrig Pro",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "3d295205229224442c34a365d6b885d1",
            "Carrig Pro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Carrig Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "f27264442e7df065b3c26373505c38b6",
            "Carrig Pro",
            "Brother 1816"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Carrig Pro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "51eb849300954cdecf9da1310c79beb2",
            "Carrig Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Carrig Pro",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "c0351a7e9af75205fea41a3719573876",
            "Carrig Pro",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "Carrig Pro",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "67aadae90ce6049659422a925a8a23d4",
            "c63e8810388d85594540bb5f6980f611",
            "Carrig Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "6badb2797a95a552c53a98a0f20c903b",
            "Stella",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Stella",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "d87ffd42ab39a3412ab905084e31b782",
            "Stella",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Stella",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Stella",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Stella",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "6972d76d6b70c4f916337708bc39ae4e",
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "Stella",
            "Synerga Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Foro",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "3a2f35b17543f0f3464b26e080b16634",
            "Foro",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "c6ff032bd835e2f806009627251b87b6",
            "Foro",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Foro",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Foro",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "280c82457252f3613b33e3791c375caf",
            "Foro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Foro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Foro",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "38c216ced240e8111b587a31e2fc5794",
            "Foro",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Foro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "b832321e77d0f1be2c00712330066c3e",
            "Foro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "c63e8810388d85594540bb5f6980f611",
            "Foro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Foro",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "cdfdc5eeac0bd71254929817415fb502",
            "Foro",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "b941ce467c4b7f2846b3226ae7988452",
            "Foro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "9e6867c857655e9d1984390fdf1dde45",
            "Foro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Foro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "fc2e33377af6aca34a9826245e325cba",
            "Foro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Foro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "6b75a9583274793e20e232032200c56d",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Foro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "c6ff032bd835e2f806009627251b87b6",
            "Askan",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "b832321e77d0f1be2c00712330066c3e",
            "Askan",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "2af66ddecaa7893391cb90362043d37a",
            "Askan",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Askan",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Askan",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Askan",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Askan",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Askan",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "38c216ced240e8111b587a31e2fc5794",
            "Askan",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Askan",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "d84e985d428e023bb87368d43461b448",
            "Askan",
            "SST"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Askan",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "9e6867c857655e9d1984390fdf1dde45",
            "Askan",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Askan",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "3a2f35b17543f0f3464b26e080b16634",
            "Askan",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "d18f103cfa62513f991b0f90a814c333",
            "Askan",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "2b443d68adf1ec97623afac779dc9572",
            "Askan",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "280c82457252f3613b33e3791c375caf",
            "Askan",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Askan",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "6badb2797a95a552c53a98a0f20c903b",
            "c63e8810388d85594540bb5f6980f611",
            "Askan",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "TT Jenevers",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "fbb9573728984c54a8ca446e19d0972a",
            "TT Jenevers",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "47e848f1f1b998207926dfb024fa4a48",
            "TT Jenevers",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "c63e8810388d85594540bb5f6980f611",
            "TT Jenevers",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "9e6867c857655e9d1984390fdf1dde45",
            "TT Jenevers",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "TT Jenevers",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "fc2e33377af6aca34a9826245e325cba",
            "TT Jenevers",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "TT Jenevers",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "TT Jenevers",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "82550c10af201d56d90be26b8833ac63",
            "TT Jenevers",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "TT Jenevers",
            "Joanna Sans Nova"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "51eb849300954cdecf9da1310c79beb2",
            "TT Jenevers",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "b941ce467c4b7f2846b3226ae7988452",
            "TT Jenevers",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "TT Jenevers",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "185f07766a2c7cd46ff339e5993e5cac",
            "TT Jenevers",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "095898e12700edc69d52ecf30ef03e2a",
            "TT Jenevers",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "TT Jenevers",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "TT Jenevers",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "6bfb91fb426b2fab33652163c2f538c2",
            "c2244758e73a4caacb7f2916afe5f38f",
            "TT Jenevers",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "f01435736b8b73793ad270cdf379a860",
            "Urge Text",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "11a56cbb71e23af5abcff867473f961a",
            "Urge Text",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "8223719dee533eb7e895e0a101f4472c",
            "Urge Text",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "b832321e77d0f1be2c00712330066c3e",
            "Urge Text",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "f0249a1bec67973885bada20741c70c2",
            "Urge Text",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "264a4ae29758ba917346fe9763531666",
            "Urge Text",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "87791721b0238c72031ce39e346933a8",
            "Urge Text",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Urge Text",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "d3caacfedf638f98ba7b0046f297f421",
            "Urge Text",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "650bcadc2c69543d997704b29b7c50d2",
            "Urge Text",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "2af66ddecaa7893391cb90362043d37a",
            "Urge Text",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "9e6867c857655e9d1984390fdf1dde45",
            "Urge Text",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "ea90949476110422d67b9af4f8ace3a2",
            "Urge Text",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Urge Text",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "38b203ce41804d19e934461faf557ecb",
            "Urge Text",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Urge Text",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Urge Text",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Urge Text",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "cae0af484abd406422956f9621c58b5f",
            "Urge Text",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "273eda1510f145ddc8cfd8bc72824d1c",
            "Urge Text",
            "DF Dejavu Pro"
        ]
    },
    {
        "likedPair": [
            "6cc60fbee266fae6c3fc301ab7962519",
            "50441227356a2e75a4737b2cfe84709b",
            "Trebuchet",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Macklin",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Macklin",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Macklin",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "d3caacfedf638f98ba7b0046f297f421",
            "Macklin",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "650bcadc2c69543d997704b29b7c50d2",
            "Macklin",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "de9599121cf31a08904a48495fadcf4a",
            "Macklin",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "38b203ce41804d19e934461faf557ecb",
            "Macklin",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Macklin",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Macklin",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Macklin",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Macklin",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Macklin",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "f0249a1bec67973885bada20741c70c2",
            "Macklin",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "fc2e33377af6aca34a9826245e325cba",
            "Macklin",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Macklin",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Macklin",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "090f944a52ed426dbc544297d0fb9442",
            "Macklin",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "be1ed63669d6244408811624d948c116",
            "Macklin",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "ea90949476110422d67b9af4f8ace3a2",
            "Macklin",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "6d47953bebf6a23dc1d89764632524d8",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Macklin",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Napolitana MF",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "de9599121cf31a08904a48495fadcf4a",
            "Napolitana MF",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Napolitana MF",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "f0249a1bec67973885bada20741c70c2",
            "Napolitana MF",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "8223719dee533eb7e895e0a101f4472c",
            "Napolitana MF",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "fc2e33377af6aca34a9826245e325cba",
            "Napolitana MF",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Napolitana MF",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "650bcadc2c69543d997704b29b7c50d2",
            "Napolitana MF",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "d3caacfedf638f98ba7b0046f297f421",
            "Napolitana MF",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Napolitana MF",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "ea90949476110422d67b9af4f8ace3a2",
            "Napolitana MF",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "f01435736b8b73793ad270cdf379a860",
            "Napolitana MF",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "38b203ce41804d19e934461faf557ecb",
            "Napolitana MF",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Napolitana MF",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "264a4ae29758ba917346fe9763531666",
            "Napolitana MF",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "87791721b0238c72031ce39e346933a8",
            "Napolitana MF",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Napolitana MF",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "d159582398d0de4d0b367233acf587ee",
            "Napolitana MF",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Napolitana MF",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "6e4bf0177f0e1b459e2b159545de1181",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Napolitana MF",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "6eda47c7a803afb813e0810fdd76fab8",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Harmonia Sans",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "6eda47c7a803afb813e0810fdd76fab8",
            "b127070b4065a62961b2bf60fb763a76",
            "Harmonia Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "6eda47c7a803afb813e0810fdd76fab8",
            "cc3e79c959420501e528f6b20113c185",
            "Harmonia Sans",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "6eda47c7a803afb813e0810fdd76fab8",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Harmonia Sans",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Cassia",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "35641bbe5146f945b85e1e7b34956a73",
            "Cassia",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Cassia",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Cassia",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Cassia",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "2af66ddecaa7893391cb90362043d37a",
            "Cassia",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Cassia",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "b832321e77d0f1be2c00712330066c3e",
            "Cassia",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Cassia",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "87791721b0238c72031ce39e346933a8",
            "Cassia",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "9e6867c857655e9d1984390fdf1dde45",
            "Cassia",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "c63e8810388d85594540bb5f6980f611",
            "Cassia",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "fc2e33377af6aca34a9826245e325cba",
            "Cassia",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Cassia",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "b941ce467c4b7f2846b3226ae7988452",
            "Cassia",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Cassia",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Cassia",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "51eb849300954cdecf9da1310c79beb2",
            "Cassia",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "82550c10af201d56d90be26b8833ac63",
            "Cassia",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "6f624e656d641d366084d9fabaa1fd6a",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Cassia",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Life",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "de9599121cf31a08904a48495fadcf4a",
            "Life",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "8223719dee533eb7e895e0a101f4472c",
            "Life",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Life",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "f0249a1bec67973885bada20741c70c2",
            "Life",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Life",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "f01435736b8b73793ad270cdf379a860",
            "Life",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Life",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "264a4ae29758ba917346fe9763531666",
            "Life",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "fc2e33377af6aca34a9826245e325cba",
            "Life",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "2af66ddecaa7893391cb90362043d37a",
            "Life",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Life",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "650bcadc2c69543d997704b29b7c50d2",
            "Life",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Life",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "ea90949476110422d67b9af4f8ace3a2",
            "Life",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "d3caacfedf638f98ba7b0046f297f421",
            "Life",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "87791721b0238c72031ce39e346933a8",
            "Life",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Life",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "38b203ce41804d19e934461faf557ecb",
            "Life",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "6f6fa02942ef2355b8e1de59dbe601af",
            "c63e8810388d85594540bb5f6980f611",
            "Life",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "c6ff032bd835e2f806009627251b87b6",
            "Tarsus",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "b832321e77d0f1be2c00712330066c3e",
            "Tarsus",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "2af66ddecaa7893391cb90362043d37a",
            "Tarsus",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "38c216ced240e8111b587a31e2fc5794",
            "Tarsus",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Tarsus",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Tarsus",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "280c82457252f3613b33e3791c375caf",
            "Tarsus",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Tarsus",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Tarsus",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "3a2f35b17543f0f3464b26e080b16634",
            "Tarsus",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "d84e985d428e023bb87368d43461b448",
            "Tarsus",
            "SST"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Tarsus",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Tarsus",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Tarsus",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "c63e8810388d85594540bb5f6980f611",
            "Tarsus",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "9e6867c857655e9d1984390fdf1dde45",
            "Tarsus",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "b941ce467c4b7f2846b3226ae7988452",
            "Tarsus",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Tarsus",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Tarsus",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "cdfdc5eeac0bd71254929817415fb502",
            "Tarsus",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "709e2472d2cf1299c88a8a4ebb88f6a0",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Seaside",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "709e2472d2cf1299c88a8a4ebb88f6a0",
            "06510c0260d17a867a598617cc3f59e9",
            "Seaside",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "709e2472d2cf1299c88a8a4ebb88f6a0",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Seaside",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Joanna Sans Nova",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "8c155b53e011d2a709548865b3edbeaf",
            "Joanna Sans Nova",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Joanna Sans Nova",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "103510159c0a328260730731e27eabe1",
            "Joanna Sans Nova",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Joanna Sans Nova",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Joanna Sans Nova",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Joanna Sans Nova",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "8ebe3248143db352da56805017ca7934",
            "Joanna Sans Nova",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "cd92499f5905694f796be4b7b3406e49",
            "Joanna Sans Nova",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "820a3fdbd8299ef1a164763cba53587e",
            "Joanna Sans Nova",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "3d42e5b4eac967ce5300247f880dc1fa",
            "Joanna Sans Nova",
            "BirkaLTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Joanna Sans Nova",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "71ce2a4123e21bfb630f651363b756f3",
            "Joanna Sans Nova",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Bunyan Pro",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Bunyan Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Bunyan Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Bunyan Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "033528c5f0137b017eff21079bd25a60",
            "Bunyan Pro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "b832321e77d0f1be2c00712330066c3e",
            "Bunyan Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Bunyan Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Bunyan Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Bunyan Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Bunyan Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Bunyan Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Bunyan Pro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "35641bbe5146f945b85e1e7b34956a73",
            "Bunyan Pro",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "51eb849300954cdecf9da1310c79beb2",
            "Bunyan Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "3d295205229224442c34a365d6b885d1",
            "Bunyan Pro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Bunyan Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Bunyan Pro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "b941ce467c4b7f2846b3226ae7988452",
            "Bunyan Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "c63e8810388d85594540bb5f6980f611",
            "Bunyan Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "71ce2a4123e21bfb630f651363b756f3",
            "095898e12700edc69d52ecf30ef03e2a",
            "Bunyan Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "7247fda75e05fa32ad9c90b669e3a46b",
            "8ebe3248143db352da56805017ca7934",
            "Santral",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "7247fda75e05fa32ad9c90b669e3a46b",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Santral",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7247fda75e05fa32ad9c90b669e3a46b",
            "b127070b4065a62961b2bf60fb763a76",
            "Santral",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7247fda75e05fa32ad9c90b669e3a46b",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Santral",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "7247fda75e05fa32ad9c90b669e3a46b",
            "cc3e79c959420501e528f6b20113c185",
            "Santral",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "8c155b53e011d2a709548865b3edbeaf",
            "Madera",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "6d47953bebf6a23dc1d89764632524d8",
            "Madera",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Madera",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Madera",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Madera",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "67aadae90ce6049659422a925a8a23d4",
            "Madera",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Madera",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "6bfb91fb426b2fab33652163c2f538c2",
            "Madera",
            "TT Jenevers"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "8ebe3248143db352da56805017ca7934",
            "Madera",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Madera",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "b74bf78a743785e3df7e3f14477a1390",
            "Madera",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Madera",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "cc3e79c959420501e528f6b20113c185",
            "Madera",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "c2722fea792cde12a9117da6e0d70f74",
            "Madera",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "955b9a400ce5accf68307eaad62c4f62",
            "Madera",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "bad316ad74318a9f95d0749417edfa04",
            "Madera",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Madera",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Madera",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "FS Brabo Paneuropean",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "280c82457252f3613b33e3791c375caf",
            "FS Brabo Paneuropean",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "2af66ddecaa7893391cb90362043d37a",
            "FS Brabo Paneuropean",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "b832321e77d0f1be2c00712330066c3e",
            "FS Brabo Paneuropean",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "FS Brabo Paneuropean",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "9e6867c857655e9d1984390fdf1dde45",
            "FS Brabo Paneuropean",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "264a4ae29758ba917346fe9763531666",
            "FS Brabo Paneuropean",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "FS Brabo Paneuropean",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "c63e8810388d85594540bb5f6980f611",
            "FS Brabo Paneuropean",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "b34fc5fd3820759a8808f554191ecaa2",
            "FS Brabo Paneuropean",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "35641bbe5146f945b85e1e7b34956a73",
            "FS Brabo Paneuropean",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FS Brabo Paneuropean",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "e1864ebcfe34672f435c3bedacde5d63",
            "FS Brabo Paneuropean",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "FS Brabo Paneuropean",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "b941ce467c4b7f2846b3226ae7988452",
            "FS Brabo Paneuropean",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "FS Brabo Paneuropean",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "91f1a74434b4ecc9129239ec3e236b42",
            "FS Brabo Paneuropean",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "FS Brabo Paneuropean",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "FS Brabo Paneuropean",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "73138474522e9719f1a246b6fff9af38",
            "fc2e33377af6aca34a9826245e325cba",
            "FS Brabo Paneuropean",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Prillwitz Pro",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Prillwitz Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "f0249a1bec67973885bada20741c70c2",
            "Prillwitz Pro",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "fc2e33377af6aca34a9826245e325cba",
            "Prillwitz Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "650bcadc2c69543d997704b29b7c50d2",
            "Prillwitz Pro",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Prillwitz Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "d3caacfedf638f98ba7b0046f297f421",
            "Prillwitz Pro",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Prillwitz Pro",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "8223719dee533eb7e895e0a101f4472c",
            "Prillwitz Pro",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Prillwitz Pro",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "de9599121cf31a08904a48495fadcf4a",
            "Prillwitz Pro",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Prillwitz Pro",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "f01435736b8b73793ad270cdf379a860",
            "Prillwitz Pro",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "ea90949476110422d67b9af4f8ace3a2",
            "Prillwitz Pro",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Prillwitz Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Prillwitz Pro",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "264a4ae29758ba917346fe9763531666",
            "Prillwitz Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "38b203ce41804d19e934461faf557ecb",
            "Prillwitz Pro",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "cae0af484abd406422956f9621c58b5f",
            "Prillwitz Pro",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "737e1d3f1693de9fd863057622d1bb02",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Prillwitz Pro",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "033528c5f0137b017eff21079bd25a60",
            "Garvis Pro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "fbb9573728984c54a8ca446e19d0972a",
            "Garvis Pro",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Garvis Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Garvis Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "2af66ddecaa7893391cb90362043d37a",
            "Garvis Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Garvis Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Garvis Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Garvis Pro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Garvis Pro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "9e6867c857655e9d1984390fdf1dde45",
            "Garvis Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "650bcadc2c69543d997704b29b7c50d2",
            "Garvis Pro",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "b24744ca2bf3616294271353ec837099",
            "Garvis Pro",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "82550c10af201d56d90be26b8833ac63",
            "Garvis Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "c63e8810388d85594540bb5f6980f611",
            "Garvis Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "fc2e33377af6aca34a9826245e325cba",
            "Garvis Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Garvis Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "51eb849300954cdecf9da1310c79beb2",
            "Garvis Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "b941ce467c4b7f2846b3226ae7988452",
            "Garvis Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "264a4ae29758ba917346fe9763531666",
            "Garvis Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "7385300fc2a1109d8d286432af1fcb85",
            "87791721b0238c72031ce39e346933a8",
            "Garvis Pro",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "8223719dee533eb7e895e0a101f4472c",
            "Clarion",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "de9599121cf31a08904a48495fadcf4a",
            "Clarion",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Clarion",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "ea90949476110422d67b9af4f8ace3a2",
            "Clarion",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Clarion",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Clarion",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "650bcadc2c69543d997704b29b7c50d2",
            "Clarion",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "fc2e33377af6aca34a9826245e325cba",
            "Clarion",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "f0249a1bec67973885bada20741c70c2",
            "Clarion",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "38b203ce41804d19e934461faf557ecb",
            "Clarion",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "f01435736b8b73793ad270cdf379a860",
            "Clarion",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Clarion",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "d3caacfedf638f98ba7b0046f297f421",
            "Clarion",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "264a4ae29758ba917346fe9763531666",
            "Clarion",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Clarion",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Clarion",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "d159582398d0de4d0b367233acf587ee",
            "Clarion",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Clarion",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "ac04c5328af335b179cf1827997e1774",
            "Clarion",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "73bb1b4a2b2fea7122f945255ea437d0",
            "cc764ebb17c10db21cd67451fce38448",
            "Clarion",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "GHEAAspet",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "c6ff032bd835e2f806009627251b87b6",
            "GHEAAspet",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "b832321e77d0f1be2c00712330066c3e",
            "GHEAAspet",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "GHEAAspet",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "280c82457252f3613b33e3791c375caf",
            "GHEAAspet",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "GHEAAspet",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "GHEAAspet",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "9e6867c857655e9d1984390fdf1dde45",
            "GHEAAspet",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "GHEAAspet",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "3d295205229224442c34a365d6b885d1",
            "GHEAAspet",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "GHEAAspet",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "91f1a74434b4ecc9129239ec3e236b42",
            "GHEAAspet",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "d84e985d428e023bb87368d43461b448",
            "GHEAAspet",
            "SST"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "c63e8810388d85594540bb5f6980f611",
            "GHEAAspet",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "b941ce467c4b7f2846b3226ae7988452",
            "GHEAAspet",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "3a2f35b17543f0f3464b26e080b16634",
            "GHEAAspet",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "GHEAAspet",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "c2244758e73a4caacb7f2916afe5f38f",
            "GHEAAspet",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "GHEAAspet",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "73e48b94c08d2015315dbceaf56efb62",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "GHEAAspet",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "8c155b53e011d2a709548865b3edbeaf",
            "Zapf Humanist 601",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Zapf Humanist 601",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Zapf Humanist 601",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Zapf Humanist 601",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "b127070b4065a62961b2bf60fb763a76",
            "Zapf Humanist 601",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "cd92499f5905694f796be4b7b3406e49",
            "Zapf Humanist 601",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Zapf Humanist 601",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Zapf Humanist 601",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Zapf Humanist 601",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Zapf Humanist 601",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Zapf Humanist 601",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Zapf Humanist 601",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Zapf Humanist 601",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "7530f20bfafbb946172b6f36a47d48c0",
            "c7117e8442a401bc7dd78049829ef83b",
            "Zapf Humanist 601",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Okta",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Okta",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Okta",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Okta",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "b127070b4065a62961b2bf60fb763a76",
            "Okta",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Okta",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Okta",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "b74bf78a743785e3df7e3f14477a1390",
            "Okta",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "3319dd949835e43d4bed270f465aff3e",
            "Okta",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "7845af5decbe105e2b0b18d71dce8878",
            "cc3e79c959420501e528f6b20113c185",
            "Okta",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "7aeffcba5052866a8b957264c459f603",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "PF Adamant Sans Pro",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "7aeffcba5052866a8b957264c459f603",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "PF Adamant Sans Pro",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "7aeffcba5052866a8b957264c459f603",
            "2f8e39ec51ce3e60d6cb146b6a21c797",
            "PF Adamant Sans Pro",
            "Synerga Pro"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Franklin Gothic SG",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Franklin Gothic SG",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Franklin Gothic SG",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "e208cca764688975f3d7d3839228dea0",
            "Franklin Gothic SG",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "50441227356a2e75a4737b2cfe84709b",
            "Franklin Gothic SG",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "88950808c1357581d744cc4f308d9f94",
            "Franklin Gothic SG",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Franklin Gothic SG",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Franklin Gothic SG",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Franklin Gothic SG",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "73e48b94c08d2015315dbceaf56efb62",
            "Franklin Gothic SG",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "5deef3f01e195e1ed663c9b01d334f7a",
            "Franklin Gothic SG",
            "Linotype Centennial"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "06510c0260d17a867a598617cc3f59e9",
            "Franklin Gothic SG",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Franklin Gothic SG",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "36ca5bc123f848ac643b6d50602259b7",
            "Franklin Gothic SG",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "35ffcac4445202ebcfefa85630823de6",
            "Franklin Gothic SG",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Franklin Gothic SG",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "Franklin Gothic SG",
            "Adriane Text"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "3319dd949835e43d4bed270f465aff3e",
            "Franklin Gothic SG",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Franklin Gothic SG",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "06779a9920e25578b6f504fcbd0ca169",
            "Franklin Gothic SG",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Applied Sans",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Applied Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Applied Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "6d47953bebf6a23dc1d89764632524d8",
            "Applied Sans",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Applied Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "8ebe3248143db352da56805017ca7934",
            "Applied Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "3319dd949835e43d4bed270f465aff3e",
            "Applied Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Applied Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "e961668cbc083722acbc4a237ca92232",
            "Applied Sans",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Applied Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Applied Sans",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "ef0f22560e30896239545a852fd7f6b4",
            "Applied Sans",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "5bd81732a879ba42412c19bd5a33589b",
            "Applied Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "386528d2feb209e45554ed0fa03d81ce",
            "Applied Sans",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Applied Sans",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "7baec41a3ec1d0673c5a53cff12839b2",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Applied Sans",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Alexandra",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "c6ff032bd835e2f806009627251b87b6",
            "Alexandra",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Alexandra",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Alexandra",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Alexandra",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Alexandra",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Alexandra",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Alexandra",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "3d295205229224442c34a365d6b885d1",
            "Alexandra",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Alexandra",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "9e6867c857655e9d1984390fdf1dde45",
            "Alexandra",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Alexandra",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Alexandra",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "c63e8810388d85594540bb5f6980f611",
            "Alexandra",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Alexandra",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "d84e985d428e023bb87368d43461b448",
            "Alexandra",
            "SST"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Alexandra",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "d18f103cfa62513f991b0f90a814c333",
            "Alexandra",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Alexandra",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "7be0986d9e30fc760c35339e0ebc7b52",
            "9b10e22dac5a2f03af2382f42b609efd",
            "Alexandra",
            "ITC Stone Sans II"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "S\u00e1nchez Niu",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "S\u00e1nchez Niu",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "S\u00e1nchez Niu",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "S\u00e1nchez Niu",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "fbb9573728984c54a8ca446e19d0972a",
            "S\u00e1nchez Niu",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "3bc3a738f4507b8feea7502049c474d2",
            "S\u00e1nchez Niu",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "be1ed63669d6244408811624d948c116",
            "S\u00e1nchez Niu",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "S\u00e1nchez Niu",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "b6249de3d08e3971282740ee906b6a8f",
            "S\u00e1nchez Niu",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "0db105f867c7eb2e491db586cc26b417",
            "S\u00e1nchez Niu",
            "Galano Grotesque"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "256f7672059f72846d940fbd8c97537d",
            "S\u00e1nchez Niu",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "ebdc49d2fe55718bce1a53f10769e589",
            "S\u00e1nchez Niu",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "96aa1c616691a0f807c13b3487bf0998",
            "S\u00e1nchez Niu",
            "Uniform Pro"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "11d514603eca39c0093336bca857f707",
            "S\u00e1nchez Niu",
            "Brahma"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "f02646f18604d6ce339590291ba509e0",
            "S\u00e1nchez Niu",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "54e3a21131de6eef0e771cba2f51e359",
            "S\u00e1nchez Niu",
            "Sofia Pro"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "S\u00e1nchez Niu",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "1ef83e490f20960c356d5bc893c42abe",
            "S\u00e1nchez Niu",
            "Clarika Pro"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "411e30ddd318c0fdf64abd6886591d95",
            "S\u00e1nchez Niu",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "S\u00e1nchez Niu",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Optima Nova",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Optima Nova",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Optima Nova",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Optima Nova",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Optima Nova",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "8c155b53e011d2a709548865b3edbeaf",
            "Optima Nova",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Optima Nova",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "0f41ebd3d659da540745d00b52334eb0",
            "Optima Nova",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "2e21709bc8f416319384ac99bb85cfeb",
            "Optima Nova",
            "ITC Giovanni"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "b127070b4065a62961b2bf60fb763a76",
            "Optima Nova",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Optima Nova",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Optima Nova",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "8ebe3248143db352da56805017ca7934",
            "Optima Nova",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Optima Nova",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Optima Nova",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Optima Nova",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "d65b523fcfc75bf2c7350da6414e75ba",
            "Optima Nova",
            "Ashbury"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "cd92499f5905694f796be4b7b3406e49",
            "Optima Nova",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Optima Nova",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "6bfb91fb426b2fab33652163c2f538c2",
            "Optima Nova",
            "TT Jenevers"
        ]
    },
    {
        "likedPair": [
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "36c50039d788bccb71ca83a792b63c1c",
            "Bau Offc",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "ef0f22560e30896239545a852fd7f6b4",
            "Bau Offc",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Bau Offc",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Bau Offc",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Larsseit",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Larsseit",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Larsseit",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "b127070b4065a62961b2bf60fb763a76",
            "Larsseit",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "0f41ebd3d659da540745d00b52334eb0",
            "Larsseit",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "c7117e8442a401bc7dd78049829ef83b",
            "Larsseit",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Larsseit",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Larsseit",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Larsseit",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Larsseit",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Larsseit",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Larsseit",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "737e1d3f1693de9fd863057622d1bb02",
            "Larsseit",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "3938fddd18b33d1b1549d30049d6e749",
            "Larsseit",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "8ec787f27be4c31cf8c185b0f1310703",
            "Larsseit",
            "Skema Pro"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "Larsseit",
            "ITC Bookman"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Larsseit",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "Larsseit",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Larsseit",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Larsseit",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Monotype Sabon",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "5efbd0a384381addc2263997954251be",
            "Monotype Sabon",
            "Tazugane Gothic"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "e3fd4fa2ddb6738d86521dac4683282d",
            "Monotype Sabon",
            "Atlan"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Monotype Sabon",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Monotype Sabon",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Monotype Sabon",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Monotype Sabon",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "090f944a52ed426dbc544297d0fb9442",
            "Monotype Sabon",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Monotype Sabon",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "522423ab26a3b1f5bb0d40a81ec91262",
            "Monotype Sabon",
            "Creo"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "7ff70643804e5a751a56a4efdce38b87",
            "Monotype Sabon",
            "Aspira"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "Monotype Sabon",
            "Madera"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "3d295205229224442c34a365d6b885d1",
            "Monotype Sabon",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Monotype Sabon",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "9b10e22dac5a2f03af2382f42b609efd",
            "Monotype Sabon",
            "ITC Stone Sans II"
        ]
    },
    {
        "likedPair": [
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "96e633e3b54168cc61a1acd1608084d3",
            "Monotype Sabon",
            "Avenir 55 Roman"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "8223719dee533eb7e895e0a101f4472c",
            "Georgia",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "de9599121cf31a08904a48495fadcf4a",
            "Georgia",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Georgia",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "f0249a1bec67973885bada20741c70c2",
            "Georgia",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "264a4ae29758ba917346fe9763531666",
            "Georgia",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Georgia",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Georgia",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "f01435736b8b73793ad270cdf379a860",
            "Georgia",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Georgia",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "87791721b0238c72031ce39e346933a8",
            "Georgia",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "ea90949476110422d67b9af4f8ace3a2",
            "Georgia",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "fc2e33377af6aca34a9826245e325cba",
            "Georgia",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "38b203ce41804d19e934461faf557ecb",
            "Georgia",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Georgia",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "650bcadc2c69543d997704b29b7c50d2",
            "Georgia",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "d3caacfedf638f98ba7b0046f297f421",
            "Georgia",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "9e6867c857655e9d1984390fdf1dde45",
            "Georgia",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "d159582398d0de4d0b367233acf587ee",
            "Georgia",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Georgia",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Georgia",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "8c155b53e011d2a709548865b3edbeaf",
            "Aspira",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Aspira",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Aspira",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Aspira",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "73e48b94c08d2015315dbceaf56efb62",
            "Aspira",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Aspira",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Aspira",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "b127070b4065a62961b2bf60fb763a76",
            "Aspira",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Aspira",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "cd92499f5905694f796be4b7b3406e49",
            "Aspira",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "c7117e8442a401bc7dd78049829ef83b",
            "Aspira",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "7ff70643804e5a751a56a4efdce38b87",
            "820a3fdbd8299ef1a164763cba53587e",
            "Aspira",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "8223719dee533eb7e895e0a101f4472c",
            "Geneo Std",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "033528c5f0137b017eff21079bd25a60",
            "Geneo Std",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "de9599121cf31a08904a48495fadcf4a",
            "Geneo Std",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "f0249a1bec67973885bada20741c70c2",
            "Geneo Std",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Geneo Std",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Geneo Std",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Geneo Std",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Geneo Std",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "38b203ce41804d19e934461faf557ecb",
            "Geneo Std",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "264a4ae29758ba917346fe9763531666",
            "Geneo Std",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Geneo Std",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "f01435736b8b73793ad270cdf379a860",
            "Geneo Std",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "650bcadc2c69543d997704b29b7c50d2",
            "Geneo Std",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "ea90949476110422d67b9af4f8ace3a2",
            "Geneo Std",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "d3caacfedf638f98ba7b0046f297f421",
            "Geneo Std",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "11a56cbb71e23af5abcff867473f961a",
            "Geneo Std",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Geneo Std",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "87791721b0238c72031ce39e346933a8",
            "Geneo Std",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Geneo Std",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "8006330b215827a8efcd0e4c791bae76",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Geneo Std",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Arazat\u00ed",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "336870775fb3762c36c707da37eabadf",
            "Arazat\u00ed",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Arazat\u00ed",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Arazat\u00ed",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "d07f2481905eefa80fa98c464d59e260",
            "Arazat\u00ed",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Arazat\u00ed",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "103510159c0a328260730731e27eabe1",
            "Arazat\u00ed",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Arazat\u00ed",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Arazat\u00ed",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Arazat\u00ed",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "c04f563b6a1457ae02100e98a49654c6",
            "Arazat\u00ed",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "3d42e5b4eac967ce5300247f880dc1fa",
            "Arazat\u00ed",
            "BirkaLTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Arazat\u00ed",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "6f624e656d641d366084d9fabaa1fd6a",
            "Arazat\u00ed",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "2d0b4f3a328383b8486d150666306efe",
            "Arazat\u00ed",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Arazat\u00ed",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Arazat\u00ed",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Arazat\u00ed",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Arazat\u00ed",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "29093af656f979957ec5d657e96fb363",
            "Arazat\u00ed",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "8ebe3248143db352da56805017ca7934",
            "Kanyon",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "c2722fea792cde12a9117da6e0d70f74",
            "Kanyon",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Kanyon",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Kanyon",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "cc3e79c959420501e528f6b20113c185",
            "Kanyon",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "80e2d3f71380d7613412a147ecc407d7",
            "b74bf78a743785e3df7e3f14477a1390",
            "Kanyon",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Passenger Serif",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Passenger Serif",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "ea90949476110422d67b9af4f8ace3a2",
            "Passenger Serif",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Passenger Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "fc2e33377af6aca34a9826245e325cba",
            "Passenger Serif",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "264a4ae29758ba917346fe9763531666",
            "Passenger Serif",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Passenger Serif",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "d3caacfedf638f98ba7b0046f297f421",
            "Passenger Serif",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "650bcadc2c69543d997704b29b7c50d2",
            "Passenger Serif",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "38b203ce41804d19e934461faf557ecb",
            "Passenger Serif",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "ac04c5328af335b179cf1827997e1774",
            "Passenger Serif",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "147f1bb910d4c3487efd5789736afc3b",
            "Passenger Serif",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "8171bb293a9276179ab81d26551b93c1",
            "cc764ebb17c10db21cd67451fce38448",
            "Passenger Serif",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Quant Text",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "033528c5f0137b017eff21079bd25a60",
            "Quant Text",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Quant Text",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Quant Text",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Quant Text",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "9e6867c857655e9d1984390fdf1dde45",
            "Quant Text",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "fc2e33377af6aca34a9826245e325cba",
            "Quant Text",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Quant Text",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "3d295205229224442c34a365d6b885d1",
            "Quant Text",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "51eb849300954cdecf9da1310c79beb2",
            "Quant Text",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Quant Text",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Quant Text",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "b941ce467c4b7f2846b3226ae7988452",
            "Quant Text",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Quant Text",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "095898e12700edc69d52ecf30ef03e2a",
            "Quant Text",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "c63e8810388d85594540bb5f6980f611",
            "Quant Text",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "820a3fdbd8299ef1a164763cba53587e",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Quant Text",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "e208cca764688975f3d7d3839228dea0",
            "Corporate S",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "50441227356a2e75a4737b2cfe84709b",
            "Corporate S",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "88950808c1357581d744cc4f308d9f94",
            "Corporate S",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "e28128adc0e75357f447267c07afb6a6",
            "Corporate S",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Corporate S",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Corporate S",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Corporate S",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Corporate S",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Corporate S",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "4b69cc4ce483966efd99a637882c74a5",
            "Corporate S",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "06510c0260d17a867a598617cc3f59e9",
            "Corporate S",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "35ffcac4445202ebcfefa85630823de6",
            "Corporate S",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Corporate S",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Corporate S",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Corporate S",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "06779a9920e25578b6f504fcbd0ca169",
            "Corporate S",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "45f11e2ac1181359f4004a104c49f31d",
            "Corporate S",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "Corporate S",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "Corporate S",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "8223719dee533eb7e895e0a101f4472c",
            "c04f563b6a1457ae02100e98a49654c6",
            "Corporate S",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Makozin",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "e208cca764688975f3d7d3839228dea0",
            "Makozin",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Makozin",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "9001cd9b7b209eebef43419463ef6c40",
            "Makozin",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Makozin",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Makozin",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Makozin",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "34a814f80a793fa3eacde02882fa9faa",
            "Makozin",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Makozin",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "d07f2481905eefa80fa98c464d59e260",
            "Makozin",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Makozin",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "2980338e1101915cd8cf85fec19fd126",
            "Makozin",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "6f624e656d641d366084d9fabaa1fd6a",
            "Makozin",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Makozin",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Makozin",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Makozin",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Makozin",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "c638239ea03b75929bff2ce833419ac3",
            "Makozin",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "ef71628ba1ab6310365a78c263679726",
            "Makozin",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "82550c10af201d56d90be26b8833ac63",
            "22556e70e77a4ba87864ff6dbd2862cc",
            "Makozin",
            "RemingaPro"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "8ebe3248143db352da56805017ca7934",
            "Primeform Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "737e1d3f1693de9fd863057622d1bb02",
            "Primeform Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Primeform Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "c2722fea792cde12a9117da6e0d70f74",
            "Primeform Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "cc3e79c959420501e528f6b20113c185",
            "Primeform Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Primeform Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "bad316ad74318a9f95d0749417edfa04",
            "Primeform Pro",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "de9599121cf31a08904a48495fadcf4a",
            "MVB Verdigris Pro",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "033528c5f0137b017eff21079bd25a60",
            "MVB Verdigris Pro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "MVB Verdigris Pro",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "MVB Verdigris Pro",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "MVB Verdigris Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "MVB Verdigris Pro",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "35641bbe5146f945b85e1e7b34956a73",
            "MVB Verdigris Pro",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "3dba1a3608c4e2faba9528b4451fa027",
            "MVB Verdigris Pro",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "b34fc5fd3820759a8808f554191ecaa2",
            "MVB Verdigris Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "d3caacfedf638f98ba7b0046f297f421",
            "MVB Verdigris Pro",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "MVB Verdigris Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "MVB Verdigris Pro",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "090f944a52ed426dbc544297d0fb9442",
            "MVB Verdigris Pro",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "d159582398d0de4d0b367233acf587ee",
            "MVB Verdigris Pro",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "fbb9573728984c54a8ca446e19d0972a",
            "MVB Verdigris Pro",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "da5723a234527888e7dc5e19548f1abb",
            "MVB Verdigris Pro",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "fc2e33377af6aca34a9826245e325cba",
            "MVB Verdigris Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "650bcadc2c69543d997704b29b7c50d2",
            "MVB Verdigris Pro",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "bb53acb0d26b7c34eaca665214b5b781",
            "MVB Verdigris Pro",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "858170a34ed4538c4ce46be2fa57f670",
            "51eb849300954cdecf9da1310c79beb2",
            "MVB Verdigris Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Yorkten Slab",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Yorkten Slab",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Yorkten Slab",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Yorkten Slab",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Yorkten Slab",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Yorkten Slab",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "b6249de3d08e3971282740ee906b6a8f",
            "Yorkten Slab",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "be1ed63669d6244408811624d948c116",
            "Yorkten Slab",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "2c3e98d17368b0b428cff1d0c384d032",
            "Yorkten Slab",
            "Celias"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "0db105f867c7eb2e491db586cc26b417",
            "Yorkten Slab",
            "Galano Grotesque"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "627f02177189a33fe40ad427eff5d5bb",
            "Yorkten Slab",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "7baec41a3ec1d0673c5a53cff12839b2",
            "Yorkten Slab",
            "Applied Sans"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "256f7672059f72846d940fbd8c97537d",
            "Yorkten Slab",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "f5a49aa2213d4997def8db2e67ea89b3",
            "Yorkten Slab",
            "Gentleman"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "54e3a21131de6eef0e771cba2f51e359",
            "Yorkten Slab",
            "Sofia Pro"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Yorkten Slab",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "80e2d3f71380d7613412a147ecc407d7",
            "Yorkten Slab",
            "Kanyon"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "3e2f48d6755b222ba6a508b152c53dd0",
            "Yorkten Slab",
            "Muller"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "Yorkten Slab",
            "Primeform Pro"
        ]
    },
    {
        "likedPair": [
            "85d8f2d0ba0f6b93900052f3b3047991",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Yorkten Slab",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Velino Text",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Velino Text",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Velino Text",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "090f944a52ed426dbc544297d0fb9442",
            "Velino Text",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Velino Text",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Velino Text",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Velino Text",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "b832321e77d0f1be2c00712330066c3e",
            "Velino Text",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Velino Text",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Velino Text",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "c63e8810388d85594540bb5f6980f611",
            "Velino Text",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Velino Text",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "9e6867c857655e9d1984390fdf1dde45",
            "Velino Text",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Velino Text",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "b941ce467c4b7f2846b3226ae7988452",
            "Velino Text",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Velino Text",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Velino Text",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "095898e12700edc69d52ecf30ef03e2a",
            "Velino Text",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Velino Text",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "862844e56f430bb0af08f52dd89f1be0",
            "51eb849300954cdecf9da1310c79beb2",
            "Velino Text",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "8ebe3248143db352da56805017ca7934",
            "Codec Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "737e1d3f1693de9fd863057622d1bb02",
            "Codec Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "6d47953bebf6a23dc1d89764632524d8",
            "Codec Pro",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "3319dd949835e43d4bed270f465aff3e",
            "Codec Pro",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Codec Pro",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "868fc2017554528c8ca4e20974e19480",
            "5bd81732a879ba42412c19bd5a33589b",
            "Codec Pro",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "c04f563b6a1457ae02100e98a49654c6",
            "Malden Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "8ebe3248143db352da56805017ca7934",
            "Malden Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "737e1d3f1693de9fd863057622d1bb02",
            "Malden Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "4b69cc4ce483966efd99a637882c74a5",
            "Malden Sans",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Malden Sans",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "35ffcac4445202ebcfefa85630823de6",
            "Malden Sans",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "38f28a6682e9d705522a7ac7a715578f",
            "Malden Sans",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "6d47953bebf6a23dc1d89764632524d8",
            "Malden Sans",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Malden Sans",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Malden Sans",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Malden Sans",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "5bd81732a879ba42412c19bd5a33589b",
            "Malden Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Malden Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Malden Sans",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Malden Sans",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "Malden Sans",
            "Life"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Malden Sans",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "d4df1a651052c6bd88be57660da085ac",
            "Malden Sans",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Malden Sans",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "87791721b0238c72031ce39e346933a8",
            "36ca5bc123f848ac643b6d50602259b7",
            "Malden Sans",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Micrograma MF",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Micrograma MF",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "de9599121cf31a08904a48495fadcf4a",
            "Micrograma MF",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "8223719dee533eb7e895e0a101f4472c",
            "Micrograma MF",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Micrograma MF",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "f0249a1bec67973885bada20741c70c2",
            "Micrograma MF",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Micrograma MF",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "fc2e33377af6aca34a9826245e325cba",
            "Micrograma MF",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "650bcadc2c69543d997704b29b7c50d2",
            "Micrograma MF",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Micrograma MF",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Micrograma MF",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Micrograma MF",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "d3caacfedf638f98ba7b0046f297f421",
            "Micrograma MF",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "f01435736b8b73793ad270cdf379a860",
            "Micrograma MF",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Micrograma MF",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "264a4ae29758ba917346fe9763531666",
            "Micrograma MF",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "ea90949476110422d67b9af4f8ace3a2",
            "Micrograma MF",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "38b203ce41804d19e934461faf557ecb",
            "Micrograma MF",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Micrograma MF",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "88950808c1357581d744cc4f308d9f94",
            "87791721b0238c72031ce39e346933a8",
            "Micrograma MF",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "b127070b4065a62961b2bf60fb763a76",
            "Trivia Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Trivia Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Trivia Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "0f41ebd3d659da540745d00b52334eb0",
            "Trivia Sans",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "3319dd949835e43d4bed270f465aff3e",
            "Trivia Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "737e1d3f1693de9fd863057622d1bb02",
            "Trivia Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Trivia Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Trivia Sans",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Trivia Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Trivia Sans",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Trivia Sans",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Trivia Sans",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "c04f563b6a1457ae02100e98a49654c6",
            "Trivia Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "8ebe3248143db352da56805017ca7934",
            "Trivia Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "73138474522e9719f1a246b6fff9af38",
            "Trivia Sans",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Trivia Sans",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Trivia Sans",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "88950808c1357581d744cc4f308d9f94",
            "Trivia Sans",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "6d47953bebf6a23dc1d89764632524d8",
            "Trivia Sans",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "899d5f15480b4c036d5ec3eabac9e398",
            "38f28a6682e9d705522a7ac7a715578f",
            "Trivia Sans",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "H Central",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "3319dd949835e43d4bed270f465aff3e",
            "H Central",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "d515a6ca361cc9d1340762f79d8263dd",
            "H Central",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "e961668cbc083722acbc4a237ca92232",
            "H Central",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "5bd81732a879ba42412c19bd5a33589b",
            "H Central",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "ef0f22560e30896239545a852fd7f6b4",
            "H Central",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "386528d2feb209e45554ed0fa03d81ce",
            "H Central",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "H Central",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "H Central",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "H Central",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "899f6baa066fd450e1dbb5d37bd763af",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "H Central",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "JT Collect",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "JT Collect",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "JT Collect",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "c7117e8442a401bc7dd78049829ef83b",
            "JT Collect",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "JT Collect",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "b127070b4065a62961b2bf60fb763a76",
            "JT Collect",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "b74bf78a743785e3df7e3f14477a1390",
            "JT Collect",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "JT Collect",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "JT Collect",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "c2722fea792cde12a9117da6e0d70f74",
            "JT Collect",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "JT Collect",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "cc3e79c959420501e528f6b20113c185",
            "JT Collect",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "8ebe3248143db352da56805017ca7934",
            "JT Collect",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "JT Collect",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "bad316ad74318a9f95d0749417edfa04",
            "JT Collect",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "3319dd949835e43d4bed270f465aff3e",
            "JT Collect",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "89ee0539f225993026d6f49e9cd8e85d",
            "d515a6ca361cc9d1340762f79d8263dd",
            "JT Collect",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Plantin Std Roman",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Plantin Std Roman",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Plantin Std Roman",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "b24744ca2bf3616294271353ec837099",
            "Plantin Std Roman",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "b6249de3d08e3971282740ee906b6a8f",
            "Plantin Std Roman",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Plantin Std Roman",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Plantin Std Roman",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Plantin Std Roman",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "7ff70643804e5a751a56a4efdce38b87",
            "Plantin Std Roman",
            "Aspira"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Plantin Std Roman",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Plantin Std Roman",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "f02646f18604d6ce339590291ba509e0",
            "Plantin Std Roman",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "fbb9573728984c54a8ca446e19d0972a",
            "Plantin Std Roman",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Plantin Std Roman",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Plantin Std Roman",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Plantin Std Roman",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "f5a49aa2213d4997def8db2e67ea89b3",
            "Plantin Std Roman",
            "Gentleman"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "411e30ddd318c0fdf64abd6886591d95",
            "Plantin Std Roman",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "47e848f1f1b998207926dfb024fa4a48",
            "Plantin Std Roman",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "8a4c23e7da3d70d046137d1932f9d536",
            "b941ce467c4b7f2846b3226ae7988452",
            "Plantin Std Roman",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Imperial",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "2af66ddecaa7893391cb90362043d37a",
            "Imperial",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Imperial",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Imperial",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "87791721b0238c72031ce39e346933a8",
            "Imperial",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "033528c5f0137b017eff21079bd25a60",
            "Imperial",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "b24744ca2bf3616294271353ec837099",
            "Imperial",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "11a56cbb71e23af5abcff867473f961a",
            "Imperial",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Imperial",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Imperial",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "fc2e33377af6aca34a9826245e325cba",
            "Imperial",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Imperial",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "f01435736b8b73793ad270cdf379a860",
            "Imperial",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "f0249a1bec67973885bada20741c70c2",
            "Imperial",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Imperial",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Imperial",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Imperial",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "Imperial",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Imperial",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "8a84a077e3b47852136fac569923059b",
            "6cc60fbee266fae6c3fc301ab7962519",
            "Imperial",
            "Trebuchet"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Salom",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Salom",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "09d88839ee48108d4891334024ee38d1",
            "Salom",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "d07f2481905eefa80fa98c464d59e260",
            "Salom",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Salom",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "9001cd9b7b209eebef43419463ef6c40",
            "Salom",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "6badb2797a95a552c53a98a0f20c903b",
            "Salom",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "d87ffd42ab39a3412ab905084e31b782",
            "Salom",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "Salom",
            "FF Franziska"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "c311a16ee279363b5113cbf699325577",
            "Salom",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "6b75a9583274793e20e232032200c56d",
            "Salom",
            "Foro"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Salom",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Salom",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Salom",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Salom",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "0b6dd07ab9ad1fbfc025d8181ffbad5c",
            "Salom",
            "Analogia"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Salom",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "c638239ea03b75929bff2ce833419ac3",
            "Salom",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Salom",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Salom",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "TT Commons \u200b\u200bClassic",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "8ebe3248143db352da56805017ca7934",
            "TT Commons \u200b\u200bClassic",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "737e1d3f1693de9fd863057622d1bb02",
            "TT Commons \u200b\u200bClassic",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "TT Commons \u200b\u200bClassic",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "TT Commons \u200b\u200bClassic",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "e093c040c71b04f76b2b181a6dd3acea",
            "TT Commons \u200b\u200bClassic",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "TT Commons \u200b\u200bClassic",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "3938fddd18b33d1b1549d30049d6e749",
            "TT Commons \u200b\u200bClassic",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "73e48b94c08d2015315dbceaf56efb62",
            "TT Commons \u200b\u200bClassic",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "b127070b4065a62961b2bf60fb763a76",
            "TT Commons \u200b\u200bClassic",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "38f28a6682e9d705522a7ac7a715578f",
            "TT Commons \u200b\u200bClassic",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "TT Commons \u200b\u200bClassic",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "8a84a077e3b47852136fac569923059b",
            "TT Commons \u200b\u200bClassic",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "TT Commons \u200b\u200bClassic",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "6d47953bebf6a23dc1d89764632524d8",
            "TT Commons \u200b\u200bClassic",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "TT Commons \u200b\u200bClassic",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "5bd81732a879ba42412c19bd5a33589b",
            "TT Commons \u200b\u200bClassic",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "8bc363a2d1b8572dde75543187ba1bd6",
            "8006330b215827a8efcd0e4c791bae76",
            "TT Commons \u200b\u200bClassic",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "91f1a74434b4ecc9129239ec3e236b42",
            "PerpetuaMTPro-Regular",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "PerpetuaMTPro-Regular",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "PerpetuaMTPro-Regular",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "PerpetuaMTPro-Regular",
            "Campton"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "PerpetuaMTPro-Regular",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "522423ab26a3b1f5bb0d40a81ec91262",
            "PerpetuaMTPro-Regular",
            "Creo"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "5efbd0a384381addc2263997954251be",
            "PerpetuaMTPro-Regular",
            "Tazugane Gothic"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "5b0c3643b9240dd5ab5dd056575c6550",
            "PerpetuaMTPro-Regular",
            "Cera Pro"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "PerpetuaMTPro-Regular",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "7247fda75e05fa32ad9c90b669e3a46b",
            "PerpetuaMTPro-Regular",
            "Santral"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "9e6867c857655e9d1984390fdf1dde45",
            "PerpetuaMTPro-Regular",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "PerpetuaMTPro-Regular",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "51eb849300954cdecf9da1310c79beb2",
            "PerpetuaMTPro-Regular",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "PerpetuaMTPro-Regular",
            "Gill Sans MT Pro Book"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "PerpetuaMTPro-Regular",
            "Madera"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "PerpetuaMTPro-Regular",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "PerpetuaMTPro-Regular",
            "Joanna Sans Nova"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "35641bbe5146f945b85e1e7b34956a73",
            "PerpetuaMTPro-Regular",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "fbb9573728984c54a8ca446e19d0972a",
            "PerpetuaMTPro-Regular",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "8c155b53e011d2a709548865b3edbeaf",
            "095898e12700edc69d52ecf30ef03e2a",
            "PerpetuaMTPro-Regular",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "3774b4df0b2cb612124f851d40399d26",
            "Milo Serif Pro",
            "Lina"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "2af66ddecaa7893391cb90362043d37a",
            "Milo Serif Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "b832321e77d0f1be2c00712330066c3e",
            "Milo Serif Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "c6ff032bd835e2f806009627251b87b6",
            "Milo Serif Pro",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Milo Serif Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Milo Serif Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Milo Serif Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "38c216ced240e8111b587a31e2fc5794",
            "Milo Serif Pro",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Milo Serif Pro",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Milo Serif Pro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Milo Serif Pro",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Milo Serif Pro",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Milo Serif Pro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "3d295205229224442c34a365d6b885d1",
            "Milo Serif Pro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "280c82457252f3613b33e3791c375caf",
            "Milo Serif Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "38296e69914b73ef3a2786f8da0e19c8",
            "Milo Serif Pro",
            "Corbel"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "3a2f35b17543f0f3464b26e080b16634",
            "Milo Serif Pro",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "095898e12700edc69d52ecf30ef03e2a",
            "Milo Serif Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "d84e985d428e023bb87368d43461b448",
            "Milo Serif Pro",
            "SST"
        ]
    },
    {
        "likedPair": [
            "8d9fd883298c86eeb3d614b7311f8431",
            "2b443d68adf1ec97623afac779dc9572",
            "Milo Serif Pro",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Sanchez Slab",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "3bc3a738f4507b8feea7502049c474d2",
            "Sanchez Slab",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Sanchez Slab",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Sanchez Slab",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "be1ed63669d6244408811624d948c116",
            "Sanchez Slab",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "2836c06f795c236900263fe1e17d245a",
            "Sanchez Slab",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "fbb9573728984c54a8ca446e19d0972a",
            "Sanchez Slab",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "256f7672059f72846d940fbd8c97537d",
            "Sanchez Slab",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Sanchez Slab",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "b6249de3d08e3971282740ee906b6a8f",
            "Sanchez Slab",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Sanchez Slab",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "96aa1c616691a0f807c13b3487bf0998",
            "Sanchez Slab",
            "Uniform Pro"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Sanchez Slab",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "411e30ddd318c0fdf64abd6886591d95",
            "Sanchez Slab",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "f02646f18604d6ce339590291ba509e0",
            "Sanchez Slab",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "Sanchez Slab",
            "Madera"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "0948bcac8c88566853911db4a5ea95e7",
            "Sanchez Slab",
            "Suprema"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "Sanchez Slab",
            "Pontiac"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "96e633e3b54168cc61a1acd1608084d3",
            "Sanchez Slab",
            "Avenir 55 Roman"
        ]
    },
    {
        "likedPair": [
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Sanchez Slab",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "f0249a1bec67973885bada20741c70c2",
            "Walbaum",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "de9599121cf31a08904a48495fadcf4a",
            "Walbaum",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "fc2e33377af6aca34a9826245e325cba",
            "Walbaum",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Walbaum",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Walbaum",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "f01435736b8b73793ad270cdf379a860",
            "Walbaum",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Walbaum",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "d3caacfedf638f98ba7b0046f297f421",
            "Walbaum",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "38b203ce41804d19e934461faf557ecb",
            "Walbaum",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Walbaum",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "090f944a52ed426dbc544297d0fb9442",
            "Walbaum",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Walbaum",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "d159582398d0de4d0b367233acf587ee",
            "Walbaum",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Walbaum",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "cae0af484abd406422956f9621c58b5f",
            "Walbaum",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Walbaum",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "ac04c5328af335b179cf1827997e1774",
            "Walbaum",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "da5723a234527888e7dc5e19548f1abb",
            "Walbaum",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "8ebe3248143db352da56805017ca7934",
            "147f1bb910d4c3487efd5789736afc3b",
            "Walbaum",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Skema Pro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Skema Pro",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "d485fcb548b17f767a22bd95356d6208",
            "Skema Pro",
            "Albany"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Skema Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "fbb9573728984c54a8ca446e19d0972a",
            "Skema Pro",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Skema Pro",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "b832321e77d0f1be2c00712330066c3e",
            "Skema Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Skema Pro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Skema Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Skema Pro",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Skema Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "9e6867c857655e9d1984390fdf1dde45",
            "Skema Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Skema Pro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Skema Pro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "c63e8810388d85594540bb5f6980f611",
            "Skema Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Skema Pro",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "fc2e33377af6aca34a9826245e325cba",
            "Skema Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "b941ce467c4b7f2846b3226ae7988452",
            "Skema Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "82550c10af201d56d90be26b8833ac63",
            "Skema Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "8ec787f27be4c31cf8c185b0f1310703",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Skema Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "8fc1532aeb815a9c0aee2394d5ad710f",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "FF Tisa Sans Paneuropean",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "8fc1532aeb815a9c0aee2394d5ad710f",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "FF Tisa Sans Paneuropean",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "b832321e77d0f1be2c00712330066c3e",
            "Carrara",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "c6ff032bd835e2f806009627251b87b6",
            "Carrara",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Carrara",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "033528c5f0137b017eff21079bd25a60",
            "Carrara",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "280c82457252f3613b33e3791c375caf",
            "Carrara",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Carrara",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Carrara",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "2af66ddecaa7893391cb90362043d37a",
            "Carrara",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "38c216ced240e8111b587a31e2fc5794",
            "Carrara",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Carrara",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "9e6867c857655e9d1984390fdf1dde45",
            "Carrara",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Carrara",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Carrara",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "3d295205229224442c34a365d6b885d1",
            "Carrara",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Carrara",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Carrara",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Carrara",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "d84e985d428e023bb87368d43461b448",
            "Carrara",
            "SST"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "35641bbe5146f945b85e1e7b34956a73",
            "Carrara",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "9001cd9b7b209eebef43419463ef6c40",
            "3a2f35b17543f0f3464b26e080b16634",
            "Carrara",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Valencia Serial",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Valencia Serial",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Valencia Serial",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "650bcadc2c69543d997704b29b7c50d2",
            "Valencia Serial",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "ea90949476110422d67b9af4f8ace3a2",
            "Valencia Serial",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Valencia Serial",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "f0249a1bec67973885bada20741c70c2",
            "Valencia Serial",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Valencia Serial",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "d3caacfedf638f98ba7b0046f297f421",
            "Valencia Serial",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "fc2e33377af6aca34a9826245e325cba",
            "Valencia Serial",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "38b203ce41804d19e934461faf557ecb",
            "Valencia Serial",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Valencia Serial",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Valencia Serial",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "264a4ae29758ba917346fe9763531666",
            "Valencia Serial",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "9038a98bf57fcb8a853acb3adf17bfed",
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "Valencia Serial",
            "Nimbus Sans Round"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Mentor Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Mentor Sans",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "336870775fb3762c36c707da37eabadf",
            "Mentor Sans",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Mentor Sans",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Mentor Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "103510159c0a328260730731e27eabe1",
            "Mentor Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Mentor Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Mentor Sans",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Mentor Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Mentor Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "34a814f80a793fa3eacde02882fa9faa",
            "Mentor Sans",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "d07f2481905eefa80fa98c464d59e260",
            "Mentor Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Mentor Sans",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "29093af656f979957ec5d657e96fb363",
            "Mentor Sans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Mentor Sans",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "ef71628ba1ab6310365a78c263679726",
            "Mentor Sans",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "09d88839ee48108d4891334024ee38d1",
            "Mentor Sans",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "afb2c306772fbf472d6549a865bf7339",
            "Mentor Sans",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "2d0b4f3a328383b8486d150666306efe",
            "Mentor Sans",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "91f1a74434b4ecc9129239ec3e236b42",
            "2980338e1101915cd8cf85fec19fd126",
            "Mentor Sans",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Palatino",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "033528c5f0137b017eff21079bd25a60",
            "Palatino",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Palatino",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Palatino",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Palatino",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Palatino",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Palatino",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "fc2e33377af6aca34a9826245e325cba",
            "Palatino",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Palatino",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "9e6867c857655e9d1984390fdf1dde45",
            "Palatino",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Palatino",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Palatino",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "2ee2a4d30afb9401e33f05d3d3cb7a1e",
            "Palatino",
            "Noah"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "411e30ddd318c0fdf64abd6886591d95",
            "Palatino",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "7ff70643804e5a751a56a4efdce38b87",
            "Palatino",
            "Aspira"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "be1ed63669d6244408811624d948c116",
            "Palatino",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "56ffc3372c0f98f87f07c0d721d0d4f7",
            "Palatino",
            "Campton"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "5067a55cd4114cbf808adbf3b4676e1a",
            "Palatino",
            "TG Aqsa Grotesque Pro"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "b832321e77d0f1be2c00712330066c3e",
            "Palatino",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "9360965dc32616b3be9ca157ebaa44eb",
            "b0f799383351d9ef86939c76bff5bafc",
            "Palatino",
            "Causten"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Oslo",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Oslo",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "737e1d3f1693de9fd863057622d1bb02",
            "Oslo",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "b127070b4065a62961b2bf60fb763a76",
            "Oslo",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Oslo",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "3319dd949835e43d4bed270f465aff3e",
            "Oslo",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "3938fddd18b33d1b1549d30049d6e749",
            "Oslo",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Oslo",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Oslo",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "6d47953bebf6a23dc1d89764632524d8",
            "Oslo",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "8ebe3248143db352da56805017ca7934",
            "Oslo",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Oslo",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "afb2c306772fbf472d6549a865bf7339",
            "Oslo",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "Oslo",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "Oslo",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Oslo",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Oslo",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "d4df1a651052c6bd88be57660da085ac",
            "Oslo",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "e961668cbc083722acbc4a237ca92232",
            "Oslo",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "93b4e55aa9798f96b3a365a441a2238d",
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "Oslo",
            "FF Franziska"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Jasan",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Jasan",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Jasan",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Jasan",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "6d47953bebf6a23dc1d89764632524d8",
            "Jasan",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Jasan",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Jasan",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Jasan",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "3319dd949835e43d4bed270f465aff3e",
            "Jasan",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "b127070b4065a62961b2bf60fb763a76",
            "Jasan",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Jasan",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "d4df1a651052c6bd88be57660da085ac",
            "Jasan",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "73e48b94c08d2015315dbceaf56efb62",
            "Jasan",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "Jasan",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "8a84a077e3b47852136fac569923059b",
            "Jasan",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "50441227356a2e75a4737b2cfe84709b",
            "Jasan",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "5bd81732a879ba42412c19bd5a33589b",
            "Jasan",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "93d2f40ad6d259e63cc39edf32be3d01",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Jasan",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "94b0e0ba124e21340f8d810e1e896eb1",
            "8c155b53e011d2a709548865b3edbeaf",
            "MB Empire",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "6badb2797a95a552c53a98a0f20c903b",
            "LCT Picon",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "LCT Picon",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "LCT Picon",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "LCT Picon",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "LCT Picon",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "2721d6b75a2c057ffe99cad685d1da58",
            "LCT Picon",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "cd92499f5905694f796be4b7b3406e49",
            "LCT Picon",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "LCT Picon",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "LCT Picon",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "862844e56f430bb0af08f52dd89f1be0",
            "LCT Picon",
            "Velino Text"
        ]
    },
    {
        "likedPair": [
            "952a354643df6c41226431ae4990f41e",
            "e0d397e073f334bdc40410c8c4093d9b",
            "LCT Picon",
            "Alkes"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "3bc3a738f4507b8feea7502049c474d2",
            "Nexa Slab",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Nexa Slab",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "be1ed63669d6244408811624d948c116",
            "Nexa Slab",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Nexa Slab",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "256f7672059f72846d940fbd8c97537d",
            "Nexa Slab",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Nexa Slab",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Nexa Slab",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "5067a55cd4114cbf808adbf3b4676e1a",
            "Nexa Slab",
            "TG Aqsa Grotesque Pro"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Nexa Slab",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Nexa Slab",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "96e633e3b54168cc61a1acd1608084d3",
            "Nexa Slab",
            "Avenir 55 Roman"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Nexa Slab",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Nexa Slab",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "b66e057e2a828535b3f7436a93c9f25a",
            "Nexa Slab",
            "Axiforma"
        ]
    },
    {
        "likedPair": [
            "955b9a400ce5accf68307eaad62c4f62",
            "96aa1c616691a0f807c13b3487bf0998",
            "Nexa Slab",
            "Uniform Pro"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "8c155b53e011d2a709548865b3edbeaf",
            "Uniform Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Uniform Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Uniform Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "67aadae90ce6049659422a925a8a23d4",
            "Uniform Pro",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Uniform Pro",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Uniform Pro",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "b74bf78a743785e3df7e3f14477a1390",
            "Uniform Pro",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "c2722fea792cde12a9117da6e0d70f74",
            "Uniform Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "cc3e79c959420501e528f6b20113c185",
            "Uniform Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Uniform Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "96aa1c616691a0f807c13b3487bf0998",
            "955b9a400ce5accf68307eaad62c4f62",
            "Uniform Pro",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "737e1d3f1693de9fd863057622d1bb02",
            "Tenon",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Tenon",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "38f28a6682e9d705522a7ac7a715578f",
            "Tenon",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "3938fddd18b33d1b1549d30049d6e749",
            "Tenon",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Tenon",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Tenon",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "6d47953bebf6a23dc1d89764632524d8",
            "Tenon",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Tenon",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Tenon",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "e961668cbc083722acbc4a237ca92232",
            "Tenon",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Tenon",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "45f11e2ac1181359f4004a104c49f31d",
            "Tenon",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Tenon",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "8a84a077e3b47852136fac569923059b",
            "Tenon",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "5bd81732a879ba42412c19bd5a33589b",
            "Tenon",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "Tenon",
            "FF Franziska"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "ef0f22560e30896239545a852fd7f6b4",
            "Tenon",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Tenon",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "386528d2feb209e45554ed0fa03d81ce",
            "Tenon",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "96da2e3b759f10f9970cef587bf11069",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Tenon",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "cfbb9acb121612b62a247f211e51cb3e",
            "2030",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "2030",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "2030",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "2030",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "2030",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "8ebe3248143db352da56805017ca7934",
            "2030",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "6d47953bebf6a23dc1d89764632524d8",
            "2030",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "b127070b4065a62961b2bf60fb763a76",
            "2030",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "3319dd949835e43d4bed270f465aff3e",
            "2030",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "b74bf78a743785e3df7e3f14477a1390",
            "2030",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "d515a6ca361cc9d1340762f79d8263dd",
            "2030",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "5bd81732a879ba42412c19bd5a33589b",
            "2030",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "955b9a400ce5accf68307eaad62c4f62",
            "2030",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "cc3e79c959420501e528f6b20113c185",
            "2030",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "bad316ad74318a9f95d0749417edfa04",
            "2030",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "2030",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Avenir 55 Roman",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "8c155b53e011d2a709548865b3edbeaf",
            "Avenir 55 Roman",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "c2722fea792cde12a9117da6e0d70f74",
            "Avenir 55 Roman",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Avenir 55 Roman",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Avenir 55 Roman",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Avenir 55 Roman",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Avenir 55 Roman",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Avenir 55 Roman",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Avenir 55 Roman",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "8ebe3248143db352da56805017ca7934",
            "Avenir 55 Roman",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "cc3e79c959420501e528f6b20113c185",
            "Avenir 55 Roman",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Avenir 55 Roman",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "b127070b4065a62961b2bf60fb763a76",
            "Avenir 55 Roman",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Avenir 55 Roman",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "737e1d3f1693de9fd863057622d1bb02",
            "Avenir 55 Roman",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Avenir 55 Roman",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Avenir 55 Roman",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "8a4c23e7da3d70d046137d1932f9d536",
            "Avenir 55 Roman",
            "Plantin Std Roman"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "67aadae90ce6049659422a925a8a23d4",
            "Avenir 55 Roman",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "96e633e3b54168cc61a1acd1608084d3",
            "955b9a400ce5accf68307eaad62c4f62",
            "Avenir 55 Roman",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Malnor Sans",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Malnor Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "c7117e8442a401bc7dd78049829ef83b",
            "Malnor Sans",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Malnor Sans",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Malnor Sans",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "b127070b4065a62961b2bf60fb763a76",
            "Malnor Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "8c155b53e011d2a709548865b3edbeaf",
            "Malnor Sans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Malnor Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Malnor Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Malnor Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Malnor Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Malnor Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "50441227356a2e75a4737b2cfe84709b",
            "Malnor Sans",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "cd92499f5905694f796be4b7b3406e49",
            "Malnor Sans",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "013968ef381969722a37a334b48bbaeb",
            "Malnor Sans",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Malnor Sans",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "97e0e7061f7e1b6a015a4e8980c84647",
            "c2722fea792cde12a9117da6e0d70f74",
            "Malnor Sans",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "de9599121cf31a08904a48495fadcf4a",
            "Marion",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Marion",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Marion",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Marion",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "d3caacfedf638f98ba7b0046f297f421",
            "Marion",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "f0249a1bec67973885bada20741c70c2",
            "Marion",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Marion",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "650bcadc2c69543d997704b29b7c50d2",
            "Marion",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "35641bbe5146f945b85e1e7b34956a73",
            "Marion",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Marion",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Marion",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "fc2e33377af6aca34a9826245e325cba",
            "Marion",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Marion",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "87791721b0238c72031ce39e346933a8",
            "Marion",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "264a4ae29758ba917346fe9763531666",
            "Marion",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Marion",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "2af66ddecaa7893391cb90362043d37a",
            "Marion",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Marion",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Marion",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "99bff8809d2a4c5208c1ba3f0b5035e3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Marion",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Gilroy",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gilroy",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gilroy",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "c2722fea792cde12a9117da6e0d70f74",
            "Gilroy",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "b127070b4065a62961b2bf60fb763a76",
            "Gilroy",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Gilroy",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "737e1d3f1693de9fd863057622d1bb02",
            "Gilroy",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "cc3e79c959420501e528f6b20113c185",
            "Gilroy",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "8ebe3248143db352da56805017ca7934",
            "Gilroy",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Gilroy",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "b74bf78a743785e3df7e3f14477a1390",
            "Gilroy",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "bad316ad74318a9f95d0749417edfa04",
            "Gilroy",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Gilroy",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "2af66ddecaa7893391cb90362043d37a",
            "PT Serif Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "c6ff032bd835e2f806009627251b87b6",
            "PT Serif Pro",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "b832321e77d0f1be2c00712330066c3e",
            "PT Serif Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "d84e985d428e023bb87368d43461b448",
            "PT Serif Pro",
            "SST"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "c63e8810388d85594540bb5f6980f611",
            "PT Serif Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "PT Serif Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "PT Serif Pro",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "PT Serif Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "PT Serif Pro",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "38c216ced240e8111b587a31e2fc5794",
            "PT Serif Pro",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "91f1a74434b4ecc9129239ec3e236b42",
            "PT Serif Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "095898e12700edc69d52ecf30ef03e2a",
            "PT Serif Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "PT Serif Pro",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "b941ce467c4b7f2846b3226ae7988452",
            "PT Serif Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "280c82457252f3613b33e3791c375caf",
            "PT Serif Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "3a2f35b17543f0f3464b26e080b16634",
            "PT Serif Pro",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "9e6867c857655e9d1984390fdf1dde45",
            "PT Serif Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "e1864ebcfe34672f435c3bedacde5d63",
            "PT Serif Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "4a8d414c86f9aeae1489e72e6293e772",
            "PT Serif Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "9a3cbe6536daacbe69badbe58dd024af",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "PT Serif Pro",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Stempel Garamond LT",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Stempel Garamond LT",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Stempel Garamond LT",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "2af66ddecaa7893391cb90362043d37a",
            "Stempel Garamond LT",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Stempel Garamond LT",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "fc2e33377af6aca34a9826245e325cba",
            "Stempel Garamond LT",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "51eb849300954cdecf9da1310c79beb2",
            "Stempel Garamond LT",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "b941ce467c4b7f2846b3226ae7988452",
            "Stempel Garamond LT",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Stempel Garamond LT",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Stempel Garamond LT",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "Stempel Garamond LT",
            "Gill Sans MT Pro Book"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "c63e8810388d85594540bb5f6980f611",
            "Stempel Garamond LT",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "095898e12700edc69d52ecf30ef03e2a",
            "Stempel Garamond LT",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Stempel Garamond LT",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Stempel Garamond LT",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "82550c10af201d56d90be26b8833ac63",
            "Stempel Garamond LT",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Alilon MF",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "de9599121cf31a08904a48495fadcf4a",
            "Alilon MF",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Alilon MF",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "f0249a1bec67973885bada20741c70c2",
            "Alilon MF",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Alilon MF",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "d3caacfedf638f98ba7b0046f297f421",
            "Alilon MF",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "8223719dee533eb7e895e0a101f4472c",
            "Alilon MF",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "fc2e33377af6aca34a9826245e325cba",
            "Alilon MF",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "650bcadc2c69543d997704b29b7c50d2",
            "Alilon MF",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "f01435736b8b73793ad270cdf379a860",
            "Alilon MF",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Alilon MF",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Alilon MF",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "090f944a52ed426dbc544297d0fb9442",
            "Alilon MF",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "264a4ae29758ba917346fe9763531666",
            "Alilon MF",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Alilon MF",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Alilon MF",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Alilon MF",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Alilon MF",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "87791721b0238c72031ce39e346933a8",
            "Alilon MF",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "9ab5daa5796d80adb55febe5da072e8a",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Alilon MF",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "2af66ddecaa7893391cb90362043d37a",
            "Quixo Offc Light",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "d3caacfedf638f98ba7b0046f297f421",
            "Quixo Offc Light",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "38b203ce41804d19e934461faf557ecb",
            "Quixo Offc Light",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Quixo Offc Light",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "f0249a1bec67973885bada20741c70c2",
            "Quixo Offc Light",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Quixo Offc Light",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "650bcadc2c69543d997704b29b7c50d2",
            "Quixo Offc Light",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Quixo Offc Light",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Quixo Offc Light",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "f01435736b8b73793ad270cdf379a860",
            "Quixo Offc Light",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Quixo Offc Light",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "de9599121cf31a08904a48495fadcf4a",
            "Quixo Offc Light",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "87791721b0238c72031ce39e346933a8",
            "Quixo Offc Light",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "033528c5f0137b017eff21079bd25a60",
            "Quixo Offc Light",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Quixo Offc Light",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Quixo Offc Light",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Quixo Offc Light",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "8223719dee533eb7e895e0a101f4472c",
            "Quixo Offc Light",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Quixo Offc Light",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "9aee5dfbc09db7dd09899af1b20620cd",
            "15f6440060216b78f6e867d5cf13fd85",
            "Quixo Offc Light",
            "HangulatinEN-Regular"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "8ebe3248143db352da56805017ca7934",
            "Cardium",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Cardium",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "737e1d3f1693de9fd863057622d1bb02",
            "Cardium",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "67aadae90ce6049659422a925a8a23d4",
            "Cardium",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Cardium",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Cardium",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Cardium",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "b127070b4065a62961b2bf60fb763a76",
            "Cardium",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Cardium",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Cardium",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "8c155b53e011d2a709548865b3edbeaf",
            "Cardium",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "c2722fea792cde12a9117da6e0d70f74",
            "Cardium",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Cardium",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "b74bf78a743785e3df7e3f14477a1390",
            "Cardium",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "cc3e79c959420501e528f6b20113c185",
            "Cardium",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Cardium",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "bad316ad74318a9f95d0749417edfa04",
            "Cardium",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "50441227356a2e75a4737b2cfe84709b",
            "ITC Stone Sans II",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "ITC Stone Sans II",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "ITC Stone Sans II",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "ITC Stone Sans II",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "8c155b53e011d2a709548865b3edbeaf",
            "ITC Stone Sans II",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "b127070b4065a62961b2bf60fb763a76",
            "ITC Stone Sans II",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "ITC Stone Sans II",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "cd92499f5905694f796be4b7b3406e49",
            "ITC Stone Sans II",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "cfbb9acb121612b62a247f211e51cb3e",
            "ITC Stone Sans II",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "73e48b94c08d2015315dbceaf56efb62",
            "ITC Stone Sans II",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "ITC Stone Sans II",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "ITC Stone Sans II",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "c7117e8442a401bc7dd78049829ef83b",
            "ITC Stone Sans II",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "2e21709bc8f416319384ac99bb85cfeb",
            "ITC Stone Sans II",
            "ITC Giovanni"
        ]
    },
    {
        "likedPair": [
            "9b10e22dac5a2f03af2382f42b609efd",
            "862844e56f430bb0af08f52dd89f1be0",
            "ITC Stone Sans II",
            "Velino Text"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "8223719dee533eb7e895e0a101f4472c",
            "Miller Text",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Miller Text",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "033528c5f0137b017eff21079bd25a60",
            "Miller Text",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Miller Text",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Miller Text",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Miller Text",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Miller Text",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "d3caacfedf638f98ba7b0046f297f421",
            "Miller Text",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Miller Text",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "de9599121cf31a08904a48495fadcf4a",
            "Miller Text",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "f0249a1bec67973885bada20741c70c2",
            "Miller Text",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Miller Text",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Miller Text",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "650bcadc2c69543d997704b29b7c50d2",
            "Miller Text",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "38b203ce41804d19e934461faf557ecb",
            "Miller Text",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "fc2e33377af6aca34a9826245e325cba",
            "Miller Text",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "264a4ae29758ba917346fe9763531666",
            "Miller Text",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "ea90949476110422d67b9af4f8ace3a2",
            "Miller Text",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "87791721b0238c72031ce39e346933a8",
            "Miller Text",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "9b642a5046a3cb501e8121b8f96cea5b",
            "f01435736b8b73793ad270cdf379a860",
            "Miller Text",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Toma Sans",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "8c155b53e011d2a709548865b3edbeaf",
            "Toma Sans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "67aadae90ce6049659422a925a8a23d4",
            "Toma Sans",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Toma Sans",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Toma Sans",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Toma Sans",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Toma Sans",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "b74bf78a743785e3df7e3f14477a1390",
            "Toma Sans",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "c2722fea792cde12a9117da6e0d70f74",
            "Toma Sans",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Toma Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "cc3e79c959420501e528f6b20113c185",
            "Toma Sans",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "9ccbb715cfb79436925d6d0d128fdab6",
            "013968ef381969722a37a334b48bbaeb",
            "Toma Sans",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "DIN Next Slab",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "26830556eeeb7d475fc5a6e1f5ee3c84",
            "DIN Next Slab",
            "Prelo"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "cdf497f40577c236216ef39ba5a1ef35",
            "DIN Next Slab",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "ebdc49d2fe55718bce1a53f10769e589",
            "DIN Next Slab",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "2b443d68adf1ec97623afac779dc9572",
            "DIN Next Slab",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "DIN Next Slab",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "147f1bb910d4c3487efd5789736afc3b",
            "DIN Next Slab",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "9e6867c857655e9d1984390fdf1dde45",
            "DIN Next Slab",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "cc764ebb17c10db21cd67451fce38448",
            "DIN Next Slab",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "899d5f15480b4c036d5ec3eabac9e398",
            "DIN Next Slab",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "DIN Next Slab",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "ac04c5328af335b179cf1827997e1774",
            "DIN Next Slab",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "650bcadc2c69543d997704b29b7c50d2",
            "DIN Next Slab",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "9d4006b028ee37610307e9af03bfdf54",
            "502b3e710c282368c44bf788cb2c7ed2",
            "DIN Next Slab",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "de9599121cf31a08904a48495fadcf4a",
            "NewAsterLTStd",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "NewAsterLTStd",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "NewAsterLTStd",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "fc2e33377af6aca34a9826245e325cba",
            "NewAsterLTStd",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "b34fc5fd3820759a8808f554191ecaa2",
            "NewAsterLTStd",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "d3caacfedf638f98ba7b0046f297f421",
            "NewAsterLTStd",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "NewAsterLTStd",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "f0249a1bec67973885bada20741c70c2",
            "NewAsterLTStd",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "NewAsterLTStd",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "38b203ce41804d19e934461faf557ecb",
            "NewAsterLTStd",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "d159582398d0de4d0b367233acf587ee",
            "NewAsterLTStd",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "ebdc49d2fe55718bce1a53f10769e589",
            "NewAsterLTStd",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "NewAsterLTStd",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "dac699b554de5b30f7764b27556f9e9e",
            "NewAsterLTStd",
            "AkzidenzGroteskBQ-Reg"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "dfa1317c450784d1f09730737065a19b",
            "NewAsterLTStd",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "NewAsterLTStd",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "cae0af484abd406422956f9621c58b5f",
            "NewAsterLTStd",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "NewAsterLTStd",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "da5723a234527888e7dc5e19548f1abb",
            "NewAsterLTStd",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "9da983bd95342b2184596f18ef3fff34",
            "96da2e3b759f10f9970cef587bf11069",
            "NewAsterLTStd",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "c6ff032bd835e2f806009627251b87b6",
            "Vigor DT",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Vigor DT",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "b832321e77d0f1be2c00712330066c3e",
            "Vigor DT",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "d84e985d428e023bb87368d43461b448",
            "Vigor DT",
            "SST"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Vigor DT",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Vigor DT",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "d18f103cfa62513f991b0f90a814c333",
            "Vigor DT",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "3a2f35b17543f0f3464b26e080b16634",
            "Vigor DT",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Vigor DT",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Vigor DT",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Vigor DT",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "db2e42ddf6a123ca85bba4367802332d",
            "Vigor DT",
            "RT_Vickerman"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Vigor DT",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Vigor DT",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "38c216ced240e8111b587a31e2fc5794",
            "Vigor DT",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Vigor DT",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "8fc1532aeb815a9c0aee2394d5ad710f",
            "Vigor DT",
            "FF Tisa Sans Paneuropean"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Vigor DT",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "280c82457252f3613b33e3791c375caf",
            "Vigor DT",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "9ded3c33a83728124405e311fff63b40",
            "2b443d68adf1ec97623afac779dc9572",
            "Vigor DT",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "8ebe3248143db352da56805017ca7934",
            "BB Noname (Pro)",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "BB Noname (Pro)",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "3319dd949835e43d4bed270f465aff3e",
            "BB Noname (Pro)",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "d515a6ca361cc9d1340762f79d8263dd",
            "BB Noname (Pro)",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "e961668cbc083722acbc4a237ca92232",
            "BB Noname (Pro)",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "5bd81732a879ba42412c19bd5a33589b",
            "BB Noname (Pro)",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "386528d2feb209e45554ed0fa03d81ce",
            "BB Noname (Pro)",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "9e0288eea87495dffd8e261f7cd68c9d",
            "ef0f22560e30896239545a852fd7f6b4",
            "BB Noname (Pro)",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Skolar Sans Latin",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Skolar Sans Latin",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "cd92499f5905694f796be4b7b3406e49",
            "Skolar Sans Latin",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "ef71628ba1ab6310365a78c263679726",
            "Skolar Sans Latin",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Skolar Sans Latin",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Skolar Sans Latin",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Skolar Sans Latin",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "103510159c0a328260730731e27eabe1",
            "Skolar Sans Latin",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "d07f2481905eefa80fa98c464d59e260",
            "Skolar Sans Latin",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Skolar Sans Latin",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "e208cca764688975f3d7d3839228dea0",
            "Skolar Sans Latin",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Skolar Sans Latin",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "50441227356a2e75a4737b2cfe84709b",
            "Skolar Sans Latin",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "2980338e1101915cd8cf85fec19fd126",
            "Skolar Sans Latin",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "d87ffd42ab39a3412ab905084e31b782",
            "Skolar Sans Latin",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "336870775fb3762c36c707da37eabadf",
            "Skolar Sans Latin",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Skolar Sans Latin",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Skolar Sans Latin",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Skolar Sans Latin",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "9e6867c857655e9d1984390fdf1dde45",
            "71ce2a4123e21bfb630f651363b756f3",
            "Skolar Sans Latin",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Andulka Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "afb2c306772fbf472d6549a865bf7339",
            "Andulka Sans",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Andulka Sans",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Andulka Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Andulka Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "4b69cc4ce483966efd99a637882c74a5",
            "Andulka Sans",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "06779a9920e25578b6f504fcbd0ca169",
            "Andulka Sans",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "336870775fb3762c36c707da37eabadf",
            "Andulka Sans",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Andulka Sans",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "88950808c1357581d744cc4f308d9f94",
            "Andulka Sans",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "35ffcac4445202ebcfefa85630823de6",
            "Andulka Sans",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Andulka Sans",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Andulka Sans",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Andulka Sans",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "09d88839ee48108d4891334024ee38d1",
            "Andulka Sans",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "5a7d711a8f8b9976093b3300e8961b83",
            "Andulka Sans",
            "Harfang Pro"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "73138474522e9719f1a246b6fff9af38",
            "Andulka Sans",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "34a814f80a793fa3eacde02882fa9faa",
            "Andulka Sans",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Andulka Sans",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "ac3bae306ba295282462c4e44068b38a",
            "Andulka Sans",
            "Geller"
        ]
    },
    {
        "likedPair": [
            "9fc82fbd5fdfd1d1a180dea201218761",
            "c2722fea792cde12a9117da6e0d70f74",
            "Century Gothic Paneuropean",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "9fc82fbd5fdfd1d1a180dea201218761",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Century Gothic Paneuropean",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "9fc82fbd5fdfd1d1a180dea201218761",
            "cc3e79c959420501e528f6b20113c185",
            "Century Gothic Paneuropean",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "9fc82fbd5fdfd1d1a180dea201218761",
            "b74bf78a743785e3df7e3f14477a1390",
            "Century Gothic Paneuropean",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "9fc82fbd5fdfd1d1a180dea201218761",
            "bad316ad74318a9f95d0749417edfa04",
            "Century Gothic Paneuropean",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "a0738796db0c7d83d8ba2c54fde1bbaf",
            "8ebe3248143db352da56805017ca7934",
            "Eina",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "a0738796db0c7d83d8ba2c54fde1bbaf",
            "737e1d3f1693de9fd863057622d1bb02",
            "Eina",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "a0738796db0c7d83d8ba2c54fde1bbaf",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Eina",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Freight Neo Pro",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Freight Neo Pro",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Freight Neo Pro",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "103510159c0a328260730731e27eabe1",
            "Freight Neo Pro",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "d07f2481905eefa80fa98c464d59e260",
            "Freight Neo Pro",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Freight Neo Pro",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Freight Neo Pro",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "336870775fb3762c36c707da37eabadf",
            "Freight Neo Pro",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Freight Neo Pro",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "cd92499f5905694f796be4b7b3406e49",
            "Freight Neo Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Freight Neo Pro",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Freight Neo Pro",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Freight Neo Pro",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Freight Neo Pro",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Freight Neo Pro",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "d87ffd42ab39a3412ab905084e31b782",
            "Freight Neo Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "3d42e5b4eac967ce5300247f880dc1fa",
            "Freight Neo Pro",
            "BirkaLTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "3bc217606a2f4a22131f20c24de7ac75",
            "Freight Neo Pro",
            "Garth Graphic"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "34a814f80a793fa3eacde02882fa9faa",
            "Freight Neo Pro",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "a0d65f3e06a945602a59f035c4c9edaf",
            "afb2c306772fbf472d6549a865bf7339",
            "Freight Neo Pro",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "ITC Galliard Pro Roman",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "b34fc5fd3820759a8808f554191ecaa2",
            "ITC Galliard Pro Roman",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "ITC Galliard Pro Roman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "ITC Galliard Pro Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "9e6867c857655e9d1984390fdf1dde45",
            "ITC Galliard Pro Roman",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "91f1a74434b4ecc9129239ec3e236b42",
            "ITC Galliard Pro Roman",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "b941ce467c4b7f2846b3226ae7988452",
            "ITC Galliard Pro Roman",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "c63e8810388d85594540bb5f6980f611",
            "ITC Galliard Pro Roman",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "2af66ddecaa7893391cb90362043d37a",
            "ITC Galliard Pro Roman",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "ITC Galliard Pro Roman",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "c2244758e73a4caacb7f2916afe5f38f",
            "ITC Galliard Pro Roman",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "a3a23b09eaba55f81683d7cb6be6349d",
            "82550c10af201d56d90be26b8833ac63",
            "ITC Galliard Pro Roman",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "3319dd949835e43d4bed270f465aff3e",
            "Nimbus Sans Round",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Nimbus Sans Round",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Nimbus Sans Round",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "6d47953bebf6a23dc1d89764632524d8",
            "Nimbus Sans Round",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "737e1d3f1693de9fd863057622d1bb02",
            "Nimbus Sans Round",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Nimbus Sans Round",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Nimbus Sans Round",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Nimbus Sans Round",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "5bd81732a879ba42412c19bd5a33589b",
            "Nimbus Sans Round",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "afb2c306772fbf472d6549a865bf7339",
            "Nimbus Sans Round",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "3938fddd18b33d1b1549d30049d6e749",
            "Nimbus Sans Round",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "386528d2feb209e45554ed0fa03d81ce",
            "Nimbus Sans Round",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Nimbus Sans Round",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Nimbus Sans Round",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Nimbus Sans Round",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Nimbus Sans Round",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Nimbus Sans Round",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "8ebe3248143db352da56805017ca7934",
            "Nimbus Sans Round",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "ef0f22560e30896239545a852fd7f6b4",
            "Nimbus Sans Round",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "e961668cbc083722acbc4a237ca92232",
            "Nimbus Sans Round",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "b832321e77d0f1be2c00712330066c3e",
            "Capitolina",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "280c82457252f3613b33e3791c375caf",
            "Capitolina",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Capitolina",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Capitolina",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Capitolina",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "2af66ddecaa7893391cb90362043d37a",
            "Capitolina",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Capitolina",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Capitolina",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "9e6867c857655e9d1984390fdf1dde45",
            "Capitolina",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Capitolina",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "38c216ced240e8111b587a31e2fc5794",
            "Capitolina",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "b941ce467c4b7f2846b3226ae7988452",
            "Capitolina",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "35641bbe5146f945b85e1e7b34956a73",
            "Capitolina",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "c63e8810388d85594540bb5f6980f611",
            "Capitolina",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Capitolina",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Capitolina",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Capitolina",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Capitolina",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Capitolina",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "a7ed66c67894164f8aee8e7069688a0d",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Capitolina",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Neuville",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Neuville",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Neuville",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Neuville",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "bad316ad74318a9f95d0749417edfa04",
            "Neuville",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "cc3e79c959420501e528f6b20113c185",
            "Neuville",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "b74bf78a743785e3df7e3f14477a1390",
            "Neuville",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Neuville",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "b127070b4065a62961b2bf60fb763a76",
            "Neuville",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Neuville",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "5bd81732a879ba42412c19bd5a33589b",
            "Neuville",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Neuville",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "a8008a4be1e40b815732b608890c3415",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Neuville",
            "Vicky"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Prumo Banner",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Prumo Banner",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "f0249a1bec67973885bada20741c70c2",
            "Prumo Banner",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "fc2e33377af6aca34a9826245e325cba",
            "Prumo Banner",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "264a4ae29758ba917346fe9763531666",
            "Prumo Banner",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "d3caacfedf638f98ba7b0046f297f421",
            "Prumo Banner",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Prumo Banner",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Prumo Banner",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Prumo Banner",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "87791721b0238c72031ce39e346933a8",
            "Prumo Banner",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "650bcadc2c69543d997704b29b7c50d2",
            "Prumo Banner",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Prumo Banner",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "38b203ce41804d19e934461faf557ecb",
            "Prumo Banner",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "b941ce467c4b7f2846b3226ae7988452",
            "Prumo Banner",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "cae0af484abd406422956f9621c58b5f",
            "Prumo Banner",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "ac04c5328af335b179cf1827997e1774",
            "Prumo Banner",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "c63e8810388d85594540bb5f6980f611",
            "Prumo Banner",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Prumo Banner",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "da5723a234527888e7dc5e19548f1abb",
            "Prumo Banner",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "a8cc661626b8f464f0d19cca4451b7a9",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Prumo Banner",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "8c155b53e011d2a709548865b3edbeaf",
            "Abrade",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Abrade",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Abrade",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "cd92499f5905694f796be4b7b3406e49",
            "Abrade",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "c2722fea792cde12a9117da6e0d70f74",
            "Abrade",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "cc3e79c959420501e528f6b20113c185",
            "Abrade",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "b74bf78a743785e3df7e3f14477a1390",
            "Abrade",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Abrade",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "a910e14cde70597d909540ef6be04677",
            "bad316ad74318a9f95d0749417edfa04",
            "Abrade",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "6d47953bebf6a23dc1d89764632524d8",
            "Dexa Pro",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "737e1d3f1693de9fd863057622d1bb02",
            "Dexa Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Dexa Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "8c155b53e011d2a709548865b3edbeaf",
            "Dexa Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "5bd81732a879ba42412c19bd5a33589b",
            "Dexa Pro",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "c7117e8442a401bc7dd78049829ef83b",
            "Dexa Pro",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Dexa Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "8ebe3248143db352da56805017ca7934",
            "Dexa Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Dexa Pro",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "013968ef381969722a37a334b48bbaeb",
            "Dexa Pro",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Dexa Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "955b9a400ce5accf68307eaad62c4f62",
            "Dexa Pro",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Dexa Pro",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "67aadae90ce6049659422a925a8a23d4",
            "Dexa Pro",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Dexa Pro",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "c2722fea792cde12a9117da6e0d70f74",
            "Dexa Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "b127070b4065a62961b2bf60fb763a76",
            "Dexa Pro",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "b74bf78a743785e3df7e3f14477a1390",
            "Dexa Pro",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "8006330b215827a8efcd0e4c791bae76",
            "Dexa Pro",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "a932edac803361b3470866f58874f633",
            "cc3e79c959420501e528f6b20113c185",
            "Dexa Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "c6ff032bd835e2f806009627251b87b6",
            "Andada-Regular",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Andada-Regular",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Andada-Regular",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "d84e985d428e023bb87368d43461b448",
            "Andada-Regular",
            "SST"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "b832321e77d0f1be2c00712330066c3e",
            "Andada-Regular",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "c63e8810388d85594540bb5f6980f611",
            "Andada-Regular",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "d18f103cfa62513f991b0f90a814c333",
            "Andada-Regular",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Andada-Regular",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Andada-Regular",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "095898e12700edc69d52ecf30ef03e2a",
            "Andada-Regular",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Andada-Regular",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "b941ce467c4b7f2846b3226ae7988452",
            "Andada-Regular",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Andada-Regular",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Andada-Regular",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Andada-Regular",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Andada-Regular",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Andada-Regular",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Andada-Regular",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "3a2f35b17543f0f3464b26e080b16634",
            "Andada-Regular",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Andada-Regular",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "ab8c8aff3daa79ef0b99a7365b29875b",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Qanelas",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "ab8c8aff3daa79ef0b99a7365b29875b",
            "955b9a400ce5accf68307eaad62c4f62",
            "Qanelas",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "ab8c8aff3daa79ef0b99a7365b29875b",
            "bad316ad74318a9f95d0749417edfa04",
            "Qanelas",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "3938fddd18b33d1b1549d30049d6e749",
            "Swiss721 BT Regular",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "6d47953bebf6a23dc1d89764632524d8",
            "Swiss721 BT Regular",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Swiss721 BT Regular",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "3319dd949835e43d4bed270f465aff3e",
            "Swiss721 BT Regular",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "d4df1a651052c6bd88be57660da085ac",
            "Swiss721 BT Regular",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "Swiss721 BT Regular",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "e961668cbc083722acbc4a237ca92232",
            "Swiss721 BT Regular",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Swiss721 BT Regular",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Swiss721 BT Regular",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "b127070b4065a62961b2bf60fb763a76",
            "Swiss721 BT Regular",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Swiss721 BT Regular",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Swiss721 BT Regular",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "8a84a077e3b47852136fac569923059b",
            "Swiss721 BT Regular",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "8ebe3248143db352da56805017ca7934",
            "Swiss721 BT Regular",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "386528d2feb209e45554ed0fa03d81ce",
            "Swiss721 BT Regular",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "5bd81732a879ba42412c19bd5a33589b",
            "Swiss721 BT Regular",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Swiss721 BT Regular",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "ef0f22560e30896239545a852fd7f6b4",
            "Swiss721 BT Regular",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Swiss721 BT Regular",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "ac04c5328af335b179cf1827997e1774",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Swiss721 BT Regular",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "8223719dee533eb7e895e0a101f4472c",
            "Geller",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "264a4ae29758ba917346fe9763531666",
            "Geller",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "f0249a1bec67973885bada20741c70c2",
            "Geller",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Geller",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Geller",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Geller",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "87791721b0238c72031ce39e346933a8",
            "Geller",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Geller",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Geller",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "38b203ce41804d19e934461faf557ecb",
            "Geller",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "650bcadc2c69543d997704b29b7c50d2",
            "Geller",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "2af66ddecaa7893391cb90362043d37a",
            "Geller",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Geller",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Geller",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "9e6867c857655e9d1984390fdf1dde45",
            "Geller",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "fc2e33377af6aca34a9826245e325cba",
            "Geller",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Geller",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Geller",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "c74f77a345edf278a01b806459f255bb",
            "Geller",
            "Neufile Grotesk"
        ]
    },
    {
        "likedPair": [
            "ac3bae306ba295282462c4e44068b38a",
            "c63e8810388d85594540bb5f6980f611",
            "Geller",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "033528c5f0137b017eff21079bd25a60",
            "Amasis",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Amasis",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Amasis",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Amasis",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Amasis",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "de9599121cf31a08904a48495fadcf4a",
            "Amasis",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Amasis",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Amasis",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "090f944a52ed426dbc544297d0fb9442",
            "Amasis",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Amasis",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Amasis",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Amasis",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Amasis",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "be1ed63669d6244408811624d948c116",
            "Amasis",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Amasis",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Amasis",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "d3caacfedf638f98ba7b0046f297f421",
            "Amasis",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "411e30ddd318c0fdf64abd6886591d95",
            "Amasis",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Amasis",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "f0249a1bec67973885bada20741c70c2",
            "Amasis",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "cfbb9acb121612b62a247f211e51cb3e",
            "JT Marnie",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "737e1d3f1693de9fd863057622d1bb02",
            "JT Marnie",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "c2722fea792cde12a9117da6e0d70f74",
            "JT Marnie",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "8ebe3248143db352da56805017ca7934",
            "JT Marnie",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "JT Marnie",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "JT Marnie",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "cc3e79c959420501e528f6b20113c185",
            "JT Marnie",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "b74bf78a743785e3df7e3f14477a1390",
            "JT Marnie",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "adbc4eb9c98764cbba0c53fe0048ccf8",
            "bad316ad74318a9f95d0749417edfa04",
            "JT Marnie",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Versailles LT Com 55 Roman",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Versailles LT Com 55 Roman",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "fc2e33377af6aca34a9826245e325cba",
            "Versailles LT Com 55 Roman",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Versailles LT Com 55 Roman",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "f0249a1bec67973885bada20741c70c2",
            "Versailles LT Com 55 Roman",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Versailles LT Com 55 Roman",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Versailles LT Com 55 Roman",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "fbb9573728984c54a8ca446e19d0972a",
            "Versailles LT Com 55 Roman",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Versailles LT Com 55 Roman",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Versailles LT Com 55 Roman",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Versailles LT Com 55 Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "cae0af484abd406422956f9621c58b5f",
            "Versailles LT Com 55 Roman",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "c0351a7e9af75205fea41a3719573876",
            "Versailles LT Com 55 Roman",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Versailles LT Com 55 Roman",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "b0a90fc4a63c26e4cfa962e289953725",
            "Versailles LT Com 55 Roman",
            "Classic Sans"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "Versailles LT Com 55 Roman",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "96da2e3b759f10f9970cef587bf11069",
            "Versailles LT Com 55 Roman",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "095d77ca120193cc9eb748f725f54dc3",
            "Versailles LT Com 55 Roman",
            "Delecta"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Versailles LT Com 55 Roman",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "adc9e6f8703a21e134aa72d637646fdc",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Versailles LT Com 55 Roman",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "PTL Superla",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "b127070b4065a62961b2bf60fb763a76",
            "PTL Superla",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "cfbb9acb121612b62a247f211e51cb3e",
            "PTL Superla",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "PTL Superla",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "PTL Superla",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "PTL Superla",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "8c155b53e011d2a709548865b3edbeaf",
            "PTL Superla",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "PTL Superla",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "PTL Superla",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "PTL Superla",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "c2722fea792cde12a9117da6e0d70f74",
            "PTL Superla",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "cd92499f5905694f796be4b7b3406e49",
            "PTL Superla",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "PTL Superla",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "5bd81732a879ba42412c19bd5a33589b",
            "PTL Superla",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "ade4f7454af096351cd57c235ecf5030",
            "b74bf78a743785e3df7e3f14477a1390",
            "PTL Superla",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "aea204501fb43b8d0db6d4fc4d01eee5",
            "c2722fea792cde12a9117da6e0d70f74",
            "Futura Now",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "aea204501fb43b8d0db6d4fc4d01eee5",
            "b127070b4065a62961b2bf60fb763a76",
            "Futura Now",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "033528c5f0137b017eff21079bd25a60",
            "TT Livret",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "TT Livret",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "TT Livret",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "TT Livret",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "e1351e92b91e4de955c73093b43ae8e2",
            "TT Livret",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "TT Livret",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "f01435736b8b73793ad270cdf379a860",
            "TT Livret",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "de9599121cf31a08904a48495fadcf4a",
            "TT Livret",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "f0249a1bec67973885bada20741c70c2",
            "TT Livret",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "8223719dee533eb7e895e0a101f4472c",
            "TT Livret",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "TT Livret",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "11a56cbb71e23af5abcff867473f961a",
            "TT Livret",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "899d5f15480b4c036d5ec3eabac9e398",
            "TT Livret",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "264a4ae29758ba917346fe9763531666",
            "TT Livret",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "650bcadc2c69543d997704b29b7c50d2",
            "TT Livret",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "TT Livret",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "d3caacfedf638f98ba7b0046f297f421",
            "TT Livret",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "fe3a6272e385cf422cb1e23f99deb591",
            "TT Livret",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "ea90949476110422d67b9af4f8ace3a2",
            "TT Livret",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "afb2c306772fbf472d6549a865bf7339",
            "38b203ce41804d19e934461faf557ecb",
            "TT Livret",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Classic Sans",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Classic Sans",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Classic Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "b127070b4065a62961b2bf60fb763a76",
            "Classic Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Classic Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "3319dd949835e43d4bed270f465aff3e",
            "Classic Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "c04f563b6a1457ae02100e98a49654c6",
            "Classic Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Classic Sans",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Classic Sans",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Classic Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Classic Sans",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Classic Sans",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "8ebe3248143db352da56805017ca7934",
            "Classic Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "737e1d3f1693de9fd863057622d1bb02",
            "Classic Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "6d47953bebf6a23dc1d89764632524d8",
            "Classic Sans",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Classic Sans",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "3938fddd18b33d1b1549d30049d6e749",
            "Classic Sans",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "5bd81732a879ba42412c19bd5a33589b",
            "Classic Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Classic Sans",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "b0a90fc4a63c26e4cfa962e289953725",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Classic Sans",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "f0249a1bec67973885bada20741c70c2",
            "Breton",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "650bcadc2c69543d997704b29b7c50d2",
            "Breton",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Breton",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Breton",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Breton",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "38b203ce41804d19e934461faf557ecb",
            "Breton",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Breton",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Breton",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "d3caacfedf638f98ba7b0046f297f421",
            "Breton",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "cae0af484abd406422956f9621c58b5f",
            "Breton",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Breton",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "d159582398d0de4d0b367233acf587ee",
            "Breton",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Breton",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "9ccbb715cfb79436925d6d0d128fdab6",
            "Breton",
            "Toma Sans"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Breton",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "f01435736b8b73793ad270cdf379a860",
            "Breton",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "de9599121cf31a08904a48495fadcf4a",
            "Breton",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Breton",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Breton",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "b0ddcd7271d30342377ba7d1683e74d7",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Breton",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Causten",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Causten",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Causten",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Causten",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "b127070b4065a62961b2bf60fb763a76",
            "Causten",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Causten",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "c2722fea792cde12a9117da6e0d70f74",
            "Causten",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Causten",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Causten",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "73e48b94c08d2015315dbceaf56efb62",
            "Causten",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "737e1d3f1693de9fd863057622d1bb02",
            "Causten",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "c7117e8442a401bc7dd78049829ef83b",
            "Causten",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "cc3e79c959420501e528f6b20113c185",
            "Causten",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Causten",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "8ebe3248143db352da56805017ca7934",
            "Causten",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Causten",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "5bd81732a879ba42412c19bd5a33589b",
            "Causten",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "bad316ad74318a9f95d0749417edfa04",
            "Causten",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "3319dd949835e43d4bed270f465aff3e",
            "Causten",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "b0f799383351d9ef86939c76bff5bafc",
            "b74bf78a743785e3df7e3f14477a1390",
            "Causten",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Candida",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Candida",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Candida",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "fc2e33377af6aca34a9826245e325cba",
            "Candida",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Candida",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Candida",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Candida",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Candida",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "090f944a52ed426dbc544297d0fb9442",
            "Candida",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Candida",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Candida",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Candida",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Candida",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Candida",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Candida",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Candida",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Candida",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "5efbd0a384381addc2263997954251be",
            "Candida",
            "Tazugane Gothic"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Candida",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "b127070b4065a62961b2bf60fb763a76",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Candida",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "033528c5f0137b017eff21079bd25a60",
            "Clifford Six Offc Pro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Clifford Six Offc Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "2af66ddecaa7893391cb90362043d37a",
            "Clifford Six Offc Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Clifford Six Offc Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Clifford Six Offc Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "9e6867c857655e9d1984390fdf1dde45",
            "Clifford Six Offc Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Clifford Six Offc Pro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "c63e8810388d85594540bb5f6980f611",
            "Clifford Six Offc Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "fc2e33377af6aca34a9826245e325cba",
            "Clifford Six Offc Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Clifford Six Offc Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "82550c10af201d56d90be26b8833ac63",
            "Clifford Six Offc Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Clifford Six Offc Pro",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "b941ce467c4b7f2846b3226ae7988452",
            "Clifford Six Offc Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Clifford Six Offc Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "51eb849300954cdecf9da1310c79beb2",
            "Clifford Six Offc Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "095898e12700edc69d52ecf30ef03e2a",
            "Clifford Six Offc Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Clifford Six Offc Pro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Clifford Six Offc Pro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "147f1bb910d4c3487efd5789736afc3b",
            "Clifford Six Offc Pro",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Ardena",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "8006330b215827a8efcd0e4c791bae76",
            "Ardena",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "b24744ca2bf3616294271353ec837099",
            "cc3e79c959420501e528f6b20113c185",
            "Nolan Next",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b24744ca2bf3616294271353ec837099",
            "bad316ad74318a9f95d0749417edfa04",
            "Nolan Next",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "b2f56909ab078483f3fe047e833fb8b4",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Fuse",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Acumin",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Acumin",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Acumin",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "b127070b4065a62961b2bf60fb763a76",
            "Acumin",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "d4df1a651052c6bd88be57660da085ac",
            "Acumin",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Acumin",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "36ca5bc123f848ac643b6d50602259b7",
            "Acumin",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Acumin",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Acumin",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Acumin",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Acumin",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Acumin",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Acumin",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "0f41ebd3d659da540745d00b52334eb0",
            "Acumin",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Acumin",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Acumin",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "103510159c0a328260730731e27eabe1",
            "Acumin",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "88950808c1357581d744cc4f308d9f94",
            "Acumin",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Acumin",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "b34fc5fd3820759a8808f554191ecaa2",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Acumin",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "2b443d68adf1ec97623afac779dc9572",
            "Prelo Slab",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "26830556eeeb7d475fc5a6e1f5ee3c84",
            "Prelo Slab",
            "Prelo"
        ]
    },
    {
        "likedPair": [
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Prelo Slab",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "9e6867c857655e9d1984390fdf1dde45",
            "Prelo Slab",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Prelo Slab",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "MeteorObliqueMF-Bold",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "de9599121cf31a08904a48495fadcf4a",
            "MeteorObliqueMF-Bold",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "e1351e92b91e4de955c73093b43ae8e2",
            "MeteorObliqueMF-Bold",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "b34fc5fd3820759a8808f554191ecaa2",
            "MeteorObliqueMF-Bold",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "f0249a1bec67973885bada20741c70c2",
            "MeteorObliqueMF-Bold",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "fc2e33377af6aca34a9826245e325cba",
            "MeteorObliqueMF-Bold",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "8223719dee533eb7e895e0a101f4472c",
            "MeteorObliqueMF-Bold",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "MeteorObliqueMF-Bold",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "650bcadc2c69543d997704b29b7c50d2",
            "MeteorObliqueMF-Bold",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "d3caacfedf638f98ba7b0046f297f421",
            "MeteorObliqueMF-Bold",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "MeteorObliqueMF-Bold",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "38b203ce41804d19e934461faf557ecb",
            "MeteorObliqueMF-Bold",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "ea90949476110422d67b9af4f8ace3a2",
            "MeteorObliqueMF-Bold",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "f01435736b8b73793ad270cdf379a860",
            "MeteorObliqueMF-Bold",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "899d5f15480b4c036d5ec3eabac9e398",
            "MeteorObliqueMF-Bold",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "e1864ebcfe34672f435c3bedacde5d63",
            "MeteorObliqueMF-Bold",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "87791721b0238c72031ce39e346933a8",
            "MeteorObliqueMF-Bold",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "MeteorObliqueMF-Bold",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "090f944a52ed426dbc544297d0fb9442",
            "MeteorObliqueMF-Bold",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "b444489e0fc33e02afa2d1a4962d46ba",
            "d159582398d0de4d0b367233acf587ee",
            "MeteorObliqueMF-Bold",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "8c155b53e011d2a709548865b3edbeaf",
            "Nexa",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Nexa",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Nexa",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Nexa",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Nexa",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Nexa",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Nexa",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "67aadae90ce6049659422a925a8a23d4",
            "Nexa",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Nexa",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "b127070b4065a62961b2bf60fb763a76",
            "Nexa",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "c2722fea792cde12a9117da6e0d70f74",
            "Nexa",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "b74bf78a743785e3df7e3f14477a1390",
            "Nexa",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Nexa",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Nexa",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "cc3e79c959420501e528f6b20113c185",
            "Nexa",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b5884d0a98caad47666f44828a0455c0",
            "bad316ad74318a9f95d0749417edfa04",
            "Nexa",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "8c155b53e011d2a709548865b3edbeaf",
            "Golden Sans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Golden Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Golden Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Golden Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Golden Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Golden Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "d87ffd42ab39a3412ab905084e31b782",
            "Golden Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Golden Sans",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "d07f2481905eefa80fa98c464d59e260",
            "Golden Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Golden Sans",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "34a814f80a793fa3eacde02882fa9faa",
            "Golden Sans",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "29093af656f979957ec5d657e96fb363",
            "Golden Sans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Golden Sans",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "9001cd9b7b209eebef43419463ef6c40",
            "Golden Sans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Golden Sans",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Golden Sans",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Golden Sans",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Golden Sans",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "c311a16ee279363b5113cbf699325577",
            "Golden Sans",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "b600d8fa12592cdb4d232b5da06842fe",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Golden Sans",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Gotham-Book",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gotham-Book",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gotham-Book",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Gotham-Book",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "c2722fea792cde12a9117da6e0d70f74",
            "Gotham-Book",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "b74bf78a743785e3df7e3f14477a1390",
            "Gotham-Book",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "b127070b4065a62961b2bf60fb763a76",
            "Gotham-Book",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "cc3e79c959420501e528f6b20113c185",
            "Gotham-Book",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Gotham-Book",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Gotham-Book",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "bad316ad74318a9f95d0749417edfa04",
            "Gotham-Book",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Gotham-Book",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "3319dd949835e43d4bed270f465aff3e",
            "Gotham-Book",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Gotham-Book",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "b61df993dabc0406618f2c3112636497",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Gotham-Book",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "8ebe3248143db352da56805017ca7934",
            "Yassitf",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Yassitf",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "737e1d3f1693de9fd863057622d1bb02",
            "Yassitf",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "67aadae90ce6049659422a925a8a23d4",
            "Yassitf",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Yassitf",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Yassitf",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Yassitf",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "b127070b4065a62961b2bf60fb763a76",
            "Yassitf",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Yassitf",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "6d47953bebf6a23dc1d89764632524d8",
            "Yassitf",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Yassitf",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "5bd81732a879ba42412c19bd5a33589b",
            "Yassitf",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Yassitf",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Yassitf",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Yassitf",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "955b9a400ce5accf68307eaad62c4f62",
            "Yassitf",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "b74bf78a743785e3df7e3f14477a1390",
            "Yassitf",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "cc3e79c959420501e528f6b20113c185",
            "Yassitf",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "c2722fea792cde12a9117da6e0d70f74",
            "Yassitf",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "b6249de3d08e3971282740ee906b6a8f",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Yassitf",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Axiforma",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Axiforma",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Axiforma",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Axiforma",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "c2722fea792cde12a9117da6e0d70f74",
            "Axiforma",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Axiforma",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Axiforma",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "737e1d3f1693de9fd863057622d1bb02",
            "Axiforma",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "8ebe3248143db352da56805017ca7934",
            "Axiforma",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "cc3e79c959420501e528f6b20113c185",
            "Axiforma",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Axiforma",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Axiforma",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "b127070b4065a62961b2bf60fb763a76",
            "Axiforma",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "b74bf78a743785e3df7e3f14477a1390",
            "Axiforma",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Axiforma",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Axiforma",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "3319dd949835e43d4bed270f465aff3e",
            "Axiforma",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "bad316ad74318a9f95d0749417edfa04",
            "Axiforma",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Axiforma",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "b66e057e2a828535b3f7436a93c9f25a",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Axiforma",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "3bc3a738f4507b8feea7502049c474d2",
            "Paralex",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Paralex",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "2836c06f795c236900263fe1e17d245a",
            "Paralex",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "57cdd235481768dc73076d8a49a44353",
            "Paralex",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Paralex",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Paralex",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Paralex",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "be1ed63669d6244408811624d948c116",
            "Paralex",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "Paralex",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Paralex",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "fbb9573728984c54a8ca446e19d0972a",
            "Paralex",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Paralex",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "Paralex",
            "Antona"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Paralex",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "1ef83e490f20960c356d5bc893c42abe",
            "Paralex",
            "Clarika Pro"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "256f7672059f72846d940fbd8c97537d",
            "Paralex",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Paralex",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "3c842311c20347e4a2d4a3b7db1b35f9",
            "Paralex",
            "Mirai"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Paralex",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "b74bf78a743785e3df7e3f14477a1390",
            "b6249de3d08e3971282740ee906b6a8f",
            "Paralex",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Madison Antiqua",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Madison Antiqua",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Madison Antiqua",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "f0249a1bec67973885bada20741c70c2",
            "Madison Antiqua",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "650bcadc2c69543d997704b29b7c50d2",
            "Madison Antiqua",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "8223719dee533eb7e895e0a101f4472c",
            "Madison Antiqua",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "fc2e33377af6aca34a9826245e325cba",
            "Madison Antiqua",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "d3caacfedf638f98ba7b0046f297f421",
            "Madison Antiqua",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Madison Antiqua",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "de9599121cf31a08904a48495fadcf4a",
            "Madison Antiqua",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Madison Antiqua",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Madison Antiqua",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "f01435736b8b73793ad270cdf379a860",
            "Madison Antiqua",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Madison Antiqua",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Madison Antiqua",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "ea90949476110422d67b9af4f8ace3a2",
            "Madison Antiqua",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Madison Antiqua",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "38b203ce41804d19e934461faf557ecb",
            "Madison Antiqua",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Madison Antiqua",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b7d17d2dc576785a3f3919a96d964e46",
            "264a4ae29758ba917346fe9763531666",
            "Madison Antiqua",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Obliqua ITC Pro",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Obliqua ITC Pro",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Obliqua ITC Pro",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d87ffd42ab39a3412ab905084e31b782",
            "Obliqua ITC Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Obliqua ITC Pro",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Obliqua ITC Pro",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Obliqua ITC Pro",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Obliqua ITC Pro",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d67f3516d06c406d9b18f083b3b32d17",
            "Obliqua ITC Pro",
            "Magneta"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "d07f2481905eefa80fa98c464d59e260",
            "Obliqua ITC Pro",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Obliqua ITC Pro",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "8c155b53e011d2a709548865b3edbeaf",
            "Obliqua ITC Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Obliqua ITC Pro",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "2d0b4f3a328383b8486d150666306efe",
            "Obliqua ITC Pro",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Obliqua ITC Pro",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "6badb2797a95a552c53a98a0f20c903b",
            "Obliqua ITC Pro",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "73138474522e9719f1a246b6fff9af38",
            "Obliqua ITC Pro",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "9001cd9b7b209eebef43419463ef6c40",
            "Obliqua ITC Pro",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "c638239ea03b75929bff2ce833419ac3",
            "Obliqua ITC Pro",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "b832321e77d0f1be2c00712330066c3e",
            "c311a16ee279363b5113cbf699325577",
            "Obliqua ITC Pro",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "2af66ddecaa7893391cb90362043d37a",
            "Eskorte Latin",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "c6ff032bd835e2f806009627251b87b6",
            "Eskorte Latin",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "d84e985d428e023bb87368d43461b448",
            "Eskorte Latin",
            "SST"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "b832321e77d0f1be2c00712330066c3e",
            "Eskorte Latin",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "c63e8810388d85594540bb5f6980f611",
            "Eskorte Latin",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Eskorte Latin",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Eskorte Latin",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "280c82457252f3613b33e3791c375caf",
            "Eskorte Latin",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Eskorte Latin",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "095898e12700edc69d52ecf30ef03e2a",
            "Eskorte Latin",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Eskorte Latin",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "b941ce467c4b7f2846b3226ae7988452",
            "Eskorte Latin",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "51eb849300954cdecf9da1310c79beb2",
            "Eskorte Latin",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Eskorte Latin",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "9e6867c857655e9d1984390fdf1dde45",
            "Eskorte Latin",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Eskorte Latin",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Eskorte Latin",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Eskorte Latin",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Eskorte Latin",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "b8515436cf84baf71ab3bfbdf73854f8",
            "82550c10af201d56d90be26b8833ac63",
            "Eskorte Latin",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Questa Serif",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "f0249a1bec67973885bada20741c70c2",
            "Questa Serif",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Questa Serif",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "f01435736b8b73793ad270cdf379a860",
            "Questa Serif",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "264a4ae29758ba917346fe9763531666",
            "Questa Serif",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Questa Serif",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Questa Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "ea90949476110422d67b9af4f8ace3a2",
            "Questa Serif",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Questa Serif",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Questa Serif",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "650bcadc2c69543d997704b29b7c50d2",
            "Questa Serif",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "38b203ce41804d19e934461faf557ecb",
            "Questa Serif",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Questa Serif",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "cae0af484abd406422956f9621c58b5f",
            "Questa Serif",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "502b3e710c282368c44bf788cb2c7ed2",
            "Questa Serif",
            "Atenta"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "2af66ddecaa7893391cb90362043d37a",
            "Questa Serif",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "fc2e33377af6aca34a9826245e325cba",
            "Questa Serif",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "Questa Serif",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "c74f77a345edf278a01b806459f255bb",
            "Questa Serif",
            "Neufile Grotesk"
        ]
    },
    {
        "likedPair": [
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "709e2472d2cf1299c88a8a4ebb88f6a0",
            "Questa Serif",
            "Seaside"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "8c155b53e011d2a709548865b3edbeaf",
            "Astoria Sans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Astoria Sans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Astoria Sans",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Astoria Sans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Astoria Sans",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "d87ffd42ab39a3412ab905084e31b782",
            "Astoria Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Astoria Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Astoria Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "d07f2481905eefa80fa98c464d59e260",
            "Astoria Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Astoria Sans",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "103510159c0a328260730731e27eabe1",
            "Astoria Sans",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Astoria Sans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Astoria Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "6f624e656d641d366084d9fabaa1fd6a",
            "Astoria Sans",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "9001cd9b7b209eebef43419463ef6c40",
            "Astoria Sans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "a7ed66c67894164f8aee8e7069688a0d",
            "Astoria Sans",
            "Capitolina"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Astoria Sans",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "29093af656f979957ec5d657e96fb363",
            "Astoria Sans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "2d0b4f3a328383b8486d150666306efe",
            "Astoria Sans",
            "Sabon Next"
        ]
    },
    {
        "likedPair": [
            "b941ce467c4b7f2846b3226ae7988452",
            "73138474522e9719f1a246b6fff9af38",
            "Astoria Sans",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "bac35fedbd3fd504663d9540a5863703",
            "5bd81732a879ba42412c19bd5a33589b",
            "Nova Grotesk",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Geometric Slabserif 703",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "2836c06f795c236900263fe1e17d245a",
            "Geometric Slabserif 703",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Geometric Slabserif 703",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Geometric Slabserif 703",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "be1ed63669d6244408811624d948c116",
            "Geometric Slabserif 703",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "3bc3a738f4507b8feea7502049c474d2",
            "Geometric Slabserif 703",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "fbb9573728984c54a8ca446e19d0972a",
            "Geometric Slabserif 703",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "256f7672059f72846d940fbd8c97537d",
            "Geometric Slabserif 703",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Geometric Slabserif 703",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Geometric Slabserif 703",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "1ef83e490f20960c356d5bc893c42abe",
            "Geometric Slabserif 703",
            "Clarika Pro"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Geometric Slabserif 703",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "c0351a7e9af75205fea41a3719573876",
            "Geometric Slabserif 703",
            "Sweet Sans Pro"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "9b0bb8895102e5176dc1a5c5dd97d78b",
            "Geometric Slabserif 703",
            "Cardium"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "bf9fc533e1700efac60390b153c27ca0",
            "Geometric Slabserif 703",
            "Arboria"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "b0f799383351d9ef86939c76bff5bafc",
            "Geometric Slabserif 703",
            "Causten"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Geometric Slabserif 703",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Geometric Slabserif 703",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "Geometric Slabserif 703",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "bad316ad74318a9f95d0749417edfa04",
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "Geometric Slabserif 703",
            "Pontiac"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Badiya",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Badiya",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Badiya",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Badiya",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "103510159c0a328260730731e27eabe1",
            "Badiya",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Badiya",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Badiya",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Badiya",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Badiya",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Badiya",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "d07f2481905eefa80fa98c464d59e260",
            "Badiya",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Badiya",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Badiya",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Badiya",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "6badb2797a95a552c53a98a0f20c903b",
            "Badiya",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Badiya",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Badiya",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Badiya",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Badiya",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "bb53acb0d26b7c34eaca665214b5b781",
            "c311a16ee279363b5113cbf699325577",
            "Badiya",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Zenon",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "264a4ae29758ba917346fe9763531666",
            "Zenon",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Zenon",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Zenon",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "2af66ddecaa7893391cb90362043d37a",
            "Zenon",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Zenon",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "c63e8810388d85594540bb5f6980f611",
            "Zenon",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "fc2e33377af6aca34a9826245e325cba",
            "Zenon",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "82550c10af201d56d90be26b8833ac63",
            "Zenon",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "9e6867c857655e9d1984390fdf1dde45",
            "Zenon",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Zenon",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Zenon",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Zenon",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "b941ce467c4b7f2846b3226ae7988452",
            "Zenon",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Zenon",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "51eb849300954cdecf9da1310c79beb2",
            "Zenon",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "bbce3951159f83e9c2239d39fd666ce5",
            "095898e12700edc69d52ecf30ef03e2a",
            "Zenon",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Lasiver",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Lasiver",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "b127070b4065a62961b2bf60fb763a76",
            "Lasiver",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Lasiver",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Lasiver",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Lasiver",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Lasiver",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "3bc217606a2f4a22131f20c24de7ac75",
            "Lasiver",
            "Garth Graphic"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "8c155b53e011d2a709548865b3edbeaf",
            "Lasiver",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Lasiver",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "c04f563b6a1457ae02100e98a49654c6",
            "Lasiver",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Lasiver",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Lasiver",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "0f41ebd3d659da540745d00b52334eb0",
            "Lasiver",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "103510159c0a328260730731e27eabe1",
            "Lasiver",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Lasiver",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "1b0f30a04e4742d8bff6d6eefc8e1383",
            "Lasiver",
            "Adriane Text"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Lasiver",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Lasiver",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Lasiver",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "b127070b4065a62961b2bf60fb763a76",
            "Armin Soft",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Armin Soft",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Armin Soft",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "3319dd949835e43d4bed270f465aff3e",
            "Armin Soft",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "8ebe3248143db352da56805017ca7934",
            "Armin Soft",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "cc3e79c959420501e528f6b20113c185",
            "Armin Soft",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Armin Soft",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "5bd81732a879ba42412c19bd5a33589b",
            "Armin Soft",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "be1ed63669d6244408811624d948c116",
            "bad316ad74318a9f95d0749417edfa04",
            "Armin Soft",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Academica",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "8223719dee533eb7e895e0a101f4472c",
            "Academica",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "de9599121cf31a08904a48495fadcf4a",
            "Academica",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "38b203ce41804d19e934461faf557ecb",
            "Academica",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "650bcadc2c69543d997704b29b7c50d2",
            "Academica",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Academica",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Academica",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Academica",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "ea90949476110422d67b9af4f8ace3a2",
            "Academica",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "f0249a1bec67973885bada20741c70c2",
            "Academica",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Academica",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Academica",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "f01435736b8b73793ad270cdf379a860",
            "Academica",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "d3caacfedf638f98ba7b0046f297f421",
            "Academica",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Academica",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "fc2e33377af6aca34a9826245e325cba",
            "Academica",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "264a4ae29758ba917346fe9763531666",
            "Academica",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Academica",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Academica",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "be483d1a100a556f9456d2ab176fd0c9",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Academica",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "c2722fea792cde12a9117da6e0d70f74",
            "Pontiac",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "cc3e79c959420501e528f6b20113c185",
            "Pontiac",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Pontiac",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Pontiac",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Pontiac",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "b74bf78a743785e3df7e3f14477a1390",
            "Pontiac",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "8c155b53e011d2a709548865b3edbeaf",
            "Pontiac",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "bad316ad74318a9f95d0749417edfa04",
            "Pontiac",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Pontiac",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Pontiac",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Pontiac",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "737e1d3f1693de9fd863057622d1bb02",
            "Pontiac",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "b127070b4065a62961b2bf60fb763a76",
            "Pontiac",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "8ebe3248143db352da56805017ca7934",
            "Pontiac",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "c7117e8442a401bc7dd78049829ef83b",
            "Pontiac",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Pontiac",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Pontiac",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Pontiac",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Pontiac",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "73e48b94c08d2015315dbceaf56efb62",
            "Pontiac",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Helserif",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "0a990399fe7f1b376e846e602e3307bb",
            "Helserif",
            "Europa Grotesk No. 2 SB"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Helserif",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "f01435736b8b73793ad270cdf379a860",
            "Helserif",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "96da2e3b759f10f9970cef587bf11069",
            "Helserif",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "d3caacfedf638f98ba7b0046f297f421",
            "Helserif",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "e703c571b26ddb70174e8b5111fea898",
            "Helserif",
            "Bw Nista"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "dfa1317c450784d1f09730737065a19b",
            "Helserif",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "cc764ebb17c10db21cd67451fce38448",
            "Helserif",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "da5723a234527888e7dc5e19548f1abb",
            "Helserif",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Helserif",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "Helserif",
            "Nimbus Sans Round"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "38b203ce41804d19e934461faf557ecb",
            "Helserif",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "ac04c5328af335b179cf1827997e1774",
            "Helserif",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "d159582398d0de4d0b367233acf587ee",
            "Helserif",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "cae0af484abd406422956f9621c58b5f",
            "Helserif",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "dac699b554de5b30f7764b27556f9e9e",
            "Helserif",
            "AkzidenzGroteskBQ-Reg"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "89ee0539f225993026d6f49e9cd8e85d",
            "Helserif",
            "JT Collect"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "238bab934db66c57e475fb05d567c3b1",
            "Helserif",
            "Figgins Sans"
        ]
    },
    {
        "likedPair": [
            "be5fdca67a94d3db868b73c7eaea39f4",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Helserif",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "JAF Bernini Sans",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "e850c1a19f5dd604e85d62b658f34d62",
            "JAF Bernini Sans",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "JAF Bernini Sans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "JAF Bernini Sans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "e28128adc0e75357f447267c07afb6a6",
            "JAF Bernini Sans",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "JAF Bernini Sans",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "c87f74a6084f73fdad817b1589a48a08",
            "JAF Bernini Sans",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "JAF Bernini Sans",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "JAF Bernini Sans",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "JAF Bernini Sans",
            "Abelard"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "c638239ea03b75929bff2ce833419ac3",
            "JAF Bernini Sans",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "6badb2797a95a552c53a98a0f20c903b",
            "JAF Bernini Sans",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "9ded3c33a83728124405e311fff63b40",
            "JAF Bernini Sans",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "c311a16ee279363b5113cbf699325577",
            "JAF Bernini Sans",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "2980338e1101915cd8cf85fec19fd126",
            "JAF Bernini Sans",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "JAF Bernini Sans",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "d87ffd42ab39a3412ab905084e31b782",
            "JAF Bernini Sans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "8d9fd883298c86eeb3d614b7311f8431",
            "JAF Bernini Sans",
            "Milo Serif Pro"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "JAF Bernini Sans",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "JAF Bernini Sans",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Arboria",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Arboria",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Arboria",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Arboria",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "737e1d3f1693de9fd863057622d1bb02",
            "Arboria",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "b127070b4065a62961b2bf60fb763a76",
            "Arboria",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "cc3e79c959420501e528f6b20113c185",
            "Arboria",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Arboria",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Arboria",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "b74bf78a743785e3df7e3f14477a1390",
            "Arboria",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "bad316ad74318a9f95d0749417edfa04",
            "Arboria",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "5bd81732a879ba42412c19bd5a33589b",
            "Arboria",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "8ebe3248143db352da56805017ca7934",
            "Arboria",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Arboria",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "3319dd949835e43d4bed270f465aff3e",
            "Arboria",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "bf9fc533e1700efac60390b153c27ca0",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Arboria",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "8c155b53e011d2a709548865b3edbeaf",
            "Sweet Sans Pro",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Sweet Sans Pro",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Sweet Sans Pro",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "cd92499f5905694f796be4b7b3406e49",
            "Sweet Sans Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "8ebe3248143db352da56805017ca7934",
            "Sweet Sans Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "737e1d3f1693de9fd863057622d1bb02",
            "Sweet Sans Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Sweet Sans Pro",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "67aadae90ce6049659422a925a8a23d4",
            "Sweet Sans Pro",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "b127070b4065a62961b2bf60fb763a76",
            "Sweet Sans Pro",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Sweet Sans Pro",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Sweet Sans Pro",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Sweet Sans Pro",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "c7117e8442a401bc7dd78049829ef83b",
            "Sweet Sans Pro",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Sweet Sans Pro",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "c2722fea792cde12a9117da6e0d70f74",
            "Sweet Sans Pro",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "b74bf78a743785e3df7e3f14477a1390",
            "Sweet Sans Pro",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Sweet Sans Pro",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "cc3e79c959420501e528f6b20113c185",
            "Sweet Sans Pro",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "bad316ad74318a9f95d0749417edfa04",
            "Sweet Sans Pro",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "c0351a7e9af75205fea41a3719573876",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Sweet Sans Pro",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "de9599121cf31a08904a48495fadcf4a",
            "Janson Text Roman",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Janson Text Roman",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Janson Text Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Janson Text Roman",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "090f944a52ed426dbc544297d0fb9442",
            "Janson Text Roman",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Janson Text Roman",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Janson Text Roman",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "d3caacfedf638f98ba7b0046f297f421",
            "Janson Text Roman",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "35641bbe5146f945b85e1e7b34956a73",
            "Janson Text Roman",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Janson Text Roman",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Janson Text Roman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "9e6867c857655e9d1984390fdf1dde45",
            "Janson Text Roman",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "b24744ca2bf3616294271353ec837099",
            "Janson Text Roman",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Janson Text Roman",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "f0249a1bec67973885bada20741c70c2",
            "Janson Text Roman",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Janson Text Roman",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "650bcadc2c69543d997704b29b7c50d2",
            "Janson Text Roman",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "87791721b0238c72031ce39e346933a8",
            "Janson Text Roman",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "d159582398d0de4d0b367233acf587ee",
            "Janson Text Roman",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "c04f563b6a1457ae02100e98a49654c6",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Janson Text Roman",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "c21e1b094f9635eaf050aa5eccb16c50",
            "b3b8acb1b972e74c0f21fd76b2829a59",
            "Glober",
            "Prelo Slab"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "8c155b53e011d2a709548865b3edbeaf",
            "Atwic Regular",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Atwic Regular",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "06779a9920e25578b6f504fcbd0ca169",
            "Atwic Regular",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Atwic Regular",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "afb2c306772fbf472d6549a865bf7339",
            "Atwic Regular",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Atwic Regular",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "d87ffd42ab39a3412ab905084e31b782",
            "Atwic Regular",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "73138474522e9719f1a246b6fff9af38",
            "Atwic Regular",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Atwic Regular",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Atwic Regular",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "Atwic Regular",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "34a814f80a793fa3eacde02882fa9faa",
            "Atwic Regular",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "9001cd9b7b209eebef43419463ef6c40",
            "Atwic Regular",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Atwic Regular",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Atwic Regular",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Atwic Regular",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Atwic Regular",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Atwic Regular",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Atwic Regular",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "c2244758e73a4caacb7f2916afe5f38f",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Atwic Regular",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Monstice",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "f0249a1bec67973885bada20741c70c2",
            "Monstice",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "fc2e33377af6aca34a9826245e325cba",
            "Monstice",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Monstice",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Monstice",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "de9599121cf31a08904a48495fadcf4a",
            "Monstice",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "f01435736b8b73793ad270cdf379a860",
            "Monstice",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "d3caacfedf638f98ba7b0046f297f421",
            "Monstice",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Monstice",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "38b203ce41804d19e934461faf557ecb",
            "Monstice",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "cae0af484abd406422956f9621c58b5f",
            "Monstice",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "d159582398d0de4d0b367233acf587ee",
            "Monstice",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Monstice",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Monstice",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "090f944a52ed426dbc544297d0fb9442",
            "Monstice",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Monstice",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Monstice",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "dfa1317c450784d1f09730737065a19b",
            "Monstice",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Monstice",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "c27194ce9d813a5cdb2ba681ef0bc36f",
            "147f1bb910d4c3487efd5789736afc3b",
            "Monstice",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Coltan Gea",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "3bc3a738f4507b8feea7502049c474d2",
            "Coltan Gea",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "f02646f18604d6ce339590291ba509e0",
            "Coltan Gea",
            "Daikon"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "9ccbb715cfb79436925d6d0d128fdab6",
            "Coltan Gea",
            "Toma Sans"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "be1ed63669d6244408811624d948c116",
            "Coltan Gea",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Coltan Gea",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "f27264442e7df065b3c26373505c38b6",
            "Coltan Gea",
            "Brother 1816"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Coltan Gea",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "b6249de3d08e3971282740ee906b6a8f",
            "Coltan Gea",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Coltan Gea",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "83c8fbe423f3cc3b3db46b82cd213b83",
            "Coltan Gea",
            "Primeform Pro"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "a932edac803361b3470866f58874f633",
            "Coltan Gea",
            "Dexa Pro"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "627f02177189a33fe40ad427eff5d5bb",
            "Coltan Gea",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Coltan Gea",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "2836c06f795c236900263fe1e17d245a",
            "Coltan Gea",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Coltan Gea",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "Coltan Gea",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "96e633e3b54168cc61a1acd1608084d3",
            "Coltan Gea",
            "Avenir 55 Roman"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Coltan Gea",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "c2722fea792cde12a9117da6e0d70f74",
            "b61df993dabc0406618f2c3112636497",
            "Coltan Gea",
            "Gotham-Book"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "d3caacfedf638f98ba7b0046f297f421",
            "Latino",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "0a990399fe7f1b376e846e602e3307bb",
            "Latino",
            "Europa Grotesk No. 2 SB"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Latino",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Latino",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Latino",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Latino",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "cc764ebb17c10db21cd67451fce38448",
            "Latino",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "9e6867c857655e9d1984390fdf1dde45",
            "Latino",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "96da2e3b759f10f9970cef587bf11069",
            "Latino",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "c29fbb04a732bbf8de9fc07f530f7ee8",
            "147f1bb910d4c3487efd5789736afc3b",
            "Latino",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "b832321e77d0f1be2c00712330066c3e",
            "Calluna",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Calluna",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Calluna",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Calluna",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "280c82457252f3613b33e3791c375caf",
            "Calluna",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "d84e985d428e023bb87368d43461b448",
            "Calluna",
            "SST"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Calluna",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "d18f103cfa62513f991b0f90a814c333",
            "Calluna",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Calluna",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "3a2f35b17543f0f3464b26e080b16634",
            "Calluna",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Calluna",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "2af66ddecaa7893391cb90362043d37a",
            "Calluna",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "3d295205229224442c34a365d6b885d1",
            "Calluna",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Calluna",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "9e6867c857655e9d1984390fdf1dde45",
            "Calluna",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "35641bbe5146f945b85e1e7b34956a73",
            "Calluna",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "c63e8810388d85594540bb5f6980f611",
            "Calluna",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Calluna",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "b941ce467c4b7f2846b3226ae7988452",
            "Calluna",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "c311a16ee279363b5113cbf699325577",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Calluna",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "de9599121cf31a08904a48495fadcf4a",
            "Dutch 766",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Dutch 766",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Dutch 766",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "8223719dee533eb7e895e0a101f4472c",
            "Dutch 766",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Dutch 766",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "9e6867c857655e9d1984390fdf1dde45",
            "Dutch 766",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "fc2e33377af6aca34a9826245e325cba",
            "Dutch 766",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "35641bbe5146f945b85e1e7b34956a73",
            "Dutch 766",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "650bcadc2c69543d997704b29b7c50d2",
            "Dutch 766",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Dutch 766",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Dutch 766",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "87791721b0238c72031ce39e346933a8",
            "Dutch 766",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Dutch 766",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "2af66ddecaa7893391cb90362043d37a",
            "Dutch 766",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "c63e8810388d85594540bb5f6980f611",
            "Dutch 766",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Dutch 766",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "264a4ae29758ba917346fe9763531666",
            "Dutch 766",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "51eb849300954cdecf9da1310c79beb2",
            "Dutch 766",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "095898e12700edc69d52ecf30ef03e2a",
            "Dutch 766",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "c3c0b5f23e63fcc31f434604265321d6",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Dutch 766",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Halesworth",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Halesworth",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Halesworth",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "b832321e77d0f1be2c00712330066c3e",
            "Halesworth",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Halesworth",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "3d295205229224442c34a365d6b885d1",
            "Halesworth",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "9e6867c857655e9d1984390fdf1dde45",
            "Halesworth",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Halesworth",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "35641bbe5146f945b85e1e7b34956a73",
            "Halesworth",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Halesworth",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "2af66ddecaa7893391cb90362043d37a",
            "Halesworth",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Halesworth",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Halesworth",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "b941ce467c4b7f2846b3226ae7988452",
            "Halesworth",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Halesworth",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Halesworth",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Halesworth",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "51eb849300954cdecf9da1310c79beb2",
            "Halesworth",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Halesworth",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "c48ed6205830c1daa57653eed6ab1fe7",
            "c63e8810388d85594540bb5f6980f611",
            "Halesworth",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "FF Yoga",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "FF Yoga",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "090f944a52ed426dbc544297d0fb9442",
            "FF Yoga",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "FF Yoga",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "565f10ac096eb5d75c4400509e23cdc1",
            "FF Yoga",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "033528c5f0137b017eff21079bd25a60",
            "FF Yoga",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "b832321e77d0f1be2c00712330066c3e",
            "FF Yoga",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FF Yoga",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "4a8d414c86f9aeae1489e72e6293e772",
            "FF Yoga",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "b34fc5fd3820759a8808f554191ecaa2",
            "FF Yoga",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "e1864ebcfe34672f435c3bedacde5d63",
            "FF Yoga",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "FF Yoga",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "FF Yoga",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "280c82457252f3613b33e3791c375caf",
            "FF Yoga",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "9e6867c857655e9d1984390fdf1dde45",
            "FF Yoga",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "fbb9573728984c54a8ca446e19d0972a",
            "FF Yoga",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "3d295205229224442c34a365d6b885d1",
            "FF Yoga",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "35641bbe5146f945b85e1e7b34956a73",
            "FF Yoga",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "FF Yoga",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "2af66ddecaa7893391cb90362043d37a",
            "FF Yoga",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Rubiesque",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "38f28a6682e9d705522a7ac7a715578f",
            "Rubiesque",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Rubiesque",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "ef71628ba1ab6310365a78c263679726",
            "Rubiesque",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Rubiesque",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "50441227356a2e75a4737b2cfe84709b",
            "Rubiesque",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "073081f11751cb576e2b13de664766f6",
            "Rubiesque",
            "Le Monde Livre Std"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "8006330b215827a8efcd0e4c791bae76",
            "Rubiesque",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "Rubiesque",
            "QuaText"
        ]
    },
    {
        "likedPair": [
            "c538bafc5828bc5e263eccf2fdeb4cf3",
            "e0d397e073f334bdc40410c8c4093d9b",
            "Rubiesque",
            "Alkes"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Gimbal Egyptian",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "c6ff032bd835e2f806009627251b87b6",
            "Gimbal Egyptian",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "d84e985d428e023bb87368d43461b448",
            "Gimbal Egyptian",
            "SST"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "2af66ddecaa7893391cb90362043d37a",
            "Gimbal Egyptian",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "3a2f35b17543f0f3464b26e080b16634",
            "Gimbal Egyptian",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "b832321e77d0f1be2c00712330066c3e",
            "Gimbal Egyptian",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Gimbal Egyptian",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "d18f103cfa62513f991b0f90a814c333",
            "Gimbal Egyptian",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Gimbal Egyptian",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Gimbal Egyptian",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "952a354643df6c41226431ae4990f41e",
            "Gimbal Egyptian",
            "LCT Picon"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "280c82457252f3613b33e3791c375caf",
            "Gimbal Egyptian",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Gimbal Egyptian",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "090f944a52ed426dbc544297d0fb9442",
            "Gimbal Egyptian",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Gimbal Egyptian",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Gimbal Egyptian",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Gimbal Egyptian",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "c63e8810388d85594540bb5f6980f611",
            "Gimbal Egyptian",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Gimbal Egyptian",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "c638239ea03b75929bff2ce833419ac3",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Gimbal Egyptian",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "LegacySansITCPro-Book",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "LegacySansITCPro-Book",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "LegacySansITCPro-Book",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "bbce3951159f83e9c2239d39fd666ce5",
            "LegacySansITCPro-Book",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "LegacySansITCPro-Book",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "d07f2481905eefa80fa98c464d59e260",
            "LegacySansITCPro-Book",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "LegacySansITCPro-Book",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "34a814f80a793fa3eacde02882fa9faa",
            "LegacySansITCPro-Book",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "d87ffd42ab39a3412ab905084e31b782",
            "LegacySansITCPro-Book",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "8c155b53e011d2a709548865b3edbeaf",
            "LegacySansITCPro-Book",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "LegacySansITCPro-Book",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "9001cd9b7b209eebef43419463ef6c40",
            "LegacySansITCPro-Book",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "6f624e656d641d366084d9fabaa1fd6a",
            "LegacySansITCPro-Book",
            "Cassia"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "e208cca764688975f3d7d3839228dea0",
            "LegacySansITCPro-Book",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "LegacySansITCPro-Book",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "e850c1a19f5dd604e85d62b658f34d62",
            "LegacySansITCPro-Book",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "LegacySansITCPro-Book",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "8d9fd883298c86eeb3d614b7311f8431",
            "LegacySansITCPro-Book",
            "Milo Serif Pro"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "c3c0b5f23e63fcc31f434604265321d6",
            "LegacySansITCPro-Book",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "c63e8810388d85594540bb5f6980f611",
            "29093af656f979957ec5d657e96fb363",
            "LegacySansITCPro-Book",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Times New Roman",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "de9599121cf31a08904a48495fadcf4a",
            "Times New Roman",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Times New Roman",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "f0249a1bec67973885bada20741c70c2",
            "Times New Roman",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Times New Roman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "d3caacfedf638f98ba7b0046f297f421",
            "Times New Roman",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "8223719dee533eb7e895e0a101f4472c",
            "Times New Roman",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "650bcadc2c69543d997704b29b7c50d2",
            "Times New Roman",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "fc2e33377af6aca34a9826245e325cba",
            "Times New Roman",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Times New Roman",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "f01435736b8b73793ad270cdf379a860",
            "Times New Roman",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "b24744ca2bf3616294271353ec837099",
            "Times New Roman",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Times New Roman",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Times New Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Times New Roman",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Times New Roman",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "090f944a52ed426dbc544297d0fb9442",
            "Times New Roman",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "87791721b0238c72031ce39e346933a8",
            "Times New Roman",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Times New Roman",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c6bae55c030fe9df4104274e7fa5df57",
            "264a4ae29758ba917346fe9763531666",
            "Times New Roman",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "9001cd9b7b209eebef43419463ef6c40",
            "Milo Pro",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Milo Pro",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Milo Pro",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "Milo Pro",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "d87ffd42ab39a3412ab905084e31b782",
            "Milo Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "Milo Pro",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "6badb2797a95a552c53a98a0f20c903b",
            "Milo Pro",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Milo Pro",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Milo Pro",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Milo Pro",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Milo Pro",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "9ded3c33a83728124405e311fff63b40",
            "Milo Pro",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "c311a16ee279363b5113cbf699325577",
            "Milo Pro",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "2980338e1101915cd8cf85fec19fd126",
            "Milo Pro",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Milo Pro",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Milo Pro",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "c638239ea03b75929bff2ce833419ac3",
            "Milo Pro",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "ef71628ba1ab6310365a78c263679726",
            "Milo Pro",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Milo Pro",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "c6ff032bd835e2f806009627251b87b6",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Milo Pro",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "f0249a1bec67973885bada20741c70c2",
            "Weekly",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "38b203ce41804d19e934461faf557ecb",
            "Weekly",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "709e2472d2cf1299c88a8a4ebb88f6a0",
            "Weekly",
            "Seaside"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "cae0af484abd406422956f9621c58b5f",
            "Weekly",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Weekly",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "d159582398d0de4d0b367233acf587ee",
            "Weekly",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Weekly",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Weekly",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Weekly",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "93b4e55aa9798f96b3a365a441a2238d",
            "Weekly",
            "Oslo"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "57cdd235481768dc73076d8a49a44353",
            "Weekly",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Weekly",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Weekly",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "207f1b88d937a2dd587e13d9edc6cb57",
            "Weekly",
            "Specify"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "6cc60fbee266fae6c3fc301ab7962519",
            "Weekly",
            "Trebuchet"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "ac04c5328af335b179cf1827997e1774",
            "Weekly",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Weekly",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "b0a90fc4a63c26e4cfa962e289953725",
            "Weekly",
            "Classic Sans"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "Weekly",
            "Bruta Global"
        ]
    },
    {
        "likedPair": [
            "c7117e8442a401bc7dd78049829ef83b",
            "03ba201f7613be300cec0afc83ee295a",
            "Weekly",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Neufile Grotesk",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Neufile Grotesk",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "36c50039d788bccb71ca83a792b63c1c",
            "Neufile Grotesk",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "06779a9920e25578b6f504fcbd0ca169",
            "Neufile Grotesk",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "2f0b0e3960e41954fb3a51cfc5b69ff7",
            "Neufile Grotesk",
            "FF Franziska"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "afb2c306772fbf472d6549a865bf7339",
            "Neufile Grotesk",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Neufile Grotesk",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "Neufile Grotesk",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "ef0f22560e30896239545a852fd7f6b4",
            "Neufile Grotesk",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Neufile Grotesk",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Neufile Grotesk",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "386528d2feb209e45554ed0fa03d81ce",
            "Neufile Grotesk",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "c74f77a345edf278a01b806459f255bb",
            "2c055a7f717a969a129cf78e586c2d39",
            "Neufile Grotesk",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "650bcadc2c69543d997704b29b7c50d2",
            "Reserve",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Reserve",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Reserve",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Reserve",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "fc2e33377af6aca34a9826245e325cba",
            "Reserve",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "38b203ce41804d19e934461faf557ecb",
            "Reserve",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "d3caacfedf638f98ba7b0046f297f421",
            "Reserve",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "d159582398d0de4d0b367233acf587ee",
            "Reserve",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "cae0af484abd406422956f9621c58b5f",
            "Reserve",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "ac04c5328af335b179cf1827997e1774",
            "Reserve",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Reserve",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "147f1bb910d4c3487efd5789736afc3b",
            "Reserve",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "b0a90fc4a63c26e4cfa962e289953725",
            "Reserve",
            "Classic Sans"
        ]
    },
    {
        "likedPair": [
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "cc764ebb17c10db21cd67451fce38448",
            "Reserve",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "b832321e77d0f1be2c00712330066c3e",
            "FF Meta Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "c6ff032bd835e2f806009627251b87b6",
            "FF Meta Serif",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "FF Meta Serif",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "FF Meta Serif",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "565f10ac096eb5d75c4400509e23cdc1",
            "FF Meta Serif",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "FF Meta Serif",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "2af66ddecaa7893391cb90362043d37a",
            "FF Meta Serif",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "2b443d68adf1ec97623afac779dc9572",
            "FF Meta Serif",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "FF Meta Serif",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "FF Meta Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "FF Meta Serif",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "280c82457252f3613b33e3791c375caf",
            "FF Meta Serif",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "e1864ebcfe34672f435c3bedacde5d63",
            "FF Meta Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "090f944a52ed426dbc544297d0fb9442",
            "FF Meta Serif",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "FF Meta Serif",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "38c216ced240e8111b587a31e2fc5794",
            "FF Meta Serif",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FF Meta Serif",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "4a8d414c86f9aeae1489e72e6293e772",
            "FF Meta Serif",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "FF Meta Serif",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "c87f74a6084f73fdad817b1589a48a08",
            "264a4ae29758ba917346fe9763531666",
            "FF Meta Serif",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "737e1d3f1693de9fd863057622d1bb02",
            "Altone",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "8ebe3248143db352da56805017ca7934",
            "Altone",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Altone",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Altone",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Altone",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Altone",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Altone",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Altone",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Altone",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Altone",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "b127070b4065a62961b2bf60fb763a76",
            "Altone",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Altone",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "d4df1a651052c6bd88be57660da085ac",
            "Altone",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "cd92499f5905694f796be4b7b3406e49",
            "Altone",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "c2722fea792cde12a9117da6e0d70f74",
            "Altone",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Altone",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "cc3e79c959420501e528f6b20113c185",
            "Altone",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Altone",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Altone",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "3319dd949835e43d4bed270f465aff3e",
            "Altone",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Excelsior LT Roman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Excelsior LT Roman",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Excelsior LT Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Excelsior LT Roman",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Excelsior LT Roman",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Excelsior LT Roman",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Excelsior LT Roman",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "b941ce467c4b7f2846b3226ae7988452",
            "Excelsior LT Roman",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "c63e8810388d85594540bb5f6980f611",
            "Excelsior LT Roman",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "ca5f3447688ac16a899f8b232fda482a",
            "82550c10af201d56d90be26b8833ac63",
            "Excelsior LT Roman",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "0f41ebd3d659da540745d00b52334eb0",
            "Alliance",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Alliance",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Alliance",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Alliance",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "8ebe3248143db352da56805017ca7934",
            "Alliance",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Alliance",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "3319dd949835e43d4bed270f465aff3e",
            "Alliance",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "737e1d3f1693de9fd863057622d1bb02",
            "Alliance",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Alliance",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "3938fddd18b33d1b1549d30049d6e749",
            "Alliance",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "36c50039d788bccb71ca83a792b63c1c",
            "Alliance",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Alliance",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Alliance",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Alliance",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "Alliance",
            "ITC Bookman"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Alliance",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Alliance",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Alliance",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "Alliance",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "cae0af484abd406422956f9621c58b5f",
            "b127070b4065a62961b2bf60fb763a76",
            "Alliance",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "3bc3a738f4507b8feea7502049c474d2",
            "ITC Lubalin Graph",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "ITC Lubalin Graph",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "be1ed63669d6244408811624d948c116",
            "ITC Lubalin Graph",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "a0738796db0c7d83d8ba2c54fde1bbaf",
            "ITC Lubalin Graph",
            "Eina"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "ITC Lubalin Graph",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "ab8c8aff3daa79ef0b99a7365b29875b",
            "ITC Lubalin Graph",
            "Qanelas"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "5392c3a915aaad224a94a891d3b3b4da",
            "ITC Lubalin Graph",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "ITC Lubalin Graph",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "ITC Lubalin Graph",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "ITC Lubalin Graph",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "899f6baa066fd450e1dbb5d37bd763af",
            "ITC Lubalin Graph",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "ac04c5328af335b179cf1827997e1774",
            "ITC Lubalin Graph",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "2836c06f795c236900263fe1e17d245a",
            "ITC Lubalin Graph",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "ITC Lubalin Graph",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "7baec41a3ec1d0673c5a53cff12839b2",
            "ITC Lubalin Graph",
            "Applied Sans"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "256f7672059f72846d940fbd8c97537d",
            "ITC Lubalin Graph",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "ITC Lubalin Graph",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "ITC Lubalin Graph",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "ITC Lubalin Graph",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "03ba201f7613be300cec0afc83ee295a",
            "ITC Lubalin Graph",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Carisma",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Carisma",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Carisma",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "8c155b53e011d2a709548865b3edbeaf",
            "Carisma",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Carisma",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Carisma",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "b127070b4065a62961b2bf60fb763a76",
            "Carisma",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "737e1d3f1693de9fd863057622d1bb02",
            "Carisma",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Carisma",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "8ebe3248143db352da56805017ca7934",
            "Carisma",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Carisma",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Carisma",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "c2722fea792cde12a9117da6e0d70f74",
            "Carisma",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "013968ef381969722a37a334b48bbaeb",
            "Carisma",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Carisma",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "67aadae90ce6049659422a925a8a23d4",
            "Carisma",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "cd92499f5905694f796be4b7b3406e49",
            "Carisma",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Carisma",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Carisma",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "cbc8e967ca57cfef415bf0f290ba5241",
            "11c4ab6960ee47d6066b255cd7f1b291",
            "Carisma",
            "Monotype test family 4"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Memphis",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Memphis",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Memphis",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Memphis",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Memphis",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "2836c06f795c236900263fe1e17d245a",
            "Memphis",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Memphis",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "3bc3a738f4507b8feea7502049c474d2",
            "Memphis",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Memphis",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "9ccbb715cfb79436925d6d0d128fdab6",
            "Memphis",
            "Toma Sans"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "03ba201f7613be300cec0afc83ee295a",
            "Memphis",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "fbb9573728984c54a8ca446e19d0972a",
            "Memphis",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "627f02177189a33fe40ad427eff5d5bb",
            "Memphis",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "be1ed63669d6244408811624d948c116",
            "Memphis",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Memphis",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "7baec41a3ec1d0673c5a53cff12839b2",
            "Memphis",
            "Applied Sans"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "b6249de3d08e3971282740ee906b6a8f",
            "Memphis",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Memphis",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "0db105f867c7eb2e491db586cc26b417",
            "Memphis",
            "Galano Grotesque"
        ]
    },
    {
        "likedPair": [
            "cc3e79c959420501e528f6b20113c185",
            "bac35fedbd3fd504663d9540a5863703",
            "Memphis",
            "Nova Grotesk"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "3319dd949835e43d4bed270f465aff3e",
            "Monotype Grotesque",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Monotype Grotesque",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Monotype Grotesque",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "afb2c306772fbf472d6549a865bf7339",
            "Monotype Grotesque",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Monotype Grotesque",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "8a84a077e3b47852136fac569923059b",
            "Monotype Grotesque",
            "Imperial"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "ef0f22560e30896239545a852fd7f6b4",
            "Monotype Grotesque",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "737e1d3f1693de9fd863057622d1bb02",
            "Monotype Grotesque",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "8ebe3248143db352da56805017ca7934",
            "Monotype Grotesque",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Monotype Grotesque",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "5bd81732a879ba42412c19bd5a33589b",
            "Monotype Grotesque",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "386528d2feb209e45554ed0fa03d81ce",
            "Monotype Grotesque",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "e961668cbc083722acbc4a237ca92232",
            "Monotype Grotesque",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "cc764ebb17c10db21cd67451fce38448",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Monotype Grotesque",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Winden",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Winden",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "3bc3a738f4507b8feea7502049c474d2",
            "Winden",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Winden",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Winden",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "be1ed63669d6244408811624d948c116",
            "Winden",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Winden",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Winden",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Winden",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "57cdd235481768dc73076d8a49a44353",
            "Winden",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "ac04c5328af335b179cf1827997e1774",
            "Winden",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "Winden",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "7baec41a3ec1d0673c5a53cff12839b2",
            "Winden",
            "Applied Sans"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "03ba201f7613be300cec0afc83ee295a",
            "Winden",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Winden",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Winden",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Winden",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "1ef83e490f20960c356d5bc893c42abe",
            "Winden",
            "Clarika Pro"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Winden",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "Winden",
            "Antona"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Zapf Calligraphic 801",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "280c82457252f3613b33e3791c375caf",
            "Zapf Calligraphic 801",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Zapf Calligraphic 801",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Zapf Calligraphic 801",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "b832321e77d0f1be2c00712330066c3e",
            "Zapf Calligraphic 801",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Zapf Calligraphic 801",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "35641bbe5146f945b85e1e7b34956a73",
            "Zapf Calligraphic 801",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "9e6867c857655e9d1984390fdf1dde45",
            "Zapf Calligraphic 801",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Zapf Calligraphic 801",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Zapf Calligraphic 801",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "090f944a52ed426dbc544297d0fb9442",
            "Zapf Calligraphic 801",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Zapf Calligraphic 801",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Zapf Calligraphic 801",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "033528c5f0137b017eff21079bd25a60",
            "Zapf Calligraphic 801",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Zapf Calligraphic 801",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "2eacbefed019a3d2ec4b91123d6c00d3",
            "Zapf Calligraphic 801",
            "Sailec"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "be1ed63669d6244408811624d948c116",
            "Zapf Calligraphic 801",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Zapf Calligraphic 801",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "66a7dbfec85d53dc214099b2ac6ecc2b",
            "Zapf Calligraphic 801",
            "Antona"
        ]
    },
    {
        "likedPair": [
            "cd92499f5905694f796be4b7b3406e49",
            "b6249de3d08e3971282740ee906b6a8f",
            "Zapf Calligraphic 801",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "1f3274d316974b1bdeb5130953af9049",
            "Auto Pro",
            "Rotis Serif"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Auto Pro",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "35ffcac4445202ebcfefa85630823de6",
            "Auto Pro",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Auto Pro",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Auto Pro",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Auto Pro",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "Auto Pro",
            "Leitura News"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Auto Pro",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Auto Pro",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "c04f563b6a1457ae02100e98a49654c6",
            "Auto Pro",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "035ba8c1c49bacc7a8cf805ead63f91f",
            "Auto Pro",
            "Quercus 10"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "ef71628ba1ab6310365a78c263679726",
            "Auto Pro",
            "ITC Stone Serif"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "71ce2a4123e21bfb630f651363b756f3",
            "Auto Pro",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "d87ffd42ab39a3412ab905084e31b782",
            "Auto Pro",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "Auto Pro",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "073081f11751cb576e2b13de664766f6",
            "Auto Pro",
            "Le Monde Livre Std"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Auto Pro",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "Auto Pro",
            "Urge Text"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "34a814f80a793fa3eacde02882fa9faa",
            "Auto Pro",
            "Aldus"
        ]
    },
    {
        "likedPair": [
            "cdf497f40577c236216ef39ba5a1ef35",
            "2980338e1101915cd8cf85fec19fd126",
            "Auto Pro",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "d87ffd42ab39a3412ab905084e31b782",
            "FS Me",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "FS Me",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "535f79f088e3c680b94a53258330a712",
            "FS Me",
            "Cambria"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "b127070b4065a62961b2bf60fb763a76",
            "FS Me",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "c87f74a6084f73fdad817b1589a48a08",
            "FS Me",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "FS Me",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "50441227356a2e75a4737b2cfe84709b",
            "FS Me",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "e28128adc0e75357f447267c07afb6a6",
            "FS Me",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FS Me",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "cfbb9acb121612b62a247f211e51cb3e",
            "FS Me",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "cdfdc5eeac0bd71254929817415fb502",
            "c7117e8442a401bc7dd78049829ef83b",
            "FS Me",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Calvert MT Pro Light",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "f0249a1bec67973885bada20741c70c2",
            "Calvert MT Pro Light",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "f01435736b8b73793ad270cdf379a860",
            "Calvert MT Pro Light",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Calvert MT Pro Light",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Calvert MT Pro Light",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Calvert MT Pro Light",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Calvert MT Pro Light",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "15f6440060216b78f6e867d5cf13fd85",
            "Calvert MT Pro Light",
            "HangulatinEN-Regular"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "3670228ec97fd2a57e8a4d5b8ad5d88a",
            "Calvert MT Pro Light",
            "Aestetico"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "264a4ae29758ba917346fe9763531666",
            "Calvert MT Pro Light",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "0a990399fe7f1b376e846e602e3307bb",
            "Calvert MT Pro Light",
            "Europa Grotesk No. 2 SB"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Calvert MT Pro Light",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "d3caacfedf638f98ba7b0046f297f421",
            "Calvert MT Pro Light",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Calvert MT Pro Light",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "93b4e55aa9798f96b3a365a441a2238d",
            "Calvert MT Pro Light",
            "Oslo"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Calvert MT Pro Light",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "650bcadc2c69543d997704b29b7c50d2",
            "Calvert MT Pro Light",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "d159582398d0de4d0b367233acf587ee",
            "Calvert MT Pro Light",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "ea90949476110422d67b9af4f8ace3a2",
            "Calvert MT Pro Light",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Calvert MT Pro Light",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Bruta Global",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "737e1d3f1693de9fd863057622d1bb02",
            "Bruta Global",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Bruta Global",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "8ebe3248143db352da56805017ca7934",
            "Bruta Global",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Bruta Global",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "562b6ef730de2f21045076a67ebe852c",
            "Bruta Global",
            "NCT Larkspur"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "36c50039d788bccb71ca83a792b63c1c",
            "Bruta Global",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Bruta Global",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Bruta Global",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "8171bb293a9276179ab81d26551b93c1",
            "Bruta Global",
            "Passenger Serif"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Bruta Global",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "3938fddd18b33d1b1549d30049d6e749",
            "Bruta Global",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Bruta Global",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "Bruta Global",
            "ITC Bookman"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "0a20b91dc6e45ae4ad663b520d9fb62b",
            "Bruta Global",
            "Cotford"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "6d47953bebf6a23dc1d89764632524d8",
            "Bruta Global",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "38f28a6682e9d705522a7ac7a715578f",
            "Bruta Global",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Bruta Global",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Bruta Global",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "cfa5a3fbdc5746ae21ee869cd428cdc1",
            "c04f563b6a1457ae02100e98a49654c6",
            "Bruta Global",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Locke",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "3bc3a738f4507b8feea7502049c474d2",
            "Locke",
            "Gordita"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "Locke",
            "Aribau Grotesk"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "be1ed63669d6244408811624d948c116",
            "Locke",
            "Armin Soft"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "2836c06f795c236900263fe1e17d245a",
            "Locke",
            "Typold"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Locke",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "5fc34ab1bc22fba3ca57b0385f7f5c16",
            "Locke",
            "Qualion"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Locke",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "256f7672059f72846d940fbd8c97537d",
            "Locke",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "10b488d59515233c5fd8a7f7a2ba3854",
            "Locke",
            "Cerebri Sans"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "5067a55cd4114cbf808adbf3b4676e1a",
            "Locke",
            "TG Aqsa Grotesque Pro"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "b6249de3d08e3971282740ee906b6a8f",
            "Locke",
            "Yassitf"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "a932edac803361b3470866f58874f633",
            "Locke",
            "Dexa Pro"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "411e30ddd318c0fdf64abd6886591d95",
            "Locke",
            "TT Norms Pro"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "1ef83e490f20960c356d5bc893c42abe",
            "Locke",
            "Clarika Pro"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "725a4e3e2c3a7f7353bbed55f34c152d",
            "Locke",
            "Madera"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Locke",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "96e633e3b54168cc61a1acd1608084d3",
            "Locke",
            "Avenir 55 Roman"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Locke",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "cfbb9acb121612b62a247f211e51cb3e",
            "dc96c9566355e2a1445ab8dad6bf029e",
            "Locke",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Dante MT Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Dante MT Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "8bc363a2d1b8572dde75543187ba1bd6",
            "Dante MT Pro",
            "TT Commons \u200b\u200bClassic"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "168b3fd618c10cbf6278fd95bcc0ee47",
            "Dante MT Pro",
            "Yorkten"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "280c82457252f3613b33e3791c375caf",
            "Dante MT Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "033528c5f0137b017eff21079bd25a60",
            "Dante MT Pro",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "de9599121cf31a08904a48495fadcf4a",
            "Dante MT Pro",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Dante MT Pro",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Dante MT Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Dante MT Pro",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "fbb9573728984c54a8ca446e19d0972a",
            "Dante MT Pro",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Dante MT Pro",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Dante MT Pro",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "Dante MT Pro",
            "Sequel Sans"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "f01435736b8b73793ad270cdf379a860",
            "Dante MT Pro",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Dante MT Pro",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "29a6581b869f16aa3cabe07a44fe75b1",
            "Dante MT Pro",
            "Bw Modelica"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Dante MT Pro",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "9e6867c857655e9d1984390fdf1dde45",
            "Dante MT Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "d07f2481905eefa80fa98c464d59e260",
            "b832321e77d0f1be2c00712330066c3e",
            "Dante MT Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Core Sans C",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "b127070b4065a62961b2bf60fb763a76",
            "Core Sans C",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Core Sans C",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Core Sans C",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Core Sans C",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Core Sans C",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Core Sans C",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "3319dd949835e43d4bed270f465aff3e",
            "Core Sans C",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "cc3e79c959420501e528f6b20113c185",
            "Core Sans C",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "d0f3ec0504ca6f976926f385f49b961d",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Core Sans C",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "de9599121cf31a08904a48495fadcf4a",
            "Century Schoolbook",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Century Schoolbook",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "fc2e33377af6aca34a9826245e325cba",
            "Century Schoolbook",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "ea90949476110422d67b9af4f8ace3a2",
            "Century Schoolbook",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Century Schoolbook",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Century Schoolbook",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "650bcadc2c69543d997704b29b7c50d2",
            "Century Schoolbook",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "f01435736b8b73793ad270cdf379a860",
            "Century Schoolbook",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "f0249a1bec67973885bada20741c70c2",
            "Century Schoolbook",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "38b203ce41804d19e934461faf557ecb",
            "Century Schoolbook",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Century Schoolbook",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "d3caacfedf638f98ba7b0046f297f421",
            "Century Schoolbook",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Century Schoolbook",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "d159582398d0de4d0b367233acf587ee",
            "Century Schoolbook",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "ac04c5328af335b179cf1827997e1774",
            "Century Schoolbook",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "cae0af484abd406422956f9621c58b5f",
            "Century Schoolbook",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "Century Schoolbook",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "cc764ebb17c10db21cd67451fce38448",
            "Century Schoolbook",
            "Monotype Grotesque"
        ]
    },
    {
        "likedPair": [
            "d115cf3c43d6c21d3082fda58ccd341c",
            "147f1bb910d4c3487efd5789736afc3b",
            "Century Schoolbook",
            "Resist Sans"
        ]
    },
    {
        "likedPair": [
            "d1498a3b5b3ae3b7d9653ffad6f8ea5a",
            "b127070b4065a62961b2bf60fb763a76",
            "Latinka",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "d1498a3b5b3ae3b7d9653ffad6f8ea5a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Latinka",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "d1498a3b5b3ae3b7d9653ffad6f8ea5a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Latinka",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "d1498a3b5b3ae3b7d9653ffad6f8ea5a",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Latinka",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "d1498a3b5b3ae3b7d9653ffad6f8ea5a",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Latinka",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "3319dd949835e43d4bed270f465aff3e",
            "Neue Haas Grotesk Text",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "e961668cbc083722acbc4a237ca92232",
            "Neue Haas Grotesk Text",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Neue Haas Grotesk Text",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "ef0f22560e30896239545a852fd7f6b4",
            "Neue Haas Grotesk Text",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "386528d2feb209e45554ed0fa03d81ce",
            "Neue Haas Grotesk Text",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "5bd81732a879ba42412c19bd5a33589b",
            "Neue Haas Grotesk Text",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "d159582398d0de4d0b367233acf587ee",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Neue Haas Grotesk Text",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "2af66ddecaa7893391cb90362043d37a",
            "Scala Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "b832321e77d0f1be2c00712330066c3e",
            "Scala Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "38c216ced240e8111b587a31e2fc5794",
            "Scala Pro",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "280c82457252f3613b33e3791c375caf",
            "Scala Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "c63e8810388d85594540bb5f6980f611",
            "Scala Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Scala Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Scala Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "b941ce467c4b7f2846b3226ae7988452",
            "Scala Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Scala Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "095898e12700edc69d52ecf30ef03e2a",
            "Scala Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Scala Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Scala Pro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Scala Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "9e6867c857655e9d1984390fdf1dde45",
            "Scala Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "51eb849300954cdecf9da1310c79beb2",
            "Scala Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Scala Pro",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "fc2e33377af6aca34a9826245e325cba",
            "Scala Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Scala Pro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "82550c10af201d56d90be26b8833ac63",
            "Scala Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Scala Pro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "Fact",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Fact",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "e28128adc0e75357f447267c07afb6a6",
            "Fact",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "Fact",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "c87f74a6084f73fdad817b1589a48a08",
            "Fact",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "6badb2797a95a552c53a98a0f20c903b",
            "Fact",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "c638239ea03b75929bff2ce833419ac3",
            "Fact",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "Fact",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Fact",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Fact",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Fact",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "35fa420174ab6d0dc90b1a38613e8af0",
            "Fact",
            "Adelle"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "Fact",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "6b75a9583274793e20e232032200c56d",
            "Fact",
            "Foro"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "2721d6b75a2c057ffe99cad685d1da58",
            "Fact",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "623b4e42d48a5d620464ccf3c37cab13",
            "Fact",
            "Tabac Slab"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "Fact",
            "Leitura News"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "24d5d362d6d70239379cd1f356e168ec",
            "Fact",
            "Mundo Serif"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "cd92499f5905694f796be4b7b3406e49",
            "Fact",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "d18f103cfa62513f991b0f90a814c333",
            "71ce2a4123e21bfb630f651363b756f3",
            "Fact",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "Winterthur",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "e850c1a19f5dd604e85d62b658f34d62",
            "Winterthur",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Winterthur",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Winterthur",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "0a5055aaaa561e80e2b0d966a4db0190",
            "Winterthur",
            "Hauteclaire"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "09d88839ee48108d4891334024ee38d1",
            "Winterthur",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "c311a16ee279363b5113cbf699325577",
            "Winterthur",
            "Calluna"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "Winterthur",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "73138474522e9719f1a246b6fff9af38",
            "Winterthur",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "9001cd9b7b209eebef43419463ef6c40",
            "Winterthur",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "c638239ea03b75929bff2ce833419ac3",
            "Winterthur",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "88950808c1357581d744cc4f308d9f94",
            "Winterthur",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Winterthur",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "0f41ebd3d659da540745d00b52334eb0",
            "Winterthur",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "d87ffd42ab39a3412ab905084e31b782",
            "Winterthur",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Winterthur",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "Winterthur",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Winterthur",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "50441227356a2e75a4737b2cfe84709b",
            "Winterthur",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "d308bf8cc668fecbc3881e69f537c8e4",
            "d4df1a651052c6bd88be57660da085ac",
            "Winterthur",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Kis Antiqua Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Kis Antiqua Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Kis Antiqua Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Kis Antiqua Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "2af66ddecaa7893391cb90362043d37a",
            "Kis Antiqua Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "264a4ae29758ba917346fe9763531666",
            "Kis Antiqua Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Kis Antiqua Pro",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Kis Antiqua Pro",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "b941ce467c4b7f2846b3226ae7988452",
            "Kis Antiqua Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "c63e8810388d85594540bb5f6980f611",
            "Kis Antiqua Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "82550c10af201d56d90be26b8833ac63",
            "Kis Antiqua Pro",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "9e6867c857655e9d1984390fdf1dde45",
            "Kis Antiqua Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "fc2e33377af6aca34a9826245e325cba",
            "Kis Antiqua Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "095898e12700edc69d52ecf30ef03e2a",
            "Kis Antiqua Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Kis Antiqua Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Kis Antiqua Pro",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "51eb849300954cdecf9da1310c79beb2",
            "Kis Antiqua Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Kis Antiqua Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Kis Antiqua Pro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "87791721b0238c72031ce39e346933a8",
            "Kis Antiqua Pro",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Devoid",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Devoid",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Devoid",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "3319dd949835e43d4bed270f465aff3e",
            "Devoid",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "3938fddd18b33d1b1549d30049d6e749",
            "Devoid",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "6d47953bebf6a23dc1d89764632524d8",
            "Devoid",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "45f11e2ac1181359f4004a104c49f31d",
            "Devoid",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "06779a9920e25578b6f504fcbd0ca169",
            "Devoid",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "8ebe3248143db352da56805017ca7934",
            "Devoid",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Devoid",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Devoid",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "e961668cbc083722acbc4a237ca92232",
            "Devoid",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "8ec787f27be4c31cf8c185b0f1310703",
            "Devoid",
            "Skema Pro"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "afb2c306772fbf472d6549a865bf7339",
            "Devoid",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "b127070b4065a62961b2bf60fb763a76",
            "Devoid",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Devoid",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Devoid",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "4dac2d953bdd6df6fb693c25fc31805c",
            "Devoid",
            "Peri\u00f3dico"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "d4df1a651052c6bd88be57660da085ac",
            "Devoid",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "d3caacfedf638f98ba7b0046f297f421",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "Devoid",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "d485fcb548b17f767a22bd95356d6208",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Albany",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "d485fcb548b17f767a22bd95356d6208",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Albany",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "d485fcb548b17f767a22bd95356d6208",
            "cd92499f5905694f796be4b7b3406e49",
            "Albany",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "d485fcb548b17f767a22bd95356d6208",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Albany",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "2c055a7f717a969a129cf78e586c2d39",
            "Dagny Offc Pro",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Dagny Offc Pro",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "c04f563b6a1457ae02100e98a49654c6",
            "Dagny Offc Pro",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "737e1d3f1693de9fd863057622d1bb02",
            "Dagny Offc Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "5bd81732a879ba42412c19bd5a33589b",
            "Dagny Offc Pro",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Dagny Offc Pro",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "6d47953bebf6a23dc1d89764632524d8",
            "Dagny Offc Pro",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Dagny Offc Pro",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "3319dd949835e43d4bed270f465aff3e",
            "Dagny Offc Pro",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "103510159c0a328260730731e27eabe1",
            "Dagny Offc Pro",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Dagny Offc Pro",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "35ffcac4445202ebcfefa85630823de6",
            "Dagny Offc Pro",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "8ebe3248143db352da56805017ca7934",
            "Dagny Offc Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "38f28a6682e9d705522a7ac7a715578f",
            "Dagny Offc Pro",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Dagny Offc Pro",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Dagny Offc Pro",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "386528d2feb209e45554ed0fa03d81ce",
            "Dagny Offc Pro",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Dagny Offc Pro",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "88950808c1357581d744cc4f308d9f94",
            "Dagny Offc Pro",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "4b69cc4ce483966efd99a637882c74a5",
            "Dagny Offc Pro",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "cae0af484abd406422956f9621c58b5f",
            "Hefring Slab",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "57cdd235481768dc73076d8a49a44353",
            "Hefring Slab",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Hefring Slab",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "d159582398d0de4d0b367233acf587ee",
            "Hefring Slab",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Hefring Slab",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "7e6dddc7c1f4581a2e8573afd8fc11a4",
            "Hefring Slab",
            "Larsseit"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Hefring Slab",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "03ba201f7613be300cec0afc83ee295a",
            "Hefring Slab",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "7e544a1b2b151addd74b6fa5a3ec21dc",
            "Hefring Slab",
            "Bau Offc"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "42242b3d0731f05814ed723a957a1ca2",
            "Hefring Slab",
            "FF Nort"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "ac04c5328af335b179cf1827997e1774",
            "Hefring Slab",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Hefring Slab",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "b0f799383351d9ef86939c76bff5bafc",
            "Hefring Slab",
            "Causten"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "bf9fc533e1700efac60390b153c27ca0",
            "Hefring Slab",
            "Arboria"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "d0f3ec0504ca6f976926f385f49b961d",
            "Hefring Slab",
            "Core Sans C"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "c942458d9c4ef70d95edd3fa2ee6d55e",
            "Hefring Slab",
            "Altone"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "Hefring Slab",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "Hefring Slab",
            "2030"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "bac35fedbd3fd504663d9540a5863703",
            "Hefring Slab",
            "Nova Grotesk"
        ]
    },
    {
        "likedPair": [
            "d4df1a651052c6bd88be57660da085ac",
            "075ee4d8b4b2f2be685deae392ee79a8",
            "Hefring Slab",
            "Averta"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Aetna JY Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "b941ce467c4b7f2846b3226ae7988452",
            "Aetna JY Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Aetna JY Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "51eb849300954cdecf9da1310c79beb2",
            "Aetna JY Pro",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "9e6867c857655e9d1984390fdf1dde45",
            "Aetna JY Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Aetna JY Pro",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Aetna JY Pro",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "280c82457252f3613b33e3791c375caf",
            "Aetna JY Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "095898e12700edc69d52ecf30ef03e2a",
            "Aetna JY Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Aetna JY Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "70c60ffb0aa7fc3a33350d4a61d5873f",
            "Aetna JY Pro",
            "Joanna Sans Nova"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Aetna JY Pro",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Aetna JY Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "35641bbe5146f945b85e1e7b34956a73",
            "Aetna JY Pro",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "565f10ac096eb5d75c4400509e23cdc1",
            "Aetna JY Pro",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Aetna JY Pro",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "28c6a19b71dc83cd8f817d2e8b1ea5e2",
            "Aetna JY Pro",
            "Gill Sans MT Pro Book"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "b832321e77d0f1be2c00712330066c3e",
            "Aetna JY Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Aetna JY Pro",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "d4f0f8030c1d155b3361152e0e4468e8",
            "3d295205229224442c34a365d6b885d1",
            "Aetna JY Pro",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "d3caacfedf638f98ba7b0046f297f421",
            "Serifa",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Serifa",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "f0249a1bec67973885bada20741c70c2",
            "Serifa",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "627f02177189a33fe40ad427eff5d5bb",
            "Serifa",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "cae0af484abd406422956f9621c58b5f",
            "Serifa",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Serifa",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Serifa",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "d159582398d0de4d0b367233acf587ee",
            "Serifa",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "ac04c5328af335b179cf1827997e1774",
            "Serifa",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Serifa",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Serifa",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Serifa",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "868fc2017554528c8ca4e20974e19480",
            "Serifa",
            "Codec Pro"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "a8008a4be1e40b815732b608890c3415",
            "Serifa",
            "Neuville"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Serifa",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Serifa",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "96da2e3b759f10f9970cef587bf11069",
            "Serifa",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "dfa1317c450784d1f09730737065a19b",
            "Serifa",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "03ba201f7613be300cec0afc83ee295a",
            "Serifa",
            "Helvetica"
        ]
    },
    {
        "likedPair": [
            "d515a6ca361cc9d1340762f79d8263dd",
            "e703c571b26ddb70174e8b5111fea898",
            "Serifa",
            "Bw Nista"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "de9599121cf31a08904a48495fadcf4a",
            "Ashbury",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Ashbury",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "Ashbury",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Ashbury",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Ashbury",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "8223719dee533eb7e895e0a101f4472c",
            "Ashbury",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "f0249a1bec67973885bada20741c70c2",
            "Ashbury",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "650bcadc2c69543d997704b29b7c50d2",
            "Ashbury",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "d3caacfedf638f98ba7b0046f297f421",
            "Ashbury",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "fc2e33377af6aca34a9826245e325cba",
            "Ashbury",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Ashbury",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "38b203ce41804d19e934461faf557ecb",
            "Ashbury",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "f01435736b8b73793ad270cdf379a860",
            "Ashbury",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Ashbury",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Ashbury",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "ebdc49d2fe55718bce1a53f10769e589",
            "Ashbury",
            "Folio"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Ashbury",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "87791721b0238c72031ce39e346933a8",
            "Ashbury",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "090f944a52ed426dbc544297d0fb9442",
            "Ashbury",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "d65b523fcfc75bf2c7350da6414e75ba",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Ashbury",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "b832321e77d0f1be2c00712330066c3e",
            "Magneta",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "b941ce467c4b7f2846b3226ae7988452",
            "Magneta",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Magneta",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "38c216ced240e8111b587a31e2fc5794",
            "Magneta",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Magneta",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "2af66ddecaa7893391cb90362043d37a",
            "Magneta",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "c63e8810388d85594540bb5f6980f611",
            "Magneta",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "095898e12700edc69d52ecf30ef03e2a",
            "Magneta",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Magneta",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Magneta",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "d67f3516d06c406d9b18f083b3b32d17",
            "9e6867c857655e9d1984390fdf1dde45",
            "Magneta",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Gloucester Pro Regular",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Gloucester Pro Regular",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Gloucester Pro Regular",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Gloucester Pro Regular",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "b832321e77d0f1be2c00712330066c3e",
            "Gloucester Pro Regular",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "18b27dd0e80d2f0a380a185f41e0dfed",
            "Gloucester Pro Regular",
            "Andale Sans Paneuropean"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "d18f103cfa62513f991b0f90a814c333",
            "Gloucester Pro Regular",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Gloucester Pro Regular",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Gloucester Pro Regular",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "Gloucester Pro Regular",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "090f944a52ed426dbc544297d0fb9442",
            "Gloucester Pro Regular",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "d84e985d428e023bb87368d43461b448",
            "Gloucester Pro Regular",
            "SST"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "47e848f1f1b998207926dfb024fa4a48",
            "Gloucester Pro Regular",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Gloucester Pro Regular",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Gloucester Pro Regular",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "185f07766a2c7cd46ff339e5993e5cac",
            "Gloucester Pro Regular",
            "Motiva Sans"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "b941ce467c4b7f2846b3226ae7988452",
            "Gloucester Pro Regular",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Gloucester Pro Regular",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Gloucester Pro Regular",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Gloucester Pro Regular",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "SST",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "e28128adc0e75357f447267c07afb6a6",
            "SST",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "c87f74a6084f73fdad817b1589a48a08",
            "SST",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "SST",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "e850c1a19f5dd604e85d62b658f34d62",
            "SST",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "6badb2797a95a552c53a98a0f20c903b",
            "SST",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "8d9fd883298c86eeb3d614b7311f8431",
            "SST",
            "Milo Serif Pro"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "SST",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "SST",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "SST",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "c638239ea03b75929bff2ce833419ac3",
            "SST",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "9ded3c33a83728124405e311fff63b40",
            "SST",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "SST",
            "Leitura News"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "cd92499f5905694f796be4b7b3406e49",
            "SST",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "9a3cbe6536daacbe69badbe58dd024af",
            "SST",
            "PT Serif Pro"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "SST",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "23cf62915fdb3dd17d0c3dbfd6127d28",
            "SST",
            "Rooney"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "9d4006b028ee37610307e9af03bfdf54",
            "SST",
            "DIN Next Slab"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "71ce2a4123e21bfb630f651363b756f3",
            "SST",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "d84e985d428e023bb87368d43461b448",
            "862844e56f430bb0af08f52dd89f1be0",
            "SST",
            "Velino Text"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "fe3a6272e385cf422cb1e23f99deb591",
            "FF Kievit Slab",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "11a56cbb71e23af5abcff867473f961a",
            "FF Kievit Slab",
            "Ballinger"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "4a8d414c86f9aeae1489e72e6293e772",
            "FF Kievit Slab",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "FF Kievit Slab",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "FF Kievit Slab",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "e1864ebcfe34672f435c3bedacde5d63",
            "FF Kievit Slab",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "b832321e77d0f1be2c00712330066c3e",
            "FF Kievit Slab",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "FF Kievit Slab",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "2af66ddecaa7893391cb90362043d37a",
            "FF Kievit Slab",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "FF Kievit Slab",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "264a4ae29758ba917346fe9763531666",
            "FF Kievit Slab",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "b941ce467c4b7f2846b3226ae7988452",
            "FF Kievit Slab",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "6972d76d6b70c4f916337708bc39ae4e",
            "FF Kievit Slab",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "c63e8810388d85594540bb5f6980f611",
            "FF Kievit Slab",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "FF Kievit Slab",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "095898e12700edc69d52ecf30ef03e2a",
            "FF Kievit Slab",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "35641bbe5146f945b85e1e7b34956a73",
            "FF Kievit Slab",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "38c216ced240e8111b587a31e2fc5794",
            "FF Kievit Slab",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "87791721b0238c72031ce39e346933a8",
            "FF Kievit Slab",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "d87ffd42ab39a3412ab905084e31b782",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "FF Kievit Slab",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "8ebe3248143db352da56805017ca7934",
            "Aribau Grotesk",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Aribau Grotesk",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "737e1d3f1693de9fd863057622d1bb02",
            "Aribau Grotesk",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Aribau Grotesk",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "c04f563b6a1457ae02100e98a49654c6",
            "Aribau Grotesk",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Aribau Grotesk",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "8c155b53e011d2a709548865b3edbeaf",
            "Aribau Grotesk",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Aribau Grotesk",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "38f28a6682e9d705522a7ac7a715578f",
            "Aribau Grotesk",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "103510159c0a328260730731e27eabe1",
            "Aribau Grotesk",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "e093c040c71b04f76b2b181a6dd3acea",
            "Aribau Grotesk",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "5f2166fea2000a7b2f6e361c76edeef4",
            "Aribau Grotesk",
            "URW Antiqua"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Aribau Grotesk",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Aribau Grotesk",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "d4df1a651052c6bd88be57660da085ac",
            "Aribau Grotesk",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "b127070b4065a62961b2bf60fb763a76",
            "Aribau Grotesk",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "73e48b94c08d2015315dbceaf56efb62",
            "Aribau Grotesk",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "9da983bd95342b2184596f18ef3fff34",
            "Aribau Grotesk",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Aribau Grotesk",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "d97df1a3c9e8b3f576924ec1a06d925c",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Aribau Grotesk",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Univers",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Univers",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Univers",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "737e1d3f1693de9fd863057622d1bb02",
            "Univers",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "3319dd949835e43d4bed270f465aff3e",
            "Univers",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "be483d1a100a556f9456d2ab176fd0c9",
            "Univers",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Univers",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "8ebe3248143db352da56805017ca7934",
            "Univers",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "3938fddd18b33d1b1549d30049d6e749",
            "Univers",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "6d47953bebf6a23dc1d89764632524d8",
            "Univers",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "73bb1b4a2b2fea7122f945255ea437d0",
            "Univers",
            "Clarion"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "b127070b4065a62961b2bf60fb763a76",
            "Univers",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Univers",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Univers",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Univers",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Univers",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "45f11e2ac1181359f4004a104c49f31d",
            "Univers",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "e961668cbc083722acbc4a237ca92232",
            "Univers",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "06779a9920e25578b6f504fcbd0ca169",
            "Univers",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "da5723a234527888e7dc5e19548f1abb",
            "36c50039d788bccb71ca83a792b63c1c",
            "Univers",
            "Humanist Slabserif 712"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "AkzidenzGroteskBQ-Reg",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "3938fddd18b33d1b1549d30049d6e749",
            "AkzidenzGroteskBQ-Reg",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "3319dd949835e43d4bed270f465aff3e",
            "AkzidenzGroteskBQ-Reg",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "737e1d3f1693de9fd863057622d1bb02",
            "AkzidenzGroteskBQ-Reg",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "d515a6ca361cc9d1340762f79d8263dd",
            "AkzidenzGroteskBQ-Reg",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "8ebe3248143db352da56805017ca7934",
            "AkzidenzGroteskBQ-Reg",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "e961668cbc083722acbc4a237ca92232",
            "AkzidenzGroteskBQ-Reg",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "AkzidenzGroteskBQ-Reg",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "ef0f22560e30896239545a852fd7f6b4",
            "AkzidenzGroteskBQ-Reg",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "5bd81732a879ba42412c19bd5a33589b",
            "AkzidenzGroteskBQ-Reg",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "AkzidenzGroteskBQ-Reg",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "dac699b554de5b30f7764b27556f9e9e",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "AkzidenzGroteskBQ-Reg",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "9ded3c33a83728124405e311fff63b40",
            "RT_Vickerman",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "6badb2797a95a552c53a98a0f20c903b",
            "RT_Vickerman",
            "Askan"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "4e5e667f9c0976af5022f8d80ee481c1",
            "RT_Vickerman",
            "Malaga"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "0252208772e96e5a876dbfe0a9d9e3d7",
            "RT_Vickerman",
            "Neue Swift"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "d87ffd42ab39a3412ab905084e31b782",
            "RT_Vickerman",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "3c493435ad297f5d9c9edf1e5dea65e4",
            "RT_Vickerman",
            "Solitas Serif"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "2980338e1101915cd8cf85fec19fd126",
            "RT_Vickerman",
            "Mastro"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "e850c1a19f5dd604e85d62b658f34d62",
            "RT_Vickerman",
            "Portada"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "aaa60aa8fc5a49a2f846ee2a0507aaa2",
            "RT_Vickerman",
            "Andada-Regular"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "c638239ea03b75929bff2ce833419ac3",
            "RT_Vickerman",
            "Gimbal Egyptian"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "d6997b0a2b523e7bef85e2d1d2cdbae4",
            "RT_Vickerman",
            "Gloucester Pro Regular"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "6fb342b0a6d0d4c31bb6b8626eeb0fb7",
            "RT_Vickerman",
            "Tarsus"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "c87f74a6084f73fdad817b1589a48a08",
            "RT_Vickerman",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "6b75a9583274793e20e232032200c56d",
            "RT_Vickerman",
            "Foro"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "e28128adc0e75357f447267c07afb6a6",
            "RT_Vickerman",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "2721d6b75a2c057ffe99cad685d1da58",
            "RT_Vickerman",
            "Sirba"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "RT_Vickerman",
            "Sole Serif"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "1a365ce6a76c9cbfa452f83d9946d984",
            "RT_Vickerman",
            "PMN Caecilia"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "8d9fd883298c86eeb3d614b7311f8431",
            "RT_Vickerman",
            "Milo Serif Pro"
        ]
    },
    {
        "likedPair": [
            "db2e42ddf6a123ca85bba4367802332d",
            "9a3cbe6536daacbe69badbe58dd024af",
            "RT_Vickerman",
            "PT Serif Pro"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "8ebe3248143db352da56805017ca7934",
            "FF Mark",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "737e1d3f1693de9fd863057622d1bb02",
            "FF Mark",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "cfbb9acb121612b62a247f211e51cb3e",
            "FF Mark",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "c2722fea792cde12a9117da6e0d70f74",
            "FF Mark",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "8c155b53e011d2a709548865b3edbeaf",
            "FF Mark",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "FF Mark",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "FF Mark",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "FF Mark",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "FF Mark",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "FF Mark",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FF Mark",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "FF Mark",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "b127070b4065a62961b2bf60fb763a76",
            "FF Mark",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "b74bf78a743785e3df7e3f14477a1390",
            "FF Mark",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "cc3e79c959420501e528f6b20113c185",
            "FF Mark",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "dc96c9566355e2a1445ab8dad6bf029e",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "FF Mark",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "3319dd949835e43d4bed270f465aff3e",
            "Gothic 720 W03 Rom",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "06779a9920e25578b6f504fcbd0ca169",
            "Gothic 720 W03 Rom",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Gothic 720 W03 Rom",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "b127070b4065a62961b2bf60fb763a76",
            "Gothic 720 W03 Rom",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Gothic 720 W03 Rom",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "afb2c306772fbf472d6549a865bf7339",
            "Gothic 720 W03 Rom",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Gothic 720 W03 Rom",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "Gothic 720 W03 Rom",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Gothic 720 W03 Rom",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Gothic 720 W03 Rom",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Gothic 720 W03 Rom",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Gothic 720 W03 Rom",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "737e1d3f1693de9fd863057622d1bb02",
            "Gothic 720 W03 Rom",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "8ebe3248143db352da56805017ca7934",
            "Gothic 720 W03 Rom",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Gothic 720 W03 Rom",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Gothic 720 W03 Rom",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "6d47953bebf6a23dc1d89764632524d8",
            "Gothic 720 W03 Rom",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "5bd81732a879ba42412c19bd5a33589b",
            "Gothic 720 W03 Rom",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "d4df1a651052c6bd88be57660da085ac",
            "Gothic 720 W03 Rom",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Gothic 720 W03 Rom",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "de2b24a2aafb511e523b18ecdb05ddee",
            "06510c0260d17a867a598617cc3f59e9",
            "DIN Next",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "de2b24a2aafb511e523b18ecdb05ddee",
            "5deef3f01e195e1ed663c9b01d334f7a",
            "DIN Next",
            "Linotype Centennial"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "8ebe3248143db352da56805017ca7934",
            "District Pro",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "District Pro",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "District Pro",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "d4df1a651052c6bd88be57660da085ac",
            "District Pro",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "263b7ffd57470af21ec49d7a144c4f23",
            "District Pro",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "737e1d3f1693de9fd863057622d1bb02",
            "District Pro",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "adc9e6f8703a21e134aa72d637646fdc",
            "District Pro",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "45f11e2ac1181359f4004a104c49f31d",
            "District Pro",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "35ffcac4445202ebcfefa85630823de6",
            "District Pro",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "36ca5bc123f848ac643b6d50602259b7",
            "District Pro",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "District Pro",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "c6bae55c030fe9df4104274e7fa5df57",
            "District Pro",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "District Pro",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "6e4bf0177f0e1b459e2b159545de1181",
            "District Pro",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "b7d17d2dc576785a3f3919a96d964e46",
            "District Pro",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "73e48b94c08d2015315dbceaf56efb62",
            "District Pro",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "District Pro",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "c04f563b6a1457ae02100e98a49654c6",
            "District Pro",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "aca2aa0b3e30f62041a42f7eb8e078ab",
            "District Pro",
            "Amasis"
        ]
    },
    {
        "likedPair": [
            "de9599121cf31a08904a48495fadcf4a",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "District Pro",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Planc",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Planc",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "8ebe3248143db352da56805017ca7934",
            "Planc",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Planc",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "737e1d3f1693de9fd863057622d1bb02",
            "Planc",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "5f2166fea2000a7b2f6e361c76edeef4",
            "Planc",
            "URW Antiqua"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Planc",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "955b9a400ce5accf68307eaad62c4f62",
            "Planc",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Planc",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "3319dd949835e43d4bed270f465aff3e",
            "Planc",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "Planc",
            "ITC Bookman"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "3938fddd18b33d1b1549d30049d6e749",
            "Planc",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Planc",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "6d47953bebf6a23dc1d89764632524d8",
            "Planc",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "9da983bd95342b2184596f18ef3fff34",
            "Planc",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "522e87f46fb6197b3326bd95f2e8cb8c",
            "Planc",
            "GazetteLTStd-Roman"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "38f28a6682e9d705522a7ac7a715578f",
            "Planc",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "c04f563b6a1457ae02100e98a49654c6",
            "Planc",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Planc",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "dfa1317c450784d1f09730737065a19b",
            "5bd81732a879ba42412c19bd5a33589b",
            "Planc",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "BerlingLTStd-Roman",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "BerlingLTStd-Roman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "BerlingLTStd-Roman",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "9e6867c857655e9d1984390fdf1dde45",
            "BerlingLTStd-Roman",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "BerlingLTStd-Roman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "c63e8810388d85594540bb5f6980f611",
            "BerlingLTStd-Roman",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "BerlingLTStd-Roman",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "91f1a74434b4ecc9129239ec3e236b42",
            "BerlingLTStd-Roman",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "dfa259ce11399457b3760878b733756c",
            "c2244758e73a4caacb7f2916afe5f38f",
            "BerlingLTStd-Roman",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Ingeborg",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "264a4ae29758ba917346fe9763531666",
            "Ingeborg",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Ingeborg",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "de9599121cf31a08904a48495fadcf4a",
            "Ingeborg",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "fc2e33377af6aca34a9826245e325cba",
            "Ingeborg",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "87791721b0238c72031ce39e346933a8",
            "Ingeborg",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Ingeborg",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "f0249a1bec67973885bada20741c70c2",
            "Ingeborg",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "ea90949476110422d67b9af4f8ace3a2",
            "Ingeborg",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Ingeborg",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "f01435736b8b73793ad270cdf379a860",
            "Ingeborg",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Ingeborg",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "d3caacfedf638f98ba7b0046f297f421",
            "Ingeborg",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "650bcadc2c69543d997704b29b7c50d2",
            "Ingeborg",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "38b203ce41804d19e934461faf557ecb",
            "Ingeborg",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Ingeborg",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "9e6867c857655e9d1984390fdf1dde45",
            "Ingeborg",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "d159582398d0de4d0b367233acf587ee",
            "Ingeborg",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Ingeborg",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "e093c040c71b04f76b2b181a6dd3acea",
            "cae0af484abd406422956f9621c58b5f",
            "Ingeborg",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Alkes",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "b832321e77d0f1be2c00712330066c3e",
            "Alkes",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Alkes",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Alkes",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "264a4ae29758ba917346fe9763531666",
            "Alkes",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Alkes",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Alkes",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Alkes",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "9e6867c857655e9d1984390fdf1dde45",
            "Alkes",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Alkes",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "fc2e33377af6aca34a9826245e325cba",
            "Alkes",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "c63e8810388d85594540bb5f6980f611",
            "Alkes",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "b941ce467c4b7f2846b3226ae7988452",
            "Alkes",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "82550c10af201d56d90be26b8833ac63",
            "Alkes",
            "Makozin"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "095898e12700edc69d52ecf30ef03e2a",
            "Alkes",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Alkes",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Alkes",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Alkes",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Alkes",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "e0d397e073f334bdc40410c8c4093d9b",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Alkes",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "b127070b4065a62961b2bf60fb763a76",
            "Neue Plak",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "3319dd949835e43d4bed270f465aff3e",
            "Neue Plak",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Neue Plak",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "8ebe3248143db352da56805017ca7934",
            "Neue Plak",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "d4df1a651052c6bd88be57660da085ac",
            "Neue Plak",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "e961668cbc083722acbc4a237ca92232",
            "Neue Plak",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Neue Plak",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "5bd81732a879ba42412c19bd5a33589b",
            "Neue Plak",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "386528d2feb209e45554ed0fa03d81ce",
            "Neue Plak",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "ef0f22560e30896239545a852fd7f6b4",
            "Neue Plak",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "8006330b215827a8efcd0e4c791bae76",
            "Neue Plak",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "50441227356a2e75a4737b2cfe84709b",
            "Neue Plak",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "e1351e92b91e4de955c73093b43ae8e2",
            "9038a98bf57fcb8a853acb3adf17bfed",
            "Neue Plak",
            "Valencia Serial"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "737e1d3f1693de9fd863057622d1bb02",
            "CG Symphony",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "c04f563b6a1457ae02100e98a49654c6",
            "CG Symphony",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "263b7ffd57470af21ec49d7a144c4f23",
            "CG Symphony",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "35ffcac4445202ebcfefa85630823de6",
            "CG Symphony",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "CG Symphony",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "CG Symphony",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "CG Symphony",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "103510159c0a328260730731e27eabe1",
            "CG Symphony",
            "Baskerville"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "6e4bf0177f0e1b459e2b159545de1181",
            "CG Symphony",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "36ca5bc123f848ac643b6d50602259b7",
            "CG Symphony",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "CG Symphony",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "c6bae55c030fe9df4104274e7fa5df57",
            "CG Symphony",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "e093c040c71b04f76b2b181a6dd3acea",
            "CG Symphony",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "88950808c1357581d744cc4f308d9f94",
            "CG Symphony",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "4b69cc4ce483966efd99a637882c74a5",
            "CG Symphony",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "CG Symphony",
            "Life"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "d4df1a651052c6bd88be57660da085ac",
            "CG Symphony",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "c3c0b5f23e63fcc31f434604265321d6",
            "CG Symphony",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "38f28a6682e9d705522a7ac7a715578f",
            "CG Symphony",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "e1864ebcfe34672f435c3bedacde5d63",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "CG Symphony",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "033528c5f0137b017eff21079bd25a60",
            "Orbi",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Orbi",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Orbi",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "264a4ae29758ba917346fe9763531666",
            "Orbi",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Orbi",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Orbi",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Orbi",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "ea90949476110422d67b9af4f8ace3a2",
            "Orbi",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Orbi",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "b832321e77d0f1be2c00712330066c3e",
            "Orbi",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "fc2e33377af6aca34a9826245e325cba",
            "Orbi",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Orbi",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Orbi",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "9e6867c857655e9d1984390fdf1dde45",
            "Orbi",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Orbi",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "38c216ced240e8111b587a31e2fc5794",
            "Orbi",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "87791721b0238c72031ce39e346933a8",
            "Orbi",
            "Malden Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Orbi",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "2af66ddecaa7893391cb90362043d37a",
            "Orbi",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "e208cca764688975f3d7d3839228dea0",
            "b941ce467c4b7f2846b3226ae7988452",
            "Orbi",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "c6ff032bd835e2f806009627251b87b6",
            "Hyperon",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "b832321e77d0f1be2c00712330066c3e",
            "Hyperon",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "3774b4df0b2cb612124f851d40399d26",
            "Hyperon",
            "Lina"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Hyperon",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Hyperon",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "264a4ae29758ba917346fe9763531666",
            "Hyperon",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Hyperon",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "2b443d68adf1ec97623afac779dc9572",
            "Hyperon",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Hyperon",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Hyperon",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "280c82457252f3613b33e3791c375caf",
            "Hyperon",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "38c216ced240e8111b587a31e2fc5794",
            "Hyperon",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Hyperon",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "2af66ddecaa7893391cb90362043d37a",
            "Hyperon",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Hyperon",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Hyperon",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "9e6867c857655e9d1984390fdf1dde45",
            "Hyperon",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "001114826556952bb283044f915f1d9c",
            "Hyperon",
            "Comenia Sans"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Hyperon",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "e28128adc0e75357f447267c07afb6a6",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Hyperon",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Atlan",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "8c155b53e011d2a709548865b3edbeaf",
            "Atlan",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Atlan",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Atlan",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Atlan",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "c7117e8442a401bc7dd78049829ef83b",
            "Atlan",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "b127070b4065a62961b2bf60fb763a76",
            "Atlan",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Atlan",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "c2722fea792cde12a9117da6e0d70f74",
            "Atlan",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Atlan",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Atlan",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "b74bf78a743785e3df7e3f14477a1390",
            "Atlan",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "cd92499f5905694f796be4b7b3406e49",
            "Atlan",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "955b9a400ce5accf68307eaad62c4f62",
            "Atlan",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "e3fd4fa2ddb6738d86521dac4683282d",
            "cc3e79c959420501e528f6b20113c185",
            "Atlan",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "8ebe3248143db352da56805017ca7934",
            "Bw Nista",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "737e1d3f1693de9fd863057622d1bb02",
            "Bw Nista",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "38f28a6682e9d705522a7ac7a715578f",
            "Bw Nista",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "9da983bd95342b2184596f18ef3fff34",
            "Bw Nista",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Bw Nista",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Bw Nista",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Bw Nista",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "3938fddd18b33d1b1549d30049d6e749",
            "Bw Nista",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Bw Nista",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "6d47953bebf6a23dc1d89764632524d8",
            "Bw Nista",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Bw Nista",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "3319dd949835e43d4bed270f465aff3e",
            "Bw Nista",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Bw Nista",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Bw Nista",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Bw Nista",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Bw Nista",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "5bd81732a879ba42412c19bd5a33589b",
            "Bw Nista",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Bw Nista",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Bw Nista",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "e703c571b26ddb70174e8b5111fea898",
            "b74bf78a743785e3df7e3f14477a1390",
            "Bw Nista",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Ano",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "b127070b4065a62961b2bf60fb763a76",
            "Ano",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Ano",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Ano",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Ano",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "cc3e79c959420501e528f6b20113c185",
            "Ano",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Ano",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "8ebe3248143db352da56805017ca7934",
            "Ano",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Ano",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "737e1d3f1693de9fd863057622d1bb02",
            "Ano",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "3319dd949835e43d4bed270f465aff3e",
            "Ano",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "bad316ad74318a9f95d0749417edfa04",
            "Ano",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Ano",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Ano",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "6d47953bebf6a23dc1d89764632524d8",
            "Ano",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "955b9a400ce5accf68307eaad62c4f62",
            "Ano",
            "Nexa Slab"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Ano",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "3938fddd18b33d1b1549d30049d6e749",
            "Ano",
            "Schotis Text"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "c7117e8442a401bc7dd78049829ef83b",
            "Ano",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "5f2166fea2000a7b2f6e361c76edeef4",
            "Ano",
            "URW Antiqua"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "f0c4c3d68e27949d411acbfa534b2fef",
            "Iwata Mincho Old Pro",
            "Tee Franklin"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "de9599121cf31a08904a48495fadcf4a",
            "Iwata Mincho Old Pro",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "8223719dee533eb7e895e0a101f4472c",
            "Iwata Mincho Old Pro",
            "Corporate S"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "f0249a1bec67973885bada20741c70c2",
            "Iwata Mincho Old Pro",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Iwata Mincho Old Pro",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Iwata Mincho Old Pro",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "264a4ae29758ba917346fe9763531666",
            "Iwata Mincho Old Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "e1351e92b91e4de955c73093b43ae8e2",
            "Iwata Mincho Old Pro",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Iwata Mincho Old Pro",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "f01435736b8b73793ad270cdf379a860",
            "Iwata Mincho Old Pro",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "ea90949476110422d67b9af4f8ace3a2",
            "Iwata Mincho Old Pro",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "fe3a6272e385cf422cb1e23f99deb591",
            "Iwata Mincho Old Pro",
            "Trade Gothic"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Iwata Mincho Old Pro",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Iwata Mincho Old Pro",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "650bcadc2c69543d997704b29b7c50d2",
            "Iwata Mincho Old Pro",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Iwata Mincho Old Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "651d20bfc43c6f0cd778bc11d04acad7",
            "Iwata Mincho Old Pro",
            "Amnesty Trade Gothic W04 Roman"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "38b203ce41804d19e934461faf557ecb",
            "Iwata Mincho Old Pro",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "fc2e33377af6aca34a9826245e325cba",
            "Iwata Mincho Old Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "d3caacfedf638f98ba7b0046f297f421",
            "Iwata Mincho Old Pro",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "c6ff032bd835e2f806009627251b87b6",
            "Portada",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "3774b4df0b2cb612124f851d40399d26",
            "Portada",
            "Lina"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "6972d76d6b70c4f916337708bc39ae4e",
            "Portada",
            "Stella"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Portada",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "b832321e77d0f1be2c00712330066c3e",
            "Portada",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "Portada",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "2b443d68adf1ec97623afac779dc9572",
            "Portada",
            "Akagi"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Portada",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "3454b36dbe2f20db2fd2966afc213a6c",
            "Portada",
            "Graublau Sans Pro"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "5b5a1198d2f08e85df4bb6a8a2adc2d5",
            "Portada",
            "Hedley New"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Portada",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "2af66ddecaa7893391cb90362043d37a",
            "Portada",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "bb53acb0d26b7c34eaca665214b5b781",
            "Portada",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "d18f103cfa62513f991b0f90a814c333",
            "Portada",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "d84e985d428e023bb87368d43461b448",
            "Portada",
            "SST"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "38c216ced240e8111b587a31e2fc5794",
            "Portada",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Portada",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "db2e42ddf6a123ca85bba4367802332d",
            "Portada",
            "RT_Vickerman"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "3a2f35b17543f0f3464b26e080b16634",
            "Portada",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "e850c1a19f5dd604e85d62b658f34d62",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Portada",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "d67f3516d06c406d9b18f083b3b32d17",
            "TheSans",
            "Magneta"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "5bc11ee6e70bd324d1e9e42d32350841",
            "TheSans",
            "Sirius"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "TheSans",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "TheSans",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "TheSans",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "TheSans",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "d87ffd42ab39a3412ab905084e31b782",
            "TheSans",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "8c155b53e011d2a709548865b3edbeaf",
            "TheSans",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "09d88839ee48108d4891334024ee38d1",
            "TheSans",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "9001cd9b7b209eebef43419463ef6c40",
            "TheSans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "TheSans",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "6c724b28ea8a3cf8c557c4d17a42bc5b",
            "TheSans",
            "Urge Text"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "b8515436cf84baf71ab3bfbdf73854f8",
            "TheSans",
            "Eskorte Latin"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "TheSans",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "TheSans",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "8ec787f27be4c31cf8c185b0f1310703",
            "TheSans",
            "Skema Pro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "d07f2481905eefa80fa98c464d59e260",
            "TheSans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "1da38b05c8cff1dd065b5c10bb7f5341",
            "TheSans",
            "Kievit Serif W02 Regular"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "29093af656f979957ec5d657e96fb363",
            "TheSans",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "bbce3951159f83e9c2239d39fd666ce5",
            "TheSans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Shandon Slab",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "97e0e7061f7e1b6a015a4e8980c84647",
            "Shandon Slab",
            "Malnor Sans"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "f0249a1bec67973885bada20741c70c2",
            "Shandon Slab",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "5392c3a915aaad224a94a891d3b3b4da",
            "Shandon Slab",
            "BR Sonoma"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "d3caacfedf638f98ba7b0046f297f421",
            "Shandon Slab",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "fc2e33377af6aca34a9826245e325cba",
            "Shandon Slab",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "cae0af484abd406422956f9621c58b5f",
            "Shandon Slab",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "57cdd235481768dc73076d8a49a44353",
            "Shandon Slab",
            "Neue Alte Grotesk"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "9e0288eea87495dffd8e261f7cd68c9d",
            "Shandon Slab",
            "BB Noname (Pro)"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Shandon Slab",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "d159582398d0de4d0b367233acf587ee",
            "Shandon Slab",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "38b203ce41804d19e934461faf557ecb",
            "Shandon Slab",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "d0f3ec0504ca6f976926f385f49b961d",
            "Shandon Slab",
            "Core Sans C"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "ac04c5328af335b179cf1827997e1774",
            "Shandon Slab",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "e703c571b26ddb70174e8b5111fea898",
            "Shandon Slab",
            "Bw Nista"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "62f7ae646bfc8fd6adf7a44ba5470c04",
            "Shandon Slab",
            "Arial"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "96da2e3b759f10f9970cef587bf11069",
            "Shandon Slab",
            "Tenon"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "dfa1317c450784d1f09730737065a19b",
            "Shandon Slab",
            "Planc"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "899f6baa066fd450e1dbb5d37bd763af",
            "Shandon Slab",
            "H Central"
        ]
    },
    {
        "likedPair": [
            "e961668cbc083722acbc4a237ca92232",
            "a66b7008e3f8f1a08f1b8233f7c0ba12",
            "Shandon Slab",
            "Nimbus Sans Round"
        ]
    },
    {
        "likedPair": [
            "e9f02d3d6799cab618b6d171d598408b",
            "50441227356a2e75a4737b2cfe84709b",
            "Innova",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "e208cca764688975f3d7d3839228dea0",
            "ITC Franklin Gothic Book",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "e28128adc0e75357f447267c07afb6a6",
            "ITC Franklin Gothic Book",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "88950808c1357581d744cc4f308d9f94",
            "ITC Franklin Gothic Book",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "6e4bf0177f0e1b459e2b159545de1181",
            "ITC Franklin Gothic Book",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "06779a9920e25578b6f504fcbd0ca169",
            "ITC Franklin Gothic Book",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "c6bae55c030fe9df4104274e7fa5df57",
            "ITC Franklin Gothic Book",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "ITC Franklin Gothic Book",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "ITC Franklin Gothic Book",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "0f41ebd3d659da540745d00b52334eb0",
            "ITC Franklin Gothic Book",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "be483d1a100a556f9456d2ab176fd0c9",
            "ITC Franklin Gothic Book",
            "Academica"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "35ffcac4445202ebcfefa85630823de6",
            "ITC Franklin Gothic Book",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "06510c0260d17a867a598617cc3f59e9",
            "ITC Franklin Gothic Book",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "36ca5bc123f848ac643b6d50602259b7",
            "ITC Franklin Gothic Book",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "9ab5daa5796d80adb55febe5da072e8a",
            "ITC Franklin Gothic Book",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "45f11e2ac1181359f4004a104c49f31d",
            "ITC Franklin Gothic Book",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "b7d17d2dc576785a3f3919a96d964e46",
            "ITC Franklin Gothic Book",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "ITC Franklin Gothic Book",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "ITC Franklin Gothic Book",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "afb2c306772fbf472d6549a865bf7339",
            "ITC Franklin Gothic Book",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "ea90949476110422d67b9af4f8ace3a2",
            "ac3bae306ba295282462c4e44068b38a",
            "ITC Franklin Gothic Book",
            "Geller"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "c6ff032bd835e2f806009627251b87b6",
            "Sole Serif",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Sole Serif",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "d84e985d428e023bb87368d43461b448",
            "Sole Serif",
            "SST"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "2af66ddecaa7893391cb90362043d37a",
            "Sole Serif",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Sole Serif",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "38c216ced240e8111b587a31e2fc5794",
            "Sole Serif",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "b832321e77d0f1be2c00712330066c3e",
            "Sole Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "3a2f35b17543f0f3464b26e080b16634",
            "Sole Serif",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Sole Serif",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Sole Serif",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Sole Serif",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "c63e8810388d85594540bb5f6980f611",
            "Sole Serif",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Sole Serif",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Sole Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "b941ce467c4b7f2846b3226ae7988452",
            "Sole Serif",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "280c82457252f3613b33e3791c375caf",
            "Sole Serif",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "9b10e22dac5a2f03af2382f42b609efd",
            "Sole Serif",
            "ITC Stone Sans II"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Sole Serif",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "9e6867c857655e9d1984390fdf1dde45",
            "Sole Serif",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "eb6fc5c25f0a3bab9150d00b234bc858",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Sole Serif",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Folio",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Folio",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Folio",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "b127070b4065a62961b2bf60fb763a76",
            "Folio",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Folio",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Folio",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Folio",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "0f41ebd3d659da540745d00b52334eb0",
            "Folio",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "88950808c1357581d744cc4f308d9f94",
            "Folio",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "8ebe3248143db352da56805017ca7934",
            "Folio",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "36ca5bc123f848ac643b6d50602259b7",
            "Folio",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "737e1d3f1693de9fd863057622d1bb02",
            "Folio",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Folio",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Folio",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Folio",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "9da983bd95342b2184596f18ef3fff34",
            "Folio",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Folio",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Folio",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "06510c0260d17a867a598617cc3f59e9",
            "Folio",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "ebdc49d2fe55718bce1a53f10769e589",
            "3319dd949835e43d4bed270f465aff3e",
            "Folio",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "c2722fea792cde12a9117da6e0d70f74",
            "FF Mark",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "cfbb9acb121612b62a247f211e51cb3e",
            "FF Mark",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "8c155b53e011d2a709548865b3edbeaf",
            "FF Mark",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "FF Mark",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "FF Mark",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "FF Mark",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "FF Mark",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "FF Mark",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "cc3e79c959420501e528f6b20113c185",
            "FF Mark",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "b74bf78a743785e3df7e3f14477a1390",
            "FF Mark",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "FF Mark",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "FF Mark",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "b832321e77d0f1be2c00712330066c3e",
            "Dolly Pro",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "2af66ddecaa7893391cb90362043d37a",
            "Dolly Pro",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "43198f9d8420d1913accd8c5f0ee2e33",
            "Dolly Pro",
            "Monsal Gothic"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "280c82457252f3613b33e3791c375caf",
            "Dolly Pro",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "264a4ae29758ba917346fe9763531666",
            "Dolly Pro",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "38c216ced240e8111b587a31e2fc5794",
            "Dolly Pro",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Dolly Pro",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "c63e8810388d85594540bb5f6980f611",
            "Dolly Pro",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Dolly Pro",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Dolly Pro",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "9e6867c857655e9d1984390fdf1dde45",
            "Dolly Pro",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Dolly Pro",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Dolly Pro",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Dolly Pro",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Dolly Pro",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "b941ce467c4b7f2846b3226ae7988452",
            "Dolly Pro",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "35641bbe5146f945b85e1e7b34956a73",
            "Dolly Pro",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Dolly Pro",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "095898e12700edc69d52ecf30ef03e2a",
            "Dolly Pro",
            "Proza"
        ]
    },
    {
        "likedPair": [
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "fc2e33377af6aca34a9826245e325cba",
            "Dolly Pro",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "9da983bd95342b2184596f18ef3fff34",
            "Neuzeit Office",
            "NewAsterLTStd"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "5f2166fea2000a7b2f6e361c76edeef4",
            "Neuzeit Office",
            "URW Antiqua"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Neuzeit Office",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "443319dbf12b8f521a4f5c68e97e5d1d",
            "Neuzeit Office",
            "Bookman Old Style"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "c878afcbfb0ca5f448d091e1ae5a544f",
            "Neuzeit Office",
            "Reserve"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Neuzeit Office",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "737e1d3f1693de9fd863057622d1bb02",
            "Neuzeit Office",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "5843b72473159a2bd66bc2f0687792a3",
            "Neuzeit Office",
            "Deccan"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "6d47953bebf6a23dc1d89764632524d8",
            "Neuzeit Office",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Neuzeit Office",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Neuzeit Office",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "73e48b94c08d2015315dbceaf56efb62",
            "Neuzeit Office",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "38f28a6682e9d705522a7ac7a715578f",
            "Neuzeit Office",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "Neuzeit Office",
            "ITC Bookman"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "d115cf3c43d6c21d3082fda58ccd341c",
            "Neuzeit Office",
            "Century Schoolbook"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Neuzeit Office",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "67aadae90ce6049659422a925a8a23d4",
            "Neuzeit Office",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "8ebe3248143db352da56805017ca7934",
            "Neuzeit Office",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Neuzeit Office",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "Neuzeit Office",
            "PalmSprings"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "cbc8e967ca57cfef415bf0f290ba5241",
            "Core Serif N",
            "Carisma"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Core Serif N",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "b34fc5fd3820759a8808f554191ecaa2",
            "Core Serif N",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Core Serif N",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Core Serif N",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "Core Serif N",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "fbb9573728984c54a8ca446e19d0972a",
            "Core Serif N",
            "Proxima Nova"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Core Serif N",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "3d295205229224442c34a365d6b885d1",
            "Core Serif N",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "9e6867c857655e9d1984390fdf1dde45",
            "Core Serif N",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Core Serif N",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Core Serif N",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Core Serif N",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Core Serif N",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Core Serif N",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "ec1d5ef2c72e776a830e270a8d22ca68",
            "Core Serif N",
            "FF Mark"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "ed7fe484972393ac7bfd6f29a1d37bbb",
            "Core Serif N",
            "Neuzeit Office"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "51eb849300954cdecf9da1310c79beb2",
            "Core Serif N",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "2af66ddecaa7893391cb90362043d37a",
            "Core Serif N",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "b941ce467c4b7f2846b3226ae7988452",
            "Core Serif N",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "3f1f1624d41e8a81c33d7db33e23f2ff",
            "Egyptienne F",
            "Classic Grotesque"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "15f6440060216b78f6e867d5cf13fd85",
            "Egyptienne F",
            "HangulatinEN-Regular"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "f0249a1bec67973885bada20741c70c2",
            "Egyptienne F",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "dd2c9ea889b0c15cef2d612fb0f4d28f",
            "Egyptienne F",
            "Gothic 720 W03 Rom"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "0a990399fe7f1b376e846e602e3307bb",
            "Egyptienne F",
            "Europa Grotesk No. 2 SB"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "899d5f15480b4c036d5ec3eabac9e398",
            "Egyptienne F",
            "Trivia Sans"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "Egyptienne F",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "650bcadc2c69543d997704b29b7c50d2",
            "Egyptienne F",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "d3caacfedf638f98ba7b0046f297f421",
            "Egyptienne F",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "3dba1a3608c4e2faba9528b4451fa027",
            "Egyptienne F",
            "Zurich"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Egyptienne F",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "fc2e33377af6aca34a9826245e325cba",
            "Egyptienne F",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "38b203ce41804d19e934461faf557ecb",
            "Egyptienne F",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "dac699b554de5b30f7764b27556f9e9e",
            "Egyptienne F",
            "AkzidenzGroteskBQ-Reg"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "Egyptienne F",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "cae0af484abd406422956f9621c58b5f",
            "Egyptienne F",
            "Alliance"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "ac04c5328af335b179cf1827997e1774",
            "Egyptienne F",
            "Swiss721 BT Regular"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "ea90949476110422d67b9af4f8ace3a2",
            "Egyptienne F",
            "ITC Franklin Gothic Book"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "d159582398d0de4d0b367233acf587ee",
            "Egyptienne F",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "ef0f22560e30896239545a852fd7f6b4",
            "da5723a234527888e7dc5e19548f1abb",
            "Egyptienne F",
            "Univers"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "ITC Stone Serif",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "b34fc5fd3820759a8808f554191ecaa2",
            "ITC Stone Serif",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "033528c5f0137b017eff21079bd25a60",
            "ITC Stone Serif",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "ITC Stone Serif",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "565f10ac096eb5d75c4400509e23cdc1",
            "ITC Stone Serif",
            "Schnebel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "ITC Stone Serif",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "b832321e77d0f1be2c00712330066c3e",
            "ITC Stone Serif",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "ITC Stone Serif",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "9e6867c857655e9d1984390fdf1dde45",
            "ITC Stone Serif",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "ITC Stone Serif",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "3d295205229224442c34a365d6b885d1",
            "ITC Stone Serif",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "b941ce467c4b7f2846b3226ae7988452",
            "ITC Stone Serif",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "ITC Stone Serif",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "ITC Stone Serif",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "ITC Stone Serif",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "91f1a74434b4ecc9129239ec3e236b42",
            "ITC Stone Serif",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "c2244758e73a4caacb7f2916afe5f38f",
            "ITC Stone Serif",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "ef71628ba1ab6310365a78c263679726",
            "c63e8810388d85594540bb5f6980f611",
            "ITC Stone Serif",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Joanna Nova",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Joanna Nova",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Joanna Nova",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "b832321e77d0f1be2c00712330066c3e",
            "Joanna Nova",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "c6ff032bd835e2f806009627251b87b6",
            "Joanna Nova",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "d84e985d428e023bb87368d43461b448",
            "Joanna Nova",
            "SST"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "c63e8810388d85594540bb5f6980f611",
            "Joanna Nova",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Joanna Nova",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "d18f103cfa62513f991b0f90a814c333",
            "Joanna Nova",
            "Fact"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "280c82457252f3613b33e3791c375caf",
            "Joanna Nova",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "3a2f35b17543f0f3464b26e080b16634",
            "Joanna Nova",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "bf9108ab113a6ebbe2aa54d9ba1d2012",
            "Joanna Nova",
            "JAF Bernini Sans"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "522423ab26a3b1f5bb0d40a81ec91262",
            "Joanna Nova",
            "Creo"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "47e848f1f1b998207926dfb024fa4a48",
            "Joanna Nova",
            "FS Elliot Paneuropean"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Joanna Nova",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Joanna Nova",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "5c9bcc9e515bb16f5715ecc5353ff897",
            "Joanna Nova",
            "Novel Sans Pro"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "35641bbe5146f945b85e1e7b34956a73",
            "Joanna Nova",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "51eb849300954cdecf9da1310c79beb2",
            "Joanna Nova",
            "Calluna Sans"
        ]
    },
    {
        "likedPair": [
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Joanna Nova",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "d4df1a651052c6bd88be57660da085ac",
            "Araboto",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Araboto",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Araboto",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "45f11e2ac1181359f4004a104c49f31d",
            "Araboto",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "36ca5bc123f848ac643b6d50602259b7",
            "Araboto",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Araboto",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Araboto",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "c6bae55c030fe9df4104274e7fa5df57",
            "Araboto",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "737e1d3f1693de9fd863057622d1bb02",
            "Araboto",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "35ffcac4445202ebcfefa85630823de6",
            "Araboto",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Araboto",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "adc9e6f8703a21e134aa72d637646fdc",
            "Araboto",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "88950808c1357581d744cc4f308d9f94",
            "Araboto",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Araboto",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "Araboto",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "4b69cc4ce483966efd99a637882c74a5",
            "Araboto",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "Araboto",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "c04f563b6a1457ae02100e98a49654c6",
            "Araboto",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Araboto",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "f01435736b8b73793ad270cdf379a860",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Araboto",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "737e1d3f1693de9fd863057622d1bb02",
            "RF Dewi",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "36ca5bc123f848ac643b6d50602259b7",
            "RF Dewi",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "263b7ffd57470af21ec49d7a144c4f23",
            "RF Dewi",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "c6bae55c030fe9df4104274e7fa5df57",
            "RF Dewi",
            "Times New Roman"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "6e4bf0177f0e1b459e2b159545de1181",
            "RF Dewi",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "45f11e2ac1181359f4004a104c49f31d",
            "RF Dewi",
            "Riccione Serial"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "RF Dewi",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "adc9e6f8703a21e134aa72d637646fdc",
            "RF Dewi",
            "Versailles LT Com 55 Roman"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "RF Dewi",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "35ffcac4445202ebcfefa85630823de6",
            "RF Dewi",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "88950808c1357581d744cc4f308d9f94",
            "RF Dewi",
            "Micrograma MF"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "be5fdca67a94d3db868b73c7eaea39f4",
            "RF Dewi",
            "Helserif"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "7f4b0c6d8c1c31c40f15c87be97ec5a7",
            "RF Dewi",
            "Georgia"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "4b69cc4ce483966efd99a637882c74a5",
            "RF Dewi",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "c04f563b6a1457ae02100e98a49654c6",
            "RF Dewi",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "9ab5daa5796d80adb55febe5da072e8a",
            "RF Dewi",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "e093c040c71b04f76b2b181a6dd3acea",
            "RF Dewi",
            "Ingeborg"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "RF Dewi",
            "Life"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "b7d17d2dc576785a3f3919a96d964e46",
            "RF Dewi",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "f0249a1bec67973885bada20741c70c2",
            "25d004c59ba64ba3dbe6e42e9480bef7",
            "RF Dewi",
            "Utopia"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "8c155b53e011d2a709548865b3edbeaf",
            "Daikon",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "c7117e8442a401bc7dd78049829ef83b",
            "Daikon",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Daikon",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Daikon",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Daikon",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Daikon",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "f02646f18604d6ce339590291ba509e0",
            "b127070b4065a62961b2bf60fb763a76",
            "Daikon",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "f0c4c3d68e27949d411acbfa534b2fef",
            "b0ddcd7271d30342377ba7d1683e74d7",
            "Tee Franklin",
            "Breton"
        ]
    },
    {
        "likedPair": [
            "f0c4c3d68e27949d411acbfa534b2fef",
            "5deef3f01e195e1ed663c9b01d334f7a",
            "Tee Franklin",
            "Linotype Centennial"
        ]
    },
    {
        "likedPair": [
            "f0c4c3d68e27949d411acbfa534b2fef",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Tee Franklin",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "f0c4c3d68e27949d411acbfa534b2fef",
            "9aee5dfbc09db7dd09899af1b20620cd",
            "Tee Franklin",
            "Quixo Offc Light"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "50441227356a2e75a4737b2cfe84709b",
            "Brother 1816",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "8c155b53e011d2a709548865b3edbeaf",
            "Brother 1816",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "24a285c9e8eb201bbb4a311ad38ff17b",
            "Brother 1816",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "73e48b94c08d2015315dbceaf56efb62",
            "Brother 1816",
            "GHEAAspet"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Brother 1816",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "c4fd3343a2800af0d7036d044b8a9d5a",
            "Brother 1816",
            "FF Yoga"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Brother 1816",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Brother 1816",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Brother 1816",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "9360965dc32616b3be9ca157ebaa44eb",
            "Brother 1816",
            "Palatino"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "cd92499f5905694f796be4b7b3406e49",
            "Brother 1816",
            "Zapf Calligraphic 801"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Brother 1816",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "013968ef381969722a37a334b48bbaeb",
            "Brother 1816",
            "Queulat"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Brother 1816",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Brother 1816",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "c7117e8442a401bc7dd78049829ef83b",
            "Brother 1816",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "b127070b4065a62961b2bf60fb763a76",
            "Brother 1816",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "c2722fea792cde12a9117da6e0d70f74",
            "Brother 1816",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "862844e56f430bb0af08f52dd89f1be0",
            "Brother 1816",
            "Velino Text"
        ]
    },
    {
        "likedPair": [
            "f27264442e7df065b3c26373505c38b6",
            "03c630ee6fa2bbc99e8c7cafbb93268f",
            "Brother 1816",
            "ITC Garamond"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "c04f563b6a1457ae02100e98a49654c6",
            "Linotype Aroma",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Linotype Aroma",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Linotype Aroma",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Linotype Aroma",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "7385300fc2a1109d8d286432af1fcb85",
            "Linotype Aroma",
            "Garvis Pro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "9a56b03fc5c8b9a7e849de833f717ae3",
            "Linotype Aroma",
            "Stempel Garamond LT"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "29093af656f979957ec5d657e96fb363",
            "Linotype Aroma",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "9001cd9b7b209eebef43419463ef6c40",
            "Linotype Aroma",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "3f57a43ed54fe91aa92025669be6fe7d",
            "Linotype Aroma",
            "FS Ostro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "623b4e42d48a5d620464ccf3c37cab13",
            "Linotype Aroma",
            "Tabac Slab"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "73138474522e9719f1a246b6fff9af38",
            "Linotype Aroma",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "858170a34ed4538c4ce46be2fa57f670",
            "Linotype Aroma",
            "MVB Verdigris Pro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "22556e70e77a4ba87864ff6dbd2862cc",
            "Linotype Aroma",
            "RemingaPro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "820a3fdbd8299ef1a164763cba53587e",
            "Linotype Aroma",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "0638a6154647ef8a772e7b46dd1d966d",
            "Linotype Aroma",
            "Rotation"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "09d88839ee48108d4891334024ee38d1",
            "Linotype Aroma",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "b13b7acc15a6827d8c14f6919e1db8a3",
            "Linotype Aroma",
            "Clifford Six Offc Pro"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Linotype Aroma",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "eed6f923cdf1e7e879935ca7f614f4a0",
            "Linotype Aroma",
            "Core Serif N"
        ]
    },
    {
        "likedPair": [
            "f2e1ddaa3544842277fbb4842ada6a72",
            "d87ffd42ab39a3412ab905084e31b782",
            "Linotype Aroma",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Gentleman",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Gentleman",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Gentleman",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "b74bf78a743785e3df7e3f14477a1390",
            "Gentleman",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "b127070b4065a62961b2bf60fb763a76",
            "Gentleman",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "f5a49aa2213d4997def8db2e67ea89b3",
            "cc3e79c959420501e528f6b20113c185",
            "Gentleman",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "cc3e79c959420501e528f6b20113c185",
            "TwCenMTPro-Light",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "bad316ad74318a9f95d0749417edfa04",
            "TwCenMTPro-Light",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "TwCenMTPro-Light",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "b127070b4065a62961b2bf60fb763a76",
            "TwCenMTPro-Light",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "TwCenMTPro-Light",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "8ebe3248143db352da56805017ca7934",
            "TwCenMTPro-Light",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "TwCenMTPro-Light",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "3319dd949835e43d4bed270f465aff3e",
            "TwCenMTPro-Light",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "f5fc061c346d51e0630e2334ab6dc004",
            "d515a6ca361cc9d1340762f79d8263dd",
            "TwCenMTPro-Light",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "de9599121cf31a08904a48495fadcf4a",
            "ITC Bookman",
            "District Pro"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "033528c5f0137b017eff21079bd25a60",
            "ITC Bookman",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "ITC Bookman",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "e1351e92b91e4de955c73093b43ae8e2",
            "ITC Bookman",
            "Neue Plak"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "f0249a1bec67973885bada20741c70c2",
            "ITC Bookman",
            "RF Dewi"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "fc2e33377af6aca34a9826245e325cba",
            "ITC Bookman",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "b34fc5fd3820759a8808f554191ecaa2",
            "ITC Bookman",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "2dabf2102a09c9b89e6ce0ee94cb13d0",
            "ITC Bookman",
            "V&W Syntax (Adobe)"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "d3caacfedf638f98ba7b0046f297f421",
            "ITC Bookman",
            "Devoid"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "650bcadc2c69543d997704b29b7c50d2",
            "ITC Bookman",
            "Passenger Sans"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "090f944a52ed426dbc544297d0fb9442",
            "ITC Bookman",
            "Syntax"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "38b203ce41804d19e934461faf557ecb",
            "ITC Bookman",
            "FS Koopman"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "4fb3b3f751d5e17a508bdf3d4d974f01",
            "ITC Bookman",
            "Pragmatica"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "ITC Bookman",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "f01435736b8b73793ad270cdf379a860",
            "ITC Bookman",
            "Araboto"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "7d12c71bfcb798ad9660e885c2f07cb5",
            "ITC Bookman",
            "Optima Nova"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "7b6132f5e609e1dd9f5c3024f56ab311",
            "ITC Bookman",
            "Franklin Gothic SG"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "d308bf8cc668fecbc3881e69f537c8e4",
            "ITC Bookman",
            "Winterthur"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "bb53acb0d26b7c34eaca665214b5b781",
            "ITC Bookman",
            "Badiya"
        ]
    },
    {
        "likedPair": [
            "f62f2790949df5ba1e4f53a36e8e82e1",
            "d159582398d0de4d0b367233acf587ee",
            "ITC Bookman",
            "Neue Haas Grotesk Text"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "d4f0f8030c1d155b3361152e0e4468e8",
            "Myriad",
            "Aetna JY Pro"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "8c155b53e011d2a709548865b3edbeaf",
            "Myriad",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "7e9d0bdb9c9ee63eff98f3572164fef1",
            "Myriad",
            "Monotype Sabon"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "ef724eada48fbb4a0fc0bdd3c5c918ed",
            "Myriad",
            "Joanna Nova"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "d87ffd42ab39a3412ab905084e31b782",
            "Myriad",
            "FF Kievit Slab"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Myriad",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "a8cc661626b8f464f0d19cca4451b7a9",
            "Myriad",
            "Prumo Banner"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "d16ffc305fae4c21f8a603d32a60b7b2",
            "Myriad",
            "Scala Pro"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "9001cd9b7b209eebef43419463ef6c40",
            "Myriad",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "09d88839ee48108d4891334024ee38d1",
            "Myriad",
            "Erato"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "c48ed6205830c1daa57653eed6ab1fe7",
            "Myriad",
            "Halesworth"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "d07f2481905eefa80fa98c464d59e260",
            "Myriad",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "4d82221c90d410a5a3c0bd9618ba01fc",
            "Myriad",
            "NCT Granite"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "29093af656f979957ec5d657e96fb363",
            "Myriad",
            "CalistoMTPro"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Myriad",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "9ded3c33a83728124405e311fff63b40",
            "Myriad",
            "Vigor DT"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Myriad",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "820a3fdbd8299ef1a164763cba53587e",
            "Myriad",
            "Quant Text"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "392ba6ef4c0939349ecf8e0e89f359f1",
            "Myriad",
            "Iowan Old Style"
        ]
    },
    {
        "likedPair": [
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "fd3d939f3fefc04b7635ab5476f37c05",
            "Myriad",
            "Pona Book"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Leitura News",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "9e6867c857655e9d1984390fdf1dde45",
            "Leitura News",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Leitura News",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "280c82457252f3613b33e3791c375caf",
            "Leitura News",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Leitura News",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Leitura News",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "b832321e77d0f1be2c00712330066c3e",
            "Leitura News",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Leitura News",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "264a4ae29758ba917346fe9763531666",
            "Leitura News",
            "News Gothic"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "49aaae34841599b1ea5ee4be4ab19fa7",
            "Leitura News",
            "Tabac Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Leitura News",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "cdf497f40577c236216ef39ba5a1ef35",
            "Leitura News",
            "Auto Pro"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Leitura News",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "b941ce467c4b7f2846b3226ae7988452",
            "Leitura News",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "f2e1ddaa3544842277fbb4842ada6a72",
            "Leitura News",
            "Linotype Aroma"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "2af66ddecaa7893391cb90362043d37a",
            "Leitura News",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "7530f20bfafbb946172b6f36a47d48c0",
            "Leitura News",
            "Zapf Humanist 601"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "c63e8810388d85594540bb5f6980f611",
            "Leitura News",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Leitura News",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "c2244758e73a4caacb7f2916afe5f38f",
            "Leitura News",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "c2722fea792cde12a9117da6e0d70f74",
            "Trenda",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "8c155b53e011d2a709548865b3edbeaf",
            "Trenda",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Trenda",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Trenda",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Trenda",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "7c4a10607b6d2e1343591f90d0c1ebb3",
            "Trenda",
            "S\u00e1nchez Niu"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Trenda",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Trenda",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "cc3e79c959420501e528f6b20113c185",
            "Trenda",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "8ebe3248143db352da56805017ca7934",
            "Trenda",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "c7117e8442a401bc7dd78049829ef83b",
            "Trenda",
            "Weekly"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "b127070b4065a62961b2bf60fb763a76",
            "Trenda",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "b74bf78a743785e3df7e3f14477a1390",
            "Trenda",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Trenda",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "f867f80ff3b5b853e048b9d401f0669a",
            "bad316ad74318a9f95d0749417edfa04",
            "Trenda",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "1ab5b6f0a8fc463f2ee6344ef8186316",
            "PalmSprings",
            "FF Infra"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "033528c5f0137b017eff21079bd25a60",
            "PalmSprings",
            "Sebino"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "b34fc5fd3820759a8808f554191ecaa2",
            "PalmSprings",
            "Acumin"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "PalmSprings",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "PalmSprings",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "PalmSprings",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "fc2e33377af6aca34a9826245e325cba",
            "PalmSprings",
            "Sole Sans"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "9e6867c857655e9d1984390fdf1dde45",
            "PalmSprings",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "b24744ca2bf3616294271353ec837099",
            "PalmSprings",
            "Nolan Next"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "bd3d5a6b48b435aaff2fcc55919f6602",
            "PalmSprings",
            "Lasiver"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "c63e8810388d85594540bb5f6980f611",
            "PalmSprings",
            "LegacySansITCPro-Book"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "f27264442e7df065b3c26373505c38b6",
            "PalmSprings",
            "Brother 1816"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "PalmSprings",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "c2244758e73a4caacb7f2916afe5f38f",
            "PalmSprings",
            "Atwic Regular"
        ]
    },
    {
        "likedPair": [
            "f8a83fc481f11aff792ba86c1bf7a31f",
            "91f1a74434b4ecc9129239ec3e236b42",
            "PalmSprings",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "c6ff032bd835e2f806009627251b87b6",
            "Abelard",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Abelard",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "b832321e77d0f1be2c00712330066c3e",
            "Abelard",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Abelard",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "52ce3f0b70ac5ce0f3eaba5df581a0aa",
            "Abelard",
            "Neue Frutiger"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "b215aa97f1d19ccf86ef621b3a85a9ff",
            "Abelard",
            "Ardena"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Abelard",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "d4b23fd2da1e2e1f064e730fe0fcb548",
            "Abelard",
            "Dagny Offc Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Abelard",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "280c82457252f3613b33e3791c375caf",
            "Abelard",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "3d295205229224442c34a365d6b885d1",
            "Abelard",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Abelard",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "d84e985d428e023bb87368d43461b448",
            "Abelard",
            "SST"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "9e6867c857655e9d1984390fdf1dde45",
            "Abelard",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Abelard",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "cdfdc5eeac0bd71254929817415fb502",
            "Abelard",
            "FS Me"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "b941ce467c4b7f2846b3226ae7988452",
            "Abelard",
            "Astoria Sans"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "80e1fc90248cfb3f3b54227ab8d1afb1",
            "Abelard",
            "Arazat\u00ed"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "3a2f35b17543f0f3464b26e080b16634",
            "Abelard",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "f8fb25d7eece73beab9f26ee8dda4b7c",
            "18a6d3e5a988d69effe05c4c405ce8db",
            "Abelard",
            "Supra Mezzo"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "737e1d3f1693de9fd863057622d1bb02",
            "Komet",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "4bcf19d01fb8d82a6109c99ad4fe31e5",
            "Komet",
            "Madley"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "c04f563b6a1457ae02100e98a49654c6",
            "Komet",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "073081f11751cb576e2b13de664766f6",
            "Komet",
            "Le Monde Livre Std"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "71ce2a4123e21bfb630f651363b756f3",
            "Komet",
            "Bunyan Pro"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "38f28a6682e9d705522a7ac7a715578f",
            "Komet",
            "Essonnes"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "6d47953bebf6a23dc1d89764632524d8",
            "Komet",
            "Macklin"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "f7c2d1df17114f22a09bc08c6e2ab79e",
            "Komet",
            "Leitura News"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "11b27f0d1fa7ae8fc1264cdc5a208f19",
            "Komet",
            "QuaText"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "8006330b215827a8efcd0e4c791bae76",
            "Komet",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "e0d397e073f334bdc40410c8c4093d9b",
            "Komet",
            "Alkes"
        ]
    },
    {
        "likedPair": [
            "f937f5334ab3163ba48c9d837754a6fe",
            "3aa67add39bd085c00649dcc61f0b368",
            "Komet",
            "Ginkgo"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "5ed60e2a7db59ce2fef37170ca825424",
            "Vicky",
            "Coco Sharp"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "4879e9509d1c5d07ebb7e1d6307b2739",
            "Vicky",
            "Glence"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "be4c17fe91041ccdbe2b10cfe8b6d769",
            "Vicky",
            "Pontiac"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "627f02177189a33fe40ad427eff5d5bb",
            "Vicky",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "0948bcac8c88566853911db4a5ea95e7",
            "Vicky",
            "Suprema"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "868fc2017554528c8ca4e20974e19480",
            "Vicky",
            "Codec Pro"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "a8008a4be1e40b815732b608890c3415",
            "Vicky",
            "Neuville"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "075ee4d8b4b2f2be685deae392ee79a8",
            "Vicky",
            "Averta"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "256f7672059f72846d940fbd8c97537d",
            "Vicky",
            "Quarion"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "bf9fc533e1700efac60390b153c27ca0",
            "Vicky",
            "Arboria"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "e7e8c166ae6feadb16eb669f1ef384a2",
            "Vicky",
            "Ano"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "d0f3ec0504ca6f976926f385f49b961d",
            "Vicky",
            "Core Sans C"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "9a21e3a1e94c73d3bf7f66ea8fb82613",
            "Vicky",
            "Gilroy"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "96e1aabdc042f39c0725e6cda9b08ab2",
            "Vicky",
            "2030"
        ]
    },
    {
        "likedPair": [
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "b61df993dabc0406618f2c3112636497",
            "Vicky",
            "Gotham-Book"
        ]
    },
    {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Proxima Nova",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "8dc3a40e423d1f3d09bc6f20e864e5b4",
            "Proxima Nova",
            "Sanchez Slab"
        ]
    },
    {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Proxima Nova",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Proxima Nova",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "fbb9573728984c54a8ca446e19d0972a",
            "c2722fea792cde12a9117da6e0d70f74",
            "Proxima Nova",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "e208cca764688975f3d7d3839228dea0",
            "Sole Sans",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "c3c0b5f23e63fcc31f434604265321d6",
            "Sole Sans",
            "Dutch 766"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "0f41ebd3d659da540745d00b52334eb0",
            "Sole Sans",
            "Bookmania"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "73138474522e9719f1a246b6fff9af38",
            "Sole Sans",
            "FS Brabo Paneuropean"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "c87f74a6084f73fdad817b1589a48a08",
            "Sole Sans",
            "FF Meta Serif"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "336870775fb3762c36c707da37eabadf",
            "Sole Sans",
            "Galliard"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "9001cd9b7b209eebef43419463ef6c40",
            "Sole Sans",
            "Carrara"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "a3a23b09eaba55f81683d7cb6be6349d",
            "Sole Sans",
            "ITC Galliard Pro Roman"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "d3172d4eb6ca50f29405f27e8eb55d02",
            "Sole Sans",
            "Kis Antiqua Pro"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "ac3bae306ba295282462c4e44068b38a",
            "Sole Sans",
            "Geller"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "9ab5daa5796d80adb55febe5da072e8a",
            "Sole Sans",
            "Alilon MF"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "06779a9920e25578b6f504fcbd0ca169",
            "Sole Sans",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "4b69cc4ce483966efd99a637882c74a5",
            "Sole Sans",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "263b7ffd57470af21ec49d7a144c4f23",
            "Sole Sans",
            "Kepler"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "c04f563b6a1457ae02100e98a49654c6",
            "Sole Sans",
            "Janson Text Roman"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "bbce3951159f83e9c2239d39fd666ce5",
            "Sole Sans",
            "Zenon"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "0e157f1d6604d94abd495cc244aaf2cf",
            "Sole Sans",
            "Aldine 401"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "d07f2481905eefa80fa98c464d59e260",
            "Sole Sans",
            "Dante MT Pro"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "36ca5bc123f848ac643b6d50602259b7",
            "Sole Sans",
            "NimbusRomNo9T-Reg"
        ]
    },
    {
        "likedPair": [
            "fc2e33377af6aca34a9826245e325cba",
            "6f6fa02942ef2355b8e1de59dbe601af",
            "Sole Sans",
            "Life"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "b832321e77d0f1be2c00712330066c3e",
            "Pona Book",
            "Obliqua ITC Pro"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "f69ccbcfad4b726953512a7d7e14c8d5",
            "Pona Book",
            "Myriad"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "c6ff032bd835e2f806009627251b87b6",
            "Pona Book",
            "Milo Pro"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "e8b5283eb3d1cbffebe9c7a6f6cd36e7",
            "Pona Book",
            "TheSans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "280c82457252f3613b33e3791c375caf",
            "Pona Book",
            "Wayfinding Sans Pro"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "2a952aa3d79c1da6126e5a070654b0b5",
            "Pona Book",
            "Multiple"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "a0d65f3e06a945602a59f035c4c9edaf",
            "Pona Book",
            "Freight Neo Pro"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "9e6867c857655e9d1984390fdf1dde45",
            "Pona Book",
            "Skolar Sans Latin"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "d84e985d428e023bb87368d43461b448",
            "Pona Book",
            "SST"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "4a8d414c86f9aeae1489e72e6293e772",
            "Pona Book",
            "Conamore"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "2af66ddecaa7893391cb90362043d37a",
            "Pona Book",
            "Foundry Sans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "38c216ced240e8111b587a31e2fc5794",
            "Pona Book",
            "Droid Sans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "3d295205229224442c34a365d6b885d1",
            "Pona Book",
            "Boutros Angham"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "3a2f35b17543f0f3464b26e080b16634",
            "Pona Book",
            "PT Sans Pro"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "8af7fbcf7bc2e756b53fae7ea6bd4cf3",
            "Pona Book",
            "Salom"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "2f1bd1f8dbef57e0409e2c64f8edc593",
            "Pona Book",
            "Mundo Sans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "9eb1a01d4d6fd3aee08d5917454c25ee",
            "Pona Book",
            "Andulka Sans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "35641bbe5146f945b85e1e7b34956a73",
            "Pona Book",
            "FF Scala Sans"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "e1864ebcfe34672f435c3bedacde5d63",
            "Pona Book",
            "CG Symphony"
        ]
    },
    {
        "likedPair": [
            "fd3d939f3fefc04b7635ab5476f37c05",
            "91f1a74434b4ecc9129239ec3e236b42",
            "Pona Book",
            "Mentor Sans"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "8c155b53e011d2a709548865b3edbeaf",
            "Boston",
            "PerpetuaMTPro-Regular"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "c2722fea792cde12a9117da6e0d70f74",
            "Boston",
            "Coltan Gea"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "85d8f2d0ba0f6b93900052f3b3047991",
            "Boston",
            "Yorkten Slab"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "cfbb9acb121612b62a247f211e51cb3e",
            "Boston",
            "Locke"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "39c6824c053d9eaf11e996a26ad2eba3",
            "Boston",
            "Museo Slab"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Boston",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "7be0986d9e30fc760c35339e0ebc7b52",
            "Boston",
            "Alexandra"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "cc3e79c959420501e528f6b20113c185",
            "Boston",
            "Memphis"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "b74bf78a743785e3df7e3f14477a1390",
            "Boston",
            "Paralex"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "67aadae90ce6049659422a925a8a23d4",
            "Boston",
            "Carrig Pro"
        ]
    },
    {
        "likedPair": [
            "fdb83b251895a26eb58c7dd29a11c59b",
            "bad316ad74318a9f95d0749417edfa04",
            "Boston",
            "Geometric Slabserif 703"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "e28128adc0e75357f447267c07afb6a6",
            "Trade Gothic",
            "Hyperon"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "e208cca764688975f3d7d3839228dea0",
            "Trade Gothic",
            "Orbi"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "06510c0260d17a867a598617cc3f59e9",
            "Trade Gothic",
            "Mencken Std"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "6e4bf0177f0e1b459e2b159545de1181",
            "Trade Gothic",
            "Napolitana MF"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "e7fd2cd9a87da85e2b8d20fb884e719e",
            "Trade Gothic",
            "Iwata Mincho Old Pro"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "b444489e0fc33e02afa2d1a4962d46ba",
            "Trade Gothic",
            "MeteorObliqueMF-Bold"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "06779a9920e25578b6f504fcbd0ca169",
            "Trade Gothic",
            "Trola"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "4b69cc4ce483966efd99a637882c74a5",
            "Trade Gothic",
            "Dutch 801"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "50441227356a2e75a4737b2cfe84709b",
            "Trade Gothic",
            "Heisei Mincho"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "35ffcac4445202ebcfefa85630823de6",
            "Trade Gothic",
            "Meruba New MF"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "b7d17d2dc576785a3f3919a96d964e46",
            "Trade Gothic",
            "Madison Antiqua"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "2c055a7f717a969a129cf78e586c2d39",
            "Trade Gothic",
            "Corporate E"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "eca7a3ecbd1738481c08b5132b63e3c9",
            "Trade Gothic",
            "Dolly Pro"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "afb2c306772fbf472d6549a865bf7339",
            "Trade Gothic",
            "TT Livret"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "9b642a5046a3cb501e8121b8f96cea5b",
            "Trade Gothic",
            "Miller Text"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "b893f19f5f314bef77fb6d7c69a5a9dd",
            "Trade Gothic",
            "Questa Serif"
        ]
    },
    {
        "likedPair": [
            "fe3a6272e385cf422cb1e23f99deb591",
            "8006330b215827a8efcd0e4c791bae76",
            "Trade Gothic",
            "Geneo Std"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "737e1d3f1693de9fd863057622d1bb02",
            "Sequel Sans",
            "Prillwitz Pro"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "284341274e9b9e7088536bfd0b0fe5c9",
            "Sequel Sans",
            "Pepi/Rudi"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "8ebe3248143db352da56805017ca7934",
            "Sequel Sans",
            "Walbaum"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "3319dd949835e43d4bed270f465aff3e",
            "Sequel Sans",
            "Metron SSi"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "e961668cbc083722acbc4a237ca92232",
            "Sequel Sans",
            "Shandon Slab"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "cd664fa7d37a4ad084c5ccc45ee36f8e",
            "Sequel Sans",
            "Winden"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "d4df1a651052c6bd88be57660da085ac",
            "Sequel Sans",
            "Hefring Slab"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "5bd81732a879ba42412c19bd5a33589b",
            "Sequel Sans",
            "TT Rationalist"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "d515a6ca361cc9d1340762f79d8263dd",
            "Sequel Sans",
            "Serifa"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "386528d2feb209e45554ed0fa03d81ce",
            "Sequel Sans",
            "Glypha"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "caee5e6a5eec9cb66a85ac115f2f5c7f",
            "Sequel Sans",
            "ITC Lubalin Graph"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "cf517867a0d18a4dd3663c6c5ca61ad3",
            "Sequel Sans",
            "Calvert MT Pro Light"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "b127070b4065a62961b2bf60fb763a76",
            "Sequel Sans",
            "Candida"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "ef0f22560e30896239545a852fd7f6b4",
            "Sequel Sans",
            "Egyptienne F"
        ]
    },
    {
        "likedPair": [
            "ff5fb53cfd43a9fd4d2009747d80380c",
            "f9f0286cc52bcc88ddbf9fb34b446667",
            "Sequel Sans",
            "Vicky"
        ]
    }
]